import { jsx as S, jsxs as Z, Fragment as Ct } from "react/jsx-runtime";
import * as V from "react";
import A, { useRef as An, useEffect as Aa, forwardRef as xs, createElement as Fi, useMemo as ws, useState as Vt, isValidElement as Pt, Children as Br, PureComponent as bt, useImperativeHandle as JA, useCallback as QA, cloneElement as De, useContext as nr, createContext as Jr, Component as Zw, Fragment as eP } from "react";
import * as Je from "@radix-ui/react-alert-dialog";
import * as ri from "@radix-ui/react-avatar";
import * as wd from "@radix-ui/react-checkbox";
import * as lt from "@radix-ui/react-dialog";
import * as ft from "@radix-ui/react-dropdown-menu";
import { Slot as tP } from "@radix-ui/react-slot";
import * as Jw from "@radix-ui/react-label";
import * as Pn from "@radix-ui/react-popover";
import * as zi from "@radix-ui/react-radio-group";
import * as Fr from "@radix-ui/react-scroll-area";
import * as rt from "@radix-ui/react-select";
import * as Qw from "@radix-ui/react-separator";
import * as Od from "@radix-ui/react-switch";
import * as Qr from "@radix-ui/react-tabs";
import * as Pa from "@radix-ui/react-tooltip";
function e1(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (r = e1(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function ue() {
  for (var e, t, r = 0, n = "", i = arguments.length; r < i; r++) (e = arguments[r]) && (t = e1(e)) && (n && (n += " "), n += t);
  return n;
}
const Xp = "-", rP = (e) => {
  const t = iP(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = e;
  return {
    getClassGroupId: (o) => {
      const s = o.split(Xp);
      return s[0] === "" && s.length !== 1 && s.shift(), t1(s, t) || nP(o);
    },
    getConflictingClassGroupIds: (o, s) => {
      const u = r[o] || [];
      return s && n[o] ? [...u, ...n[o]] : u;
    }
  };
}, t1 = (e, t) => {
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], n = t.nextPart.get(r), i = n ? t1(e.slice(1), n) : void 0;
  if (i)
    return i;
  if (t.validators.length === 0)
    return;
  const a = e.join(Xp);
  return t.validators.find(({
    validator: o
  }) => o(a))?.classGroupId;
}, xv = /^\[(.+)\]$/, nP = (e) => {
  if (xv.test(e)) {
    const t = xv.exec(e)[1], r = t?.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, iP = (e) => {
  const {
    theme: t,
    prefix: r
  } = e, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return oP(Object.entries(e.classGroups), r).forEach(([a, o]) => {
    _d(o, n, a, t);
  }), n;
}, _d = (e, t, r, n) => {
  e.forEach((i) => {
    if (typeof i == "string") {
      const a = i === "" ? t : wv(t, i);
      a.classGroupId = r;
      return;
    }
    if (typeof i == "function") {
      if (aP(i)) {
        _d(i(n), t, r, n);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: r
      });
      return;
    }
    Object.entries(i).forEach(([a, o]) => {
      _d(o, wv(t, a), r, n);
    });
  });
}, wv = (e, t) => {
  let r = e;
  return t.split(Xp).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}, aP = (e) => e.isThemeGetter, oP = (e, t) => t ? e.map(([r, n]) => {
  const i = n.map((a) => typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(([o, s]) => [t + o, s])) : a);
  return [r, i];
}) : e, sP = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const i = (a, o) => {
    r.set(a, o), t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let o = r.get(a);
      if (o !== void 0)
        return o;
      if ((o = n.get(a)) !== void 0)
        return i(a, o), o;
    },
    set(a, o) {
      r.has(a) ? r.set(a, o) : i(a, o);
    }
  };
}, r1 = "!", uP = (e) => {
  const {
    separator: t,
    experimentalParseClassName: r
  } = e, n = t.length === 1, i = t[0], a = t.length, o = (s) => {
    const u = [];
    let c = 0, l = 0, f;
    for (let p = 0; p < s.length; p++) {
      let g = s[p];
      if (c === 0) {
        if (g === i && (n || s.slice(p, p + a) === t)) {
          u.push(s.slice(l, p)), l = p + a;
          continue;
        }
        if (g === "/") {
          f = p;
          continue;
        }
      }
      g === "[" ? c++ : g === "]" && c--;
    }
    const d = u.length === 0 ? s : s.substring(l), h = d.startsWith(r1), m = h ? d.substring(1) : d, v = f && f > l ? f - l : void 0;
    return {
      modifiers: u,
      hasImportantModifier: h,
      baseClassName: m,
      maybePostfixModifierPosition: v
    };
  };
  return r ? (s) => r({
    className: s,
    parseClassName: o
  }) : o;
}, cP = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let r = [];
  return e.forEach((n) => {
    n[0] === "[" ? (t.push(...r.sort(), n), r = []) : r.push(n);
  }), t.push(...r.sort()), t;
}, lP = (e) => ({
  cache: sP(e.cacheSize),
  parseClassName: uP(e),
  ...rP(e)
}), fP = /\s+/, dP = (e, t) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: i
  } = t, a = [], o = e.trim().split(fP);
  let s = "";
  for (let u = o.length - 1; u >= 0; u -= 1) {
    const c = o[u], {
      modifiers: l,
      hasImportantModifier: f,
      baseClassName: d,
      maybePostfixModifierPosition: h
    } = r(c);
    let m = !!h, v = n(m ? d.substring(0, h) : d);
    if (!v) {
      if (!m) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (v = n(d), !v) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      m = !1;
    }
    const p = cP(l).join(":"), g = f ? p + r1 : p, b = g + v;
    if (a.includes(b))
      continue;
    a.push(b);
    const w = i(v, m);
    for (let O = 0; O < w.length; ++O) {
      const y = w[O];
      a.push(g + y);
    }
    s = c + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function pP() {
  let e = 0, t, r, n = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r = n1(t)) && (n && (n += " "), n += r);
  return n;
}
const n1 = (e) => {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = n1(e[n])) && (r && (r += " "), r += t);
  return r;
};
function hP(e, ...t) {
  let r, n, i, a = o;
  function o(u) {
    const c = t.reduce((l, f) => f(l), e());
    return r = lP(c), n = r.cache.get, i = r.cache.set, a = s, s(u);
  }
  function s(u) {
    const c = n(u);
    if (c)
      return c;
    const l = dP(u, r);
    return i(u, l), l;
  }
  return function() {
    return a(pP.apply(null, arguments));
  };
}
const Pe = (e) => {
  const t = (r) => r[e] || [];
  return t.isThemeGetter = !0, t;
}, i1 = /^\[(?:([a-z-]+):)?(.+)\]$/i, vP = /^\d+\/\d+$/, yP = /* @__PURE__ */ new Set(["px", "full", "screen"]), mP = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, gP = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, bP = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, xP = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, wP = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Wt = (e) => bn(e) || yP.has(e) || vP.test(e), lr = (e) => ni(e, "length", CP), bn = (e) => !!e && !Number.isNaN(Number(e)), fu = (e) => ni(e, "number", bn), hi = (e) => !!e && Number.isInteger(Number(e)), OP = (e) => e.endsWith("%") && bn(e.slice(0, -1)), ce = (e) => i1.test(e), fr = (e) => mP.test(e), _P = /* @__PURE__ */ new Set(["length", "size", "percentage"]), SP = (e) => ni(e, _P, a1), AP = (e) => ni(e, "position", a1), PP = /* @__PURE__ */ new Set(["image", "url"]), TP = (e) => ni(e, PP, jP), EP = (e) => ni(e, "", MP), vi = () => !0, ni = (e, t, r) => {
  const n = i1.exec(e);
  return n ? n[1] ? typeof t == "string" ? n[1] === t : t.has(n[1]) : r(n[2]) : !1;
}, CP = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  gP.test(e) && !bP.test(e)
), a1 = () => !1, MP = (e) => xP.test(e), jP = (e) => wP.test(e), kP = () => {
  const e = Pe("colors"), t = Pe("spacing"), r = Pe("blur"), n = Pe("brightness"), i = Pe("borderColor"), a = Pe("borderRadius"), o = Pe("borderSpacing"), s = Pe("borderWidth"), u = Pe("contrast"), c = Pe("grayscale"), l = Pe("hueRotate"), f = Pe("invert"), d = Pe("gap"), h = Pe("gradientColorStops"), m = Pe("gradientColorStopPositions"), v = Pe("inset"), p = Pe("margin"), g = Pe("opacity"), b = Pe("padding"), w = Pe("saturate"), O = Pe("scale"), y = Pe("sepia"), x = Pe("skew"), _ = Pe("space"), P = Pe("translate"), E = () => ["auto", "contain", "none"], M = () => ["auto", "hidden", "clip", "visible", "scroll"], C = () => ["auto", ce, t], T = () => [ce, t], k = () => ["", Wt, lr], $ = () => ["auto", bn, ce], I = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], R = () => ["solid", "dashed", "dotted", "double", "none"], q = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], W = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], H = () => ["", "0", ce], N = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], L = () => [bn, ce];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [vi],
      spacing: [Wt, lr],
      blur: ["none", "", fr, ce],
      brightness: L(),
      borderColor: [e],
      borderRadius: ["none", "", "full", fr, ce],
      borderSpacing: T(),
      borderWidth: k(),
      contrast: L(),
      grayscale: H(),
      hueRotate: L(),
      invert: H(),
      gap: T(),
      gradientColorStops: [e],
      gradientColorStopPositions: [OP, lr],
      inset: C(),
      margin: C(),
      opacity: L(),
      padding: T(),
      saturate: L(),
      scale: L(),
      sepia: H(),
      skew: L(),
      space: T(),
      translate: T()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", ce]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [fr]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": N()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": N()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...I(), ce]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: M()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": M()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": M()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: E()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": E()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": E()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [v]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [v]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [v]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [v]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [v]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [v]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [v]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [v]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [v]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", hi, ce]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: C()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", ce]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: H()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: H()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", hi, ce]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [vi]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", hi, ce]
        }, ce]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": $()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": $()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [vi]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [hi, ce]
        }, ce]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": $()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": $()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", ce]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", ce]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [d]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [d]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [d]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...W()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...W(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...W(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [b]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [b]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [b]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [b]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [b]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [b]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [b]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [b]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [b]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [p]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [p]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [p]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [p]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [p]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [p]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [p]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [p]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [p]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [_]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [_]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", ce, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [ce, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [ce, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [fr]
        }, fr]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [ce, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [ce, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [ce, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [ce, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", fr, lr]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", fu]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [vi]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", ce]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", bn, fu]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Wt, ce]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", ce]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", ce]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [g]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [g]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...R(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Wt, lr]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Wt, ce]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: T()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", ce]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", ce]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [g]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...I(), AP]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", SP]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, TP]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [m]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [g]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...R(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [g]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: R()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [i]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...R()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Wt, ce]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Wt, lr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: k()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [g]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Wt, lr]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", fr, EP]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [vi]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [g]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...q(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": q()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [u]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", fr, ce]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [l]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [y]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [u]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [l]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [g]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [y]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", ce]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: L()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", ce]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: L()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", ce]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [O]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [O]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [O]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [hi, ce]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [P]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [P]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [x]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [x]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", ce]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", ce]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": T()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": T()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": T()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": T()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": T()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": T()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": T()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": T()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": T()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": T()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": T()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": T()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": T()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": T()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": T()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": T()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": T()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": T()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", ce]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Wt, lr, fu]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, $P = /* @__PURE__ */ hP(kP);
function z(...e) {
  return $P(ue(e));
}
const NP = (e, t) => t.reduce(
  (r, n) => r && typeof r == "object" ? r[n] : void 0,
  e
), Nz = (e, t, r) => {
  const n = Array.isArray(t) ? t : t.replace(/(\w)\[/g, "$1.[").split(".").map((a) => a.includes("[") ? parseInt(a.substring(1, a.length - 1), 10) : a);
  let i = e;
  for (let a = 0; a < n.length; a++) {
    const o = n[a], s = n[a + 1], u = i;
    typeof s < "u" ? u[o] = u[o] ?? (typeof s == "number" || /^\d+$/.test(String(s)) ? [] : {}) : u[o] = r, i = u[o];
  }
  return e;
}, IP = (e, t) => {
  const r = /* @__PURE__ */ new Set();
  return e.filter((n) => {
    const i = t(n);
    return r.has(i) ? !1 : (r.add(i), !0);
  });
}, Iz = (e) => (t, ...r) => (t.preventDefault(), e?.(t, ...r)), Rz = (e) => (t, ...r) => (t.stopPropagation(), e?.(t, ...r));
function RP(e, { rootMargin: t = "100px", threshold: r = 0.1, enabled: n = !0 } = {}) {
  const i = An(null), a = An(e);
  return a.current = e, Aa(() => {
    const o = i.current;
    if (!o || !n) return;
    const s = new IntersectionObserver(
      (u) => {
        const [c] = u;
        c?.isIntersecting && a.current();
      },
      { rootMargin: t, threshold: r }
    );
    return s.observe(o), () => {
      s.unobserve(o), s.disconnect();
    };
  }, [t, r, n]), i;
}
const Ov = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, _v = ue, Zp = (e, t) => (r) => {
  var n;
  if (t?.variants == null) return _v(e, r?.class, r?.className);
  const { variants: i, defaultVariants: a } = t, o = Object.keys(i).map((c) => {
    const l = r?.[c], f = a?.[c];
    if (l === null) return null;
    const d = Ov(l) || Ov(f);
    return i[c][d];
  }), s = r && Object.entries(r).reduce((c, l) => {
    let [f, d] = l;
    return d === void 0 || (c[f] = d), c;
  }, {}), u = t == null || (n = t.compoundVariants) === null || n === void 0 ? void 0 : n.reduce((c, l) => {
    let { class: f, className: d, ...h } = l;
    return Object.entries(h).every((m) => {
      let [v, p] = m;
      return Array.isArray(p) ? p.includes({
        ...a,
        ...s
      }[v]) : {
        ...a,
        ...s
      }[v] === p;
    }) ? [
      ...c,
      f,
      d
    ] : c;
  }, []);
  return _v(e, o, u, r?.class, r?.className);
}, Ta = Zp(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-button text-center text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:opacity-90 shadow",
        destructive: "bg-destructive text-destructive-foreground hover:opacity-90",
        outline: "border border-input bg-background hover:bg-surface hover:text-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:opacity-90",
        ghost: "hover:bg-surface hover:text-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 px-3 text-xs",
        lg: "h-11 px-8",
        icon: "h-10 w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DP = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), o1 = (...e) => e.filter((t, r, n) => !!t && t.trim() !== "" && n.indexOf(t) === r).join(" ").trim();
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var LP = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qP = xs(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: r = 2,
    absoluteStrokeWidth: n,
    className: i = "",
    children: a,
    iconNode: o,
    ...s
  }, u) => Fi(
    "svg",
    {
      ref: u,
      ...LP,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: n ? Number(r) * 24 / Number(t) : r,
      className: o1("lucide", i),
      ...s
    },
    [
      ...o.map(([c, l]) => Fi(c, l)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xt = (e, t) => {
  const r = xs(
    ({ className: n, ...i }, a) => Fi(qP, {
      ref: a,
      iconNode: t,
      className: o1(`lucide-${DP(e)}`, n),
      ...i
    })
  );
  return r.displayName = `${e}`, r;
};
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s1 = xt("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u1 = xt("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BP = xt("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c1 = xt("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FP = xt("ChevronUp", [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zP = xt("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WP = xt("Ellipsis", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UP = xt("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l1 = xt("LoaderCircle", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GP = xt("Loader", [
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m16.2 7.8 2.9-2.9", key: "r700ao" }],
  ["path", { d: "M18 12h4", key: "wj9ykh" }],
  ["path", { d: "m16.2 16.2 2.9 2.9", key: "1bxg5t" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "m4.9 19.1 2.9-2.9", key: "bwix9q" }],
  ["path", { d: "M2 12h4", key: "j09sii" }],
  ["path", { d: "m4.9 4.9 2.9 2.9", key: "giyufr" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HP = xt("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jp = xt("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]), fo = lt.Root, Sv = lt.Trigger, po = lt.Portal, Av = lt.Close, Wi = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  lt.Overlay,
  {
    ref: r,
    className: z(
      "fixed inset-0 z-50 bg-black/60 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
Wi.displayName = lt.Overlay.displayName;
const Ui = V.forwardRef(({ className: e, children: t, showCloseButton: r = !0, ...n }, i) => /* @__PURE__ */ Z(po, { children: [
  /* @__PURE__ */ S(Wi, {}),
  /* @__PURE__ */ Z(
    lt.Content,
    {
      ref: i,
      className: z(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-surface p-6 shadow-lg sm:rounded-lg",
        e
      ),
      ...n,
      children: [
        t,
        r && /* @__PURE__ */ Z(
          lt.Close,
          {
            className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none",
            "aria-label": "Close",
            title: "Close",
            children: [
              /* @__PURE__ */ S(Jp, { className: "h-4 w-4", "aria-hidden": "true" }),
              /* @__PURE__ */ S("span", { className: "sr-only", children: "Close" })
            ]
          }
        )
      ]
    }
  )
] }));
Ui.displayName = lt.Content.displayName;
const ho = ({ className: e, ...t }) => /* @__PURE__ */ S(
  "div",
  {
    className: z("flex flex-col space-y-1.5 text-center sm:text-left", e),
    ...t
  }
);
ho.displayName = "DialogHeader";
const xn = ({ className: e, ...t }) => /* @__PURE__ */ S(
  "div",
  {
    className: z(
      "flex flex-col-reverse gap-2 sm:flex-row sm:justify-end",
      e
    ),
    ...t
  }
);
xn.displayName = "DialogFooter";
const vo = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  lt.Title,
  {
    ref: r,
    className: z("text-lg font-semibold leading-none tracking-tight", e),
    ...t
  }
));
vo.displayName = lt.Title.displayName;
const Sd = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  lt.Description,
  {
    ref: r,
    className: z("text-sm text-muted-foreground", e),
    ...t
  }
));
Sd.displayName = lt.Description.displayName;
const VP = Je.Root, KP = Je.Trigger, f1 = Je.Portal, Qp = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  Je.Overlay,
  {
    className: z(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/80",
      e
    ),
    ...t,
    ref: r
  }
));
Qp.displayName = Je.Overlay.displayName;
const d1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ Z(f1, { children: [
  /* @__PURE__ */ S(Qp, {}),
  /* @__PURE__ */ S(
    Je.Content,
    {
      ref: r,
      className: z(
        "bg-background fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border p-6 shadow-lg duration-200 sm:rounded-lg",
        e
      ),
      ...t
    }
  )
] }));
d1.displayName = Je.Content.displayName;
const YP = ({
  className: e,
  ...t
}) => /* @__PURE__ */ S(
  "div",
  {
    className: z(
      "flex flex-col space-y-2 text-center sm:text-left",
      e
    ),
    ...t
  }
), p1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  Je.Title,
  {
    ref: r,
    className: z("text-lg font-semibold", e),
    ...t
  }
));
p1.displayName = Je.Title.displayName;
const h1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  Je.Description,
  {
    ref: r,
    className: z("text-muted-foreground text-sm", e),
    ...t
  }
));
h1.displayName = Je.Description.displayName;
const v1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  Je.Action,
  {
    ref: r,
    className: z(Ta(), e),
    ...t
  }
));
v1.displayName = Je.Action.displayName;
const y1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  Je.Cancel,
  {
    ref: r,
    className: z(
      Ta({ variant: "outline" }),
      "mt-2 sm:mt-0",
      e
    ),
    ...t
  }
));
y1.displayName = Je.Cancel.displayName;
const m1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  ri.Root,
  {
    ref: r,
    className: z(
      "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full",
      e
    ),
    ...t
  }
));
m1.displayName = ri.Root.displayName;
const g1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  ri.Image,
  {
    ref: r,
    className: z("aspect-square h-full w-full", e),
    ...t
  }
));
g1.displayName = ri.Image.displayName;
const b1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  ri.Fallback,
  {
    ref: r,
    className: z(
      "bg-surface flex h-full w-full items-center justify-center rounded-full",
      e
    ),
    ...t
  }
));
b1.displayName = ri.Fallback.displayName;
const eh = Zp(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive: "border-transparent bg-destructive text-destructive-foreground",
        outline: "text-foreground",
        success: "border-transparent bg-success text-success-foreground",
        warning: "border-transparent bg-warning text-warning-foreground"
      }
    },
    defaultVariants: { variant: "default" }
  }
);
function XP({ className: e, variant: t, ...r }) {
  return /* @__PURE__ */ S("div", { className: z(eh({ variant: t }), e), ...r });
}
const x1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  "div",
  {
    ref: r,
    className: z(
      "bg-surface text-muted-foreground rounded-lg border shadow-sm",
      e
    ),
    ...t
  }
));
x1.displayName = "Card";
const w1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  "div",
  {
    ref: r,
    className: z("flex flex-col space-y-1.5 p-6", e),
    ...t
  }
));
w1.displayName = "CardHeader";
const O1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  "h3",
  {
    ref: r,
    className: z(
      "text-2xl font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
O1.displayName = "CardTitle";
const _1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  "p",
  {
    ref: r,
    className: z("text-muted-foreground text-sm", e),
    ...t
  }
));
_1.displayName = "CardDescription";
const S1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S("div", { ref: r, className: z("p-6 pt-0", e), ...t }));
S1.displayName = "CardContent";
const A1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  "div",
  {
    ref: r,
    className: z("flex items-center p-6 pt-0", e),
    ...t
  }
));
A1.displayName = "CardFooter";
const P1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  wd.Root,
  {
    ref: r,
    className: z(
      "border-primary ring-offset-background focus-visible:ring-ring data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground peer h-4 w-4 shrink-0 rounded-sm border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...t,
    children: /* @__PURE__ */ S(
      wd.Indicator,
      {
        className: z("flex items-center justify-center text-current"),
        children: /* @__PURE__ */ S(s1, { className: "h-4 w-4" })
      }
    )
  }
));
P1.displayName = wd.Root.displayName;
const Tn = ({ children: e }) => /* @__PURE__ */ S("span", { className: "sr-only", children: e }), ZP = (e, t) => {
  if (typeof e == "string" && e.trim())
    return e.trim();
  if (t?.trim()) return t.trim();
}, JP = (e, t) => {
  const r = t.trim().toLowerCase();
  if (!r) return !1;
  const n = (i) => V.Children.toArray(i).some((a) => typeof a == "string" || typeof a == "number" ? String(a).toLowerCase().includes(r) : V.isValidElement(a) ? n(a.props.children) : !1);
  return n(e);
}, Tt = V.forwardRef(
  ({
    loading: e = !1,
    variant: t = "default",
    size: r,
    className: n = "",
    disabled: i = !1,
    action: a,
    title: o = "",
    children: s,
    loadingText: u,
    loadingContent: c,
    spinnerOnlyOnLoading: l = !1,
    compact: f = !1,
    type: d = "button",
    newTab: h = !1,
    onClick: m,
    "aria-label": v,
    ...p
  }, g) => {
    const [b, w] = V.useState(!1), O = e || b, y = ZP(v, o), _ = t === "unstyled" ? n : z(
      Ta({
        variant: t,
        size: r ?? (f ? "sm" : "default")
      }),
      n
    ), P = u ?? c ?? s, E = !O || !l, M = E ? O ? P : s : null, C = y && !JP(M, y) ? y : void 0, T = /* @__PURE__ */ Z(Ct, { children: [
      O && /* @__PURE__ */ S(
        l1,
        {
          className: z("h-4 w-4 animate-spin", E && "mr-2"),
          "aria-hidden": "true"
        }
      ),
      M,
      C ? /* @__PURE__ */ S(Tn, { children: C }) : null
    ] });
    if (typeof a == "string")
      return /* @__PURE__ */ S(
        "a",
        {
          ref: g,
          title: o || void 0,
          "aria-label": y,
          href: a,
          target: h ? "_blank" : void 0,
          rel: h ? "noopener noreferrer" : void 0,
          className: _,
          onClick: (I) => {
            m?.(I), !I.defaultPrevented && (I.stopPropagation(), (i || O) && I.preventDefault());
          },
          ...p,
          children: T
        }
      );
    const k = a;
    return /* @__PURE__ */ S(
      "button",
      {
        ref: g,
        type: d,
        title: o || void 0,
        "aria-label": y,
        disabled: i || O,
        className: _,
        onClick: async ($) => {
          if (m?.($), !($.defaultPrevented || typeof k != "function")) {
            $.stopPropagation(), $.preventDefault(), w(!0);
            try {
              await k();
            } finally {
              w(!1);
            }
          }
        },
        ...p,
        children: T
      }
    );
  }
);
Tt.displayName = "Button";
function Dz({
  icon: e,
  iconSize: t,
  ...r
}) {
  return /* @__PURE__ */ S(Tt, { ...r, children: /* @__PURE__ */ S("span", { "aria-hidden": "true", children: /* @__PURE__ */ S(e, { size: t }) }) });
}
function Lz({ text: e, ...t }) {
  return /* @__PURE__ */ S(Tt, { ...t, children: e });
}
const QP = ({
  actionLabel: e,
  onAction: t,
  cancelLabel: r,
  onCancel: n,
  actionVariant: i = "default",
  disabled: a,
  className: o
}) => /* @__PURE__ */ Z(xn, { className: o, children: [
  r != null && n != null ? /* @__PURE__ */ S(Tt, { variant: "outline", action: n, children: r }) : null,
  /* @__PURE__ */ S(Tt, { variant: i, action: t, disabled: a, children: e })
] }), th = ft.Root, rh = ft.Trigger, eT = ft.Group, tT = ft.Portal, Os = V.forwardRef(({ className: e, sideOffset: t = 4, ...r }, n) => /* @__PURE__ */ S(ft.Portal, { children: /* @__PURE__ */ S(
  ft.Content,
  {
    ref: n,
    sideOffset: t,
    className: z(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md",
      e
    ),
    ...r
  }
) }));
Os.displayName = ft.Content.displayName;
const T1 = V.forwardRef(({ className: e, inset: t, ...r }, n) => /* @__PURE__ */ S(
  ft.Item,
  {
    ref: n,
    className: z(
      "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:size-4 [&_svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...r
  }
));
T1.displayName = ft.Item.displayName;
const E1 = V.forwardRef(({ className: e, inset: t, ...r }, n) => /* @__PURE__ */ S(
  ft.Label,
  {
    ref: n,
    className: z("px-2 py-1.5 text-sm font-semibold", t && "pl-8", e),
    ...r
  }
));
E1.displayName = ft.Label.displayName;
const C1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  ft.Separator,
  {
    ref: r,
    className: z("-mx-1 my-1 h-px bg-border", e),
    ...t
  }
));
C1.displayName = ft.Separator.displayName;
var rT = (e) => e.type === "checkbox", Ei = (e) => e instanceof Date, nh = (e) => e == null;
const M1 = (e) => typeof e == "object";
var Gr = (e) => !nh(e) && !Array.isArray(e) && M1(e) && !Ei(e), nT = (e) => Gr(e) && e.target ? rT(e.target) ? e.target.checked : e.target.value : e, iT = (e, t) => t.split(".").some((r, n, i) => !isNaN(Number(r)) && e.has(i.slice(0, n).join("."))), aT = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Gr(t) && t.hasOwnProperty("isPrototypeOf");
}, oT = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function j1(e) {
  if (e instanceof Date)
    return new Date(e);
  const t = typeof FileList < "u" && e instanceof FileList;
  if (oT && (e instanceof Blob || t))
    return e;
  const r = Array.isArray(e);
  if (!r && !(Gr(e) && aT(e)))
    return e;
  const n = r ? [] : Object.create(Object.getPrototypeOf(e));
  for (const i in e)
    Object.prototype.hasOwnProperty.call(e, i) && (n[i] = j1(e[i]));
  return n;
}
var k1 = (e) => /^\w*$/.test(e), Ad = (e) => e === void 0, sT = (e) => Array.isArray(e) ? e.filter(Boolean) : [], $1 = (e) => sT(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Qe = (e, t, r) => {
  if (!t || !Gr(e))
    return r;
  const i = (k1(t) ? [t] : $1(t)).reduce((a, o) => nh(a) ? void 0 : a[o], e);
  return Ad(i) || i === e ? Ad(e[t]) ? r : e[t] : i;
}, du = (e) => typeof e == "boolean", qa = (e) => typeof e == "function", Pv = (e, t, r) => {
  let n = -1;
  const i = k1(t) ? [t] : $1(t), a = i.length, o = a - 1;
  for (; ++n < a; ) {
    const s = i[n];
    let u = r;
    if (n !== o) {
      const c = e[s];
      u = Gr(c) || Array.isArray(c) ? c : isNaN(+i[n + 1]) ? {} : [];
    }
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    e[s] = u, e = e[s];
  }
};
const Tv = {
  BLUR: "blur",
  CHANGE: "change"
}, Ev = {
  all: "all"
}, ih = A.createContext(null);
ih.displayName = "HookFormControlContext";
const ah = () => A.useContext(ih);
var uT = (e, t, r, n = !0) => {
  const i = {
    defaultValues: t._defaultValues
  };
  for (const a in e)
    Object.defineProperty(i, a, {
      get: () => {
        const o = a;
        return t._proxyFormState[o] !== Ev.all && (t._proxyFormState[o] = !n || Ev.all), r && (r[o] = !0), e[o];
      }
    });
  return i;
};
const N1 = typeof window < "u" ? A.useLayoutEffect : A.useEffect;
function cT(e) {
  const t = ah(), { control: r = t, disabled: n, name: i, exact: a } = e || {}, [o, s] = A.useState(r._formState), u = A.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  });
  return N1(() => r._subscribe({
    name: i,
    formState: u.current,
    exact: a,
    callback: (c) => {
      !n && s({
        ...r._formState,
        ...c
      });
    }
  }), [i, n, a]), A.useEffect(() => {
    u.current.isValid && r._setValid(!0);
  }, [r]), A.useMemo(() => uT(o, r, u.current, !1), [o, r]);
}
var lT = (e) => typeof e == "string", Cv = (e, t, r, n, i) => lT(e) ? Qe(r, e, i) : Array.isArray(e) ? e.map((a) => Qe(r, a)) : r, Mv = (e) => nh(e) || !M1(e);
function co(e, t, r = /* @__PURE__ */ new WeakSet()) {
  if (e === t)
    return !0;
  if (Mv(e) || Mv(t))
    return Object.is(e, t);
  if (Ei(e) && Ei(t))
    return Object.is(e.getTime(), t.getTime());
  const n = Object.keys(e), i = Object.keys(t);
  if (n.length !== i.length)
    return !1;
  if (r.has(e) || r.has(t))
    return !0;
  r.add(e), r.add(t);
  for (const a of n) {
    const o = e[a];
    if (!(a in t))
      return !1;
    if (a !== "ref") {
      const s = t[a];
      if (Ei(o) && Ei(s) || (Gr(o) || Array.isArray(o)) && (Gr(s) || Array.isArray(s)) ? !co(o, s, r) : !Object.is(o, s))
        return !1;
    }
  }
  return !0;
}
function fT(e) {
  const t = ah(), { control: r = t, name: n, defaultValue: i, disabled: a, exact: o, compute: s } = e || {}, u = A.useRef(i), c = A.useRef(s), l = A.useRef(void 0), f = A.useRef(r), d = A.useRef(n);
  c.current = s;
  const [h, m] = A.useState(() => {
    const O = r._getWatch(n, u.current);
    return c.current ? c.current(O) : O;
  }), v = A.useCallback((O) => {
    const y = Cv(n, r._names, O || r._formValues, !1, u.current);
    return c.current ? c.current(y) : y;
  }, [r._formValues, r._names, n]), p = A.useCallback((O) => {
    if (!a) {
      const y = Cv(n, r._names, O || r._formValues, !1, u.current);
      if (c.current) {
        const x = c.current(y);
        co(x, l.current) || (m(x), l.current = x);
      } else
        m(y);
    }
  }, [r._formValues, r._names, a, n]);
  N1(() => ((f.current !== r || !co(d.current, n)) && (f.current = r, d.current = n, p()), r._subscribe({
    name: n,
    formState: {
      values: !0
    },
    exact: o,
    callback: (O) => {
      p(O.values);
    }
  })), [r, o, n, p]), A.useEffect(() => r._removeUnmounted());
  const g = f.current !== r, b = d.current, w = A.useMemo(() => {
    if (a)
      return null;
    const O = !g && !co(b, n);
    return g || O ? v() : null;
  }, [a, g, n, b, v]);
  return w !== null ? w : h;
}
function dT(e) {
  const t = ah(), { name: r, disabled: n, control: i = t, shouldUnregister: a, defaultValue: o, exact: s = !0 } = e, u = iT(i._names.array, r), c = A.useMemo(() => Qe(i._formValues, r, Qe(i._defaultValues, r, o)), [i, r, o]), l = fT({
    control: i,
    name: r,
    defaultValue: c,
    exact: s
  }), f = cT({
    control: i,
    name: r,
    exact: s
  }), d = A.useRef(e), h = A.useRef(void 0), m = A.useRef(i.register(r, {
    ...e.rules,
    value: l,
    ...du(e.disabled) ? { disabled: e.disabled } : {}
  }));
  d.current = e;
  const v = A.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Qe(f.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Qe(f.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Qe(f.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Qe(f.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Qe(f.errors, r)
    }
  }), [f, r]), p = A.useCallback((O) => m.current.onChange({
    target: {
      value: nT(O),
      name: r
    },
    type: Tv.CHANGE
  }), [r]), g = A.useCallback(() => m.current.onBlur({
    target: {
      value: Qe(i._formValues, r),
      name: r
    },
    type: Tv.BLUR
  }), [r, i._formValues]), b = A.useCallback((O) => {
    const y = Qe(i._fields, r);
    y && y._f && O && (y._f.ref = {
      focus: () => qa(O.focus) && O.focus(),
      select: () => qa(O.select) && O.select(),
      setCustomValidity: (x) => qa(O.setCustomValidity) && O.setCustomValidity(x),
      reportValidity: () => qa(O.reportValidity) && O.reportValidity()
    });
  }, [i._fields, r]), w = A.useMemo(() => ({
    name: r,
    value: l,
    ...du(n) || f.disabled ? { disabled: f.disabled || n } : {},
    onChange: p,
    onBlur: g,
    ref: b
  }), [r, n, f.disabled, p, g, b, l]);
  return A.useEffect(() => {
    const O = i._options.shouldUnregister || a, y = h.current;
    y && y !== r && !u && i.unregister(y), i.register(r, {
      ...d.current.rules,
      ...du(d.current.disabled) ? { disabled: d.current.disabled } : {}
    });
    const x = (_, P) => {
      const E = Qe(i._fields, _);
      E && E._f && (E._f.mount = P);
    };
    if (x(r, !0), O) {
      const _ = j1(Qe(i._options.defaultValues, r, d.current.defaultValue));
      Pv(i._defaultValues, r, _), Ad(Qe(i._formValues, r)) && Pv(i._formValues, r, _);
    }
    return !u && i.register(r), h.current = r, () => {
      (u ? O && !i._state.action : O) ? i.unregister(r) : x(r, !1);
    };
  }, [r, i, u, a]), A.useEffect(() => {
    i._setDisabledField({
      disabled: n,
      name: r
    });
  }, [n, r, i]), A.useMemo(() => ({
    field: w,
    formState: f,
    fieldState: v
  }), [w, f, v]);
}
const pT = (e) => e.render(dT(e)), oh = A.createContext(null);
oh.displayName = "HookFormContext";
const hT = () => A.useContext(oh), vT = (e) => {
  const { children: t, watch: r, getValues: n, getFieldState: i, setError: a, clearErrors: o, setValue: s, trigger: u, formState: c, resetField: l, reset: f, handleSubmit: d, unregister: h, control: m, register: v, setFocus: p, subscribe: g } = e, b = A.useMemo(() => ({
    watch: r,
    getValues: n,
    getFieldState: i,
    setError: a,
    clearErrors: o,
    setValue: s,
    trigger: u,
    formState: c,
    resetField: l,
    reset: f,
    handleSubmit: d,
    unregister: h,
    control: m,
    register: v,
    setFocus: p,
    subscribe: g
  }), [
    o,
    m,
    c,
    i,
    n,
    d,
    v,
    f,
    l,
    a,
    p,
    s,
    g,
    u,
    h,
    r
  ]);
  return A.createElement(
    oh.Provider,
    { value: b },
    A.createElement(ih.Provider, { value: b.control }, t)
  );
}, yT = Zp(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), sh = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(Jw.Root, { ref: r, className: z(yT(), e), ...t }));
sh.displayName = Jw.Root.displayName;
const mT = vT, I1 = V.createContext(
  {}
), gT = ({
  ...e
}) => /* @__PURE__ */ S(I1.Provider, { value: { name: e.name }, children: /* @__PURE__ */ S(pT, { ...e }) }), R1 = V.createContext(
  {}
), Ea = () => {
  const e = V.useContext(I1), t = V.useContext(R1), { getFieldState: r, formState: n } = hT(), i = r(e.name, n);
  if (!e?.name)
    throw new Error("useFormField should be used within <FormField>");
  const { id: a } = t;
  return {
    id: a,
    name: e.name,
    formItemId: `${a}-form-item`,
    formDescriptionId: `${a}-form-item-description`,
    formMessageId: `${a}-form-item-message`,
    ...i
  };
}, D1 = V.forwardRef(({ className: e, ...t }, r) => {
  const n = V.useId();
  return /* @__PURE__ */ S(R1.Provider, { value: { id: n }, children: /* @__PURE__ */ S("div", { ref: r, className: z("space-y-2", e), ...t }) });
});
D1.displayName = "FormItem";
const L1 = V.forwardRef(({ className: e, ...t }, r) => {
  const { error: n, formItemId: i } = Ea();
  return /* @__PURE__ */ S(
    sh,
    {
      ref: r,
      className: z(n && "text-destructive", e),
      htmlFor: i,
      ...t
    }
  );
});
L1.displayName = "FormLabel";
const q1 = V.forwardRef(({ ...e }, t) => {
  const { error: r, formItemId: n, formDescriptionId: i, formMessageId: a } = Ea();
  return /* @__PURE__ */ S(
    tP,
    {
      ref: t,
      id: n,
      "aria-describedby": r ? `${i} ${a}` : i,
      "aria-invalid": !!r,
      ...e
    }
  );
});
q1.displayName = "FormControl";
const B1 = V.forwardRef(({ className: e, ...t }, r) => {
  const { formDescriptionId: n } = Ea();
  return /* @__PURE__ */ S(
    "p",
    {
      ref: r,
      id: n,
      className: z("text-muted-foreground text-sm", e),
      ...t
    }
  );
});
B1.displayName = "FormDescription";
const F1 = V.forwardRef(({ className: e, children: t, ...r }, n) => {
  const { error: i, formMessageId: a } = Ea(), o = i ? String(i.message ?? "") : t;
  return o ? /* @__PURE__ */ S(
    "p",
    {
      ref: n,
      id: a,
      className: z("text-destructive text-sm font-medium", e),
      ...r,
      children: o
    }
  ) : null;
});
F1.displayName = "FormMessage";
const uh = V.forwardRef(
  ({ className: e, type: t, error: r, ...n }, i) => /* @__PURE__ */ S(
    "input",
    {
      type: t,
      ref: i,
      className: z(
        t === "checkbox" ? "size-5 shrink-0 cursor-pointer rounded-sm border-2 border-primary bg-background accent-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" : "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 file:border-0 file:bg-transparent file:text-sm file:font-medium md:text-sm",
        r && "border-error focus-visible:ring-error",
        e
      ),
      ...n
    }
  )
);
uh.displayName = "Input";
const z1 = Pn.Root, W1 = Pn.Trigger, bT = Pn.Anchor, ch = V.forwardRef(({ className: e, align: t = "center", sideOffset: r = 4, ...n }, i) => /* @__PURE__ */ S(Pn.Portal, { children: /* @__PURE__ */ S(
  Pn.Content,
  {
    ref: i,
    align: t,
    sideOffset: r,
    className: z(
      "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none",
      e
    ),
    ...n
  }
) }));
ch.displayName = Pn.Content.displayName;
const U1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(zi.Root, { className: z("grid gap-2", e), ref: r, ...t }));
U1.displayName = zi.Root.displayName;
const G1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  zi.Item,
  {
    ref: r,
    className: z(
      "aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...t,
    children: /* @__PURE__ */ S(zi.Indicator, { className: "flex items-center justify-center", children: /* @__PURE__ */ S(zP, { className: "h-2.5 w-2.5 fill-current text-current" }) })
  }
));
G1.displayName = zi.Item.displayName;
const H1 = V.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ Z(Fr.Root, { ref: n, className: z("relative overflow-hidden", e), ...r, children: [
  /* @__PURE__ */ S(Fr.Viewport, { className: "h-full w-full rounded-[inherit]", children: t }),
  /* @__PURE__ */ S(lh, {}),
  /* @__PURE__ */ S(Fr.Corner, {})
] }));
H1.displayName = Fr.Root.displayName;
const lh = V.forwardRef(({ className: e, orientation: t = "vertical", ...r }, n) => /* @__PURE__ */ S(
  Fr.ScrollAreaScrollbar,
  {
    ref: n,
    orientation: t,
    className: z(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      e
    ),
    ...r,
    children: /* @__PURE__ */ S(Fr.ScrollAreaThumb, { className: "relative flex-1 rounded-full bg-border" })
  }
));
lh.displayName = Fr.ScrollAreaScrollbar.displayName;
const xT = rt.Root, wT = rt.Value, OT = rt.Group, V1 = V.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ Z(
  rt.Trigger,
  {
    ref: n,
    className: z(
      "border-input bg-background ring-offset-background placeholder:text-muted-foreground focus:ring-ring flex h-10 w-full items-center justify-between rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
      e
    ),
    ...r,
    children: [
      t,
      /* @__PURE__ */ S(rt.Icon, { asChild: !0, children: /* @__PURE__ */ S(u1, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
));
V1.displayName = rt.Trigger.displayName;
const K1 = V.forwardRef(({ className: e, children: t, position: r = "popper", ...n }, i) => /* @__PURE__ */ S(rt.Portal, { children: /* @__PURE__ */ S(
  rt.Content,
  {
    ref: i,
    className: z(
      "bg-popover text-popover-foreground relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border shadow-md",
      r === "popper" && "data-[side=bottom]:translate-y-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: r,
    ...n,
    children: /* @__PURE__ */ S(
      rt.Viewport,
      {
        className: z(
          "p-1",
          r === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
        ),
        children: t
      }
    )
  }
) }));
K1.displayName = rt.Content.displayName;
const Y1 = V.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ Z(
  rt.Item,
  {
    ref: n,
    className: z(
      "focus:bg-accent focus:text-accent-foreground relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...r,
    children: [
      /* @__PURE__ */ S("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ S(rt.ItemIndicator, { children: /* @__PURE__ */ S(s1, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ S(rt.ItemText, { children: t })
    ]
  }
));
Y1.displayName = rt.Item.displayName;
const X1 = V.forwardRef(({ className: e, orientation: t = "horizontal", decorative: r = !0, ...n }, i) => /* @__PURE__ */ S(
  Qw.Root,
  {
    ref: i,
    decorative: r,
    orientation: t,
    className: z(
      "shrink-0 bg-border",
      t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
      e
    ),
    ...n
  }
));
X1.displayName = Qw.Root.displayName;
function _T({ className: e, ...t }) {
  return /* @__PURE__ */ S("div", { className: z("animate-pulse rounded-md bg-surface", e), ...t });
}
const Z1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  Od.Root,
  {
    className: z(
      "focus-visible:ring-ring focus-visible:ring-offset-background data-[state=checked]:bg-primary data-[state=unchecked]:bg-input peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...t,
    ref: r,
    children: /* @__PURE__ */ S(
      Od.Thumb,
      {
        className: z(
          "bg-background pointer-events-none block h-5 w-5 rounded-full shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
        )
      }
    )
  }
));
Z1.displayName = Od.Root.displayName;
const J1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ S("table", { ref: r, className: z("w-full caption-bottom text-sm", e), ...t }) }));
J1.displayName = "TableRoot";
const Q1 = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S("thead", { ref: r, className: z("[&_tr]:border-b", e), ...t }));
Q1.displayName = "TableHeader";
const eO = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S("tbody", { ref: r, className: z("[&_tr:last-child]:border-0", e), ...t }));
eO.displayName = "TableBody";
const tO = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  "tr",
  {
    ref: r,
    className: z(
      "border-b transition-colors hover:bg-surface/50 data-[state=selected]:bg-surface",
      e
    ),
    ...t
  }
));
tO.displayName = "TableRow";
const rO = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  "th",
  {
    ref: r,
    className: z(
      "h-12 px-4 text-left align-middle font-medium text-muted-foreground",
      e
    ),
    ...t
  }
));
rO.displayName = "TableHead";
const nO = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S("td", { ref: r, className: z("p-4 align-middle", e), ...t }));
nO.displayName = "TableCell";
const ST = Qr.Root, iO = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  Qr.List,
  {
    ref: r,
    className: z(
      "bg-surface text-muted-foreground inline-flex h-10 items-center justify-center rounded-md p-1",
      e
    ),
    ...t
  }
));
iO.displayName = Qr.List.displayName;
const aO = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  Qr.Trigger,
  {
    ref: r,
    className: z(
      "ring-offset-background focus-visible:ring-ring data-[state=active]:bg-background data-[state=active]:text-foreground inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:shadow-sm",
      e
    ),
    ...t
  }
));
aO.displayName = Qr.Trigger.displayName;
const oO = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  Qr.Content,
  {
    ref: r,
    className: z(
      "ring-offset-background focus-visible:ring-ring mt-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
      e
    ),
    ...t
  }
));
oO.displayName = Qr.Content.displayName;
const sO = V.forwardRef(
  ({ className: e, error: t, ...r }, n) => /* @__PURE__ */ S(
    "textarea",
    {
      ref: n,
      className: z(
        "flex min-h-[80px] w-full rounded-md border border-input bg-background p-[3px] text-base placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-muted-foreground focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        t && "border-error focus-visible:ring-error",
        e
      ),
      ...r
    }
  )
);
sO.displayName = "Textarea";
const uO = Pa.Provider, cO = Pa.Root, lO = Pa.Trigger, fh = V.forwardRef(({ className: e, sideOffset: t = 4, ...r }, n) => /* @__PURE__ */ S(
  Pa.Content,
  {
    ref: n,
    sideOffset: t,
    className: z(
      "z-50 overflow-hidden rounded-md bg-foreground px-3 py-1.5 text-xs text-background shadow-md",
      e
    ),
    ...r
  }
));
fh.displayName = Pa.Content.displayName;
const _s = V.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  "span",
  {
    role: "status",
    "aria-label": "Loading",
    className: z(
      // after:border-b-primary must follow after:border-transparent.
      // twMerge drops the accent if the pair is reversed, and Prettier's
      // Tailwind plugin sorts `border-b-*` before `border-transparent`.
      "border-foreground relative box-border inline-block h-12 w-12 animate-spin rounded-full border-[3px] after:absolute after:left-1/2 after:top-1/2 after:box-border after:h-10 after:w-10 after:-translate-x-1/2 after:-translate-y-1/2 after:rounded-full after:border-[3px] after:border-transparent after:content-['']",
      "after:border-b-primary",
      e
    ),
    ref: r,
    ...t
  }
));
_s.displayName = "LoadingSpinner";
const qz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AlertDialog: VP,
  AlertDialogAction: v1,
  AlertDialogCancel: y1,
  AlertDialogContent: d1,
  AlertDialogDescription: h1,
  AlertDialogFooter: xn,
  AlertDialogHeader: YP,
  AlertDialogOverlay: Qp,
  AlertDialogPortal: f1,
  AlertDialogTitle: p1,
  AlertDialogTrigger: KP,
  Avatar: m1,
  AvatarFallback: b1,
  AvatarImage: g1,
  Card: x1,
  CardContent: S1,
  CardDescription: _1,
  CardFooter: A1,
  CardHeader: w1,
  CardTitle: O1,
  Checkbox: P1,
  Dialog: fo,
  DialogActions: QP,
  DialogClose: Av,
  DialogContent: Ui,
  DialogDescription: Sd,
  DialogFooter: xn,
  DialogHeader: ho,
  DialogOverlay: Wi,
  DialogPortal: po,
  DialogTitle: vo,
  DialogTrigger: Sv,
  DropdownMenu: th,
  DropdownMenuContent: Os,
  DropdownMenuGroup: eT,
  DropdownMenuItem: T1,
  DropdownMenuLabel: E1,
  DropdownMenuPortal: tT,
  DropdownMenuSeparator: C1,
  DropdownMenuTrigger: rh,
  Form: mT,
  FormControl: q1,
  FormDescription: B1,
  FormField: gT,
  FormItem: D1,
  FormLabel: L1,
  FormMessage: F1,
  Input: uh,
  Label: sh,
  LoadingSpinner: _s,
  Popover: z1,
  PopoverAnchor: bT,
  PopoverContent: ch,
  PopoverTrigger: W1,
  RadioGroup: U1,
  RadioGroupItem: G1,
  ScrollArea: H1,
  ScrollBar: lh,
  Select: xT,
  SelectContent: K1,
  SelectGroup: OT,
  SelectItem: Y1,
  SelectTrigger: V1,
  SelectValue: wT,
  Separator: X1,
  ShadcnBadge: XP,
  Sheet: fo,
  SheetClose: Av,
  SheetContent: Ui,
  SheetDescription: Sd,
  SheetFooter: xn,
  SheetHeader: ho,
  SheetOverlay: Wi,
  SheetPortal: po,
  SheetTitle: vo,
  SheetTrigger: Sv,
  Skeleton: _T,
  Switch: Z1,
  TableBody: eO,
  TableCell: nO,
  TableHead: rO,
  TableHeader: Q1,
  TableRoot: J1,
  TableRow: tO,
  Tabs: ST,
  TabsContent: oO,
  TabsList: iO,
  TabsTrigger: aO,
  Textarea: sO,
  TooltipContent: fh,
  TooltipProvider: uO,
  TooltipRoot: cO,
  TooltipTrigger: lO,
  badgeVariants: eh,
  useFormField: Ea
}, Symbol.toStringTag, { value: "Module" })), AT = ({
  status: e,
  variant: t = "default",
  className: r
}) => /* @__PURE__ */ S("span", { className: z(eh({ variant: t }), "op-badge", r), children: e }), Bz = ({ data: e }) => /* @__PURE__ */ S("div", { className: "flex flex-wrap gap-1", children: e.map(({ status: t, variant: r }, n) => /* @__PURE__ */ S(AT, { status: t, variant: r }, n)) }), PT = (e) => {
  const t = /* @__PURE__ */ new Date(), r = e instanceof Date ? e : new Date(e), n = t.getTime() - r.getTime();
  return n < -60 * 60 * 1e3 ? `on ${r.toLocaleDateString()} at ${r.toLocaleTimeString()}` : n < -60 * 1e3 ? `in ${Math.abs(Math.floor(n / 6e4))} minutes ` : n < 60 * 1e3 ? "now" : n < 60 * 60 * 1e3 ? `${Math.floor(n / 6e4)}m ago` : `${r.toLocaleDateString()} ${r.toLocaleTimeString()}`;
}, TT = (e) => {
  const t = Math.floor(e / 1e3), r = Math.floor(t / 3600), n = Math.floor(t % 3600 / 60), i = t % 60;
  return `${r.toString().padStart(2, "0")}:${n.toString().padStart(2, "0")}:${i.toString().padStart(2, "0")}`;
};
function Fz({
  date: e,
  formatter: t = PT,
  intervalMs: r = 6e4
}) {
  const [n, i] = V.useState(() => t(e));
  return V.useEffect(() => {
    i(t(e));
    const a = setInterval(() => {
      i(t(e));
    }, r);
    return () => clearInterval(a);
  }, [e, t, r]), /* @__PURE__ */ S(Ct, { children: n });
}
function zz({
  start: e,
  formatter: t = TT,
  intervalMs: r = 1e3
}) {
  const [n, i] = V.useState(
    () => t(Date.now() - new Date(e).getTime())
  );
  return V.useEffect(() => {
    i(t(Date.now() - new Date(e).getTime()));
    const a = setInterval(() => {
      i(t(Date.now() - new Date(e).getTime()));
    }, r);
    return () => clearInterval(a);
  }, [e, t, r]), /* @__PURE__ */ S(Ct, { children: n });
}
function Wz({ start: e, end: t, timeZone: r, truncate: n }) {
  const i = V.useMemo(
    () => typeof window < "u" ? Intl.DateTimeFormat().resolvedOptions().timeZone : "UTC",
    []
  ), a = r || i, o = new Date(e), s = t ? new Date(t) : void 0, u = o.toLocaleDateString(void 0, {
    timeZone: a,
    dateStyle: "full"
  }), c = o.toLocaleTimeString(void 0, {
    timeZone: a,
    timeStyle: "short"
  }), l = s?.toLocaleDateString(void 0, {
    timeZone: a,
    dateStyle: "full"
  }), f = s?.toLocaleTimeString(void 0, {
    timeZone: a,
    timeStyle: "short"
  }), h = l ? l && u === l ? `${u}, ${c} - ${f}` : `${u}, ${c} - ${l}, ${f}` : `${u}, ${c}`;
  return /* @__PURE__ */ S(Ct, { children: n ? `${h.substring(0, n)}...` : h });
}
function Uz({
  title: e,
  children: t,
  initialOpen: r = !1
}) {
  const [n, i] = V.useState(r), a = typeof e == "string" ? `${n ? "Collapse" : "Expand"} ${e}` : n ? "Collapse" : "Expand";
  return /* @__PURE__ */ Z("div", { className: "flex items-start gap-2", children: [
    /* @__PURE__ */ Z(
      "button",
      {
        type: "button",
        className: "w-4",
        onClick: () => i((o) => !o),
        "aria-expanded": n,
        "aria-label": a,
        title: a,
        children: [
          n ? /* @__PURE__ */ S(u1, { "aria-hidden": "true" }) : /* @__PURE__ */ S(c1, { "aria-hidden": "true" }),
          /* @__PURE__ */ S("span", { className: "sr-only", children: a })
        ]
      }
    ),
    /* @__PURE__ */ Z("div", { className: "flex-grow", children: [
      /* @__PURE__ */ S("div", { children: e }),
      n && /* @__PURE__ */ S("div", { children: t })
    ] })
  ] });
}
const ET = (e, t) => {
  if (!t) return "";
  switch (e.severity) {
    case "error":
      return "text-destructive";
    case "warning":
      return "text-warning";
    case "info":
      return "";
  }
};
function CT({
  title: e = "",
  messages: t = [],
  classes: r,
  description: n = "",
  forCheckbox: i = !1,
  inline: a = !1,
  dirty: o = !1,
  required: s = !1,
  htmlFor: u,
  children: c
}) {
  return /* @__PURE__ */ Z(
    "label",
    {
      htmlFor: u,
      className: z(
        "flex",
        a ? "flex-row items-center gap-2" : "flex-col",
        r
      ),
      children: [
        e && /* @__PURE__ */ Z("span", { children: [
          e,
          s && /* @__PURE__ */ S("span", { className: z(o && "text-destructive"), children: "*" })
        ] }),
        /* @__PURE__ */ Z(
          "span",
          {
            className: z(
              "flex flex-grow",
              i ? "items-center gap-2" : "flex-col"
            ),
            children: [
              n && /* @__PURE__ */ S("span", { className: "text-sm", children: n }),
              c
            ]
          }
        ),
        t.map((l, f) => /* @__PURE__ */ Z(
          "span",
          {
            className: z("flex items-center gap-2", ET(l, o)),
            children: [
              /* @__PURE__ */ S(UP, { className: "size-4" }),
              l.text
            ]
          },
          f
        ))
      ]
    }
  );
}
/**
 * uuidv7: A JavaScript implementation of UUID version 7
 *
 * Copyright 2021-2024 LiosK
 *
 * @license Apache-2.0
 * @packageDocumentation
 */
const Ba = "0123456789abcdef";
class Nr {
  /** @param bytes - The 16-byte byte array representation. */
  constructor(t) {
    this.bytes = t;
  }
  /**
   * Creates an object from the internal representation, a 16-byte byte array
   * containing the binary UUID representation in the big-endian byte order.
   *
   * This method does NOT shallow-copy the argument, and thus the created object
   * holds the reference to the underlying buffer.
   *
   * @throws TypeError if the length of the argument is not 16.
   */
  static ofInner(t) {
    if (t.length !== 16)
      throw new TypeError("not 128-bit length");
    return new Nr(t);
  }
  /**
   * Builds a byte array from UUIDv7 field values.
   *
   * @param unixTsMs - A 48-bit `unix_ts_ms` field value.
   * @param randA - A 12-bit `rand_a` field value.
   * @param randBHi - The higher 30 bits of 62-bit `rand_b` field value.
   * @param randBLo - The lower 32 bits of 62-bit `rand_b` field value.
   * @throws RangeError if any field value is out of the specified range.
   */
  static fromFieldsV7(t, r, n, i) {
    if (!Number.isInteger(t) || !Number.isInteger(r) || !Number.isInteger(n) || !Number.isInteger(i) || t < 0 || r < 0 || n < 0 || i < 0 || t > 281474976710655 || r > 4095 || n > 1073741823 || i > 4294967295)
      throw new RangeError("invalid field value");
    const a = new Uint8Array(16);
    return a[0] = t / 2 ** 40, a[1] = t / 2 ** 32, a[2] = t / 2 ** 24, a[3] = t / 2 ** 16, a[4] = t / 2 ** 8, a[5] = t, a[6] = 112 | r >>> 8, a[7] = r, a[8] = 128 | n >>> 24, a[9] = n >>> 16, a[10] = n >>> 8, a[11] = n, a[12] = i >>> 24, a[13] = i >>> 16, a[14] = i >>> 8, a[15] = i, new Nr(a);
  }
  /**
   * Builds a byte array from a string representation.
   *
   * This method accepts the following formats:
   *
   * - 32-digit hexadecimal format without hyphens: `0189dcd553117d408db09496a2eef37b`
   * - 8-4-4-4-12 hyphenated format: `0189dcd5-5311-7d40-8db0-9496a2eef37b`
   * - Hyphenated format with surrounding braces: `{0189dcd5-5311-7d40-8db0-9496a2eef37b}`
   * - RFC 9562 URN format: `urn:uuid:0189dcd5-5311-7d40-8db0-9496a2eef37b`
   *
   * Leading and trailing whitespaces represents an error.
   *
   * @throws SyntaxError if the argument could not parse as a valid UUID string.
   */
  static parse(t) {
    var r, n, i, a;
    let o;
    switch (t.length) {
      case 32:
        o = (r = /^[0-9a-f]{32}$/i.exec(t)) === null || r === void 0 ? void 0 : r[0];
        break;
      case 36:
        o = (n = /^([0-9a-f]{8})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{12})$/i.exec(t)) === null || n === void 0 ? void 0 : n.slice(1, 6).join("");
        break;
      case 38:
        o = (i = /^\{([0-9a-f]{8})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{12})\}$/i.exec(t)) === null || i === void 0 ? void 0 : i.slice(1, 6).join("");
        break;
      case 45:
        o = (a = /^urn:uuid:([0-9a-f]{8})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{12})$/i.exec(t)) === null || a === void 0 ? void 0 : a.slice(1, 6).join("");
        break;
    }
    if (o) {
      const s = new Uint8Array(16);
      for (let u = 0; u < 16; u += 4) {
        const c = parseInt(o.substring(2 * u, 2 * u + 8), 16);
        s[u + 0] = c >>> 24, s[u + 1] = c >>> 16, s[u + 2] = c >>> 8, s[u + 3] = c;
      }
      return new Nr(s);
    } else
      throw new SyntaxError("could not parse UUID string");
  }
  /**
   * @returns The 8-4-4-4-12 canonical hexadecimal string representation
   * (`0189dcd5-5311-7d40-8db0-9496a2eef37b`).
   */
  toString() {
    let t = "";
    for (let r = 0; r < this.bytes.length; r++)
      t += Ba.charAt(this.bytes[r] >>> 4), t += Ba.charAt(this.bytes[r] & 15), (r === 3 || r === 5 || r === 7 || r === 9) && (t += "-");
    return t;
  }
  /**
   * @returns The 32-digit hexadecimal representation without hyphens
   * (`0189dcd553117d408db09496a2eef37b`).
   */
  toHex() {
    let t = "";
    for (let r = 0; r < this.bytes.length; r++)
      t += Ba.charAt(this.bytes[r] >>> 4), t += Ba.charAt(this.bytes[r] & 15);
    return t;
  }
  /** @returns The 8-4-4-4-12 canonical hexadecimal string representation. */
  toJSON() {
    return this.toString();
  }
  /**
   * Reports the variant field value of the UUID or, if appropriate, "NIL" or
   * "MAX".
   *
   * For convenience, this method reports "NIL" or "MAX" if `this` represents
   * the Nil or Max UUID, although the Nil and Max UUIDs are technically
   * subsumed under the variants `0b0` and `0b111`, respectively.
   */
  getVariant() {
    const t = this.bytes[8] >>> 4;
    if (t < 0)
      throw new Error("unreachable");
    if (t <= 7)
      return this.bytes.every((r) => r === 0) ? "NIL" : "VAR_0";
    if (t <= 11)
      return "VAR_10";
    if (t <= 13)
      return "VAR_110";
    if (t <= 15)
      return this.bytes.every((r) => r === 255) ? "MAX" : "VAR_RESERVED";
    throw new Error("unreachable");
  }
  /**
   * Returns the version field value of the UUID or `undefined` if the UUID does
   * not have the variant field value of `0b10`.
   */
  getVersion() {
    return this.getVariant() === "VAR_10" ? this.bytes[6] >>> 4 : void 0;
  }
  /** Creates an object from `this`. */
  clone() {
    return new Nr(this.bytes.slice(0));
  }
  /** Returns true if `this` is equivalent to `other`. */
  equals(t) {
    return this.compareTo(t) === 0;
  }
  /**
   * Returns a negative integer, zero, or positive integer if `this` is less
   * than, equal to, or greater than `other`, respectively.
   */
  compareTo(t) {
    for (let r = 0; r < 16; r++) {
      const n = this.bytes[r] - t.bytes[r];
      if (n !== 0)
        return Math.sign(n);
    }
    return 0;
  }
}
class MT {
  /**
   * Creates a generator object with the default random number generator, or
   * with the specified one if passed as an argument. The specified random
   * number generator should be cryptographically strong and securely seeded.
   */
  constructor(t) {
    this.timestamp = 0, this.counter = 0, this.random = t ?? jT();
  }
  /**
   * Generates a new UUIDv7 object from the current timestamp, or resets the
   * generator upon significant timestamp rollback.
   *
   * This method returns a monotonically increasing UUID by reusing the previous
   * timestamp even if the up-to-date timestamp is smaller than the immediately
   * preceding UUID's. However, when such a clock rollback is considered
   * significant (i.e., by more than ten seconds), this method resets the
   * generator and returns a new UUID based on the given timestamp, breaking the
   * increasing order of UUIDs.
   *
   * See {@link generateOrAbort} for the other mode of generation and
   * {@link generateOrResetCore} for the low-level primitive.
   */
  generate() {
    return this.generateOrResetCore(Date.now(), 1e4);
  }
  /**
   * Generates a new UUIDv7 object from the current timestamp, or returns
   * `undefined` upon significant timestamp rollback.
   *
   * This method returns a monotonically increasing UUID by reusing the previous
   * timestamp even if the up-to-date timestamp is smaller than the immediately
   * preceding UUID's. However, when such a clock rollback is considered
   * significant (i.e., by more than ten seconds), this method aborts and
   * returns `undefined` immediately.
   *
   * See {@link generate} for the other mode of generation and
   * {@link generateOrAbortCore} for the low-level primitive.
   */
  generateOrAbort() {
    return this.generateOrAbortCore(Date.now(), 1e4);
  }
  /**
   * Generates a new UUIDv7 object from the `unixTsMs` passed, or resets the
   * generator upon significant timestamp rollback.
   *
   * This method is equivalent to {@link generate} except that it takes a custom
   * timestamp and clock rollback allowance.
   *
   * @param rollbackAllowance - The amount of `unixTsMs` rollback that is
   * considered significant. A suggested value is `10_000` (milliseconds).
   * @throws RangeError if `unixTsMs` is not a 48-bit positive integer.
   */
  generateOrResetCore(t, r) {
    let n = this.generateOrAbortCore(t, r);
    return n === void 0 && (this.timestamp = 0, n = this.generateOrAbortCore(t, r)), n;
  }
  /**
   * Generates a new UUIDv7 object from the `unixTsMs` passed, or returns
   * `undefined` upon significant timestamp rollback.
   *
   * This method is equivalent to {@link generateOrAbort} except that it takes a
   * custom timestamp and clock rollback allowance.
   *
   * @param rollbackAllowance - The amount of `unixTsMs` rollback that is
   * considered significant. A suggested value is `10_000` (milliseconds).
   * @throws RangeError if `unixTsMs` is not a 48-bit positive integer.
   */
  generateOrAbortCore(t, r) {
    if (!Number.isInteger(t) || t < 1 || t > 281474976710655)
      throw new RangeError("`unixTsMs` must be a 48-bit positive integer");
    if (r < 0 || r > 281474976710655)
      throw new RangeError("`rollbackAllowance` out of reasonable range");
    if (t > this.timestamp)
      this.timestamp = t, this.resetCounter();
    else if (t + r >= this.timestamp)
      this.counter++, this.counter > 4398046511103 && (this.timestamp++, this.resetCounter());
    else
      return;
    return Nr.fromFieldsV7(this.timestamp, Math.trunc(this.counter / 2 ** 30), this.counter & 2 ** 30 - 1, this.random.nextUint32());
  }
  /** Initializes the counter at a 42-bit random integer. */
  resetCounter() {
    this.counter = this.random.nextUint32() * 1024 + (this.random.nextUint32() & 1023);
  }
  /**
   * Generates a new UUIDv4 object utilizing the random number generator inside.
   *
   * @internal
   */
  generateV4() {
    const t = new Uint8Array(Uint32Array.of(this.random.nextUint32(), this.random.nextUint32(), this.random.nextUint32(), this.random.nextUint32()).buffer);
    return t[6] = 64 | t[6] >>> 4, t[8] = 128 | t[8] >>> 2, Nr.ofInner(t);
  }
}
const jT = () => {
  if (typeof crypto < "u" && typeof crypto.getRandomValues < "u")
    return new kT();
  if (typeof UUIDV7_DENY_WEAK_RNG < "u" && UUIDV7_DENY_WEAK_RNG)
    throw new Error("no cryptographically strong RNG available");
  return {
    nextUint32: () => Math.trunc(Math.random() * 65536) * 65536 + Math.trunc(Math.random() * 65536)
  };
};
class kT {
  constructor() {
    this.buffer = new Uint32Array(8), this.cursor = 65535;
  }
  nextUint32() {
    return this.cursor >= this.buffer.length && (crypto.getRandomValues(this.buffer), this.cursor = 0), this.buffer[this.cursor++];
  }
}
let jv;
const $T = () => NT().toString(), NT = () => (jv || (jv = new MT())).generateV4();
function Gz({
  title: e = "",
  description: t,
  disabled: r = !1,
  value: n,
  onChange: i,
  options: a,
  optionTestId: o
}) {
  const s = V.useMemo(() => `radio-select-${$T()}-`, []);
  return /* @__PURE__ */ Z("div", { className: z("flex flex-col gap-y-2 px-4", r && "opacity-50"), children: [
    /* @__PURE__ */ S(CT, { classes: "text-lg font-medium", title: e }),
    t && /* @__PURE__ */ S("div", { children: t }),
    a.map((u) => {
      const c = `${s}-${u.value}`;
      return /* @__PURE__ */ Z("div", { className: "flex gap-x-2", children: [
        /* @__PURE__ */ S(
          "input",
          {
            type: "radio",
            id: c,
            checked: n === u.value,
            onChange: (l) => i?.(l.currentTarget.value),
            className: "text-primary mt-1 size-4",
            value: u.value,
            disabled: r,
            "data-testid": o?.(u.value)
          }
        ),
        /* @__PURE__ */ Z("div", { className: "flex flex-col gap-1", children: [
          /* @__PURE__ */ S("label", { className: "text-foreground font-medium", htmlFor: c, children: u.title }),
          /* @__PURE__ */ S("label", { className: "text-muted-foreground text-sm", htmlFor: c, children: u.description })
        ] })
      ] }, u.value);
    })
  ] });
}
const IT = "M3.99996 8.66699C3.63329 8.66699 3.33329 8.96699 3.33329 9.33366C3.33329 9.70033 3.63329 10.0003 3.99996 10.0003C4.36663 10.0003 4.66663 9.70033 4.66663 9.33366C4.66663 8.96699 4.36663 8.66699 3.99996 8.66699ZM3.99996 11.3337C3.63329 11.3337 3.33329 11.6337 3.33329 12.0003C3.33329 12.367 3.63329 12.667 3.99996 12.667C4.36663 12.667 4.66663 12.367 4.66663 12.0003C4.66663 11.6337 4.36663 11.3337 3.99996 11.3337ZM3.99996 6.00033C3.63329 6.00033 3.33329 6.30033 3.33329 6.66699C3.33329 7.03366 3.63329 7.33366 3.99996 7.33366C4.36663 7.33366 4.66663 7.03366 4.66663 6.66699C4.66663 6.30033 4.36663 6.00033 3.99996 6.00033ZM1.99996 6.33366C1.81663 6.33366 1.66663 6.48366 1.66663 6.66699C1.66663 6.85033 1.81663 7.00033 1.99996 7.00033C2.18329 7.00033 2.33329 6.85033 2.33329 6.66699C2.33329 6.48366 2.18329 6.33366 1.99996 6.33366ZM3.99996 3.33366C3.63329 3.33366 3.33329 3.63366 3.33329 4.00033C3.33329 4.36699 3.63329 4.66699 3.99996 4.66699C4.36663 4.66699 4.66663 4.36699 4.66663 4.00033C4.66663 3.63366 4.36663 3.33366 3.99996 3.33366ZM14 7.00033C14.1833 7.00033 14.3333 6.85033 14.3333 6.66699C14.3333 6.48366 14.1833 6.33366 14 6.33366C13.8166 6.33366 13.6666 6.48366 13.6666 6.66699C13.6666 6.85033 13.8166 7.00033 14 7.00033ZM9.33329 4.66699C9.69996 4.66699 9.99996 4.36699 9.99996 4.00033C9.99996 3.63366 9.69996 3.33366 9.33329 3.33366C8.96663 3.33366 8.66663 3.63366 8.66663 4.00033C8.66663 4.36699 8.96663 4.66699 9.33329 4.66699ZM9.33329 2.33366C9.51663 2.33366 9.66663 2.18366 9.66663 2.00033C9.66663 1.81699 9.51663 1.66699 9.33329 1.66699C9.14996 1.66699 8.99996 1.81699 8.99996 2.00033C8.99996 2.18366 9.14996 2.33366 9.33329 2.33366ZM1.99996 9.00033C1.81663 9.00033 1.66663 9.15033 1.66663 9.33366C1.66663 9.51699 1.81663 9.66699 1.99996 9.66699C2.18329 9.66699 2.33329 9.51699 2.33329 9.33366C2.33329 9.15033 2.18329 9.00033 1.99996 9.00033ZM6.66663 13.667C6.48329 13.667 6.33329 13.817 6.33329 14.0003C6.33329 14.1837 6.48329 14.3337 6.66663 14.3337C6.84996 14.3337 6.99996 14.1837 6.99996 14.0003C6.99996 13.817 6.84996 13.667 6.66663 13.667ZM6.66663 2.33366C6.84996 2.33366 6.99996 2.18366 6.99996 2.00033C6.99996 1.81699 6.84996 1.66699 6.66663 1.66699C6.48329 1.66699 6.33329 1.81699 6.33329 2.00033C6.33329 2.18366 6.48329 2.33366 6.66663 2.33366ZM6.66663 4.66699C7.03329 4.66699 7.33329 4.36699 7.33329 4.00033C7.33329 3.63366 7.03329 3.33366 6.66663 3.33366C6.29996 3.33366 5.99996 3.63366 5.99996 4.00033C5.99996 4.36699 6.29996 4.66699 6.66663 4.66699ZM6.66663 8.33366C6.11329 8.33366 5.66663 8.78032 5.66663 9.33366C5.66663 9.88699 6.11329 10.3337 6.66663 10.3337C7.21996 10.3337 7.66663 9.88699 7.66663 9.33366C7.66663 8.78032 7.21996 8.33366 6.66663 8.33366ZM12 8.66699C11.6333 8.66699 11.3333 8.96699 11.3333 9.33366C11.3333 9.70033 11.6333 10.0003 12 10.0003C12.3666 10.0003 12.6666 9.70033 12.6666 9.33366C12.6666 8.96699 12.3666 8.66699 12 8.66699ZM12 11.3337C11.6333 11.3337 11.3333 11.6337 11.3333 12.0003C11.3333 12.367 11.6333 12.667 12 12.667C12.3666 12.667 12.6666 12.367 12.6666 12.0003C12.6666 11.6337 12.3666 11.3337 12 11.3337ZM12 6.00033C11.6333 6.00033 11.3333 6.30033 11.3333 6.66699C11.3333 7.03366 11.6333 7.33366 12 7.33366C12.3666 7.33366 12.6666 7.03366 12.6666 6.66699C12.6666 6.30033 12.3666 6.00033 12 6.00033ZM12 3.33366C11.6333 3.33366 11.3333 3.63366 11.3333 4.00033C11.3333 4.36699 11.6333 4.66699 12 4.66699C12.3666 4.66699 12.6666 4.36699 12.6666 4.00033C12.6666 3.63366 12.3666 3.33366 12 3.33366ZM14 9.00033C13.8166 9.00033 13.6666 9.15033 13.6666 9.33366C13.6666 9.51699 13.8166 9.66699 14 9.66699C14.1833 9.66699 14.3333 9.51699 14.3333 9.33366C14.3333 9.15033 14.1833 9.00033 14 9.00033ZM9.33329 11.3337C8.96663 11.3337 8.66663 11.6337 8.66663 12.0003C8.66663 12.367 8.96663 12.667 9.33329 12.667C9.69996 12.667 9.99996 12.367 9.99996 12.0003C9.99996 11.6337 9.69996 11.3337 9.33329 11.3337ZM9.33329 13.667C9.14996 13.667 8.99996 13.817 8.99996 14.0003C8.99996 14.1837 9.14996 14.3337 9.33329 14.3337C9.51663 14.3337 9.66663 14.1837 9.66663 14.0003C9.66663 13.817 9.51663 13.667 9.33329 13.667ZM6.66663 5.66699C6.11329 5.66699 5.66663 6.11366 5.66663 6.66699C5.66663 7.22032 6.11329 7.66699 6.66663 7.66699C7.21996 7.66699 7.66663 7.22032 7.66663 6.66699C7.66663 6.11366 7.21996 5.66699 6.66663 5.66699ZM6.66663 11.3337C6.29996 11.3337 5.99996 11.6337 5.99996 12.0003C5.99996 12.367 6.29996 12.667 6.66663 12.667C7.03329 12.667 7.33329 12.367 7.33329 12.0003C7.33329 11.6337 7.03329 11.3337 6.66663 11.3337ZM9.33329 8.33366C8.77996 8.33366 8.33329 8.78032 8.33329 9.33366C8.33329 9.88699 8.77996 10.3337 9.33329 10.3337C9.88663 10.3337 10.3333 9.88699 10.3333 9.33366C10.3333 8.78032 9.88663 8.33366 9.33329 8.33366ZM9.33329 5.66699C8.77996 5.66699 8.33329 6.11366 8.33329 6.66699C8.33329 7.22032 8.77996 7.66699 9.33329 7.66699C9.88663 7.66699 10.3333 7.22032 10.3333 6.66699C10.3333 6.11366 9.88663 5.66699 9.33329 5.66699Z";
function Hz({ size: e = 16, className: t, ...r }) {
  return /* @__PURE__ */ S(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: e,
      viewBox: "0 0 16 16",
      fill: "currentColor",
      strokeWidth: 0,
      className: t,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ S("path", { d: IT })
    }
  );
}
function Vz({
  size: e = 24,
  absoluteStrokeWidth: t,
  className: r,
  strokeWidth: n = 2,
  ...i
}) {
  const a = t ? Number(n) * 24 / Number(e) : n;
  return /* @__PURE__ */ Z(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: e,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: a,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: r ? `lucide lucide-square-stop ${r}` : "lucide lucide-square-stop",
      "aria-hidden": "true",
      ...i,
      children: [
        /* @__PURE__ */ S("rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }),
        /* @__PURE__ */ S("rect", { x: "9", y: "9", width: "6", height: "6", rx: "1" })
      ]
    }
  );
}
function RT({
  queries: e,
  promises: t,
  ignoreErrors: r = !1,
  loading: n,
  success: i,
  error: a,
  children: o
}) {
  const [s, u] = V.useState(
    () => t && t.length ? "pending" : "resolved"
  );
  V.useEffect(() => {
    if (!t || t.length === 0) {
      u("resolved");
      return;
    }
    let l = !1;
    return u("pending"), Promise.all(t).then(() => {
      l || u("resolved");
    }).catch(() => {
      l || u("rejected");
    }), () => {
      l = !0;
    };
  }, [t]);
  let c = null;
  return s === "pending" ? c = n : s === "rejected" ? c = r ? i : a : e?.some((l) => l.isPending) ? c = n : !e || e.every((l) => l.isSuccess) || r ? c = i : c = a, /* @__PURE__ */ Z(Ct, { children: [
    c,
    o
  ] });
}
function DT({
  fullScreen: e = !1,
  loadingMessage: t = "",
  errorMessage: r = "An error occurred.",
  className: n,
  queries: i,
  promises: a,
  ignoreErrors: o = !1,
  children: s,
  loading: u,
  error: c
}) {
  const l = z(
    "z-30 flex w-full flex-col items-center justify-center bg-background/80 p-10",
    e && "fixed left-0 top-0 h-full",
    n
  );
  return /* @__PURE__ */ S(
    RT,
    {
      queries: i,
      promises: a,
      ignoreErrors: o,
      success: s,
      loading: /* @__PURE__ */ S("div", { className: l, children: u ?? /* @__PURE__ */ Z(Ct, { children: [
        /* @__PURE__ */ S(_s, {}),
        t && /* @__PURE__ */ S("p", { className: "mt-3", children: t })
      ] }) }),
      error: /* @__PURE__ */ S("div", { className: l, children: c ?? /* @__PURE__ */ S("p", { children: r }) })
    }
  );
}
function kv({ query: e }) {
  const t = RP(
    () => {
      e.hasNextPage && !e.isFetchingNextPage && e.fetchNextPage();
    },
    { enabled: !!e.hasNextPage }
  );
  return /* @__PURE__ */ Z(Ct, { children: [
    e.hasNextPage && /* @__PURE__ */ S("div", { ref: t, className: "h-4 w-full", "aria-hidden": "true" }),
    e.isFetchingNextPage && /* @__PURE__ */ S("div", { className: "flex items-center justify-center py-6", children: /* @__PURE__ */ S("div", { className: "text-muted-foreground flex items-center gap-2", children: /* @__PURE__ */ S("div", { className: "border-border border-t-primary h-4 w-4 animate-spin rounded-full border-2" }) }) })
  ] });
}
function Kz({
  query: e,
  children: t,
  empty: r,
  uniqueBy: n,
  scrollTop: i = !1,
  additionalItems: a = []
}) {
  const o = V.useMemo(
    () => IP(
      [...(e.data?.pages ?? []).flat(), ...a],
      n
    ),
    [e.data, a, n]
  );
  return e ? /* @__PURE__ */ S(
    DT,
    {
      queries: [
        {
          isPending: e.isPending,
          isSuccess: e.isSuccess,
          data: e.data
        }
      ],
      children: o.length ? /* @__PURE__ */ Z(Ct, { children: [
        i && /* @__PURE__ */ S(kv, { query: e }),
        t({ list: o }),
        !i && /* @__PURE__ */ S(kv, { query: e })
      ] }) : r
    }
  ) : null;
}
function Yz({
  loading: e = !1,
  className: t = "",
  disabled: r = !1,
  action: n,
  mutations: i = [],
  title: a = "",
  newTab: o = !1,
  children: s
}) {
  const [u, c] = V.useState(!1), l = e || u || i.some((h) => h.isPending), f = z("op-anchor", t), d = /* @__PURE__ */ Z(Ct, { children: [
    l && /* @__PURE__ */ S(l1, { className: "mr-2 inline h-4 w-4 animate-spin" }),
    s
  ] });
  return typeof n == "string" ? /* @__PURE__ */ S(
    "a",
    {
      title: a,
      href: n,
      target: o ? "_blank" : void 0,
      rel: o ? "noopener noreferrer" : void 0,
      className: f,
      onClick: (h) => {
        (l || r) && h.preventDefault();
      },
      children: d
    }
  ) : /* @__PURE__ */ S(
    "button",
    {
      type: "button",
      title: a,
      disabled: l || r,
      className: f,
      onClick: async (h) => {
        if (h.stopPropagation(), h.preventDefault(), !!n) {
          c(!0);
          try {
            await n();
          } finally {
            c(!1);
          }
        }
      },
      children: d
    }
  );
}
const Xz = ({ className: e }) => /* @__PURE__ */ S(_s, { className: e });
let Ut = [];
const Pd = /* @__PURE__ */ new Set();
let LT = 0;
const Fa = () => Pd.forEach((e) => e()), Kt = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getStack: () => Ut,
  subscribe: (e) => (Pd.add(e), () => Pd.delete(e)),
  push: (e, t, r) => {
    const n = `modal-${++LT}`;
    return Ut = [{ id: n, component: e, props: t, response: r }, ...Ut], Fa(), n;
  },
  closeTop: () => {
    if (Ut.length === 0) return;
    const [e, ...t] = Ut;
    Ut = t, Fa(), e && e.response && e.response(e.setResponseValue);
  },
  closeAll: () => {
    Ut = [], Fa();
  },
  setTopResponse: (e) => {
    if (Ut.length === 0) return;
    const t = Ut[0];
    t && (t.setResponseValue = e, Fa());
  }
};
function Zz() {
  const t = V.useSyncExternalStore(
    Kt.subscribe,
    Kt.getStack,
    Kt.getStack
  )[0];
  return /* @__PURE__ */ S(
    fo,
    {
      open: !!t,
      onOpenChange: (r) => {
        r || Kt.closeTop();
      },
      children: t && /* @__PURE__ */ Z(po, { children: [
        /* @__PURE__ */ S(Wi, {}),
        /* @__PURE__ */ S(Ui, { showCloseButton: !1, className: "max-h-[90vh] overflow-y-auto p-0", children: /* @__PURE__ */ S(qT, { entry: t }) })
      ] })
    }
  );
}
function qT({ entry: e }) {
  const t = e.component, r = V.useCallback(
    (i) => Kt.setTopResponse(i),
    []
  ), n = V.useCallback(() => Kt.closeTop(), []);
  return /* @__PURE__ */ S(t, { ...e.props, close: n, setResponse: r });
}
function Jz({
  className: e,
  width: t = "w-[95vw] max-w-2xl",
  children: r
}) {
  return /* @__PURE__ */ S(
    "div",
    {
      className: z(
        "op-card max-h-[90vh] overflow-y-auto bg-surface shadow-xl",
        t,
        e
      ),
      children: r
    }
  );
}
const BT = () => ({
  show: (e, t, r) => Kt.push(
    e,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    t ?? {},
    r
  ),
  close: () => Kt.closeTop(),
  closeAll: () => Kt.closeAll()
}), FT = () => ws(() => BT(), []);
function Qz({
  title: e = "",
  hasCloseButton: t = !0,
  isCustomTitle: r = !1,
  children: n
}) {
  const i = FT();
  return /* @__PURE__ */ Z("header", { className: "bg-surface sticky top-0 z-10 flex items-center justify-between border-b px-4 py-2 text-2xl font-bold", children: [
    r ? n : /* @__PURE__ */ S("div", { className: "flex items-center gap-3", children: /* @__PURE__ */ S("p", { className: "text-lg font-medium", children: e }) }),
    t && /* @__PURE__ */ S(
      Tt,
      {
        title: "Close",
        action: () => i.close(),
        className: "op-btn flex h-12 w-12 items-center justify-center",
        children: /* @__PURE__ */ S(Jp, {})
      }
    )
  ] });
}
function eW({
  variant: e,
  className: t,
  icon: r = WP,
  iconSize: n = 16,
  placement: i = "bottom",
  compact: a = !1,
  menuButton: o,
  children: s,
  title: u = "Open menu",
  width: c,
  text: l
}) {
  const [f, d] = zT(i), h = u || l;
  return /* @__PURE__ */ Z(th, { children: [
    /* @__PURE__ */ S(rh, { asChild: !0, children: /* @__PURE__ */ Z(
      "button",
      {
        type: "button",
        title: u,
        "aria-label": h || void 0,
        className: z(
          "rounded-button inline-flex items-center justify-center gap-1",
          e && Ta({ variant: e }),
          t
        ),
        onClick: (m) => {
          m.stopPropagation(), m.preventDefault();
        },
        children: [
          o ?? /* @__PURE__ */ S("span", { "aria-hidden": "true", children: /* @__PURE__ */ S(r, { size: n }) }),
          l && /* @__PURE__ */ S("span", { className: "text-sm", children: l }),
          h && !l ? /* @__PURE__ */ S(Tn, { children: h }) : null
        ]
      }
    ) }),
    /* @__PURE__ */ S(
      Os,
      {
        side: f,
        align: d,
        className: z(
          "flex flex-col items-start p-2 text-left",
          a ? "w-16" : c ?? "w-52"
        ),
        children: s
      }
    )
  ] });
}
function zT(e) {
  const [t, r] = e.split("-");
  return [t, r ?? "center"];
}
function tW({
  variant: e,
  action: t,
  title: r = "",
  children: n,
  menuChildren: i,
  menuTitle: a = "Change",
  placement: o = "top-start",
  chevronIcon: s = FP,
  chevronSize: u = 20,
  className: c,
  menuWidth: l,
  disabled: f = !1
}) {
  const [d, h] = WT(o), m = r || void 0, v = (p) => {
    p.stopPropagation(), p.preventDefault(), !f && typeof t == "function" && t();
  };
  return /* @__PURE__ */ Z("div", { className: z("flex items-center", c), children: [
    /* @__PURE__ */ Z(
      "button",
      {
        type: "button",
        title: m,
        "aria-label": m,
        disabled: f,
        onClick: v,
        className: z(
          Ta({ variant: e ?? "secondary", size: "icon" }),
          "rounded-button size-10 transition-opacity"
        ),
        children: [
          n,
          m ? /* @__PURE__ */ S(Tn, { children: m }) : null
        ]
      }
    ),
    /* @__PURE__ */ Z(th, { children: [
      /* @__PURE__ */ S(rh, { asChild: !0, children: /* @__PURE__ */ Z(
        "button",
        {
          type: "button",
          title: a,
          "aria-label": a,
          className: "hover:bg-surface rounded-r-button text-foreground -ml-1 flex h-10 items-center justify-center pl-0.5 pr-1.5 transition-colors",
          onClick: (p) => p.stopPropagation(),
          children: [
            /* @__PURE__ */ S("span", { "aria-hidden": "true", children: /* @__PURE__ */ S(s, { size: u }) }),
            /* @__PURE__ */ S(Tn, { children: a })
          ]
        }
      ) }),
      /* @__PURE__ */ S(
        Os,
        {
          side: d,
          align: h,
          className: z(
            "flex max-h-[60vh] flex-col items-start overflow-y-auto p-2 text-left",
            l ?? "w-56"
          ),
          children: i
        }
      )
    ] })
  ] });
}
function WT(e) {
  const [t, r] = e.split("-");
  return [t, r ?? "center"];
}
const $v = "flex w-full items-center gap-x-2 rounded-button p-2 text-left transition-colors hover:bg-surface disabled:opacity-60";
function rW({
  action: e,
  text: t = "",
  loadingText: r = "",
  icon: n,
  danger: i = !1,
  compact: a = !1,
  title: o = "",
  textSlot: s
}) {
  const [u, c] = V.useState(!1), l = o || t, f = u ? /* @__PURE__ */ Z(Ct, { children: [
    /* @__PURE__ */ S(GP, { size: 16, className: "shrink-0", "aria-hidden": "true" }),
    !a && /* @__PURE__ */ S("span", { children: r || t }),
    a && l ? /* @__PURE__ */ S(Tn, { children: l }) : null
  ] }) : /* @__PURE__ */ Z(Ct, { children: [
    n && /* @__PURE__ */ S("span", { "aria-hidden": "true", children: /* @__PURE__ */ S(n, { size: 16, className: "shrink-0" }) }),
    !a && (s ?? /* @__PURE__ */ S("span", { className: "text-left", children: t })),
    a && l ? /* @__PURE__ */ S(Tn, { children: l }) : null
  ] });
  return typeof e == "string" ? /* @__PURE__ */ S(
    "a",
    {
      title: o || void 0,
      "aria-label": a && l || void 0,
      href: e,
      className: z(
        $v,
        i && "text-error",
        a && "justify-center"
      ),
      onClick: (d) => {
        d.stopPropagation(), c(!0);
      },
      children: f
    }
  ) : /* @__PURE__ */ S(
    "button",
    {
      type: "button",
      title: o || void 0,
      "aria-label": a && l || void 0,
      disabled: u,
      className: z(
        $v,
        i && "text-error",
        a && "justify-center"
      ),
      onClick: async (d) => {
        d.stopPropagation(), d.preventDefault(), c(!0);
        try {
          await e();
        } finally {
          c(!1);
        }
      },
      children: f
    }
  );
}
function nW({ title: e }) {
  return /* @__PURE__ */ S("div", { className: "w-full p-2 font-semibold", children: e });
}
function iW() {
  return /* @__PURE__ */ S("div", { className: "my-1 h-[1px] w-full border-b border-border" });
}
function aW({
  search: e = "",
  onSearchChange: t,
  placeholder: r = "Search",
  className: n,
  debounceTimeMs: i = 800,
  hideIcon: a = !1,
  minLength: o = 3
}) {
  const [s, u] = V.useState(e);
  return V.useEffect(() => {
    if (!t) return;
    const c = setTimeout(() => {
      s.length < o ? t("") : t(s);
    }, i);
    return () => clearTimeout(c);
  }, [s, i, o, t]), /* @__PURE__ */ S("div", { className: n, children: /* @__PURE__ */ Z(
    "div",
    {
      className: z("border-border-2 flex items-center rounded-md border"),
      children: [
        !a && /* @__PURE__ */ S(
          "button",
          {
            type: "button",
            className: "flex items-center justify-center rounded-l-md px-2 py-1",
            tabIndex: -1,
            "aria-hidden": "true",
            children: /* @__PURE__ */ S(HP, {})
          }
        ),
        /* @__PURE__ */ S(
          uh,
          {
            placeholder: r,
            value: s,
            onChange: (c) => u(c.target.value),
            className: "h-10 flex-grow border-0 bg-inherit px-2 py-1 outline-none focus-visible:ring-0 focus-visible:ring-offset-0"
          }
        )
      ]
    }
  ) });
}
function oW({
  data: e = [],
  columnDefinitions: t,
  filter: r = () => !0,
  className: n
}) {
  const i = "break-words px-2 py-4 align-top";
  return /* @__PURE__ */ S("div", { className: "min-w-0 overflow-x-auto", children: /* @__PURE__ */ Z("table", { className: `mt-2 w-full ${n ?? ""}`, children: [
    /* @__PURE__ */ S("thead", { children: /* @__PURE__ */ S("tr", { className: "border-b-2 border-t-2", children: t.map((a) => /* @__PURE__ */ S(
      "th",
      {
        className: "py-4 pl-4 text-left align-top",
        children: typeof a.header == "string" ? a.header : typeof a.header == "function" ? V.createElement(a.header) : a.header
      },
      String(a.id)
    )) }) }),
    /* @__PURE__ */ S("tbody", { children: e.filter(r).map((a, o) => /* @__PURE__ */ S("tr", { className: "border-b-2 border-t-2", children: t.map((s) => {
      const u = String(s.id);
      if (s.type === "property")
        return /* @__PURE__ */ S("td", { className: i, children: String(
          a[s.id] ?? ""
        ) }, u);
      if (s.type === "path")
        return /* @__PURE__ */ S("td", { className: i, children: String(NP(a, s.path) ?? "") }, u);
      if (s.type === "text")
        return /* @__PURE__ */ S("td", { className: i, children: s.render(a) }, u);
      const { component: c, props: l } = s.render(a);
      return /* @__PURE__ */ S("td", { className: i, children: /* @__PURE__ */ S(c, { ...l }) }, u);
    }) }, o)) })
  ] }) });
}
const UT = {
  success: "bg-success text-success-foreground border-success",
  error: "bg-error text-error-foreground border-error"
};
function sW({
  children: e,
  variant: t = "success",
  duration: r,
  onDismiss: n,
  testId: i,
  inline: a = !1
}) {
  const [o, s] = Vt(!0), u = r ?? (t === "error" ? 0 : 5e3);
  if (Aa(() => {
    if (!u) return;
    const f = setTimeout(() => {
      s(!1), n?.();
    }, u);
    return () => clearTimeout(f);
  }, [u, n]), !o) return null;
  const c = () => {
    s(!1), n?.();
  }, l = /* @__PURE__ */ Z(
    "div",
    {
      role: t === "error" ? "alert" : "status",
      "data-testid": i,
      className: z(
        "flex items-start gap-2 rounded-md border p-3 text-sm font-medium shadow-md",
        UT[t]
      ),
      children: [
        /* @__PURE__ */ S("span", { className: "min-w-0 flex-1", children: e }),
        /* @__PURE__ */ Z(
          "button",
          {
            type: "button",
            "aria-label": "Dismiss",
            title: "Dismiss",
            onClick: c,
            className: "-mr-1 -mt-0.5 shrink-0 opacity-80 hover:opacity-100",
            children: [
              /* @__PURE__ */ S(Jp, { className: "size-4", "aria-hidden": "true" }),
              /* @__PURE__ */ S("span", { className: "sr-only", children: "Dismiss" })
            ]
          }
        )
      ]
    }
  );
  return a ? l : /* @__PURE__ */ S("div", { className: "fixed right-4 top-4 z-50 flex max-w-sm flex-col gap-2", children: l });
}
function uW({
  position: e = "top",
  children: t,
  trigger: r,
  delayDuration: n = 200
}) {
  return r ? /* @__PURE__ */ S(uO, { delayDuration: n, children: /* @__PURE__ */ Z(cO, { children: [
    /* @__PURE__ */ S(lO, { asChild: !0, children: r }),
    /* @__PURE__ */ S(fh, { side: e, children: t })
  ] }) }) : /* @__PURE__ */ S("span", { className: "absolute z-50 whitespace-nowrap rounded bg-foreground px-2 py-1 text-xs text-background", children: t });
}
const GT = ({
  label: e,
  info: t,
  className: r
}) => /* @__PURE__ */ Z(z1, { children: [
  /* @__PURE__ */ S(W1, { asChild: !0, children: /* @__PURE__ */ Z(
    "button",
    {
      type: "button",
      className: z(
        "text-muted-foreground hover:text-foreground hover:border-foreground/30 inline-flex size-4 shrink-0 items-center justify-center rounded-full border border-current text-[10px] font-semibold leading-none transition-colors",
        r
      ),
      "aria-label": `About ${e}`,
      onClick: (n) => n.stopPropagation(),
      children: [
        /* @__PURE__ */ S("span", { "aria-hidden": "true", children: "i" }),
        /* @__PURE__ */ S("span", { className: "sr-only", children: `About ${e}` })
      ]
    }
  ) }),
  /* @__PURE__ */ Z(
    ch,
    {
      align: "end",
      className: "w-72 p-3 text-sm leading-relaxed",
      onClick: (n) => n.stopPropagation(),
      children: [
        /* @__PURE__ */ S("p", { className: "text-foreground font-medium", children: e }),
        /* @__PURE__ */ S("p", { className: "text-muted-foreground mt-1.5 whitespace-pre-wrap", children: t })
      ]
    }
  )
] }), HT = (e) => {
  if (e == null) return null;
  const t = Math.round(e);
  return `${t > 0 ? "+" : ""}${t}%`;
}, VT = new Intl.NumberFormat(void 0, {
  notation: "compact",
  maximumFractionDigits: 1
}), cW = ({
  label: e,
  value: t,
  deltaPct: r,
  subtitle: n,
  info: i,
  className: a
}) => {
  const o = HT(r), s = r == null ? "text-muted-foreground" : r >= 0 ? "text-emerald-600" : "text-rose-600";
  return /* @__PURE__ */ Z(
    "div",
    {
      className: z(
        // min-w-0 lets grid columns shrink below the intrinsic width of
        // large numbers + deltas; overflow-hidden clips anything left over.
        // Safe for the info badge because its popover renders in a portal.
        "bg-background relative flex min-h-28 min-w-0 flex-col justify-between overflow-hidden rounded-xl border p-4 shadow-sm",
        a
      ),
      children: [
        i ? /* @__PURE__ */ S("div", { className: "absolute right-3 top-3", children: /* @__PURE__ */ S(GT, { label: e, info: i }) }) : null,
        /* @__PURE__ */ S(
          "div",
          {
            className: z(
              "text-muted-foreground text-xs font-medium uppercase tracking-wide",
              i && "pr-5"
            ),
            children: e
          }
        ),
        /* @__PURE__ */ Z("div", { className: "mt-2 min-w-0", children: [
          /* @__PURE__ */ Z("div", { className: "flex min-w-0 flex-wrap items-baseline gap-x-2 gap-y-0.5", children: [
            /* @__PURE__ */ S(
              "div",
              {
                className: z(
                  "min-w-0 font-semibold tracking-tight",
                  typeof t == "number" ? "truncate text-3xl tabular-nums" : "break-words text-2xl leading-tight"
                ),
                title: typeof t == "number" ? t.toLocaleString() : t,
                children: typeof t == "number" ? VT.format(t) : t
              }
            ),
            o != null ? /* @__PURE__ */ Z(
              "span",
              {
                className: z(
                  "inline-flex shrink-0 items-center gap-0.5 text-sm font-medium tabular-nums",
                  s
                ),
                children: [
                  /* @__PURE__ */ S("span", { "aria-hidden": !0, className: "text-[0.65rem] leading-none", children: r != null && r >= 0 ? "▲" : "▼" }),
                  o
                ]
              }
            ) : null
          ] }),
          n ? /* @__PURE__ */ S("div", { className: "text-muted-foreground mt-1 text-xs", children: n }) : null
        ] })
      ]
    }
  );
}, fO = 6048e5, KT = 864e5, dO = 6e4, pO = 36e5, Nv = Symbol.for("constructDateFrom");
function dt(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Nv in e ? e[Nv](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Me(e, t) {
  return dt(t || e, e);
}
function YT(e, t, r) {
  const n = Me(e, r?.in);
  return isNaN(t) ? dt(e, NaN) : (n.setDate(n.getDate() + t), n);
}
function hO(e, t, r) {
  const n = Me(e, r?.in);
  if (isNaN(t)) return dt(e, NaN);
  if (!t)
    return n;
  const i = n.getDate(), a = dt(e, n.getTime());
  a.setMonth(n.getMonth() + t + 1, 0);
  const o = a.getDate();
  return i >= o ? a : (n.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    i
  ), n);
}
let XT = {};
function Ss() {
  return XT;
}
function En(e, t) {
  const r = Ss(), n = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, i = Me(e, t?.in), a = i.getDay(), o = (a < n ? 7 : 0) + a - n;
  return i.setDate(i.getDate() - o), i.setHours(0, 0, 0, 0), i;
}
function yo(e, t) {
  return En(e, { ...t, weekStartsOn: 1 });
}
function vO(e, t) {
  const r = Me(e, t?.in), n = r.getFullYear(), i = dt(r, 0);
  i.setFullYear(n + 1, 0, 4), i.setHours(0, 0, 0, 0);
  const a = yo(i), o = dt(r, 0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  const s = yo(o);
  return r.getTime() >= a.getTime() ? n + 1 : r.getTime() >= s.getTime() ? n : n - 1;
}
function Iv(e) {
  const t = Me(e), r = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return r.setUTCFullYear(t.getFullYear()), +e - +r;
}
function As(e, ...t) {
  const r = dt.bind(
    null,
    t.find((n) => typeof n == "object")
  );
  return t.map(r);
}
function br(e, t) {
  const r = Me(e, t?.in);
  return r.setHours(0, 0, 0, 0), r;
}
function ZT(e, t, r) {
  const [n, i] = As(
    r?.in,
    e,
    t
  ), a = br(n), o = br(i), s = +a - Iv(a), u = +o - Iv(o);
  return Math.round((s - u) / KT);
}
function JT(e, t) {
  const r = vO(e, t), n = dt(e, 0);
  return n.setFullYear(r, 0, 4), n.setHours(0, 0, 0, 0), yo(n);
}
function QT(e, t, r) {
  const [n, i] = As(
    r?.in,
    e,
    t
  );
  return +br(n) == +br(i);
}
function eE(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function tE(e) {
  return !(!eE(e) && typeof e != "number" || isNaN(+Me(e)));
}
function rE(e, t) {
  const r = Me(e, t?.in), n = r.getMonth();
  return r.setFullYear(r.getFullYear(), n + 1, 0), r.setHours(23, 59, 59, 999), r;
}
function nE(e, t) {
  const [r, n] = As(e, t.start, t.end);
  return { start: r, end: n };
}
function iE(e, t) {
  const { start: r, end: n } = nE(t?.in, e);
  let i = +r > +n;
  const a = i ? +r : +n, o = i ? n : r;
  o.setHours(0, 0, 0, 0);
  let s = 1;
  const u = [];
  for (; +o <= a; )
    u.push(dt(r, o)), o.setDate(o.getDate() + s), o.setHours(0, 0, 0, 0);
  return i ? u.reverse() : u;
}
function Ci(e, t) {
  const r = Me(e, t?.in);
  return r.setDate(1), r.setHours(0, 0, 0, 0), r;
}
function aE(e, t) {
  const r = Me(e, t?.in);
  return r.setFullYear(r.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
function oE(e, t) {
  const r = t?.weekStartsOn, n = Me(e, t?.in), i = n.getDay(), a = (i < r ? -7 : 0) + 6 - (i - r);
  return n.setDate(n.getDate() + a), n.setHours(23, 59, 59, 999), n;
}
const sE = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, uE = (e, t, r) => {
  let n;
  const i = sE[e];
  return typeof i == "string" ? n = i : t === 1 ? n = i.one : n = i.other.replace("{{count}}", t.toString()), r?.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
function pu(e) {
  return (t = {}) => {
    const r = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
const cE = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, lE = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, fE = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, dE = {
  date: pu({
    formats: cE,
    defaultWidth: "full"
  }),
  time: pu({
    formats: lE,
    defaultWidth: "full"
  }),
  dateTime: pu({
    formats: fE,
    defaultWidth: "full"
  })
}, pE = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, hE = (e, t, r, n) => pE[e];
function yi(e) {
  return (t, r) => {
    const n = r?.context ? String(r.context) : "standalone";
    let i;
    if (n === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, s = r?.width ? String(r.width) : o;
      i = e.formattingValues[s] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, s = r?.width ? String(r.width) : e.defaultWidth;
      i = e.values[s] || e.values[o];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[a];
  };
}
const vE = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, yE = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, mE = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, gE = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, bE = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, xE = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, wE = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, OE = {
  ordinalNumber: wE,
  era: yi({
    values: vE,
    defaultWidth: "wide"
  }),
  quarter: yi({
    values: yE,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: yi({
    values: mE,
    defaultWidth: "wide"
  }),
  day: yi({
    values: gE,
    defaultWidth: "wide"
  }),
  dayPeriod: yi({
    values: bE,
    defaultWidth: "wide",
    formattingValues: xE,
    defaultFormattingWidth: "wide"
  })
};
function mi(e) {
  return (t, r = {}) => {
    const n = r.width, i = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
    if (!a)
      return null;
    const o = a[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(s) ? SE(s, (f) => f.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      _E(s, (f) => f.test(o))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(u) : u, c = r.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      r.valueCallback(c)
    ) : c;
    const l = t.slice(o.length);
    return { value: c, rest: l };
  };
}
function _E(e, t) {
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
      return r;
}
function SE(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function AE(e) {
  return (t, r = {}) => {
    const n = t.match(e.matchPattern);
    if (!n) return null;
    const i = n[0], a = t.match(e.parsePattern);
    if (!a) return null;
    let o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    const s = t.slice(i.length);
    return { value: o, rest: s };
  };
}
const PE = /^(\d+)(th|st|nd|rd)?/i, TE = /\d+/i, EE = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, CE = {
  any: [/^b/i, /^(a|c)/i]
}, ME = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, jE = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, kE = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, $E = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, NE = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, IE = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, RE = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, DE = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, LE = {
  ordinalNumber: AE({
    matchPattern: PE,
    parsePattern: TE,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: mi({
    matchPatterns: EE,
    defaultMatchWidth: "wide",
    parsePatterns: CE,
    defaultParseWidth: "any"
  }),
  quarter: mi({
    matchPatterns: ME,
    defaultMatchWidth: "wide",
    parsePatterns: jE,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: mi({
    matchPatterns: kE,
    defaultMatchWidth: "wide",
    parsePatterns: $E,
    defaultParseWidth: "any"
  }),
  day: mi({
    matchPatterns: NE,
    defaultMatchWidth: "wide",
    parsePatterns: IE,
    defaultParseWidth: "any"
  }),
  dayPeriod: mi({
    matchPatterns: RE,
    defaultMatchWidth: "any",
    parsePatterns: DE,
    defaultParseWidth: "any"
  })
}, qE = {
  code: "en-US",
  formatDistance: uE,
  formatLong: dE,
  formatRelative: hE,
  localize: OE,
  match: LE,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function BE(e, t) {
  const r = Me(e, t?.in);
  return ZT(r, aE(r)) + 1;
}
function FE(e, t) {
  const r = Me(e, t?.in), n = +yo(r) - +JT(r);
  return Math.round(n / fO) + 1;
}
function yO(e, t) {
  const r = Me(e, t?.in), n = r.getFullYear(), i = Ss(), a = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, o = dt(t?.in || e, 0);
  o.setFullYear(n + 1, 0, a), o.setHours(0, 0, 0, 0);
  const s = En(o, t), u = dt(t?.in || e, 0);
  u.setFullYear(n, 0, a), u.setHours(0, 0, 0, 0);
  const c = En(u, t);
  return +r >= +s ? n + 1 : +r >= +c ? n : n - 1;
}
function zE(e, t) {
  const r = Ss(), n = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, i = yO(e, t), a = dt(t?.in || e, 0);
  return a.setFullYear(i, 0, n), a.setHours(0, 0, 0, 0), En(a, t);
}
function WE(e, t) {
  const r = Me(e, t?.in), n = +En(r, t) - +zE(r, t);
  return Math.round(n / fO) + 1;
}
function de(e, t) {
  const r = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
  return r + n;
}
const dr = {
  // Year
  y(e, t) {
    const r = e.getFullYear(), n = r > 0 ? r : 1 - r;
    return de(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M(e, t) {
    const r = e.getMonth();
    return t === "M" ? String(r + 1) : de(r + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return de(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return de(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return de(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return de(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return de(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const r = t.length, n = e.getMilliseconds(), i = Math.trunc(
      n * Math.pow(10, r - 3)
    );
    return de(i, t.length);
  }
}, cn = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Rv = {
  // Era
  G: function(e, t, r) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return r.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      const n = e.getFullYear(), i = n > 0 ? n : 1 - n;
      return r.ordinalNumber(i, { unit: "year" });
    }
    return dr.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, n) {
    const i = yO(e, n), a = i > 0 ? i : 1 - i;
    if (t === "YY") {
      const o = a % 100;
      return de(o, 2);
    }
    return t === "Yo" ? r.ordinalNumber(a, { unit: "year" }) : de(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const r = vO(e);
    return de(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const r = e.getFullYear();
    return de(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(n);
      // 01, 02, 03, 04
      case "QQ":
        return de(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(n);
      // 01, 02, 03, 04
      case "qq":
        return de(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return dr.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(n + 1);
      // 01, 02, ..., 12
      case "LL":
        return de(n + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, r, n) {
    const i = WE(e, n);
    return t === "wo" ? r.ordinalNumber(i, { unit: "week" }) : de(i, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    const n = FE(e);
    return t === "Io" ? r.ordinalNumber(n, { unit: "week" }) : de(n, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : dr.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    const n = BE(e);
    return t === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : de(n, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    const n = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, n) {
    const i = e.getDay(), a = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(a);
      // Padded numerical value
      case "ee":
        return de(a, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return r.ordinalNumber(a, { unit: "day" });
      case "eee":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, n) {
    const i = e.getDay(), a = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(a);
      // Padded numerical value
      case "cc":
        return de(a, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return r.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return r.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return r.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return r.day(i, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return r.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    const n = e.getDay(), i = n === 0 ? 7 : n;
    switch (t) {
      // 2
      case "i":
        return String(i);
      // 02
      case "ii":
        return de(i, t.length);
      // 2nd
      case "io":
        return r.ordinalNumber(i, { unit: "day" });
      // Tue
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    const i = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    const n = e.getHours();
    let i;
    switch (n === 12 ? i = cn.noon : n === 0 ? i = cn.midnight : i = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    const n = e.getHours();
    let i;
    switch (n >= 17 ? i = cn.evening : n >= 12 ? i = cn.afternoon : n >= 4 ? i = cn.morning : i = cn.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
    }
    return dr.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : dr.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    const n = e.getHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : de(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    let n = e.getHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : de(n, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : dr.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : dr.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return dr.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return Lv(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Mr(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Mr(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return Lv(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Mr(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Mr(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Dv(n, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Mr(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Dv(n, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Mr(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r) {
    const n = Math.trunc(+e / 1e3);
    return de(n, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r) {
    return de(+e, t.length);
  }
};
function Dv(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), i = Math.trunc(n / 60), a = n % 60;
  return a === 0 ? r + String(i) : r + String(i) + t + de(a, 2);
}
function Lv(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + de(Math.abs(e) / 60, 2) : Mr(e, t);
}
function Mr(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), i = de(Math.trunc(n / 60), 2), a = de(n % 60, 2);
  return r + i + t + a;
}
const qv = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, mO = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, UE = (e, t) => {
  const r = e.match(/(P+)(p+)?/) || [], n = r[1], i = r[2];
  if (!i)
    return qv(e, t);
  let a;
  switch (n) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", qv(n, t)).replace("{{time}}", mO(i, t));
}, GE = {
  p: mO,
  P: UE
}, HE = /^D+$/, VE = /^Y+$/, KE = ["D", "DD", "YY", "YYYY"];
function YE(e) {
  return HE.test(e);
}
function XE(e) {
  return VE.test(e);
}
function ZE(e, t, r) {
  const n = JE(e, t, r);
  if (console.warn(n), KE.includes(e)) throw new RangeError(n);
}
function JE(e, t, r) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const QE = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, eC = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, tC = /^'([^]*?)'?$/, rC = /''/g, nC = /[a-zA-Z]/;
function Bv(e, t, r) {
  const n = Ss(), i = n.locale ?? qE, a = n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, o = n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, s = Me(e, r?.in);
  if (!tE(s))
    throw new RangeError("Invalid time value");
  let u = t.match(eC).map((l) => {
    const f = l[0];
    if (f === "p" || f === "P") {
      const d = GE[f];
      return d(l, i.formatLong);
    }
    return l;
  }).join("").match(QE).map((l) => {
    if (l === "''")
      return { isToken: !1, value: "'" };
    const f = l[0];
    if (f === "'")
      return { isToken: !1, value: iC(l) };
    if (Rv[f])
      return { isToken: !0, value: l };
    if (f.match(nC))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + f + "`"
      );
    return { isToken: !1, value: l };
  });
  i.localize.preprocessor && (u = i.localize.preprocessor(s, u));
  const c = {
    firstWeekContainsDate: a,
    weekStartsOn: o,
    locale: i
  };
  return u.map((l) => {
    if (!l.isToken) return l.value;
    const f = l.value;
    (XE(f) || YE(f)) && ZE(f, t, String(e));
    const d = Rv[f[0]];
    return d(s, f, i.localize, c);
  }).join("");
}
function iC(e) {
  const t = e.match(tC);
  return t ? t[1].replace(rC, "'") : e;
}
function aC(e, t) {
  const r = Me(e, t?.in);
  if (isNaN(+r))
    throw new RangeError("Invalid time value");
  const n = t?.format ?? "extended";
  let i = "";
  const a = n === "extended" ? "-" : "";
  {
    const o = de(r.getDate(), 2), s = de(r.getMonth() + 1, 2);
    i = `${de(r.getFullYear(), 4)}${a}${s}${a}${o}`;
  }
  return i;
}
function gO(e, t) {
  return +Me(e) > +Me(t);
}
function bO(e, t) {
  return +Me(e) < +Me(t);
}
function oC(e, t, r) {
  const [n, i] = As(
    r?.in,
    e,
    t
  );
  return n.getFullYear() === i.getFullYear() && n.getMonth() === i.getMonth();
}
function Fv(e, t, r) {
  return YT(e, -29, r);
}
function Mi(e, t) {
  const r = () => dt(t?.in, NaN), i = lC(e);
  let a;
  if (i.date) {
    const c = fC(i.date, 2);
    a = dC(c.restDateString, c.year);
  }
  if (!a || isNaN(+a)) return r();
  const o = +a;
  let s = 0, u;
  if (i.time && (s = pC(i.time), isNaN(s)))
    return r();
  if (i.timezone) {
    if (u = hC(i.timezone), isNaN(u)) return r();
  } else {
    const c = new Date(o + s), l = Me(0, t?.in);
    return l.setFullYear(
      c.getUTCFullYear(),
      c.getUTCMonth(),
      c.getUTCDate()
    ), l.setHours(
      c.getUTCHours(),
      c.getUTCMinutes(),
      c.getUTCSeconds(),
      c.getUTCMilliseconds()
    ), l;
  }
  return Me(o + s + u, t?.in);
}
const za = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, sC = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, uC = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, cC = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function lC(e) {
  const t = {}, r = e.split(za.dateTimeDelimiter);
  let n;
  if (r.length > 2)
    return t;
  if (/:/.test(r[0]) ? n = r[0] : (t.date = r[0], n = r[1], za.timeZoneDelimiter.test(t.date) && (t.date = e.split(za.timeZoneDelimiter)[0], n = e.substr(
    t.date.length,
    e.length
  ))), n) {
    const i = za.timezone.exec(n);
    i ? (t.time = n.replace(i[1], ""), t.timezone = i[1]) : t.time = n;
  }
  return t;
}
function fC(e, t) {
  const r = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), n = e.match(r);
  if (!n) return { year: NaN, restDateString: "" };
  const i = n[1] ? parseInt(n[1]) : null, a = n[2] ? parseInt(n[2]) : null;
  return {
    year: a === null ? i : a * 100,
    restDateString: e.slice((n[1] || n[2]).length)
  };
}
function dC(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  const r = e.match(sC);
  if (!r) return /* @__PURE__ */ new Date(NaN);
  const n = !!r[4], i = gi(r[1]), a = gi(r[2]) - 1, o = gi(r[3]), s = gi(r[4]), u = gi(r[5]) - 1;
  if (n)
    return bC(t, s, u) ? vC(t, s, u) : /* @__PURE__ */ new Date(NaN);
  {
    const c = /* @__PURE__ */ new Date(0);
    return !mC(t, a, o) || !gC(t, i) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(t, a, Math.max(i, o)), c);
  }
}
function gi(e) {
  return e ? parseInt(e) : 1;
}
function pC(e) {
  const t = e.match(uC);
  if (!t) return NaN;
  const r = hu(t[1]), n = hu(t[2]), i = hu(t[3]);
  return xC(r, n, i) ? r * pO + n * dO + i * 1e3 : NaN;
}
function hu(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function hC(e) {
  if (e === "Z") return 0;
  const t = e.match(cC);
  if (!t) return 0;
  const r = t[1] === "+" ? -1 : 1, n = parseInt(t[2]), i = t[3] && parseInt(t[3]) || 0;
  return wC(n, i) ? r * (n * pO + i * dO) : NaN;
}
function vC(e, t, r) {
  const n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  const i = n.getUTCDay() || 7, a = (t - 1) * 7 + r + 1 - i;
  return n.setUTCDate(n.getUTCDate() + a), n;
}
const yC = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function xO(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function mC(e, t, r) {
  return t >= 0 && t <= 11 && r >= 1 && r <= (yC[t] || (xO(e) ? 29 : 28));
}
function gC(e, t) {
  return t >= 1 && t <= (xO(e) ? 366 : 365);
}
function bC(e, t, r) {
  return t >= 1 && t <= 53 && r >= 0 && r <= 6;
}
function xC(e, t, r) {
  return e === 24 ? t === 0 && r === 0 : r >= 0 && r < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function wC(e, t) {
  return t >= 0 && t <= 59;
}
function OC(e, t, r) {
  return hO(e, -1, r);
}
const _C = [
  { key: "7d", label: "7d" },
  { key: "30d", label: "30d" },
  { key: "3m", label: "3m" },
  { key: "6m", label: "6m" },
  { key: "12m", label: "12m" },
  { key: "all", label: "All" },
  { key: "custom", label: "Custom" }
], Wa = (e) => aC(br(e), {}), Ua = (e) => e ? br(Mi(e)) : void 0, zv = ({
  title: e,
  month: t,
  onMonthChange: r,
  selected: n,
  onSelect: i,
  rangeStart: a,
  rangeEnd: o
}) => {
  const s = ws(() => {
    const u = En(Ci(t), { weekStartsOn: 1 }), c = oE(rE(t), { weekStartsOn: 1 });
    return iE({ start: u, end: c });
  }, [t]);
  return /* @__PURE__ */ Z("div", { className: "w-[252px]", children: [
    /* @__PURE__ */ S("div", { className: "text-muted-foreground mb-2 text-xs font-semibold uppercase tracking-wide", children: e }),
    /* @__PURE__ */ Z("div", { className: "mb-2 flex items-center justify-between", children: [
      /* @__PURE__ */ S(
        Tt,
        {
          type: "button",
          size: "sm",
          variant: "ghost",
          className: "size-8 p-0",
          "aria-label": "Previous month",
          onClick: () => r(OC(t)),
          children: /* @__PURE__ */ S(BP, { className: "size-4" })
        }
      ),
      /* @__PURE__ */ S("div", { className: "text-sm font-medium", children: Bv(t, "MMMM yyyy") }),
      /* @__PURE__ */ S(
        Tt,
        {
          type: "button",
          size: "sm",
          variant: "ghost",
          className: "size-8 p-0",
          "aria-label": "Next month",
          onClick: () => r(hO(t, 1)),
          children: /* @__PURE__ */ S(c1, { className: "size-4" })
        }
      )
    ] }),
    /* @__PURE__ */ S("div", { className: "text-muted-foreground mb-1 grid grid-cols-7 gap-0.5 text-center text-[10px] font-medium uppercase", children: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"].map((u) => /* @__PURE__ */ S("div", { className: "py-1", children: u }, u)) }),
    /* @__PURE__ */ S("div", { className: "grid grid-cols-7 gap-0.5", children: s.map((u) => {
      const c = oC(u, t), l = n ? QT(u, n) : !1, f = a && o && !bO(u, a) && !gO(u, o);
      return /* @__PURE__ */ S(
        "button",
        {
          type: "button",
          disabled: !c,
          onClick: () => i(u),
          className: z(
            "h-8 rounded-md text-sm tabular-nums transition-colors",
            !c && "invisible",
            c && !l && "hover:bg-accent",
            f && !l && "bg-accent/60",
            l && "bg-foreground text-background hover:bg-foreground"
          ),
          children: Bv(u, "d")
        },
        u.toISOString()
      );
    }) })
  ] });
}, lW = ({
  value: e,
  onChange: t,
  className: r,
  compact: n = !1
}) => {
  const [i, a] = Vt(!1), [o, s] = Vt(e.from), [u, c] = Vt(e.to), [l, f] = Vt(
    () => Ci(Ua(e.from) ?? Fv(/* @__PURE__ */ new Date()))
  ), [d, h] = Vt(
    () => Ci(Ua(e.to) ?? /* @__PURE__ */ new Date())
  ), m = e.preset ?? (e.from && e.to ? "custom" : "30d"), v = () => {
    const w = e.from ?? Wa(Fv(br(/* @__PURE__ */ new Date()))), O = e.to ?? Wa(br(/* @__PURE__ */ new Date()));
    s(w), c(O), f(Ci(Mi(w))), h(Ci(Mi(O))), a(!0);
  }, p = Ua(o), g = Ua(u), b = !!(o && u);
  return /* @__PURE__ */ Z(
    "div",
    {
      className: z(
        "flex flex-col gap-2",
        n ? "items-end" : void 0,
        r
      ),
      children: [
        /* @__PURE__ */ S(
          "div",
          {
            className: z(
              "bg-background flex flex-wrap gap-0.5 rounded-lg border p-0.5",
              n ? "justify-end" : void 0
            ),
            children: _C.map((w) => /* @__PURE__ */ S(
              Tt,
              {
                type: "button",
                size: "sm",
                variant: m === w.key ? "default" : "ghost",
                className: z(
                  "h-7 px-2.5 text-xs",
                  m === w.key ? void 0 : "text-muted-foreground"
                ),
                onClick: () => {
                  if (w.key === "custom") {
                    v();
                    return;
                  }
                  a(!1), t({ preset: w.key });
                },
                children: w.label
              },
              w.key
            ))
          }
        ),
        /* @__PURE__ */ S(fo, { open: i, onOpenChange: a, children: /* @__PURE__ */ Z(Ui, { className: "max-w-fit", children: [
          /* @__PURE__ */ S(ho, { children: /* @__PURE__ */ S(vo, { children: "Custom date range" }) }),
          /* @__PURE__ */ Z("div", { className: "flex flex-col gap-6 sm:flex-row sm:gap-8", children: [
            /* @__PURE__ */ S(
              zv,
              {
                title: "Start",
                month: l,
                onMonthChange: f,
                selected: p,
                rangeStart: p,
                rangeEnd: g,
                onSelect: (w) => {
                  const O = Wa(w);
                  s(O), u && gO(w, Mi(u)) && c(O);
                }
              }
            ),
            /* @__PURE__ */ S(
              zv,
              {
                title: "End",
                month: d,
                onMonthChange: h,
                selected: g,
                rangeStart: p,
                rangeEnd: g,
                onSelect: (w) => {
                  const O = Wa(w);
                  c(O), o && bO(w, Mi(o)) && s(O);
                }
              }
            )
          ] }),
          /* @__PURE__ */ Z(xn, { className: "gap-2 sm:justify-between", children: [
            /* @__PURE__ */ Z("p", { className: "text-muted-foreground self-center text-sm tabular-nums", children: [
              o ?? "—",
              " → ",
              u ?? "—"
            ] }),
            /* @__PURE__ */ Z("div", { className: "flex gap-2", children: [
              /* @__PURE__ */ S(
                Tt,
                {
                  type: "button",
                  variant: "outline",
                  onClick: () => a(!1),
                  children: "Cancel"
                }
              ),
              /* @__PURE__ */ S(
                Tt,
                {
                  type: "button",
                  disabled: !b,
                  onClick: () => {
                    !o || !u || (t({ from: o, to: u }), a(!1));
                  },
                  children: "Apply"
                }
              )
            ] })
          ] })
        ] }) })
      ]
    }
  );
};
var Ga = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function xe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var vu, Wv;
function nt() {
  if (Wv) return vu;
  Wv = 1;
  var e = Array.isArray;
  return vu = e, vu;
}
var yu, Uv;
function wO() {
  if (Uv) return yu;
  Uv = 1;
  var e = typeof Ga == "object" && Ga && Ga.Object === Object && Ga;
  return yu = e, yu;
}
var mu, Gv;
function Bt() {
  if (Gv) return mu;
  Gv = 1;
  var e = wO(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return mu = r, mu;
}
var gu, Hv;
function Ca() {
  if (Hv) return gu;
  Hv = 1;
  var e = Bt(), t = e.Symbol;
  return gu = t, gu;
}
var bu, Vv;
function SC() {
  if (Vv) return bu;
  Vv = 1;
  var e = Ca(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, i = e ? e.toStringTag : void 0;
  function a(o) {
    var s = r.call(o, i), u = o[i];
    try {
      o[i] = void 0;
      var c = !0;
    } catch {
    }
    var l = n.call(o);
    return c && (s ? o[i] = u : delete o[i]), l;
  }
  return bu = a, bu;
}
var xu, Kv;
function AC() {
  if (Kv) return xu;
  Kv = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return xu = r, xu;
}
var wu, Yv;
function ir() {
  if (Yv) return wu;
  Yv = 1;
  var e = Ca(), t = SC(), r = AC(), n = "[object Null]", i = "[object Undefined]", a = e ? e.toStringTag : void 0;
  function o(s) {
    return s == null ? s === void 0 ? i : n : a && a in Object(s) ? t(s) : r(s);
  }
  return wu = o, wu;
}
var Ou, Xv;
function ar() {
  if (Xv) return Ou;
  Xv = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return Ou = e, Ou;
}
var _u, Zv;
function ii() {
  if (Zv) return _u;
  Zv = 1;
  var e = ir(), t = ar(), r = "[object Symbol]";
  function n(i) {
    return typeof i == "symbol" || t(i) && e(i) == r;
  }
  return _u = n, _u;
}
var Su, Jv;
function dh() {
  if (Jv) return Su;
  Jv = 1;
  var e = nt(), t = ii(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
  function i(a, o) {
    if (e(a))
      return !1;
    var s = typeof a;
    return s == "number" || s == "symbol" || s == "boolean" || a == null || t(a) ? !0 : n.test(a) || !r.test(a) || o != null && a in Object(o);
  }
  return Su = i, Su;
}
var Au, Qv;
function xr() {
  if (Qv) return Au;
  Qv = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return Au = e, Au;
}
var Pu, ey;
function ph() {
  if (ey) return Pu;
  ey = 1;
  var e = ir(), t = xr(), r = "[object AsyncFunction]", n = "[object Function]", i = "[object GeneratorFunction]", a = "[object Proxy]";
  function o(s) {
    if (!t(s))
      return !1;
    var u = e(s);
    return u == n || u == i || u == r || u == a;
  }
  return Pu = o, Pu;
}
var Tu, ty;
function PC() {
  if (ty) return Tu;
  ty = 1;
  var e = Bt(), t = e["__core-js_shared__"];
  return Tu = t, Tu;
}
var Eu, ry;
function TC() {
  if (ry) return Eu;
  ry = 1;
  var e = PC(), t = function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  }();
  function r(n) {
    return !!t && t in n;
  }
  return Eu = r, Eu;
}
var Cu, ny;
function OO() {
  if (ny) return Cu;
  ny = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return Cu = r, Cu;
}
var Mu, iy;
function EC() {
  if (iy) return Mu;
  iy = 1;
  var e = ph(), t = TC(), r = xr(), n = OO(), i = /[\\^$.*+?()[\]{}|]/g, a = /^\[object .+?Constructor\]$/, o = Function.prototype, s = Object.prototype, u = o.toString, c = s.hasOwnProperty, l = RegExp(
    "^" + u.call(c).replace(i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(d) {
    if (!r(d) || t(d))
      return !1;
    var h = e(d) ? l : a;
    return h.test(n(d));
  }
  return Mu = f, Mu;
}
var ju, ay;
function CC() {
  if (ay) return ju;
  ay = 1;
  function e(t, r) {
    return t?.[r];
  }
  return ju = e, ju;
}
var ku, oy;
function en() {
  if (oy) return ku;
  oy = 1;
  var e = EC(), t = CC();
  function r(n, i) {
    var a = t(n, i);
    return e(a) ? a : void 0;
  }
  return ku = r, ku;
}
var $u, sy;
function Ps() {
  if (sy) return $u;
  sy = 1;
  var e = en(), t = e(Object, "create");
  return $u = t, $u;
}
var Nu, uy;
function MC() {
  if (uy) return Nu;
  uy = 1;
  var e = Ps();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Nu = t, Nu;
}
var Iu, cy;
function jC() {
  if (cy) return Iu;
  cy = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return Iu = e, Iu;
}
var Ru, ly;
function kC() {
  if (ly) return Ru;
  ly = 1;
  var e = Ps(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    if (e) {
      var s = o[a];
      return s === t ? void 0 : s;
    }
    return n.call(o, a) ? o[a] : void 0;
  }
  return Ru = i, Ru;
}
var Du, fy;
function $C() {
  if (fy) return Du;
  fy = 1;
  var e = Ps(), t = Object.prototype, r = t.hasOwnProperty;
  function n(i) {
    var a = this.__data__;
    return e ? a[i] !== void 0 : r.call(a, i);
  }
  return Du = n, Du;
}
var Lu, dy;
function NC() {
  if (dy) return Lu;
  dy = 1;
  var e = Ps(), t = "__lodash_hash_undefined__";
  function r(n, i) {
    var a = this.__data__;
    return this.size += this.has(n) ? 0 : 1, a[n] = e && i === void 0 ? t : i, this;
  }
  return Lu = r, Lu;
}
var qu, py;
function IC() {
  if (py) return qu;
  py = 1;
  var e = MC(), t = jC(), r = kC(), n = $C(), i = NC();
  function a(o) {
    var s = -1, u = o == null ? 0 : o.length;
    for (this.clear(); ++s < u; ) {
      var c = o[s];
      this.set(c[0], c[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = n, a.prototype.set = i, qu = a, qu;
}
var Bu, hy;
function RC() {
  if (hy) return Bu;
  hy = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Bu = e, Bu;
}
var Fu, vy;
function hh() {
  if (vy) return Fu;
  vy = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return Fu = e, Fu;
}
var zu, yy;
function Ts() {
  if (yy) return zu;
  yy = 1;
  var e = hh();
  function t(r, n) {
    for (var i = r.length; i--; )
      if (e(r[i][0], n))
        return i;
    return -1;
  }
  return zu = t, zu;
}
var Wu, my;
function DC() {
  if (my) return Wu;
  my = 1;
  var e = Ts(), t = Array.prototype, r = t.splice;
  function n(i) {
    var a = this.__data__, o = e(a, i);
    if (o < 0)
      return !1;
    var s = a.length - 1;
    return o == s ? a.pop() : r.call(a, o, 1), --this.size, !0;
  }
  return Wu = n, Wu;
}
var Uu, gy;
function LC() {
  if (gy) return Uu;
  gy = 1;
  var e = Ts();
  function t(r) {
    var n = this.__data__, i = e(n, r);
    return i < 0 ? void 0 : n[i][1];
  }
  return Uu = t, Uu;
}
var Gu, by;
function qC() {
  if (by) return Gu;
  by = 1;
  var e = Ts();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return Gu = t, Gu;
}
var Hu, xy;
function BC() {
  if (xy) return Hu;
  xy = 1;
  var e = Ts();
  function t(r, n) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? (++this.size, i.push([r, n])) : i[a][1] = n, this;
  }
  return Hu = t, Hu;
}
var Vu, wy;
function Es() {
  if (wy) return Vu;
  wy = 1;
  var e = RC(), t = DC(), r = LC(), n = qC(), i = BC();
  function a(o) {
    var s = -1, u = o == null ? 0 : o.length;
    for (this.clear(); ++s < u; ) {
      var c = o[s];
      this.set(c[0], c[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = n, a.prototype.set = i, Vu = a, Vu;
}
var Ku, Oy;
function vh() {
  if (Oy) return Ku;
  Oy = 1;
  var e = en(), t = Bt(), r = e(t, "Map");
  return Ku = r, Ku;
}
var Yu, _y;
function FC() {
  if (_y) return Yu;
  _y = 1;
  var e = IC(), t = Es(), r = vh();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return Yu = n, Yu;
}
var Xu, Sy;
function zC() {
  if (Sy) return Xu;
  Sy = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return Xu = e, Xu;
}
var Zu, Ay;
function Cs() {
  if (Ay) return Zu;
  Ay = 1;
  var e = zC();
  function t(r, n) {
    var i = r.__data__;
    return e(n) ? i[typeof n == "string" ? "string" : "hash"] : i.map;
  }
  return Zu = t, Zu;
}
var Ju, Py;
function WC() {
  if (Py) return Ju;
  Py = 1;
  var e = Cs();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return Ju = t, Ju;
}
var Qu, Ty;
function UC() {
  if (Ty) return Qu;
  Ty = 1;
  var e = Cs();
  function t(r) {
    return e(this, r).get(r);
  }
  return Qu = t, Qu;
}
var ec, Ey;
function GC() {
  if (Ey) return ec;
  Ey = 1;
  var e = Cs();
  function t(r) {
    return e(this, r).has(r);
  }
  return ec = t, ec;
}
var tc, Cy;
function HC() {
  if (Cy) return tc;
  Cy = 1;
  var e = Cs();
  function t(r, n) {
    var i = e(this, r), a = i.size;
    return i.set(r, n), this.size += i.size == a ? 0 : 1, this;
  }
  return tc = t, tc;
}
var rc, My;
function yh() {
  if (My) return rc;
  My = 1;
  var e = FC(), t = WC(), r = UC(), n = GC(), i = HC();
  function a(o) {
    var s = -1, u = o == null ? 0 : o.length;
    for (this.clear(); ++s < u; ) {
      var c = o[s];
      this.set(c[0], c[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = n, a.prototype.set = i, rc = a, rc;
}
var nc, jy;
function _O() {
  if (jy) return nc;
  jy = 1;
  var e = yh(), t = "Expected a function";
  function r(n, i) {
    if (typeof n != "function" || i != null && typeof i != "function")
      throw new TypeError(t);
    var a = function() {
      var o = arguments, s = i ? i.apply(this, o) : o[0], u = a.cache;
      if (u.has(s))
        return u.get(s);
      var c = n.apply(this, o);
      return a.cache = u.set(s, c) || u, c;
    };
    return a.cache = new (r.Cache || e)(), a;
  }
  return r.Cache = e, nc = r, nc;
}
var ic, ky;
function VC() {
  if (ky) return ic;
  ky = 1;
  var e = _O(), t = 500;
  function r(n) {
    var i = e(n, function(o) {
      return a.size === t && a.clear(), o;
    }), a = i.cache;
    return i;
  }
  return ic = r, ic;
}
var ac, $y;
function KC() {
  if ($y) return ac;
  $y = 1;
  var e = VC(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, n = e(function(i) {
    var a = [];
    return i.charCodeAt(0) === 46 && a.push(""), i.replace(t, function(o, s, u, c) {
      a.push(u ? c.replace(r, "$1") : s || o);
    }), a;
  });
  return ac = n, ac;
}
var oc, Ny;
function mh() {
  if (Ny) return oc;
  Ny = 1;
  function e(t, r) {
    for (var n = -1, i = t == null ? 0 : t.length, a = Array(i); ++n < i; )
      a[n] = r(t[n], n, t);
    return a;
  }
  return oc = e, oc;
}
var sc, Iy;
function YC() {
  if (Iy) return sc;
  Iy = 1;
  var e = Ca(), t = mh(), r = nt(), n = ii(), i = e ? e.prototype : void 0, a = i ? i.toString : void 0;
  function o(s) {
    if (typeof s == "string")
      return s;
    if (r(s))
      return t(s, o) + "";
    if (n(s))
      return a ? a.call(s) : "";
    var u = s + "";
    return u == "0" && 1 / s == -1 / 0 ? "-0" : u;
  }
  return sc = o, sc;
}
var uc, Ry;
function SO() {
  if (Ry) return uc;
  Ry = 1;
  var e = YC();
  function t(r) {
    return r == null ? "" : e(r);
  }
  return uc = t, uc;
}
var cc, Dy;
function AO() {
  if (Dy) return cc;
  Dy = 1;
  var e = nt(), t = dh(), r = KC(), n = SO();
  function i(a, o) {
    return e(a) ? a : t(a, o) ? [a] : r(n(a));
  }
  return cc = i, cc;
}
var lc, Ly;
function Ms() {
  if (Ly) return lc;
  Ly = 1;
  var e = ii();
  function t(r) {
    if (typeof r == "string" || e(r))
      return r;
    var n = r + "";
    return n == "0" && 1 / r == -1 / 0 ? "-0" : n;
  }
  return lc = t, lc;
}
var fc, qy;
function gh() {
  if (qy) return fc;
  qy = 1;
  var e = AO(), t = Ms();
  function r(n, i) {
    i = e(i, n);
    for (var a = 0, o = i.length; n != null && a < o; )
      n = n[t(i[a++])];
    return a && a == o ? n : void 0;
  }
  return fc = r, fc;
}
var dc, By;
function PO() {
  if (By) return dc;
  By = 1;
  var e = gh();
  function t(r, n, i) {
    var a = r == null ? void 0 : e(r, n);
    return a === void 0 ? i : a;
  }
  return dc = t, dc;
}
var XC = PO();
const ut = /* @__PURE__ */ xe(XC);
var pc, Fy;
function ZC() {
  if (Fy) return pc;
  Fy = 1;
  function e(t) {
    return t == null;
  }
  return pc = e, pc;
}
var JC = ZC();
const se = /* @__PURE__ */ xe(JC);
var hc, zy;
function QC() {
  if (zy) return hc;
  zy = 1;
  var e = ir(), t = nt(), r = ar(), n = "[object String]";
  function i(a) {
    return typeof a == "string" || !t(a) && r(a) && e(a) == n;
  }
  return hc = i, hc;
}
var e3 = QC();
const Hr = /* @__PURE__ */ xe(e3);
var t3 = ph();
const ie = /* @__PURE__ */ xe(t3);
var r3 = xr();
const ai = /* @__PURE__ */ xe(r3);
var Ha = { exports: {} }, he = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wy;
function n3() {
  if (Wy) return he;
  Wy = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m;
  m = Symbol.for("react.module.reference");
  function v(p) {
    if (typeof p == "object" && p !== null) {
      var g = p.$$typeof;
      switch (g) {
        case e:
          switch (p = p.type, p) {
            case r:
            case i:
            case n:
            case c:
            case l:
              return p;
            default:
              switch (p = p && p.$$typeof, p) {
                case s:
                case o:
                case u:
                case d:
                case f:
                case a:
                  return p;
                default:
                  return g;
              }
          }
        case t:
          return g;
      }
    }
  }
  return he.ContextConsumer = o, he.ContextProvider = a, he.Element = e, he.ForwardRef = u, he.Fragment = r, he.Lazy = d, he.Memo = f, he.Portal = t, he.Profiler = i, he.StrictMode = n, he.Suspense = c, he.SuspenseList = l, he.isAsyncMode = function() {
    return !1;
  }, he.isConcurrentMode = function() {
    return !1;
  }, he.isContextConsumer = function(p) {
    return v(p) === o;
  }, he.isContextProvider = function(p) {
    return v(p) === a;
  }, he.isElement = function(p) {
    return typeof p == "object" && p !== null && p.$$typeof === e;
  }, he.isForwardRef = function(p) {
    return v(p) === u;
  }, he.isFragment = function(p) {
    return v(p) === r;
  }, he.isLazy = function(p) {
    return v(p) === d;
  }, he.isMemo = function(p) {
    return v(p) === f;
  }, he.isPortal = function(p) {
    return v(p) === t;
  }, he.isProfiler = function(p) {
    return v(p) === i;
  }, he.isStrictMode = function(p) {
    return v(p) === n;
  }, he.isSuspense = function(p) {
    return v(p) === c;
  }, he.isSuspenseList = function(p) {
    return v(p) === l;
  }, he.isValidElementType = function(p) {
    return typeof p == "string" || typeof p == "function" || p === r || p === i || p === n || p === c || p === l || p === h || typeof p == "object" && p !== null && (p.$$typeof === d || p.$$typeof === f || p.$$typeof === a || p.$$typeof === o || p.$$typeof === u || p.$$typeof === m || p.getModuleId !== void 0);
  }, he.typeOf = v, he;
}
var ve = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Uy;
function i3() {
  return Uy || (Uy = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = !1, v = !1, p = !1, g = !1, b = !1, w;
    w = Symbol.for("react.module.reference");
    function O(G) {
      return !!(typeof G == "string" || typeof G == "function" || G === r || G === i || b || G === n || G === c || G === l || g || G === h || m || v || p || typeof G == "object" && G !== null && (G.$$typeof === d || G.$$typeof === f || G.$$typeof === a || G.$$typeof === o || G.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      G.$$typeof === w || G.getModuleId !== void 0));
    }
    function y(G) {
      if (typeof G == "object" && G !== null) {
        var Oe = G.$$typeof;
        switch (Oe) {
          case e:
            var Ee = G.type;
            switch (Ee) {
              case r:
              case i:
              case n:
              case c:
              case l:
                return Ee;
              default:
                var Ue = Ee && Ee.$$typeof;
                switch (Ue) {
                  case s:
                  case o:
                  case u:
                  case d:
                  case f:
                  case a:
                    return Ue;
                  default:
                    return Oe;
                }
            }
          case t:
            return Oe;
        }
      }
    }
    var x = o, _ = a, P = e, E = u, M = r, C = d, T = f, k = t, $ = i, I = n, R = c, q = l, W = !1, H = !1;
    function N(G) {
      return W || (W = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function L(G) {
      return H || (H = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function B(G) {
      return y(G) === o;
    }
    function K(G) {
      return y(G) === a;
    }
    function X(G) {
      return typeof G == "object" && G !== null && G.$$typeof === e;
    }
    function te(G) {
      return y(G) === u;
    }
    function re(G) {
      return y(G) === r;
    }
    function oe(G) {
      return y(G) === d;
    }
    function ae(G) {
      return y(G) === f;
    }
    function F(G) {
      return y(G) === t;
    }
    function Y(G) {
      return y(G) === i;
    }
    function ee(G) {
      return y(G) === n;
    }
    function j(G) {
      return y(G) === c;
    }
    function fe(G) {
      return y(G) === l;
    }
    ve.ContextConsumer = x, ve.ContextProvider = _, ve.Element = P, ve.ForwardRef = E, ve.Fragment = M, ve.Lazy = C, ve.Memo = T, ve.Portal = k, ve.Profiler = $, ve.StrictMode = I, ve.Suspense = R, ve.SuspenseList = q, ve.isAsyncMode = N, ve.isConcurrentMode = L, ve.isContextConsumer = B, ve.isContextProvider = K, ve.isElement = X, ve.isForwardRef = te, ve.isFragment = re, ve.isLazy = oe, ve.isMemo = ae, ve.isPortal = F, ve.isProfiler = Y, ve.isStrictMode = ee, ve.isSuspense = j, ve.isSuspenseList = fe, ve.isValidElementType = O, ve.typeOf = y;
  }()), ve;
}
var Gy;
function a3() {
  return Gy || (Gy = 1, process.env.NODE_ENV === "production" ? Ha.exports = n3() : Ha.exports = i3()), Ha.exports;
}
var o3 = a3(), vc, Hy;
function TO() {
  if (Hy) return vc;
  Hy = 1;
  var e = ir(), t = ar(), r = "[object Number]";
  function n(i) {
    return typeof i == "number" || t(i) && e(i) == r;
  }
  return vc = n, vc;
}
var yc, Vy;
function s3() {
  if (Vy) return yc;
  Vy = 1;
  var e = TO();
  function t(r) {
    return e(r) && r != +r;
  }
  return yc = t, yc;
}
var u3 = s3();
const oi = /* @__PURE__ */ xe(u3);
var c3 = TO();
const l3 = /* @__PURE__ */ xe(c3);
var Ye = function(t) {
  return t === 0 ? 0 : t > 0 ? 1 : -1;
}, Ir = function(t) {
  return Hr(t) && t.indexOf("%") === t.length - 1;
}, U = function(t) {
  return l3(t) && !oi(t);
}, f3 = function(t) {
  return se(t);
}, qe = function(t) {
  return U(t) || Hr(t);
}, d3 = 0, tn = function(t) {
  var r = ++d3;
  return "".concat(t || "").concat(r);
}, Xe = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!U(t) && !Hr(t))
    return n;
  var a;
  if (Ir(t)) {
    var o = t.indexOf("%");
    a = r * parseFloat(t.slice(0, o)) / 100;
  } else
    a = +t;
  return oi(a) && (a = n), i && a > r && (a = r), a;
}, vr = function(t) {
  if (!t)
    return null;
  var r = Object.keys(t);
  return r && r.length ? t[r[0]] : null;
}, p3 = function(t) {
  if (!Array.isArray(t))
    return !1;
  for (var r = t.length, n = {}, i = 0; i < r; i++)
    if (!n[t[i]])
      n[t[i]] = !0;
    else
      return !0;
  return !1;
}, Le = function(t, r) {
  return U(t) && U(r) ? function(n) {
    return t + n * (r - t);
  } : function() {
    return r;
  };
};
function mo(e, t, r) {
  return !e || !e.length ? null : e.find(function(n) {
    return n && (typeof t == "function" ? t(n) : ut(n, t)) === r;
  });
}
var h3 = function(t, r) {
  return U(t) && U(r) ? t - r : Hr(t) && Hr(r) ? t.localeCompare(r) : t instanceof Date && r instanceof Date ? t.getTime() - r.getTime() : String(t).localeCompare(String(r));
};
function wn(e, t) {
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r) && (!{}.hasOwnProperty.call(t, r) || e[r] !== t[r]))
      return !1;
  for (var n in t)
    if ({}.hasOwnProperty.call(t, n) && !{}.hasOwnProperty.call(e, n))
      return !1;
  return !0;
}
function Td(e) {
  "@babel/helpers - typeof";
  return Td = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Td(e);
}
var v3 = ["viewBox", "children"], y3 = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], Ky = ["points", "pathLength"], mc = {
  svg: v3,
  polygon: Ky,
  polyline: Ky
}, bh = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], go = function(t, r) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var n = t;
  if (/* @__PURE__ */ Pt(t) && (n = t.props), !ai(n))
    return null;
  var i = {};
  return Object.keys(n).forEach(function(a) {
    bh.includes(a) && (i[a] = r || function(o) {
      return n[a](n, o);
    });
  }), i;
}, m3 = function(t, r, n) {
  return function(i) {
    return t(r, n, i), null;
  };
}, Vr = function(t, r, n) {
  if (!ai(t) || Td(t) !== "object")
    return null;
  var i = null;
  return Object.keys(t).forEach(function(a) {
    var o = t[a];
    bh.includes(a) && typeof o == "function" && (i || (i = {}), i[a] = m3(o, r, n));
  }), i;
}, g3 = ["children"], b3 = ["children"];
function Yy(e, t) {
  if (e == null) return {};
  var r = x3(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function x3(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Ed(e) {
  "@babel/helpers - typeof";
  return Ed = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ed(e);
}
var Xy = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart",
  contextmenu: "onContextMenu",
  dblclick: "onDoubleClick"
}, Jt = function(t) {
  return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
}, Zy = null, gc = null, xh = function e(t) {
  if (t === Zy && Array.isArray(gc))
    return gc;
  var r = [];
  return Br.forEach(t, function(n) {
    se(n) || (o3.isFragment(n) ? r = r.concat(e(n.props.children)) : r.push(n));
  }), gc = r, Zy = t, r;
};
function ct(e, t) {
  var r = [], n = [];
  return Array.isArray(t) ? n = t.map(function(i) {
    return Jt(i);
  }) : n = [Jt(t)], xh(e).forEach(function(i) {
    var a = ut(i, "type.displayName") || ut(i, "type.name");
    n.indexOf(a) !== -1 && r.push(i);
  }), r;
}
function ot(e, t) {
  var r = ct(e, t);
  return r && r[0];
}
var Jy = function(t) {
  if (!t || !t.props)
    return !1;
  var r = t.props, n = r.width, i = r.height;
  return !(!U(n) || n <= 0 || !U(i) || i <= 0);
}, w3 = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], O3 = function(t) {
  return t && t.type && Hr(t.type) && w3.indexOf(t.type) >= 0;
}, EO = function(t) {
  return t && Ed(t) === "object" && "clipDot" in t;
}, _3 = function(t, r, n, i) {
  var a, o = (a = mc?.[i]) !== null && a !== void 0 ? a : [];
  return r.startsWith("data-") || !ie(t) && (i && o.includes(r) || y3.includes(r)) || n && bh.includes(r);
}, Q = function(t, r, n) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var i = t;
  if (/* @__PURE__ */ Pt(t) && (i = t.props), !ai(i))
    return null;
  var a = {};
  return Object.keys(i).forEach(function(o) {
    var s;
    _3((s = i) === null || s === void 0 ? void 0 : s[o], o, r, n) && (a[o] = i[o]);
  }), a;
}, Cd = function e(t, r) {
  if (t === r)
    return !0;
  var n = Br.count(t);
  if (n !== Br.count(r))
    return !1;
  if (n === 0)
    return !0;
  if (n === 1)
    return Qy(Array.isArray(t) ? t[0] : t, Array.isArray(r) ? r[0] : r);
  for (var i = 0; i < n; i++) {
    var a = t[i], o = r[i];
    if (Array.isArray(a) || Array.isArray(o)) {
      if (!e(a, o))
        return !1;
    } else if (!Qy(a, o))
      return !1;
  }
  return !0;
}, Qy = function(t, r) {
  if (se(t) && se(r))
    return !0;
  if (!se(t) && !se(r)) {
    var n = t.props || {}, i = n.children, a = Yy(n, g3), o = r.props || {}, s = o.children, u = Yy(o, b3);
    return i && s ? wn(a, u) && Cd(i, s) : !i && !s ? wn(a, u) : !1;
  }
  return !1;
}, em = function(t, r) {
  var n = [], i = {};
  return xh(t).forEach(function(a, o) {
    if (O3(a))
      n.push(a);
    else if (a) {
      var s = Jt(a.type), u = r[s] || {}, c = u.handler, l = u.once;
      if (c && (!l || !i[s])) {
        var f = c(a, s, o);
        n.push(f), i[s] = !0;
      }
    }
  }), n;
}, S3 = function(t) {
  var r = t && t.type;
  return r && Xy[r] ? Xy[r] : null;
}, A3 = function(t, r) {
  return xh(r).indexOf(t);
}, P3 = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function Md() {
  return Md = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Md.apply(this, arguments);
}
function T3(e, t) {
  if (e == null) return {};
  var r = E3(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function E3(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function jd(e) {
  var t = e.children, r = e.width, n = e.height, i = e.viewBox, a = e.className, o = e.style, s = e.title, u = e.desc, c = T3(e, P3), l = i || {
    width: r,
    height: n,
    x: 0,
    y: 0
  }, f = ue("recharts-surface", a);
  return /* @__PURE__ */ A.createElement("svg", Md({}, Q(c, !0, "svg"), {
    className: f,
    width: r,
    height: n,
    style: o,
    viewBox: "".concat(l.x, " ").concat(l.y, " ").concat(l.width, " ").concat(l.height)
  }), /* @__PURE__ */ A.createElement("title", null, s), /* @__PURE__ */ A.createElement("desc", null, u), t);
}
var C3 = ["children", "className"];
function kd() {
  return kd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kd.apply(this, arguments);
}
function M3(e, t) {
  if (e == null) return {};
  var r = j3(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function j3(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var le = /* @__PURE__ */ A.forwardRef(function(e, t) {
  var r = e.children, n = e.className, i = M3(e, C3), a = ue("recharts-layer", n);
  return /* @__PURE__ */ A.createElement("g", kd({
    className: a
  }, Q(i, !0), {
    ref: t
  }), r);
}), k3 = process.env.NODE_ENV !== "production", Et = function(t, r) {
  for (var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), a = 2; a < n; a++)
    i[a - 2] = arguments[a];
  if (k3 && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var o = 0;
      console.warn(r.replace(/%s/g, function() {
        return i[o++];
      }));
    }
}, bc, tm;
function $3() {
  if (tm) return bc;
  tm = 1;
  function e(t, r, n) {
    var i = -1, a = t.length;
    r < 0 && (r = -r > a ? 0 : a + r), n = n > a ? a : n, n < 0 && (n += a), a = r > n ? 0 : n - r >>> 0, r >>>= 0;
    for (var o = Array(a); ++i < a; )
      o[i] = t[i + r];
    return o;
  }
  return bc = e, bc;
}
var xc, rm;
function N3() {
  if (rm) return xc;
  rm = 1;
  var e = $3();
  function t(r, n, i) {
    var a = r.length;
    return i = i === void 0 ? a : i, !n && i >= a ? r : e(r, n, i);
  }
  return xc = t, xc;
}
var wc, nm;
function CO() {
  if (nm) return wc;
  nm = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", i = t + r + n, a = "\\ufe0e\\ufe0f", o = "\\u200d", s = RegExp("[" + o + e + i + a + "]");
  function u(c) {
    return s.test(c);
  }
  return wc = u, wc;
}
var Oc, im;
function I3() {
  if (im) return Oc;
  im = 1;
  function e(t) {
    return t.split("");
  }
  return Oc = e, Oc;
}
var _c, am;
function R3() {
  if (am) return _c;
  am = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", i = t + r + n, a = "\\ufe0e\\ufe0f", o = "[" + e + "]", s = "[" + i + "]", u = "\\ud83c[\\udffb-\\udfff]", c = "(?:" + s + "|" + u + ")", l = "[^" + e + "]", f = "(?:\\ud83c[\\udde6-\\uddff]){2}", d = "[\\ud800-\\udbff][\\udc00-\\udfff]", h = "\\u200d", m = c + "?", v = "[" + a + "]?", p = "(?:" + h + "(?:" + [l, f, d].join("|") + ")" + v + m + ")*", g = v + m + p, b = "(?:" + [l + s + "?", s, f, d, o].join("|") + ")", w = RegExp(u + "(?=" + u + ")|" + b + g, "g");
  function O(y) {
    return y.match(w) || [];
  }
  return _c = O, _c;
}
var Sc, om;
function D3() {
  if (om) return Sc;
  om = 1;
  var e = I3(), t = CO(), r = R3();
  function n(i) {
    return t(i) ? r(i) : e(i);
  }
  return Sc = n, Sc;
}
var Ac, sm;
function L3() {
  if (sm) return Ac;
  sm = 1;
  var e = N3(), t = CO(), r = D3(), n = SO();
  function i(a) {
    return function(o) {
      o = n(o);
      var s = t(o) ? r(o) : void 0, u = s ? s[0] : o.charAt(0), c = s ? e(s, 1).join("") : o.slice(1);
      return u[a]() + c;
    };
  }
  return Ac = i, Ac;
}
var Pc, um;
function q3() {
  if (um) return Pc;
  um = 1;
  var e = L3(), t = e("toUpperCase");
  return Pc = t, Pc;
}
var B3 = q3();
const js = /* @__PURE__ */ xe(B3);
function Se(e) {
  return function() {
    return e;
  };
}
const MO = Math.cos, bo = Math.sin, jt = Math.sqrt, xo = Math.PI, ks = 2 * xo, $d = Math.PI, Nd = 2 * $d, jr = 1e-6, F3 = Nd - jr;
function jO(e) {
  this._ += e[0];
  for (let t = 1, r = e.length; t < r; ++t)
    this._ += arguments[t] + e[t];
}
function z3(e) {
  let t = Math.floor(e);
  if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
  if (t > 15) return jO;
  const r = 10 ** t;
  return function(n) {
    this._ += n[0];
    for (let i = 1, a = n.length; i < a; ++i)
      this._ += Math.round(arguments[i] * r) / r + n[i];
  };
}
class W3 {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? jO : z3(t);
  }
  moveTo(t, r) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, r) {
    this._append`L${this._x1 = +t},${this._y1 = +r}`;
  }
  quadraticCurveTo(t, r, n, i) {
    this._append`Q${+t},${+r},${this._x1 = +n},${this._y1 = +i}`;
  }
  bezierCurveTo(t, r, n, i, a, o) {
    this._append`C${+t},${+r},${+n},${+i},${this._x1 = +a},${this._y1 = +o}`;
  }
  arcTo(t, r, n, i, a) {
    if (t = +t, r = +r, n = +n, i = +i, a = +a, a < 0) throw new Error(`negative radius: ${a}`);
    let o = this._x1, s = this._y1, u = n - t, c = i - r, l = o - t, f = s - r, d = l * l + f * f;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = r}`;
    else if (d > jr) if (!(Math.abs(f * u - c * l) > jr) || !a)
      this._append`L${this._x1 = t},${this._y1 = r}`;
    else {
      let h = n - o, m = i - s, v = u * u + c * c, p = h * h + m * m, g = Math.sqrt(v), b = Math.sqrt(d), w = a * Math.tan(($d - Math.acos((v + d - p) / (2 * g * b))) / 2), O = w / b, y = w / g;
      Math.abs(O - 1) > jr && this._append`L${t + O * l},${r + O * f}`, this._append`A${a},${a},0,0,${+(f * h > l * m)},${this._x1 = t + y * u},${this._y1 = r + y * c}`;
    }
  }
  arc(t, r, n, i, a, o) {
    if (t = +t, r = +r, n = +n, o = !!o, n < 0) throw new Error(`negative radius: ${n}`);
    let s = n * Math.cos(i), u = n * Math.sin(i), c = t + s, l = r + u, f = 1 ^ o, d = o ? i - a : a - i;
    this._x1 === null ? this._append`M${c},${l}` : (Math.abs(this._x1 - c) > jr || Math.abs(this._y1 - l) > jr) && this._append`L${c},${l}`, n && (d < 0 && (d = d % Nd + Nd), d > F3 ? this._append`A${n},${n},0,1,${f},${t - s},${r - u}A${n},${n},0,1,${f},${this._x1 = c},${this._y1 = l}` : d > jr && this._append`A${n},${n},0,${+(d >= $d)},${f},${this._x1 = t + n * Math.cos(a)},${this._y1 = r + n * Math.sin(a)}`);
  }
  rect(t, r, n, i) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}h${n = +n}v${+i}h${-n}Z`;
  }
  toString() {
    return this._;
  }
}
function wh(e) {
  let t = 3;
  return e.digits = function(r) {
    if (!arguments.length) return t;
    if (r == null)
      t = null;
    else {
      const n = Math.floor(r);
      if (!(n >= 0)) throw new RangeError(`invalid digits: ${r}`);
      t = n;
    }
    return e;
  }, () => new W3(t);
}
function Oh(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function kO(e) {
  this._context = e;
}
kO.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function $s(e) {
  return new kO(e);
}
function $O(e) {
  return e[0];
}
function NO(e) {
  return e[1];
}
function IO(e, t) {
  var r = Se(!0), n = null, i = $s, a = null, o = wh(s);
  e = typeof e == "function" ? e : e === void 0 ? $O : Se(e), t = typeof t == "function" ? t : t === void 0 ? NO : Se(t);
  function s(u) {
    var c, l = (u = Oh(u)).length, f, d = !1, h;
    for (n == null && (a = i(h = o())), c = 0; c <= l; ++c)
      !(c < l && r(f = u[c], c, u)) === d && ((d = !d) ? a.lineStart() : a.lineEnd()), d && a.point(+e(f, c, u), +t(f, c, u));
    if (h) return a = null, h + "" || null;
  }
  return s.x = function(u) {
    return arguments.length ? (e = typeof u == "function" ? u : Se(+u), s) : e;
  }, s.y = function(u) {
    return arguments.length ? (t = typeof u == "function" ? u : Se(+u), s) : t;
  }, s.defined = function(u) {
    return arguments.length ? (r = typeof u == "function" ? u : Se(!!u), s) : r;
  }, s.curve = function(u) {
    return arguments.length ? (i = u, n != null && (a = i(n)), s) : i;
  }, s.context = function(u) {
    return arguments.length ? (u == null ? n = a = null : a = i(n = u), s) : n;
  }, s;
}
function Va(e, t, r) {
  var n = null, i = Se(!0), a = null, o = $s, s = null, u = wh(c);
  e = typeof e == "function" ? e : e === void 0 ? $O : Se(+e), t = typeof t == "function" ? t : Se(t === void 0 ? 0 : +t), r = typeof r == "function" ? r : r === void 0 ? NO : Se(+r);
  function c(f) {
    var d, h, m, v = (f = Oh(f)).length, p, g = !1, b, w = new Array(v), O = new Array(v);
    for (a == null && (s = o(b = u())), d = 0; d <= v; ++d) {
      if (!(d < v && i(p = f[d], d, f)) === g)
        if (g = !g)
          h = d, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), m = d - 1; m >= h; --m)
            s.point(w[m], O[m]);
          s.lineEnd(), s.areaEnd();
        }
      g && (w[d] = +e(p, d, f), O[d] = +t(p, d, f), s.point(n ? +n(p, d, f) : w[d], r ? +r(p, d, f) : O[d]));
    }
    if (b) return s = null, b + "" || null;
  }
  function l() {
    return IO().defined(i).curve(o).context(a);
  }
  return c.x = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : Se(+f), n = null, c) : e;
  }, c.x0 = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : Se(+f), c) : e;
  }, c.x1 = function(f) {
    return arguments.length ? (n = f == null ? null : typeof f == "function" ? f : Se(+f), c) : n;
  }, c.y = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : Se(+f), r = null, c) : t;
  }, c.y0 = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : Se(+f), c) : t;
  }, c.y1 = function(f) {
    return arguments.length ? (r = f == null ? null : typeof f == "function" ? f : Se(+f), c) : r;
  }, c.lineX0 = c.lineY0 = function() {
    return l().x(e).y(t);
  }, c.lineY1 = function() {
    return l().x(e).y(r);
  }, c.lineX1 = function() {
    return l().x(n).y(t);
  }, c.defined = function(f) {
    return arguments.length ? (i = typeof f == "function" ? f : Se(!!f), c) : i;
  }, c.curve = function(f) {
    return arguments.length ? (o = f, a != null && (s = o(a)), c) : o;
  }, c.context = function(f) {
    return arguments.length ? (f == null ? a = s = null : s = o(a = f), c) : a;
  }, c;
}
class RO {
  constructor(t, r) {
    this._context = t, this._x = r;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, r) {
    switch (t = +t, r = +r, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, r) : this._context.moveTo(t, r);
        break;
      }
      case 1:
        this._point = 2;
      // falls through
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, r, t, r) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + r) / 2, t, this._y0, t, r);
        break;
      }
    }
    this._x0 = t, this._y0 = r;
  }
}
function U3(e) {
  return new RO(e, !0);
}
function G3(e) {
  return new RO(e, !1);
}
const _h = {
  draw(e, t) {
    const r = jt(t / xo);
    e.moveTo(r, 0), e.arc(0, 0, r, 0, ks);
  }
}, H3 = {
  draw(e, t) {
    const r = jt(t / 5) / 2;
    e.moveTo(-3 * r, -r), e.lineTo(-r, -r), e.lineTo(-r, -3 * r), e.lineTo(r, -3 * r), e.lineTo(r, -r), e.lineTo(3 * r, -r), e.lineTo(3 * r, r), e.lineTo(r, r), e.lineTo(r, 3 * r), e.lineTo(-r, 3 * r), e.lineTo(-r, r), e.lineTo(-3 * r, r), e.closePath();
  }
}, DO = jt(1 / 3), V3 = DO * 2, K3 = {
  draw(e, t) {
    const r = jt(t / V3), n = r * DO;
    e.moveTo(0, -r), e.lineTo(n, 0), e.lineTo(0, r), e.lineTo(-n, 0), e.closePath();
  }
}, Y3 = {
  draw(e, t) {
    const r = jt(t), n = -r / 2;
    e.rect(n, n, r, r);
  }
}, X3 = 0.8908130915292852, LO = bo(xo / 10) / bo(7 * xo / 10), Z3 = bo(ks / 10) * LO, J3 = -MO(ks / 10) * LO, Q3 = {
  draw(e, t) {
    const r = jt(t * X3), n = Z3 * r, i = J3 * r;
    e.moveTo(0, -r), e.lineTo(n, i);
    for (let a = 1; a < 5; ++a) {
      const o = ks * a / 5, s = MO(o), u = bo(o);
      e.lineTo(u * r, -s * r), e.lineTo(s * n - u * i, u * n + s * i);
    }
    e.closePath();
  }
}, Tc = jt(3), e6 = {
  draw(e, t) {
    const r = -jt(t / (Tc * 3));
    e.moveTo(0, r * 2), e.lineTo(-Tc * r, -r), e.lineTo(Tc * r, -r), e.closePath();
  }
}, pt = -0.5, ht = jt(3) / 2, Id = 1 / jt(12), t6 = (Id / 2 + 1) * 3, r6 = {
  draw(e, t) {
    const r = jt(t / t6), n = r / 2, i = r * Id, a = n, o = r * Id + r, s = -a, u = o;
    e.moveTo(n, i), e.lineTo(a, o), e.lineTo(s, u), e.lineTo(pt * n - ht * i, ht * n + pt * i), e.lineTo(pt * a - ht * o, ht * a + pt * o), e.lineTo(pt * s - ht * u, ht * s + pt * u), e.lineTo(pt * n + ht * i, pt * i - ht * n), e.lineTo(pt * a + ht * o, pt * o - ht * a), e.lineTo(pt * s + ht * u, pt * u - ht * s), e.closePath();
  }
};
function n6(e, t) {
  let r = null, n = wh(i);
  e = typeof e == "function" ? e : Se(e || _h), t = typeof t == "function" ? t : Se(t === void 0 ? 64 : +t);
  function i() {
    let a;
    if (r || (r = a = n()), e.apply(this, arguments).draw(r, +t.apply(this, arguments)), a) return r = null, a + "" || null;
  }
  return i.type = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : Se(a), i) : e;
  }, i.size = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : Se(+a), i) : t;
  }, i.context = function(a) {
    return arguments.length ? (r = a ?? null, i) : r;
  }, i;
}
function wo() {
}
function Oo(e, t, r) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + r) / 6
  );
}
function qO(e) {
  this._context = e;
}
qO.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        Oo(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        Oo(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function i6(e) {
  return new qO(e);
}
function BO(e) {
  this._context = e;
}
BO.prototype = {
  areaStart: wo,
  areaEnd: wo,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        Oo(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function a6(e) {
  return new BO(e);
}
function FO(e) {
  this._context = e;
}
FO.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var r = (this._x0 + 4 * this._x1 + e) / 6, n = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(r, n) : this._context.moveTo(r, n);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        Oo(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function o6(e) {
  return new FO(e);
}
function zO(e) {
  this._context = e;
}
zO.prototype = {
  areaStart: wo,
  areaEnd: wo,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function s6(e) {
  return new zO(e);
}
function cm(e) {
  return e < 0 ? -1 : 1;
}
function lm(e, t, r) {
  var n = e._x1 - e._x0, i = t - e._x1, a = (e._y1 - e._y0) / (n || i < 0 && -0), o = (r - e._y1) / (i || n < 0 && -0), s = (a * i + o * n) / (n + i);
  return (cm(a) + cm(o)) * Math.min(Math.abs(a), Math.abs(o), 0.5 * Math.abs(s)) || 0;
}
function fm(e, t) {
  var r = e._x1 - e._x0;
  return r ? (3 * (e._y1 - e._y0) / r - t) / 2 : t;
}
function Ec(e, t, r) {
  var n = e._x0, i = e._y0, a = e._x1, o = e._y1, s = (a - n) / 3;
  e._context.bezierCurveTo(n + s, i + s * t, a - s, o - s * r, a, o);
}
function _o(e) {
  this._context = e;
}
_o.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        Ec(this, this._t0, fm(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var r = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, Ec(this, fm(this, r = lm(this, e, t)), r);
          break;
        default:
          Ec(this, this._t0, r = lm(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = r;
    }
  }
};
function WO(e) {
  this._context = new UO(e);
}
(WO.prototype = Object.create(_o.prototype)).point = function(e, t) {
  _o.prototype.point.call(this, t, e);
};
function UO(e) {
  this._context = e;
}
UO.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, r, n, i, a) {
    this._context.bezierCurveTo(t, e, n, r, a, i);
  }
};
function u6(e) {
  return new _o(e);
}
function c6(e) {
  return new WO(e);
}
function GO(e) {
  this._context = e;
}
GO.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, r = e.length;
    if (r)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), r === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var n = dm(e), i = dm(t), a = 0, o = 1; o < r; ++a, ++o)
          this._context.bezierCurveTo(n[0][a], i[0][a], n[1][a], i[1][a], e[o], t[o]);
    (this._line || this._line !== 0 && r === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function dm(e) {
  var t, r = e.length - 1, n, i = new Array(r), a = new Array(r), o = new Array(r);
  for (i[0] = 0, a[0] = 2, o[0] = e[0] + 2 * e[1], t = 1; t < r - 1; ++t) i[t] = 1, a[t] = 4, o[t] = 4 * e[t] + 2 * e[t + 1];
  for (i[r - 1] = 2, a[r - 1] = 7, o[r - 1] = 8 * e[r - 1] + e[r], t = 1; t < r; ++t) n = i[t] / a[t - 1], a[t] -= n, o[t] -= n * o[t - 1];
  for (i[r - 1] = o[r - 1] / a[r - 1], t = r - 2; t >= 0; --t) i[t] = (o[t] - i[t + 1]) / a[t];
  for (a[r - 1] = (e[r] + i[r - 1]) / 2, t = 0; t < r - 1; ++t) a[t] = 2 * e[t + 1] - i[t + 1];
  return [i, a];
}
function l6(e) {
  return new GO(e);
}
function Ns(e, t) {
  this._context = e, this._t = t;
}
Ns.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var r = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(r, this._y), this._context.lineTo(r, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function f6(e) {
  return new Ns(e, 0.5);
}
function d6(e) {
  return new Ns(e, 0);
}
function p6(e) {
  return new Ns(e, 1);
}
function Cn(e, t) {
  if ((o = e.length) > 1)
    for (var r = 1, n, i, a = e[t[0]], o, s = a.length; r < o; ++r)
      for (i = a, a = e[t[r]], n = 0; n < s; ++n)
        a[n][1] += a[n][0] = isNaN(i[n][1]) ? i[n][0] : i[n][1];
}
function Rd(e) {
  for (var t = e.length, r = new Array(t); --t >= 0; ) r[t] = t;
  return r;
}
function h6(e, t) {
  return e[t];
}
function v6(e) {
  const t = [];
  return t.key = e, t;
}
function y6() {
  var e = Se([]), t = Rd, r = Cn, n = h6;
  function i(a) {
    var o = Array.from(e.apply(this, arguments), v6), s, u = o.length, c = -1, l;
    for (const f of a)
      for (s = 0, ++c; s < u; ++s)
        (o[s][c] = [0, +n(f, o[s].key, c, a)]).data = f;
    for (s = 0, l = Oh(t(o)); s < u; ++s)
      o[l[s]].index = s;
    return r(o, l), o;
  }
  return i.keys = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : Se(Array.from(a)), i) : e;
  }, i.value = function(a) {
    return arguments.length ? (n = typeof a == "function" ? a : Se(+a), i) : n;
  }, i.order = function(a) {
    return arguments.length ? (t = a == null ? Rd : typeof a == "function" ? a : Se(Array.from(a)), i) : t;
  }, i.offset = function(a) {
    return arguments.length ? (r = a ?? Cn, i) : r;
  }, i;
}
function m6(e, t) {
  if ((n = e.length) > 0) {
    for (var r, n, i = 0, a = e[0].length, o; i < a; ++i) {
      for (o = r = 0; r < n; ++r) o += e[r][i][1] || 0;
      if (o) for (r = 0; r < n; ++r) e[r][i][1] /= o;
    }
    Cn(e, t);
  }
}
function g6(e, t) {
  if ((i = e.length) > 0) {
    for (var r = 0, n = e[t[0]], i, a = n.length; r < a; ++r) {
      for (var o = 0, s = 0; o < i; ++o) s += e[o][r][1] || 0;
      n[r][1] += n[r][0] = -s / 2;
    }
    Cn(e, t);
  }
}
function b6(e, t) {
  if (!(!((o = e.length) > 0) || !((a = (i = e[t[0]]).length) > 0))) {
    for (var r = 0, n = 1, i, a, o; n < a; ++n) {
      for (var s = 0, u = 0, c = 0; s < o; ++s) {
        for (var l = e[t[s]], f = l[n][1] || 0, d = l[n - 1][1] || 0, h = (f - d) / 2, m = 0; m < s; ++m) {
          var v = e[t[m]], p = v[n][1] || 0, g = v[n - 1][1] || 0;
          h += p - g;
        }
        u += f, c += h * f;
      }
      i[n - 1][1] += i[n - 1][0] = r, u && (r -= c / u);
    }
    i[n - 1][1] += i[n - 1][0] = r, Cn(e, t);
  }
}
function Gi(e) {
  "@babel/helpers - typeof";
  return Gi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gi(e);
}
var x6 = ["type", "size", "sizeType"];
function Dd() {
  return Dd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Dd.apply(this, arguments);
}
function pm(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function hm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pm(Object(r), !0).forEach(function(n) {
      w6(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : pm(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function w6(e, t, r) {
  return t = O6(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function O6(e) {
  var t = _6(e, "string");
  return Gi(t) == "symbol" ? t : t + "";
}
function _6(e, t) {
  if (Gi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Gi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function S6(e, t) {
  if (e == null) return {};
  var r = A6(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function A6(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var HO = {
  symbolCircle: _h,
  symbolCross: H3,
  symbolDiamond: K3,
  symbolSquare: Y3,
  symbolStar: Q3,
  symbolTriangle: e6,
  symbolWye: r6
}, P6 = Math.PI / 180, T6 = function(t) {
  var r = "symbol".concat(js(t));
  return HO[r] || _h;
}, E6 = function(t, r, n) {
  if (r === "area")
    return t;
  switch (n) {
    case "cross":
      return 5 * t * t / 9;
    case "diamond":
      return 0.5 * t * t / Math.sqrt(3);
    case "square":
      return t * t;
    case "star": {
      var i = 18 * P6;
      return 1.25 * t * t * (Math.tan(i) - Math.tan(i * 2) * Math.pow(Math.tan(i), 2));
    }
    case "triangle":
      return Math.sqrt(3) * t * t / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * t * t / 8;
    default:
      return Math.PI * t * t / 4;
  }
}, C6 = function(t, r) {
  HO["symbol".concat(js(t))] = r;
}, Sh = function(t) {
  var r = t.type, n = r === void 0 ? "circle" : r, i = t.size, a = i === void 0 ? 64 : i, o = t.sizeType, s = o === void 0 ? "area" : o, u = S6(t, x6), c = hm(hm({}, u), {}, {
    type: n,
    size: a,
    sizeType: s
  }), l = function() {
    var p = T6(n), g = n6().type(p).size(E6(a, s, n));
    return g();
  }, f = c.className, d = c.cx, h = c.cy, m = Q(c, !0);
  return d === +d && h === +h && a === +a ? /* @__PURE__ */ A.createElement("path", Dd({}, m, {
    className: ue("recharts-symbols", f),
    transform: "translate(".concat(d, ", ").concat(h, ")"),
    d: l()
  })) : null;
};
Sh.registerSymbol = C6;
function Mn(e) {
  "@babel/helpers - typeof";
  return Mn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mn(e);
}
function Ld() {
  return Ld = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ld.apply(this, arguments);
}
function vm(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function M6(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vm(Object(r), !0).forEach(function(n) {
      Hi(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vm(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function j6(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function k6(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, KO(n.key), n);
  }
}
function $6(e, t, r) {
  return t && k6(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function N6(e, t, r) {
  return t = So(t), I6(e, VO() ? Reflect.construct(t, r || [], So(e).constructor) : t.apply(e, r));
}
function I6(e, t) {
  if (t && (Mn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return R6(e);
}
function R6(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function VO() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (VO = function() {
    return !!e;
  })();
}
function So(e) {
  return So = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, So(e);
}
function D6(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && qd(e, t);
}
function qd(e, t) {
  return qd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, qd(e, t);
}
function Hi(e, t, r) {
  return t = KO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function KO(e) {
  var t = L6(e, "string");
  return Mn(t) == "symbol" ? t : t + "";
}
function L6(e, t) {
  if (Mn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Mn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var vt = 32, Ah = /* @__PURE__ */ function(e) {
  function t() {
    return j6(this, t), N6(this, t, arguments);
  }
  return D6(t, e), $6(t, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(n) {
        var i = this.props.inactiveColor, a = vt / 2, o = vt / 6, s = vt / 3, u = n.inactive ? i : n.color;
        if (n.type === "plainline")
          return /* @__PURE__ */ A.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: u,
            strokeDasharray: n.payload.strokeDasharray,
            x1: 0,
            y1: a,
            x2: vt,
            y2: a,
            className: "recharts-legend-icon"
          });
        if (n.type === "line")
          return /* @__PURE__ */ A.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: u,
            d: "M0,".concat(a, "h").concat(s, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(2 * s, ",").concat(a, `
            H`).concat(vt, "M").concat(2 * s, ",").concat(a, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(s, ",").concat(a),
            className: "recharts-legend-icon"
          });
        if (n.type === "rect")
          return /* @__PURE__ */ A.createElement("path", {
            stroke: "none",
            fill: u,
            d: "M0,".concat(vt / 8, "h").concat(vt, "v").concat(vt * 3 / 4, "h").concat(-vt, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ A.isValidElement(n.legendIcon)) {
          var c = M6({}, n);
          return delete c.legendIcon, /* @__PURE__ */ A.cloneElement(n.legendIcon, c);
        }
        return /* @__PURE__ */ A.createElement(Sh, {
          fill: u,
          cx: a,
          cy: a,
          size: vt,
          sizeType: "diameter",
          type: n.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var n = this, i = this.props, a = i.payload, o = i.iconSize, s = i.layout, u = i.formatter, c = i.inactiveColor, l = {
        x: 0,
        y: 0,
        width: vt,
        height: vt
      }, f = {
        display: s === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, d = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return a.map(function(h, m) {
        var v = h.formatter || u, p = ue(Hi(Hi({
          "recharts-legend-item": !0
        }, "legend-item-".concat(m), !0), "inactive", h.inactive));
        if (h.type === "none")
          return null;
        var g = ie(h.value) ? null : h.value;
        Et(
          !ie(h.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var b = h.inactive ? c : h.color;
        return /* @__PURE__ */ A.createElement("li", Ld({
          className: p,
          style: f,
          key: "legend-item-".concat(m)
        }, Vr(n.props, h, m)), /* @__PURE__ */ A.createElement(jd, {
          width: o,
          height: o,
          viewBox: l,
          style: d
        }, n.renderIcon(h)), /* @__PURE__ */ A.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: b
          }
        }, v ? v(g, h, m) : g));
      });
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, i = n.payload, a = n.layout, o = n.align;
      if (!i || !i.length)
        return null;
      var s = {
        padding: 0,
        margin: 0,
        textAlign: a === "horizontal" ? o : "left"
      };
      return /* @__PURE__ */ A.createElement("ul", {
        className: "recharts-default-legend",
        style: s
      }, this.renderItems());
    }
  }]);
}(bt);
Hi(Ah, "displayName", "Legend");
Hi(Ah, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var Cc, ym;
function q6() {
  if (ym) return Cc;
  ym = 1;
  var e = Es();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return Cc = t, Cc;
}
var Mc, mm;
function B6() {
  if (mm) return Mc;
  mm = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return Mc = e, Mc;
}
var jc, gm;
function F6() {
  if (gm) return jc;
  gm = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return jc = e, jc;
}
var kc, bm;
function z6() {
  if (bm) return kc;
  bm = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return kc = e, kc;
}
var $c, xm;
function W6() {
  if (xm) return $c;
  xm = 1;
  var e = Es(), t = vh(), r = yh(), n = 200;
  function i(a, o) {
    var s = this.__data__;
    if (s instanceof e) {
      var u = s.__data__;
      if (!t || u.length < n - 1)
        return u.push([a, o]), this.size = ++s.size, this;
      s = this.__data__ = new r(u);
    }
    return s.set(a, o), this.size = s.size, this;
  }
  return $c = i, $c;
}
var Nc, wm;
function YO() {
  if (wm) return Nc;
  wm = 1;
  var e = Es(), t = q6(), r = B6(), n = F6(), i = z6(), a = W6();
  function o(s) {
    var u = this.__data__ = new e(s);
    this.size = u.size;
  }
  return o.prototype.clear = t, o.prototype.delete = r, o.prototype.get = n, o.prototype.has = i, o.prototype.set = a, Nc = o, Nc;
}
var Ic, Om;
function U6() {
  if (Om) return Ic;
  Om = 1;
  var e = "__lodash_hash_undefined__";
  function t(r) {
    return this.__data__.set(r, e), this;
  }
  return Ic = t, Ic;
}
var Rc, _m;
function G6() {
  if (_m) return Rc;
  _m = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Rc = e, Rc;
}
var Dc, Sm;
function XO() {
  if (Sm) return Dc;
  Sm = 1;
  var e = yh(), t = U6(), r = G6();
  function n(i) {
    var a = -1, o = i == null ? 0 : i.length;
    for (this.__data__ = new e(); ++a < o; )
      this.add(i[a]);
  }
  return n.prototype.add = n.prototype.push = t, n.prototype.has = r, Dc = n, Dc;
}
var Lc, Am;
function ZO() {
  if (Am) return Lc;
  Am = 1;
  function e(t, r) {
    for (var n = -1, i = t == null ? 0 : t.length; ++n < i; )
      if (r(t[n], n, t))
        return !0;
    return !1;
  }
  return Lc = e, Lc;
}
var qc, Pm;
function JO() {
  if (Pm) return qc;
  Pm = 1;
  function e(t, r) {
    return t.has(r);
  }
  return qc = e, qc;
}
var Bc, Tm;
function QO() {
  if (Tm) return Bc;
  Tm = 1;
  var e = XO(), t = ZO(), r = JO(), n = 1, i = 2;
  function a(o, s, u, c, l, f) {
    var d = u & n, h = o.length, m = s.length;
    if (h != m && !(d && m > h))
      return !1;
    var v = f.get(o), p = f.get(s);
    if (v && p)
      return v == s && p == o;
    var g = -1, b = !0, w = u & i ? new e() : void 0;
    for (f.set(o, s), f.set(s, o); ++g < h; ) {
      var O = o[g], y = s[g];
      if (c)
        var x = d ? c(y, O, g, s, o, f) : c(O, y, g, o, s, f);
      if (x !== void 0) {
        if (x)
          continue;
        b = !1;
        break;
      }
      if (w) {
        if (!t(s, function(_, P) {
          if (!r(w, P) && (O === _ || l(O, _, u, c, f)))
            return w.push(P);
        })) {
          b = !1;
          break;
        }
      } else if (!(O === y || l(O, y, u, c, f))) {
        b = !1;
        break;
      }
    }
    return f.delete(o), f.delete(s), b;
  }
  return Bc = a, Bc;
}
var Fc, Em;
function H6() {
  if (Em) return Fc;
  Em = 1;
  var e = Bt(), t = e.Uint8Array;
  return Fc = t, Fc;
}
var zc, Cm;
function V6() {
  if (Cm) return zc;
  Cm = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(i, a) {
      n[++r] = [a, i];
    }), n;
  }
  return zc = e, zc;
}
var Wc, Mm;
function Ph() {
  if (Mm) return Wc;
  Mm = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(i) {
      n[++r] = i;
    }), n;
  }
  return Wc = e, Wc;
}
var Uc, jm;
function K6() {
  if (jm) return Uc;
  jm = 1;
  var e = Ca(), t = H6(), r = hh(), n = QO(), i = V6(), a = Ph(), o = 1, s = 2, u = "[object Boolean]", c = "[object Date]", l = "[object Error]", f = "[object Map]", d = "[object Number]", h = "[object RegExp]", m = "[object Set]", v = "[object String]", p = "[object Symbol]", g = "[object ArrayBuffer]", b = "[object DataView]", w = e ? e.prototype : void 0, O = w ? w.valueOf : void 0;
  function y(x, _, P, E, M, C, T) {
    switch (P) {
      case b:
        if (x.byteLength != _.byteLength || x.byteOffset != _.byteOffset)
          return !1;
        x = x.buffer, _ = _.buffer;
      case g:
        return !(x.byteLength != _.byteLength || !C(new t(x), new t(_)));
      case u:
      case c:
      case d:
        return r(+x, +_);
      case l:
        return x.name == _.name && x.message == _.message;
      case h:
      case v:
        return x == _ + "";
      case f:
        var k = i;
      case m:
        var $ = E & o;
        if (k || (k = a), x.size != _.size && !$)
          return !1;
        var I = T.get(x);
        if (I)
          return I == _;
        E |= s, T.set(x, _);
        var R = n(k(x), k(_), E, M, C, T);
        return T.delete(x), R;
      case p:
        if (O)
          return O.call(x) == O.call(_);
    }
    return !1;
  }
  return Uc = y, Uc;
}
var Gc, km;
function e_() {
  if (km) return Gc;
  km = 1;
  function e(t, r) {
    for (var n = -1, i = r.length, a = t.length; ++n < i; )
      t[a + n] = r[n];
    return t;
  }
  return Gc = e, Gc;
}
var Hc, $m;
function Y6() {
  if ($m) return Hc;
  $m = 1;
  var e = e_(), t = nt();
  function r(n, i, a) {
    var o = i(n);
    return t(n) ? o : e(o, a(n));
  }
  return Hc = r, Hc;
}
var Vc, Nm;
function X6() {
  if (Nm) return Vc;
  Nm = 1;
  function e(t, r) {
    for (var n = -1, i = t == null ? 0 : t.length, a = 0, o = []; ++n < i; ) {
      var s = t[n];
      r(s, n, t) && (o[a++] = s);
    }
    return o;
  }
  return Vc = e, Vc;
}
var Kc, Im;
function Z6() {
  if (Im) return Kc;
  Im = 1;
  function e() {
    return [];
  }
  return Kc = e, Kc;
}
var Yc, Rm;
function J6() {
  if (Rm) return Yc;
  Rm = 1;
  var e = X6(), t = Z6(), r = Object.prototype, n = r.propertyIsEnumerable, i = Object.getOwnPropertySymbols, a = i ? function(o) {
    return o == null ? [] : (o = Object(o), e(i(o), function(s) {
      return n.call(o, s);
    }));
  } : t;
  return Yc = a, Yc;
}
var Xc, Dm;
function Q6() {
  if (Dm) return Xc;
  Dm = 1;
  function e(t, r) {
    for (var n = -1, i = Array(t); ++n < t; )
      i[n] = r(n);
    return i;
  }
  return Xc = e, Xc;
}
var Zc, Lm;
function eM() {
  if (Lm) return Zc;
  Lm = 1;
  var e = ir(), t = ar(), r = "[object Arguments]";
  function n(i) {
    return t(i) && e(i) == r;
  }
  return Zc = n, Zc;
}
var Jc, qm;
function Th() {
  if (qm) return Jc;
  qm = 1;
  var e = eM(), t = ar(), r = Object.prototype, n = r.hasOwnProperty, i = r.propertyIsEnumerable, a = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(o) {
    return t(o) && n.call(o, "callee") && !i.call(o, "callee");
  };
  return Jc = a, Jc;
}
var ji = { exports: {} }, Qc, Bm;
function tM() {
  if (Bm) return Qc;
  Bm = 1;
  function e() {
    return !1;
  }
  return Qc = e, Qc;
}
ji.exports;
var Fm;
function t_() {
  return Fm || (Fm = 1, function(e, t) {
    var r = Bt(), n = tM(), i = t && !t.nodeType && t, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, u = s ? s.isBuffer : void 0, c = u || n;
    e.exports = c;
  }(ji, ji.exports)), ji.exports;
}
var el, zm;
function Eh() {
  if (zm) return el;
  zm = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, i) {
    var a = typeof n;
    return i = i ?? e, !!i && (a == "number" || a != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < i;
  }
  return el = r, el;
}
var tl, Wm;
function Ch() {
  if (Wm) return tl;
  Wm = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return tl = t, tl;
}
var rl, Um;
function rM() {
  if (Um) return rl;
  Um = 1;
  var e = ir(), t = Ch(), r = ar(), n = "[object Arguments]", i = "[object Array]", a = "[object Boolean]", o = "[object Date]", s = "[object Error]", u = "[object Function]", c = "[object Map]", l = "[object Number]", f = "[object Object]", d = "[object RegExp]", h = "[object Set]", m = "[object String]", v = "[object WeakMap]", p = "[object ArrayBuffer]", g = "[object DataView]", b = "[object Float32Array]", w = "[object Float64Array]", O = "[object Int8Array]", y = "[object Int16Array]", x = "[object Int32Array]", _ = "[object Uint8Array]", P = "[object Uint8ClampedArray]", E = "[object Uint16Array]", M = "[object Uint32Array]", C = {};
  C[b] = C[w] = C[O] = C[y] = C[x] = C[_] = C[P] = C[E] = C[M] = !0, C[n] = C[i] = C[p] = C[a] = C[g] = C[o] = C[s] = C[u] = C[c] = C[l] = C[f] = C[d] = C[h] = C[m] = C[v] = !1;
  function T(k) {
    return r(k) && t(k.length) && !!C[e(k)];
  }
  return rl = T, rl;
}
var nl, Gm;
function r_() {
  if (Gm) return nl;
  Gm = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return nl = e, nl;
}
var ki = { exports: {} };
ki.exports;
var Hm;
function nM() {
  return Hm || (Hm = 1, function(e, t) {
    var r = wO(), n = t && !t.nodeType && t, i = n && !0 && e && !e.nodeType && e, a = i && i.exports === n, o = a && r.process, s = function() {
      try {
        var u = i && i.require && i.require("util").types;
        return u || o && o.binding && o.binding("util");
      } catch {
      }
    }();
    e.exports = s;
  }(ki, ki.exports)), ki.exports;
}
var il, Vm;
function n_() {
  if (Vm) return il;
  Vm = 1;
  var e = rM(), t = r_(), r = nM(), n = r && r.isTypedArray, i = n ? t(n) : e;
  return il = i, il;
}
var al, Km;
function iM() {
  if (Km) return al;
  Km = 1;
  var e = Q6(), t = Th(), r = nt(), n = t_(), i = Eh(), a = n_(), o = Object.prototype, s = o.hasOwnProperty;
  function u(c, l) {
    var f = r(c), d = !f && t(c), h = !f && !d && n(c), m = !f && !d && !h && a(c), v = f || d || h || m, p = v ? e(c.length, String) : [], g = p.length;
    for (var b in c)
      (l || s.call(c, b)) && !(v && // Safari 9 has enumerable `arguments.length` in strict mode.
      (b == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      h && (b == "offset" || b == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      m && (b == "buffer" || b == "byteLength" || b == "byteOffset") || // Skip index properties.
      i(b, g))) && p.push(b);
    return p;
  }
  return al = u, al;
}
var ol, Ym;
function aM() {
  if (Ym) return ol;
  Ym = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, i = typeof n == "function" && n.prototype || e;
    return r === i;
  }
  return ol = t, ol;
}
var sl, Xm;
function i_() {
  if (Xm) return sl;
  Xm = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return sl = e, sl;
}
var ul, Zm;
function oM() {
  if (Zm) return ul;
  Zm = 1;
  var e = i_(), t = e(Object.keys, Object);
  return ul = t, ul;
}
var cl, Jm;
function sM() {
  if (Jm) return cl;
  Jm = 1;
  var e = aM(), t = oM(), r = Object.prototype, n = r.hasOwnProperty;
  function i(a) {
    if (!e(a))
      return t(a);
    var o = [];
    for (var s in Object(a))
      n.call(a, s) && s != "constructor" && o.push(s);
    return o;
  }
  return cl = i, cl;
}
var ll, Qm;
function Ma() {
  if (Qm) return ll;
  Qm = 1;
  var e = ph(), t = Ch();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return ll = r, ll;
}
var fl, eg;
function Is() {
  if (eg) return fl;
  eg = 1;
  var e = iM(), t = sM(), r = Ma();
  function n(i) {
    return r(i) ? e(i) : t(i);
  }
  return fl = n, fl;
}
var dl, tg;
function uM() {
  if (tg) return dl;
  tg = 1;
  var e = Y6(), t = J6(), r = Is();
  function n(i) {
    return e(i, r, t);
  }
  return dl = n, dl;
}
var pl, rg;
function cM() {
  if (rg) return pl;
  rg = 1;
  var e = uM(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
  function i(a, o, s, u, c, l) {
    var f = s & t, d = e(a), h = d.length, m = e(o), v = m.length;
    if (h != v && !f)
      return !1;
    for (var p = h; p--; ) {
      var g = d[p];
      if (!(f ? g in o : n.call(o, g)))
        return !1;
    }
    var b = l.get(a), w = l.get(o);
    if (b && w)
      return b == o && w == a;
    var O = !0;
    l.set(a, o), l.set(o, a);
    for (var y = f; ++p < h; ) {
      g = d[p];
      var x = a[g], _ = o[g];
      if (u)
        var P = f ? u(_, x, g, o, a, l) : u(x, _, g, a, o, l);
      if (!(P === void 0 ? x === _ || c(x, _, s, u, l) : P)) {
        O = !1;
        break;
      }
      y || (y = g == "constructor");
    }
    if (O && !y) {
      var E = a.constructor, M = o.constructor;
      E != M && "constructor" in a && "constructor" in o && !(typeof E == "function" && E instanceof E && typeof M == "function" && M instanceof M) && (O = !1);
    }
    return l.delete(a), l.delete(o), O;
  }
  return pl = i, pl;
}
var hl, ng;
function lM() {
  if (ng) return hl;
  ng = 1;
  var e = en(), t = Bt(), r = e(t, "DataView");
  return hl = r, hl;
}
var vl, ig;
function fM() {
  if (ig) return vl;
  ig = 1;
  var e = en(), t = Bt(), r = e(t, "Promise");
  return vl = r, vl;
}
var yl, ag;
function a_() {
  if (ag) return yl;
  ag = 1;
  var e = en(), t = Bt(), r = e(t, "Set");
  return yl = r, yl;
}
var ml, og;
function dM() {
  if (og) return ml;
  og = 1;
  var e = en(), t = Bt(), r = e(t, "WeakMap");
  return ml = r, ml;
}
var gl, sg;
function pM() {
  if (sg) return gl;
  sg = 1;
  var e = lM(), t = vh(), r = fM(), n = a_(), i = dM(), a = ir(), o = OO(), s = "[object Map]", u = "[object Object]", c = "[object Promise]", l = "[object Set]", f = "[object WeakMap]", d = "[object DataView]", h = o(e), m = o(t), v = o(r), p = o(n), g = o(i), b = a;
  return (e && b(new e(new ArrayBuffer(1))) != d || t && b(new t()) != s || r && b(r.resolve()) != c || n && b(new n()) != l || i && b(new i()) != f) && (b = function(w) {
    var O = a(w), y = O == u ? w.constructor : void 0, x = y ? o(y) : "";
    if (x)
      switch (x) {
        case h:
          return d;
        case m:
          return s;
        case v:
          return c;
        case p:
          return l;
        case g:
          return f;
      }
    return O;
  }), gl = b, gl;
}
var bl, ug;
function hM() {
  if (ug) return bl;
  ug = 1;
  var e = YO(), t = QO(), r = K6(), n = cM(), i = pM(), a = nt(), o = t_(), s = n_(), u = 1, c = "[object Arguments]", l = "[object Array]", f = "[object Object]", d = Object.prototype, h = d.hasOwnProperty;
  function m(v, p, g, b, w, O) {
    var y = a(v), x = a(p), _ = y ? l : i(v), P = x ? l : i(p);
    _ = _ == c ? f : _, P = P == c ? f : P;
    var E = _ == f, M = P == f, C = _ == P;
    if (C && o(v)) {
      if (!o(p))
        return !1;
      y = !0, E = !1;
    }
    if (C && !E)
      return O || (O = new e()), y || s(v) ? t(v, p, g, b, w, O) : r(v, p, _, g, b, w, O);
    if (!(g & u)) {
      var T = E && h.call(v, "__wrapped__"), k = M && h.call(p, "__wrapped__");
      if (T || k) {
        var $ = T ? v.value() : v, I = k ? p.value() : p;
        return O || (O = new e()), w($, I, g, b, O);
      }
    }
    return C ? (O || (O = new e()), n(v, p, g, b, w, O)) : !1;
  }
  return bl = m, bl;
}
var xl, cg;
function Mh() {
  if (cg) return xl;
  cg = 1;
  var e = hM(), t = ar();
  function r(n, i, a, o, s) {
    return n === i ? !0 : n == null || i == null || !t(n) && !t(i) ? n !== n && i !== i : e(n, i, a, o, r, s);
  }
  return xl = r, xl;
}
var wl, lg;
function vM() {
  if (lg) return wl;
  lg = 1;
  var e = YO(), t = Mh(), r = 1, n = 2;
  function i(a, o, s, u) {
    var c = s.length, l = c, f = !u;
    if (a == null)
      return !l;
    for (a = Object(a); c--; ) {
      var d = s[c];
      if (f && d[2] ? d[1] !== a[d[0]] : !(d[0] in a))
        return !1;
    }
    for (; ++c < l; ) {
      d = s[c];
      var h = d[0], m = a[h], v = d[1];
      if (f && d[2]) {
        if (m === void 0 && !(h in a))
          return !1;
      } else {
        var p = new e();
        if (u)
          var g = u(m, v, h, a, o, p);
        if (!(g === void 0 ? t(v, m, r | n, u, p) : g))
          return !1;
      }
    }
    return !0;
  }
  return wl = i, wl;
}
var Ol, fg;
function o_() {
  if (fg) return Ol;
  fg = 1;
  var e = xr();
  function t(r) {
    return r === r && !e(r);
  }
  return Ol = t, Ol;
}
var _l, dg;
function yM() {
  if (dg) return _l;
  dg = 1;
  var e = o_(), t = Is();
  function r(n) {
    for (var i = t(n), a = i.length; a--; ) {
      var o = i[a], s = n[o];
      i[a] = [o, s, e(s)];
    }
    return i;
  }
  return _l = r, _l;
}
var Sl, pg;
function s_() {
  if (pg) return Sl;
  pg = 1;
  function e(t, r) {
    return function(n) {
      return n == null ? !1 : n[t] === r && (r !== void 0 || t in Object(n));
    };
  }
  return Sl = e, Sl;
}
var Al, hg;
function mM() {
  if (hg) return Al;
  hg = 1;
  var e = vM(), t = yM(), r = s_();
  function n(i) {
    var a = t(i);
    return a.length == 1 && a[0][2] ? r(a[0][0], a[0][1]) : function(o) {
      return o === i || e(o, i, a);
    };
  }
  return Al = n, Al;
}
var Pl, vg;
function gM() {
  if (vg) return Pl;
  vg = 1;
  function e(t, r) {
    return t != null && r in Object(t);
  }
  return Pl = e, Pl;
}
var Tl, yg;
function bM() {
  if (yg) return Tl;
  yg = 1;
  var e = AO(), t = Th(), r = nt(), n = Eh(), i = Ch(), a = Ms();
  function o(s, u, c) {
    u = e(u, s);
    for (var l = -1, f = u.length, d = !1; ++l < f; ) {
      var h = a(u[l]);
      if (!(d = s != null && c(s, h)))
        break;
      s = s[h];
    }
    return d || ++l != f ? d : (f = s == null ? 0 : s.length, !!f && i(f) && n(h, f) && (r(s) || t(s)));
  }
  return Tl = o, Tl;
}
var El, mg;
function xM() {
  if (mg) return El;
  mg = 1;
  var e = gM(), t = bM();
  function r(n, i) {
    return n != null && t(n, i, e);
  }
  return El = r, El;
}
var Cl, gg;
function wM() {
  if (gg) return Cl;
  gg = 1;
  var e = Mh(), t = PO(), r = xM(), n = dh(), i = o_(), a = s_(), o = Ms(), s = 1, u = 2;
  function c(l, f) {
    return n(l) && i(f) ? a(o(l), f) : function(d) {
      var h = t(d, l);
      return h === void 0 && h === f ? r(d, l) : e(f, h, s | u);
    };
  }
  return Cl = c, Cl;
}
var Ml, bg;
function si() {
  if (bg) return Ml;
  bg = 1;
  function e(t) {
    return t;
  }
  return Ml = e, Ml;
}
var jl, xg;
function OM() {
  if (xg) return jl;
  xg = 1;
  function e(t) {
    return function(r) {
      return r?.[t];
    };
  }
  return jl = e, jl;
}
var kl, wg;
function _M() {
  if (wg) return kl;
  wg = 1;
  var e = gh();
  function t(r) {
    return function(n) {
      return e(n, r);
    };
  }
  return kl = t, kl;
}
var $l, Og;
function SM() {
  if (Og) return $l;
  Og = 1;
  var e = OM(), t = _M(), r = dh(), n = Ms();
  function i(a) {
    return r(a) ? e(n(a)) : t(a);
  }
  return $l = i, $l;
}
var Nl, _g;
function Ft() {
  if (_g) return Nl;
  _g = 1;
  var e = mM(), t = wM(), r = si(), n = nt(), i = SM();
  function a(o) {
    return typeof o == "function" ? o : o == null ? r : typeof o == "object" ? n(o) ? t(o[0], o[1]) : e(o) : i(o);
  }
  return Nl = a, Nl;
}
var Il, Sg;
function u_() {
  if (Sg) return Il;
  Sg = 1;
  function e(t, r, n, i) {
    for (var a = t.length, o = n + (i ? 1 : -1); i ? o-- : ++o < a; )
      if (r(t[o], o, t))
        return o;
    return -1;
  }
  return Il = e, Il;
}
var Rl, Ag;
function AM() {
  if (Ag) return Rl;
  Ag = 1;
  function e(t) {
    return t !== t;
  }
  return Rl = e, Rl;
}
var Dl, Pg;
function PM() {
  if (Pg) return Dl;
  Pg = 1;
  function e(t, r, n) {
    for (var i = n - 1, a = t.length; ++i < a; )
      if (t[i] === r)
        return i;
    return -1;
  }
  return Dl = e, Dl;
}
var Ll, Tg;
function TM() {
  if (Tg) return Ll;
  Tg = 1;
  var e = u_(), t = AM(), r = PM();
  function n(i, a, o) {
    return a === a ? r(i, a, o) : e(i, t, o);
  }
  return Ll = n, Ll;
}
var ql, Eg;
function EM() {
  if (Eg) return ql;
  Eg = 1;
  var e = TM();
  function t(r, n) {
    var i = r == null ? 0 : r.length;
    return !!i && e(r, n, 0) > -1;
  }
  return ql = t, ql;
}
var Bl, Cg;
function CM() {
  if (Cg) return Bl;
  Cg = 1;
  function e(t, r, n) {
    for (var i = -1, a = t == null ? 0 : t.length; ++i < a; )
      if (n(r, t[i]))
        return !0;
    return !1;
  }
  return Bl = e, Bl;
}
var Fl, Mg;
function MM() {
  if (Mg) return Fl;
  Mg = 1;
  function e() {
  }
  return Fl = e, Fl;
}
var zl, jg;
function jM() {
  if (jg) return zl;
  jg = 1;
  var e = a_(), t = MM(), r = Ph(), n = 1 / 0, i = e && 1 / r(new e([, -0]))[1] == n ? function(a) {
    return new e(a);
  } : t;
  return zl = i, zl;
}
var Wl, kg;
function kM() {
  if (kg) return Wl;
  kg = 1;
  var e = XO(), t = EM(), r = CM(), n = JO(), i = jM(), a = Ph(), o = 200;
  function s(u, c, l) {
    var f = -1, d = t, h = u.length, m = !0, v = [], p = v;
    if (l)
      m = !1, d = r;
    else if (h >= o) {
      var g = c ? null : i(u);
      if (g)
        return a(g);
      m = !1, d = n, p = new e();
    } else
      p = c ? [] : v;
    e:
      for (; ++f < h; ) {
        var b = u[f], w = c ? c(b) : b;
        if (b = l || b !== 0 ? b : 0, m && w === w) {
          for (var O = p.length; O--; )
            if (p[O] === w)
              continue e;
          c && p.push(w), v.push(b);
        } else d(p, w, l) || (p !== v && p.push(w), v.push(b));
      }
    return v;
  }
  return Wl = s, Wl;
}
var Ul, $g;
function $M() {
  if ($g) return Ul;
  $g = 1;
  var e = Ft(), t = kM();
  function r(n, i) {
    return n && n.length ? t(n, e(i, 2)) : [];
  }
  return Ul = r, Ul;
}
var NM = $M();
const Ng = /* @__PURE__ */ xe(NM);
function c_(e, t, r) {
  return t === !0 ? Ng(e, r) : ie(t) ? Ng(e, t) : e;
}
function jn(e) {
  "@babel/helpers - typeof";
  return jn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, jn(e);
}
var IM = ["ref"];
function Ig(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Gt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ig(Object(r), !0).forEach(function(n) {
      Rs(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ig(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function RM(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Rg(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, f_(n.key), n);
  }
}
function DM(e, t, r) {
  return t && Rg(e.prototype, t), r && Rg(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function LM(e, t, r) {
  return t = Ao(t), qM(e, l_() ? Reflect.construct(t, r || [], Ao(e).constructor) : t.apply(e, r));
}
function qM(e, t) {
  if (t && (jn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return BM(e);
}
function BM(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function l_() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (l_ = function() {
    return !!e;
  })();
}
function Ao(e) {
  return Ao = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ao(e);
}
function FM(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Bd(e, t);
}
function Bd(e, t) {
  return Bd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Bd(e, t);
}
function Rs(e, t, r) {
  return t = f_(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function f_(e) {
  var t = zM(e, "string");
  return jn(t) == "symbol" ? t : t + "";
}
function zM(e, t) {
  if (jn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (jn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function WM(e, t) {
  if (e == null) return {};
  var r = UM(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function UM(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function GM(e) {
  return e.value;
}
function HM(e, t) {
  if (/* @__PURE__ */ A.isValidElement(e))
    return /* @__PURE__ */ A.cloneElement(e, t);
  if (typeof e == "function")
    return /* @__PURE__ */ A.createElement(e, t);
  t.ref;
  var r = WM(t, IM);
  return /* @__PURE__ */ A.createElement(Ah, r);
}
var Dg = 1, On = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    RM(this, t);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = LM(this, t, [].concat(i)), Rs(r, "lastBoundingBox", {
      width: -1,
      height: -1
    }), r;
  }
  return FM(t, e), DM(t, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        return n.height = this.wrapperNode.offsetHeight, n.width = this.wrapperNode.offsetWidth, n;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var n = this.props.onBBoxUpdate, i = this.getBBox();
      i ? (Math.abs(i.width - this.lastBoundingBox.width) > Dg || Math.abs(i.height - this.lastBoundingBox.height) > Dg) && (this.lastBoundingBox.width = i.width, this.lastBoundingBox.height = i.height, n && n(i)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, n && n(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? Gt({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(n) {
      var i = this.props, a = i.layout, o = i.align, s = i.verticalAlign, u = i.margin, c = i.chartWidth, l = i.chartHeight, f, d;
      if (!n || (n.left === void 0 || n.left === null) && (n.right === void 0 || n.right === null))
        if (o === "center" && a === "vertical") {
          var h = this.getBBoxSnapshot();
          f = {
            left: ((c || 0) - h.width) / 2
          };
        } else
          f = o === "right" ? {
            right: u && u.right || 0
          } : {
            left: u && u.left || 0
          };
      if (!n || (n.top === void 0 || n.top === null) && (n.bottom === void 0 || n.bottom === null))
        if (s === "middle") {
          var m = this.getBBoxSnapshot();
          d = {
            top: ((l || 0) - m.height) / 2
          };
        } else
          d = s === "bottom" ? {
            bottom: u && u.bottom || 0
          } : {
            top: u && u.top || 0
          };
      return Gt(Gt({}, f), d);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, i = this.props, a = i.content, o = i.width, s = i.height, u = i.wrapperStyle, c = i.payloadUniqBy, l = i.payload, f = Gt(Gt({
        position: "absolute",
        width: o || "auto",
        height: s || "auto"
      }, this.getDefaultPosition(u)), u);
      return /* @__PURE__ */ A.createElement("div", {
        className: "recharts-legend-wrapper",
        style: f,
        ref: function(h) {
          n.wrapperNode = h;
        }
      }, HM(a, Gt(Gt({}, this.props), {}, {
        payload: c_(l, c, GM)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(n, i) {
      var a = Gt(Gt({}, this.defaultProps), n.props), o = a.layout;
      return o === "vertical" && U(n.props.height) ? {
        height: n.props.height
      } : o === "horizontal" ? {
        width: n.props.width || i
      } : null;
    }
  }]);
}(bt);
Rs(On, "displayName", "Legend");
Rs(On, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var Gl, Lg;
function VM() {
  if (Lg) return Gl;
  Lg = 1;
  var e = Ca(), t = Th(), r = nt(), n = e ? e.isConcatSpreadable : void 0;
  function i(a) {
    return r(a) || t(a) || !!(n && a && a[n]);
  }
  return Gl = i, Gl;
}
var Hl, qg;
function d_() {
  if (qg) return Hl;
  qg = 1;
  var e = e_(), t = VM();
  function r(n, i, a, o, s) {
    var u = -1, c = n.length;
    for (a || (a = t), s || (s = []); ++u < c; ) {
      var l = n[u];
      i > 0 && a(l) ? i > 1 ? r(l, i - 1, a, o, s) : e(s, l) : o || (s[s.length] = l);
    }
    return s;
  }
  return Hl = r, Hl;
}
var Vl, Bg;
function KM() {
  if (Bg) return Vl;
  Bg = 1;
  function e(t) {
    return function(r, n, i) {
      for (var a = -1, o = Object(r), s = i(r), u = s.length; u--; ) {
        var c = s[t ? u : ++a];
        if (n(o[c], c, o) === !1)
          break;
      }
      return r;
    };
  }
  return Vl = e, Vl;
}
var Kl, Fg;
function YM() {
  if (Fg) return Kl;
  Fg = 1;
  var e = KM(), t = e();
  return Kl = t, Kl;
}
var Yl, zg;
function p_() {
  if (zg) return Yl;
  zg = 1;
  var e = YM(), t = Is();
  function r(n, i) {
    return n && e(n, i, t);
  }
  return Yl = r, Yl;
}
var Xl, Wg;
function XM() {
  if (Wg) return Xl;
  Wg = 1;
  var e = Ma();
  function t(r, n) {
    return function(i, a) {
      if (i == null)
        return i;
      if (!e(i))
        return r(i, a);
      for (var o = i.length, s = n ? o : -1, u = Object(i); (n ? s-- : ++s < o) && a(u[s], s, u) !== !1; )
        ;
      return i;
    };
  }
  return Xl = t, Xl;
}
var Zl, Ug;
function jh() {
  if (Ug) return Zl;
  Ug = 1;
  var e = p_(), t = XM(), r = t(e);
  return Zl = r, Zl;
}
var Jl, Gg;
function h_() {
  if (Gg) return Jl;
  Gg = 1;
  var e = jh(), t = Ma();
  function r(n, i) {
    var a = -1, o = t(n) ? Array(n.length) : [];
    return e(n, function(s, u, c) {
      o[++a] = i(s, u, c);
    }), o;
  }
  return Jl = r, Jl;
}
var Ql, Hg;
function ZM() {
  if (Hg) return Ql;
  Hg = 1;
  function e(t, r) {
    var n = t.length;
    for (t.sort(r); n--; )
      t[n] = t[n].value;
    return t;
  }
  return Ql = e, Ql;
}
var ef, Vg;
function JM() {
  if (Vg) return ef;
  Vg = 1;
  var e = ii();
  function t(r, n) {
    if (r !== n) {
      var i = r !== void 0, a = r === null, o = r === r, s = e(r), u = n !== void 0, c = n === null, l = n === n, f = e(n);
      if (!c && !f && !s && r > n || s && u && l && !c && !f || a && u && l || !i && l || !o)
        return 1;
      if (!a && !s && !f && r < n || f && i && o && !a && !s || c && i && o || !u && o || !l)
        return -1;
    }
    return 0;
  }
  return ef = t, ef;
}
var tf, Kg;
function QM() {
  if (Kg) return tf;
  Kg = 1;
  var e = JM();
  function t(r, n, i) {
    for (var a = -1, o = r.criteria, s = n.criteria, u = o.length, c = i.length; ++a < u; ) {
      var l = e(o[a], s[a]);
      if (l) {
        if (a >= c)
          return l;
        var f = i[a];
        return l * (f == "desc" ? -1 : 1);
      }
    }
    return r.index - n.index;
  }
  return tf = t, tf;
}
var rf, Yg;
function ej() {
  if (Yg) return rf;
  Yg = 1;
  var e = mh(), t = gh(), r = Ft(), n = h_(), i = ZM(), a = r_(), o = QM(), s = si(), u = nt();
  function c(l, f, d) {
    f.length ? f = e(f, function(v) {
      return u(v) ? function(p) {
        return t(p, v.length === 1 ? v[0] : v);
      } : v;
    }) : f = [s];
    var h = -1;
    f = e(f, a(r));
    var m = n(l, function(v, p, g) {
      var b = e(f, function(w) {
        return w(v);
      });
      return { criteria: b, index: ++h, value: v };
    });
    return i(m, function(v, p) {
      return o(v, p, d);
    });
  }
  return rf = c, rf;
}
var nf, Xg;
function tj() {
  if (Xg) return nf;
  Xg = 1;
  function e(t, r, n) {
    switch (n.length) {
      case 0:
        return t.call(r);
      case 1:
        return t.call(r, n[0]);
      case 2:
        return t.call(r, n[0], n[1]);
      case 3:
        return t.call(r, n[0], n[1], n[2]);
    }
    return t.apply(r, n);
  }
  return nf = e, nf;
}
var af, Zg;
function rj() {
  if (Zg) return af;
  Zg = 1;
  var e = tj(), t = Math.max;
  function r(n, i, a) {
    return i = t(i === void 0 ? n.length - 1 : i, 0), function() {
      for (var o = arguments, s = -1, u = t(o.length - i, 0), c = Array(u); ++s < u; )
        c[s] = o[i + s];
      s = -1;
      for (var l = Array(i + 1); ++s < i; )
        l[s] = o[s];
      return l[i] = a(c), e(n, this, l);
    };
  }
  return af = r, af;
}
var of, Jg;
function nj() {
  if (Jg) return of;
  Jg = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return of = e, of;
}
var sf, Qg;
function v_() {
  if (Qg) return sf;
  Qg = 1;
  var e = en(), t = function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  }();
  return sf = t, sf;
}
var uf, eb;
function ij() {
  if (eb) return uf;
  eb = 1;
  var e = nj(), t = v_(), r = si(), n = t ? function(i, a) {
    return t(i, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(a),
      writable: !0
    });
  } : r;
  return uf = n, uf;
}
var cf, tb;
function aj() {
  if (tb) return cf;
  tb = 1;
  var e = 800, t = 16, r = Date.now;
  function n(i) {
    var a = 0, o = 0;
    return function() {
      var s = r(), u = t - (s - o);
      if (o = s, u > 0) {
        if (++a >= e)
          return arguments[0];
      } else
        a = 0;
      return i.apply(void 0, arguments);
    };
  }
  return cf = n, cf;
}
var lf, rb;
function oj() {
  if (rb) return lf;
  rb = 1;
  var e = ij(), t = aj(), r = t(e);
  return lf = r, lf;
}
var ff, nb;
function sj() {
  if (nb) return ff;
  nb = 1;
  var e = si(), t = rj(), r = oj();
  function n(i, a) {
    return r(t(i, a, e), i + "");
  }
  return ff = n, ff;
}
var df, ib;
function Ds() {
  if (ib) return df;
  ib = 1;
  var e = hh(), t = Ma(), r = Eh(), n = xr();
  function i(a, o, s) {
    if (!n(s))
      return !1;
    var u = typeof o;
    return (u == "number" ? t(s) && r(o, s.length) : u == "string" && o in s) ? e(s[o], a) : !1;
  }
  return df = i, df;
}
var pf, ab;
function uj() {
  if (ab) return pf;
  ab = 1;
  var e = d_(), t = ej(), r = sj(), n = Ds(), i = r(function(a, o) {
    if (a == null)
      return [];
    var s = o.length;
    return s > 1 && n(a, o[0], o[1]) ? o = [] : s > 2 && n(o[0], o[1], o[2]) && (o = [o[0]]), t(a, e(o, 1), []);
  });
  return pf = i, pf;
}
var cj = uj();
const kh = /* @__PURE__ */ xe(cj);
function Vi(e) {
  "@babel/helpers - typeof";
  return Vi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Vi(e);
}
function Fd() {
  return Fd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fd.apply(this, arguments);
}
function lj(e, t) {
  return hj(e) || pj(e, t) || dj(e, t) || fj();
}
function fj() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function dj(e, t) {
  if (e) {
    if (typeof e == "string") return ob(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ob(e, t);
  }
}
function ob(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function pj(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function hj(e) {
  if (Array.isArray(e)) return e;
}
function sb(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function hf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? sb(Object(r), !0).forEach(function(n) {
      vj(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : sb(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function vj(e, t, r) {
  return t = yj(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function yj(e) {
  var t = mj(e, "string");
  return Vi(t) == "symbol" ? t : t + "";
}
function mj(e, t) {
  if (Vi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Vi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function gj(e) {
  return Array.isArray(e) && qe(e[0]) && qe(e[1]) ? e.join(" ~ ") : e;
}
var bj = function(t) {
  var r = t.separator, n = r === void 0 ? " : " : r, i = t.contentStyle, a = i === void 0 ? {} : i, o = t.itemStyle, s = o === void 0 ? {} : o, u = t.labelStyle, c = u === void 0 ? {} : u, l = t.payload, f = t.formatter, d = t.itemSorter, h = t.wrapperClassName, m = t.labelClassName, v = t.label, p = t.labelFormatter, g = t.accessibilityLayer, b = g === void 0 ? !1 : g, w = function() {
    if (l && l.length) {
      var T = {
        padding: 0,
        margin: 0
      }, k = (d ? kh(l, d) : l).map(function($, I) {
        if ($.type === "none")
          return null;
        var R = hf({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: $.color || "#000"
        }, s), q = $.formatter || f || gj, W = $.value, H = $.name, N = W, L = H;
        if (q && N != null && L != null) {
          var B = q(W, H, $, I, l);
          if (Array.isArray(B)) {
            var K = lj(B, 2);
            N = K[0], L = K[1];
          } else
            N = B;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ A.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(I),
            style: R
          }, qe(L) ? /* @__PURE__ */ A.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, L) : null, qe(L) ? /* @__PURE__ */ A.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, n) : null, /* @__PURE__ */ A.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, N), /* @__PURE__ */ A.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, $.unit || ""))
        );
      });
      return /* @__PURE__ */ A.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: T
      }, k);
    }
    return null;
  }, O = hf({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, a), y = hf({
    margin: 0
  }, c), x = !se(v), _ = x ? v : "", P = ue("recharts-default-tooltip", h), E = ue("recharts-tooltip-label", m);
  x && p && l !== void 0 && l !== null && (_ = p(v, l));
  var M = b ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ A.createElement("div", Fd({
    className: P,
    style: O
  }, M), /* @__PURE__ */ A.createElement("p", {
    className: E,
    style: y
  }, /* @__PURE__ */ A.isValidElement(_) ? _ : "".concat(_)), w());
};
function Ki(e) {
  "@babel/helpers - typeof";
  return Ki = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ki(e);
}
function Ka(e, t, r) {
  return t = xj(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function xj(e) {
  var t = wj(e, "string");
  return Ki(t) == "symbol" ? t : t + "";
}
function wj(e, t) {
  if (Ki(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ki(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var bi = "recharts-tooltip-wrapper", Oj = {
  visibility: "hidden"
};
function _j(e) {
  var t = e.coordinate, r = e.translateX, n = e.translateY;
  return ue(bi, Ka(Ka(Ka(Ka({}, "".concat(bi, "-right"), U(r) && t && U(t.x) && r >= t.x), "".concat(bi, "-left"), U(r) && t && U(t.x) && r < t.x), "".concat(bi, "-bottom"), U(n) && t && U(t.y) && n >= t.y), "".concat(bi, "-top"), U(n) && t && U(t.y) && n < t.y));
}
function ub(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.key, i = e.offsetTopLeft, a = e.position, o = e.reverseDirection, s = e.tooltipDimension, u = e.viewBox, c = e.viewBoxDimension;
  if (a && U(a[n]))
    return a[n];
  var l = r[n] - s - i, f = r[n] + i;
  if (t[n])
    return o[n] ? l : f;
  if (o[n]) {
    var d = l, h = u[n];
    return d < h ? Math.max(f, u[n]) : Math.max(l, u[n]);
  }
  var m = f + s, v = u[n] + c;
  return m > v ? Math.max(l, u[n]) : Math.max(f, u[n]);
}
function Sj(e) {
  var t = e.translateX, r = e.translateY, n = e.useTranslate3d;
  return {
    transform: n ? "translate3d(".concat(t, "px, ").concat(r, "px, 0)") : "translate(".concat(t, "px, ").concat(r, "px)")
  };
}
function Aj(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.offsetTopLeft, i = e.position, a = e.reverseDirection, o = e.tooltipBox, s = e.useTranslate3d, u = e.viewBox, c, l, f;
  return o.height > 0 && o.width > 0 && r ? (l = ub({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "x",
    offsetTopLeft: n,
    position: i,
    reverseDirection: a,
    tooltipDimension: o.width,
    viewBox: u,
    viewBoxDimension: u.width
  }), f = ub({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "y",
    offsetTopLeft: n,
    position: i,
    reverseDirection: a,
    tooltipDimension: o.height,
    viewBox: u,
    viewBoxDimension: u.height
  }), c = Sj({
    translateX: l,
    translateY: f,
    useTranslate3d: s
  })) : c = Oj, {
    cssProperties: c,
    cssClasses: _j({
      translateX: l,
      translateY: f,
      coordinate: r
    })
  };
}
function kn(e) {
  "@babel/helpers - typeof";
  return kn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, kn(e);
}
function cb(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function lb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cb(Object(r), !0).forEach(function(n) {
      Wd(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : cb(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Pj(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Tj(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, m_(n.key), n);
  }
}
function Ej(e, t, r) {
  return t && Tj(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Cj(e, t, r) {
  return t = Po(t), Mj(e, y_() ? Reflect.construct(t, r || [], Po(e).constructor) : t.apply(e, r));
}
function Mj(e, t) {
  if (t && (kn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return jj(e);
}
function jj(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function y_() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (y_ = function() {
    return !!e;
  })();
}
function Po(e) {
  return Po = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Po(e);
}
function kj(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && zd(e, t);
}
function zd(e, t) {
  return zd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, zd(e, t);
}
function Wd(e, t, r) {
  return t = m_(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function m_(e) {
  var t = $j(e, "string");
  return kn(t) == "symbol" ? t : t + "";
}
function $j(e, t) {
  if (kn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (kn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var fb = 1, Nj = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    Pj(this, t);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = Cj(this, t, [].concat(i)), Wd(r, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), Wd(r, "handleKeyDown", function(o) {
      if (o.key === "Escape") {
        var s, u, c, l;
        r.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (s = (u = r.props.coordinate) === null || u === void 0 ? void 0 : u.x) !== null && s !== void 0 ? s : 0,
            y: (c = (l = r.props.coordinate) === null || l === void 0 ? void 0 : l.y) !== null && c !== void 0 ? c : 0
          }
        });
      }
    }), r;
  }
  return kj(t, e), Ej(t, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        (Math.abs(n.width - this.state.lastBoundingBox.width) > fb || Math.abs(n.height - this.state.lastBoundingBox.height) > fb) && this.setState({
          lastBoundingBox: {
            width: n.width,
            height: n.height
          }
        });
      } else (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
        lastBoundingBox: {
          width: -1,
          height: -1
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var n, i;
      this.props.active && this.updateBBox(), this.state.dismissed && (((n = this.props.coordinate) === null || n === void 0 ? void 0 : n.x) !== this.state.dismissedAtCoordinate.x || ((i = this.props.coordinate) === null || i === void 0 ? void 0 : i.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, i = this.props, a = i.active, o = i.allowEscapeViewBox, s = i.animationDuration, u = i.animationEasing, c = i.children, l = i.coordinate, f = i.hasPayload, d = i.isAnimationActive, h = i.offset, m = i.position, v = i.reverseDirection, p = i.useTranslate3d, g = i.viewBox, b = i.wrapperStyle, w = Aj({
        allowEscapeViewBox: o,
        coordinate: l,
        offsetTopLeft: h,
        position: m,
        reverseDirection: v,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: p,
        viewBox: g
      }), O = w.cssClasses, y = w.cssProperties, x = lb(lb({
        transition: d && a ? "transform ".concat(s, "ms ").concat(u) : void 0
      }, y), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && a && f ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, b);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ A.createElement("div", {
          tabIndex: -1,
          className: O,
          style: x,
          ref: function(P) {
            n.wrapperNode = P;
          }
        }, c)
      );
    }
  }]);
}(bt), Ij = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, wr = {
  isSsr: Ij()
};
function $n(e) {
  "@babel/helpers - typeof";
  return $n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $n(e);
}
function db(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function pb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? db(Object(r), !0).forEach(function(n) {
      $h(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : db(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Rj(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Dj(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, b_(n.key), n);
  }
}
function Lj(e, t, r) {
  return t && Dj(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function qj(e, t, r) {
  return t = To(t), Bj(e, g_() ? Reflect.construct(t, r || [], To(e).constructor) : t.apply(e, r));
}
function Bj(e, t) {
  if (t && ($n(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Fj(e);
}
function Fj(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function g_() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (g_ = function() {
    return !!e;
  })();
}
function To(e) {
  return To = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, To(e);
}
function zj(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ud(e, t);
}
function Ud(e, t) {
  return Ud = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Ud(e, t);
}
function $h(e, t, r) {
  return t = b_(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function b_(e) {
  var t = Wj(e, "string");
  return $n(t) == "symbol" ? t : t + "";
}
function Wj(e, t) {
  if ($n(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if ($n(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Uj(e) {
  return e.dataKey;
}
function Gj(e, t) {
  return /* @__PURE__ */ A.isValidElement(e) ? /* @__PURE__ */ A.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ A.createElement(e, t) : /* @__PURE__ */ A.createElement(bj, t);
}
var Ve = /* @__PURE__ */ function(e) {
  function t() {
    return Rj(this, t), qj(this, t, arguments);
  }
  return zj(t, e), Lj(t, [{
    key: "render",
    value: function() {
      var n = this, i = this.props, a = i.active, o = i.allowEscapeViewBox, s = i.animationDuration, u = i.animationEasing, c = i.content, l = i.coordinate, f = i.filterNull, d = i.isAnimationActive, h = i.offset, m = i.payload, v = i.payloadUniqBy, p = i.position, g = i.reverseDirection, b = i.useTranslate3d, w = i.viewBox, O = i.wrapperStyle, y = m ?? [];
      f && y.length && (y = c_(m.filter(function(_) {
        return _.value != null && (_.hide !== !0 || n.props.includeHidden);
      }), v, Uj));
      var x = y.length > 0;
      return /* @__PURE__ */ A.createElement(Nj, {
        allowEscapeViewBox: o,
        animationDuration: s,
        animationEasing: u,
        isAnimationActive: d,
        active: a,
        coordinate: l,
        hasPayload: x,
        offset: h,
        position: p,
        reverseDirection: g,
        useTranslate3d: b,
        viewBox: w,
        wrapperStyle: O
      }, Gj(c, pb(pb({}, this.props), {}, {
        payload: y
      })));
    }
  }]);
}(bt);
$h(Ve, "displayName", "Tooltip");
$h(Ve, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !wr.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var vf, hb;
function Hj() {
  if (hb) return vf;
  hb = 1;
  var e = Bt(), t = function() {
    return e.Date.now();
  };
  return vf = t, vf;
}
var yf, vb;
function Vj() {
  if (vb) return yf;
  vb = 1;
  var e = /\s/;
  function t(r) {
    for (var n = r.length; n-- && e.test(r.charAt(n)); )
      ;
    return n;
  }
  return yf = t, yf;
}
var mf, yb;
function Kj() {
  if (yb) return mf;
  yb = 1;
  var e = Vj(), t = /^\s+/;
  function r(n) {
    return n && n.slice(0, e(n) + 1).replace(t, "");
  }
  return mf = r, mf;
}
var gf, mb;
function x_() {
  if (mb) return gf;
  mb = 1;
  var e = Kj(), t = xr(), r = ii(), n = NaN, i = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, o = /^0o[0-7]+$/i, s = parseInt;
  function u(c) {
    if (typeof c == "number")
      return c;
    if (r(c))
      return n;
    if (t(c)) {
      var l = typeof c.valueOf == "function" ? c.valueOf() : c;
      c = t(l) ? l + "" : l;
    }
    if (typeof c != "string")
      return c === 0 ? c : +c;
    c = e(c);
    var f = a.test(c);
    return f || o.test(c) ? s(c.slice(2), f ? 2 : 8) : i.test(c) ? n : +c;
  }
  return gf = u, gf;
}
var bf, gb;
function Yj() {
  if (gb) return bf;
  gb = 1;
  var e = xr(), t = Hj(), r = x_(), n = "Expected a function", i = Math.max, a = Math.min;
  function o(s, u, c) {
    var l, f, d, h, m, v, p = 0, g = !1, b = !1, w = !0;
    if (typeof s != "function")
      throw new TypeError(n);
    u = r(u) || 0, e(c) && (g = !!c.leading, b = "maxWait" in c, d = b ? i(r(c.maxWait) || 0, u) : d, w = "trailing" in c ? !!c.trailing : w);
    function O(k) {
      var $ = l, I = f;
      return l = f = void 0, p = k, h = s.apply(I, $), h;
    }
    function y(k) {
      return p = k, m = setTimeout(P, u), g ? O(k) : h;
    }
    function x(k) {
      var $ = k - v, I = k - p, R = u - $;
      return b ? a(R, d - I) : R;
    }
    function _(k) {
      var $ = k - v, I = k - p;
      return v === void 0 || $ >= u || $ < 0 || b && I >= d;
    }
    function P() {
      var k = t();
      if (_(k))
        return E(k);
      m = setTimeout(P, x(k));
    }
    function E(k) {
      return m = void 0, w && l ? O(k) : (l = f = void 0, h);
    }
    function M() {
      m !== void 0 && clearTimeout(m), p = 0, l = v = f = m = void 0;
    }
    function C() {
      return m === void 0 ? h : E(t());
    }
    function T() {
      var k = t(), $ = _(k);
      if (l = arguments, f = this, v = k, $) {
        if (m === void 0)
          return y(v);
        if (b)
          return clearTimeout(m), m = setTimeout(P, u), O(v);
      }
      return m === void 0 && (m = setTimeout(P, u)), h;
    }
    return T.cancel = M, T.flush = C, T;
  }
  return bf = o, bf;
}
var xf, bb;
function Xj() {
  if (bb) return xf;
  bb = 1;
  var e = Yj(), t = xr(), r = "Expected a function";
  function n(i, a, o) {
    var s = !0, u = !0;
    if (typeof i != "function")
      throw new TypeError(r);
    return t(o) && (s = "leading" in o ? !!o.leading : s, u = "trailing" in o ? !!o.trailing : u), e(i, a, {
      leading: s,
      maxWait: a,
      trailing: u
    });
  }
  return xf = n, xf;
}
var Zj = Xj();
const w_ = /* @__PURE__ */ xe(Zj);
function Yi(e) {
  "@babel/helpers - typeof";
  return Yi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Yi(e);
}
function xb(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ya(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xb(Object(r), !0).forEach(function(n) {
      Jj(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : xb(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Jj(e, t, r) {
  return t = Qj(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Qj(e) {
  var t = ek(e, "string");
  return Yi(t) == "symbol" ? t : t + "";
}
function ek(e, t) {
  if (Yi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Yi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function tk(e, t) {
  return ak(e) || ik(e, t) || nk(e, t) || rk();
}
function rk() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nk(e, t) {
  if (e) {
    if (typeof e == "string") return wb(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return wb(e, t);
  }
}
function wb(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function ik(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function ak(e) {
  if (Array.isArray(e)) return e;
}
var rn = /* @__PURE__ */ xs(function(e, t) {
  var r = e.aspect, n = e.initialDimension, i = n === void 0 ? {
    width: -1,
    height: -1
  } : n, a = e.width, o = a === void 0 ? "100%" : a, s = e.height, u = s === void 0 ? "100%" : s, c = e.minWidth, l = c === void 0 ? 0 : c, f = e.minHeight, d = e.maxHeight, h = e.children, m = e.debounce, v = m === void 0 ? 0 : m, p = e.id, g = e.className, b = e.onResize, w = e.style, O = w === void 0 ? {} : w, y = An(null), x = An();
  x.current = b, JA(t, function() {
    return Object.defineProperty(y.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), y.current;
      },
      configurable: !0
    });
  });
  var _ = Vt({
    containerWidth: i.width,
    containerHeight: i.height
  }), P = tk(_, 2), E = P[0], M = P[1], C = QA(function(k, $) {
    M(function(I) {
      var R = Math.round(k), q = Math.round($);
      return I.containerWidth === R && I.containerHeight === q ? I : {
        containerWidth: R,
        containerHeight: q
      };
    });
  }, []);
  Aa(function() {
    var k = function(H) {
      var N, L = H[0].contentRect, B = L.width, K = L.height;
      C(B, K), (N = x.current) === null || N === void 0 || N.call(x, B, K);
    };
    v > 0 && (k = w_(k, v, {
      trailing: !0,
      leading: !1
    }));
    var $ = new ResizeObserver(k), I = y.current.getBoundingClientRect(), R = I.width, q = I.height;
    return C(R, q), $.observe(y.current), function() {
      $.disconnect();
    };
  }, [C, v]);
  var T = ws(function() {
    var k = E.containerWidth, $ = E.containerHeight;
    if (k < 0 || $ < 0)
      return null;
    Et(Ir(o) || Ir(u), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, o, u), Et(!r || r > 0, "The aspect(%s) must be greater than zero.", r);
    var I = Ir(o) ? k : o, R = Ir(u) ? $ : u;
    r && r > 0 && (I ? R = I / r : R && (I = R * r), d && R > d && (R = d)), Et(I > 0 || R > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, I, R, o, u, l, f, r);
    var q = !Array.isArray(h) && Jt(h.type).endsWith("Chart");
    return A.Children.map(h, function(W) {
      return /* @__PURE__ */ A.isValidElement(W) ? /* @__PURE__ */ De(W, Ya({
        width: I,
        height: R
      }, q ? {
        style: Ya({
          height: "100%",
          width: "100%",
          maxHeight: R,
          maxWidth: I
        }, W.props.style)
      } : {})) : W;
    });
  }, [r, h, u, d, f, l, E, o]);
  return /* @__PURE__ */ A.createElement("div", {
    id: p ? "".concat(p) : void 0,
    className: ue("recharts-responsive-container", g),
    style: Ya(Ya({}, O), {}, {
      width: o,
      height: u,
      minWidth: l,
      minHeight: f,
      maxHeight: d
    }),
    ref: y
  }, T);
}), Ls = function(t) {
  return null;
};
Ls.displayName = "Cell";
function Xi(e) {
  "@babel/helpers - typeof";
  return Xi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xi(e);
}
function Ob(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Gd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ob(Object(r), !0).forEach(function(n) {
      ok(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ob(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ok(e, t, r) {
  return t = sk(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function sk(e) {
  var t = uk(e, "string");
  return Xi(t) == "symbol" ? t : t + "";
}
function uk(e, t) {
  if (Xi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Xi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ln = {
  widthCache: {},
  cacheCount: 0
}, ck = 2e3, lk = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, _b = "recharts_measurement_span";
function fk(e) {
  var t = Gd({}, e);
  return Object.keys(t).forEach(function(r) {
    t[r] || delete t[r];
  }), t;
}
var Ni = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || wr.isSsr)
    return {
      width: 0,
      height: 0
    };
  var n = fk(r), i = JSON.stringify({
    text: t,
    copyStyle: n
  });
  if (ln.widthCache[i])
    return ln.widthCache[i];
  try {
    var a = document.getElementById(_b);
    a || (a = document.createElement("span"), a.setAttribute("id", _b), a.setAttribute("aria-hidden", "true"), document.body.appendChild(a));
    var o = Gd(Gd({}, lk), n);
    Object.assign(a.style, o), a.textContent = "".concat(t);
    var s = a.getBoundingClientRect(), u = {
      width: s.width,
      height: s.height
    };
    return ln.widthCache[i] = u, ++ln.cacheCount > ck && (ln.cacheCount = 0, ln.widthCache = {}), u;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, dk = function(t) {
  return {
    top: t.top + window.scrollY - document.documentElement.clientTop,
    left: t.left + window.scrollX - document.documentElement.clientLeft
  };
};
function Zi(e) {
  "@babel/helpers - typeof";
  return Zi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zi(e);
}
function Eo(e, t) {
  return yk(e) || vk(e, t) || hk(e, t) || pk();
}
function pk() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function hk(e, t) {
  if (e) {
    if (typeof e == "string") return Sb(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Sb(e, t);
  }
}
function Sb(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function vk(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        u = !1;
      } else for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function yk(e) {
  if (Array.isArray(e)) return e;
}
function mk(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ab(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bk(n.key), n);
  }
}
function gk(e, t, r) {
  return t && Ab(e.prototype, t), r && Ab(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function bk(e) {
  var t = xk(e, "string");
  return Zi(t) == "symbol" ? t : t + "";
}
function xk(e, t) {
  if (Zi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Zi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Pb = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, Tb = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, wk = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, Ok = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, O_ = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, _k = Object.keys(O_), hn = "NaN";
function Sk(e, t) {
  return e * O_[t];
}
var Xa = /* @__PURE__ */ function() {
  function e(t, r) {
    mk(this, e), this.num = t, this.unit = r, this.num = t, this.unit = r, Number.isNaN(t) && (this.unit = ""), r !== "" && !wk.test(r) && (this.num = NaN, this.unit = ""), _k.includes(r) && (this.num = Sk(t, r), this.unit = "px");
  }
  return gk(e, [{
    key: "add",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num + r.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num - r.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num * r.num, this.unit || r.unit);
    }
  }, {
    key: "divide",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num / r.num, this.unit || r.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(r) {
      var n, i = (n = Ok.exec(r)) !== null && n !== void 0 ? n : [], a = Eo(i, 3), o = a[1], s = a[2];
      return new e(parseFloat(o), s ?? "");
    }
  }]);
}();
function __(e) {
  if (e.includes(hn))
    return hn;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var r, n = (r = Pb.exec(t)) !== null && r !== void 0 ? r : [], i = Eo(n, 4), a = i[1], o = i[2], s = i[3], u = Xa.parse(a ?? ""), c = Xa.parse(s ?? ""), l = o === "*" ? u.multiply(c) : u.divide(c);
    if (l.isNaN())
      return hn;
    t = t.replace(Pb, l.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var f, d = (f = Tb.exec(t)) !== null && f !== void 0 ? f : [], h = Eo(d, 4), m = h[1], v = h[2], p = h[3], g = Xa.parse(m ?? ""), b = Xa.parse(p ?? ""), w = v === "+" ? g.add(b) : g.subtract(b);
    if (w.isNaN())
      return hn;
    t = t.replace(Tb, w.toString());
  }
  return t;
}
var Eb = /\(([^()]*)\)/;
function Ak(e) {
  for (var t = e; t.includes("("); ) {
    var r = Eb.exec(t), n = Eo(r, 2), i = n[1];
    t = t.replace(Eb, __(i));
  }
  return t;
}
function Pk(e) {
  var t = e.replace(/\s+/g, "");
  return t = Ak(t), t = __(t), t;
}
function Tk(e) {
  try {
    return Pk(e);
  } catch {
    return hn;
  }
}
function wf(e) {
  var t = Tk(e.slice(5, -1));
  return t === hn ? "" : t;
}
var Ek = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], Ck = ["dx", "dy", "angle", "className", "breakAll"];
function Hd() {
  return Hd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Hd.apply(this, arguments);
}
function Cb(e, t) {
  if (e == null) return {};
  var r = Mk(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Mk(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Mb(e, t) {
  return Nk(e) || $k(e, t) || kk(e, t) || jk();
}
function jk() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kk(e, t) {
  if (e) {
    if (typeof e == "string") return jb(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return jb(e, t);
  }
}
function jb(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function $k(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        u = !1;
      } else for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function Nk(e) {
  if (Array.isArray(e)) return e;
}
var S_ = /[ \f\n\r\t\v\u2028\u2029]+/, A_ = function(t) {
  var r = t.children, n = t.breakAll, i = t.style;
  try {
    var a = [];
    se(r) || (n ? a = r.toString().split("") : a = r.toString().split(S_));
    var o = a.map(function(u) {
      return {
        word: u,
        width: Ni(u, i).width
      };
    }), s = n ? 0 : Ni(" ", i).width;
    return {
      wordsWithComputedWidth: o,
      spaceWidth: s
    };
  } catch {
    return null;
  }
}, Ik = function(t, r, n, i, a) {
  var o = t.maxLines, s = t.children, u = t.style, c = t.breakAll, l = U(o), f = s, d = function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return I.reduce(function(R, q) {
      var W = q.word, H = q.width, N = R[R.length - 1];
      if (N && (i == null || a || N.width + H + n < Number(i)))
        N.words.push(W), N.width += H + n;
      else {
        var L = {
          words: [W],
          width: H
        };
        R.push(L);
      }
      return R;
    }, []);
  }, h = d(r), m = function(I) {
    return I.reduce(function(R, q) {
      return R.width > q.width ? R : q;
    });
  };
  if (!l)
    return h;
  for (var v = "…", p = function(I) {
    var R = f.slice(0, I), q = A_({
      breakAll: c,
      style: u,
      children: R + v
    }).wordsWithComputedWidth, W = d(q), H = W.length > o || m(W).width > Number(i);
    return [H, W];
  }, g = 0, b = f.length - 1, w = 0, O; g <= b && w <= f.length - 1; ) {
    var y = Math.floor((g + b) / 2), x = y - 1, _ = p(x), P = Mb(_, 2), E = P[0], M = P[1], C = p(y), T = Mb(C, 1), k = T[0];
    if (!E && !k && (g = y + 1), E && k && (b = y - 1), !E && k) {
      O = M;
      break;
    }
    w++;
  }
  return O || h;
}, kb = function(t) {
  var r = se(t) ? [] : t.toString().split(S_);
  return [{
    words: r
  }];
}, Rk = function(t) {
  var r = t.width, n = t.scaleToFit, i = t.children, a = t.style, o = t.breakAll, s = t.maxLines;
  if ((r || n) && !wr.isSsr) {
    var u, c, l = A_({
      breakAll: o,
      children: i,
      style: a
    });
    if (l) {
      var f = l.wordsWithComputedWidth, d = l.spaceWidth;
      u = f, c = d;
    } else
      return kb(i);
    return Ik({
      breakAll: o,
      children: i,
      maxLines: s,
      style: a
    }, u, c, r, n);
  }
  return kb(i);
}, $b = "#808080", Kr = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, i = t.y, a = i === void 0 ? 0 : i, o = t.lineHeight, s = o === void 0 ? "1em" : o, u = t.capHeight, c = u === void 0 ? "0.71em" : u, l = t.scaleToFit, f = l === void 0 ? !1 : l, d = t.textAnchor, h = d === void 0 ? "start" : d, m = t.verticalAnchor, v = m === void 0 ? "end" : m, p = t.fill, g = p === void 0 ? $b : p, b = Cb(t, Ek), w = ws(function() {
    return Rk({
      breakAll: b.breakAll,
      children: b.children,
      maxLines: b.maxLines,
      scaleToFit: f,
      style: b.style,
      width: b.width
    });
  }, [b.breakAll, b.children, b.maxLines, f, b.style, b.width]), O = b.dx, y = b.dy, x = b.angle, _ = b.className, P = b.breakAll, E = Cb(b, Ck);
  if (!qe(n) || !qe(a))
    return null;
  var M = n + (U(O) ? O : 0), C = a + (U(y) ? y : 0), T;
  switch (v) {
    case "start":
      T = wf("calc(".concat(c, ")"));
      break;
    case "middle":
      T = wf("calc(".concat((w.length - 1) / 2, " * -").concat(s, " + (").concat(c, " / 2))"));
      break;
    default:
      T = wf("calc(".concat(w.length - 1, " * -").concat(s, ")"));
      break;
  }
  var k = [];
  if (f) {
    var $ = w[0].width, I = b.width;
    k.push("scale(".concat((U(I) ? I / $ : 1) / $, ")"));
  }
  return x && k.push("rotate(".concat(x, ", ").concat(M, ", ").concat(C, ")")), k.length && (E.transform = k.join(" ")), /* @__PURE__ */ A.createElement("text", Hd({}, Q(E, !0), {
    x: M,
    y: C,
    className: ue("recharts-text", _),
    textAnchor: h,
    fill: g.includes("url") ? $b : g
  }), w.map(function(R, q) {
    var W = R.words.join(P ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ A.createElement("tspan", {
        x: M,
        dy: q === 0 ? T : s,
        key: "".concat(W, "-").concat(q)
      }, W)
    );
  }));
};
function gr(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function Dk(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function Nh(e) {
  let t, r, n;
  e.length !== 2 ? (t = gr, r = (s, u) => gr(e(s), u), n = (s, u) => e(s) - u) : (t = e === gr || e === Dk ? e : Lk, r = e, n = e);
  function i(s, u, c = 0, l = s.length) {
    if (c < l) {
      if (t(u, u) !== 0) return l;
      do {
        const f = c + l >>> 1;
        r(s[f], u) < 0 ? c = f + 1 : l = f;
      } while (c < l);
    }
    return c;
  }
  function a(s, u, c = 0, l = s.length) {
    if (c < l) {
      if (t(u, u) !== 0) return l;
      do {
        const f = c + l >>> 1;
        r(s[f], u) <= 0 ? c = f + 1 : l = f;
      } while (c < l);
    }
    return c;
  }
  function o(s, u, c = 0, l = s.length) {
    const f = i(s, u, c, l - 1);
    return f > c && n(s[f - 1], u) > -n(s[f], u) ? f - 1 : f;
  }
  return { left: i, center: o, right: a };
}
function Lk() {
  return 0;
}
function P_(e) {
  return e === null ? NaN : +e;
}
function* qk(e, t) {
  for (let r of e)
    r != null && (r = +r) >= r && (yield r);
}
const Bk = Nh(gr), ja = Bk.right;
Nh(P_).center;
class Nb extends Map {
  constructor(t, r = Wk) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: r } }), t != null) for (const [n, i] of t) this.set(n, i);
  }
  get(t) {
    return super.get(Ib(this, t));
  }
  has(t) {
    return super.has(Ib(this, t));
  }
  set(t, r) {
    return super.set(Fk(this, t), r);
  }
  delete(t) {
    return super.delete(zk(this, t));
  }
}
function Ib({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : r;
}
function Fk({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : (e.set(n, r), r);
}
function zk({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) && (r = e.get(n), e.delete(n)), r;
}
function Wk(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function Uk(e = gr) {
  if (e === gr) return T_;
  if (typeof e != "function") throw new TypeError("compare is not a function");
  return (t, r) => {
    const n = e(t, r);
    return n || n === 0 ? n : (e(r, r) === 0) - (e(t, t) === 0);
  };
}
function T_(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const Gk = Math.sqrt(50), Hk = Math.sqrt(10), Vk = Math.sqrt(2);
function Co(e, t, r) {
  const n = (t - e) / Math.max(0, r), i = Math.floor(Math.log10(n)), a = n / Math.pow(10, i), o = a >= Gk ? 10 : a >= Hk ? 5 : a >= Vk ? 2 : 1;
  let s, u, c;
  return i < 0 ? (c = Math.pow(10, -i) / o, s = Math.round(e * c), u = Math.round(t * c), s / c < e && ++s, u / c > t && --u, c = -c) : (c = Math.pow(10, i) * o, s = Math.round(e / c), u = Math.round(t / c), s * c < e && ++s, u * c > t && --u), u < s && 0.5 <= r && r < 2 ? Co(e, t, r * 2) : [s, u, c];
}
function Vd(e, t, r) {
  if (t = +t, e = +e, r = +r, !(r > 0)) return [];
  if (e === t) return [e];
  const n = t < e, [i, a, o] = n ? Co(t, e, r) : Co(e, t, r);
  if (!(a >= i)) return [];
  const s = a - i + 1, u = new Array(s);
  if (n)
    if (o < 0) for (let c = 0; c < s; ++c) u[c] = (a - c) / -o;
    else for (let c = 0; c < s; ++c) u[c] = (a - c) * o;
  else if (o < 0) for (let c = 0; c < s; ++c) u[c] = (i + c) / -o;
  else for (let c = 0; c < s; ++c) u[c] = (i + c) * o;
  return u;
}
function Kd(e, t, r) {
  return t = +t, e = +e, r = +r, Co(e, t, r)[2];
}
function Yd(e, t, r) {
  t = +t, e = +e, r = +r;
  const n = t < e, i = n ? Kd(t, e, r) : Kd(e, t, r);
  return (n ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function Rb(e, t) {
  let r;
  for (const n of e)
    n != null && (r < n || r === void 0 && n >= n) && (r = n);
  return r;
}
function Db(e, t) {
  let r;
  for (const n of e)
    n != null && (r > n || r === void 0 && n >= n) && (r = n);
  return r;
}
function E_(e, t, r = 0, n = 1 / 0, i) {
  if (t = Math.floor(t), r = Math.floor(Math.max(0, r)), n = Math.floor(Math.min(e.length - 1, n)), !(r <= t && t <= n)) return e;
  for (i = i === void 0 ? T_ : Uk(i); n > r; ) {
    if (n - r > 600) {
      const u = n - r + 1, c = t - r + 1, l = Math.log(u), f = 0.5 * Math.exp(2 * l / 3), d = 0.5 * Math.sqrt(l * f * (u - f) / u) * (c - u / 2 < 0 ? -1 : 1), h = Math.max(r, Math.floor(t - c * f / u + d)), m = Math.min(n, Math.floor(t + (u - c) * f / u + d));
      E_(e, t, h, m, i);
    }
    const a = e[t];
    let o = r, s = n;
    for (xi(e, r, t), i(e[n], a) > 0 && xi(e, r, n); o < s; ) {
      for (xi(e, o, s), ++o, --s; i(e[o], a) < 0; ) ++o;
      for (; i(e[s], a) > 0; ) --s;
    }
    i(e[r], a) === 0 ? xi(e, r, s) : (++s, xi(e, s, n)), s <= t && (r = s + 1), t <= s && (n = s - 1);
  }
  return e;
}
function xi(e, t, r) {
  const n = e[t];
  e[t] = e[r], e[r] = n;
}
function Kk(e, t, r) {
  if (e = Float64Array.from(qk(e)), !(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2) return Db(e);
    if (t >= 1) return Rb(e);
    var n, i = (n - 1) * t, a = Math.floor(i), o = Rb(E_(e, a).subarray(0, a + 1)), s = Db(e.subarray(a + 1));
    return o + (s - o) * (i - a);
  }
}
function Yk(e, t, r = P_) {
  if (!(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2) return +r(e[0], 0, e);
    if (t >= 1) return +r(e[n - 1], n - 1, e);
    var n, i = (n - 1) * t, a = Math.floor(i), o = +r(e[a], a, e), s = +r(e[a + 1], a + 1, e);
    return o + (s - o) * (i - a);
  }
}
function Xk(e, t, r) {
  e = +e, t = +t, r = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +r;
  for (var n = -1, i = Math.max(0, Math.ceil((t - e) / r)) | 0, a = new Array(i); ++n < i; )
    a[n] = e + n * r;
  return a;
}
function wt(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function or(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const Xd = Symbol("implicit");
function Ih() {
  var e = new Nb(), t = [], r = [], n = Xd;
  function i(a) {
    let o = e.get(a);
    if (o === void 0) {
      if (n !== Xd) return n;
      e.set(a, o = t.push(a) - 1);
    }
    return r[o % r.length];
  }
  return i.domain = function(a) {
    if (!arguments.length) return t.slice();
    t = [], e = new Nb();
    for (const o of a)
      e.has(o) || e.set(o, t.push(o) - 1);
    return i;
  }, i.range = function(a) {
    return arguments.length ? (r = Array.from(a), i) : r.slice();
  }, i.unknown = function(a) {
    return arguments.length ? (n = a, i) : n;
  }, i.copy = function() {
    return Ih(t, r).unknown(n);
  }, wt.apply(i, arguments), i;
}
function Ji() {
  var e = Ih().unknown(void 0), t = e.domain, r = e.range, n = 0, i = 1, a, o, s = !1, u = 0, c = 0, l = 0.5;
  delete e.unknown;
  function f() {
    var d = t().length, h = i < n, m = h ? i : n, v = h ? n : i;
    a = (v - m) / Math.max(1, d - u + c * 2), s && (a = Math.floor(a)), m += (v - m - a * (d - u)) * l, o = a * (1 - u), s && (m = Math.round(m), o = Math.round(o));
    var p = Xk(d).map(function(g) {
      return m + a * g;
    });
    return r(h ? p.reverse() : p);
  }
  return e.domain = function(d) {
    return arguments.length ? (t(d), f()) : t();
  }, e.range = function(d) {
    return arguments.length ? ([n, i] = d, n = +n, i = +i, f()) : [n, i];
  }, e.rangeRound = function(d) {
    return [n, i] = d, n = +n, i = +i, s = !0, f();
  }, e.bandwidth = function() {
    return o;
  }, e.step = function() {
    return a;
  }, e.round = function(d) {
    return arguments.length ? (s = !!d, f()) : s;
  }, e.padding = function(d) {
    return arguments.length ? (u = Math.min(1, c = +d), f()) : u;
  }, e.paddingInner = function(d) {
    return arguments.length ? (u = Math.min(1, d), f()) : u;
  }, e.paddingOuter = function(d) {
    return arguments.length ? (c = +d, f()) : c;
  }, e.align = function(d) {
    return arguments.length ? (l = Math.max(0, Math.min(1, d)), f()) : l;
  }, e.copy = function() {
    return Ji(t(), [n, i]).round(s).paddingInner(u).paddingOuter(c).align(l);
  }, wt.apply(f(), arguments);
}
function C_(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return C_(t());
  }, e;
}
function Ii() {
  return C_(Ji.apply(null, arguments).paddingInner(1));
}
function Rh(e, t, r) {
  e.prototype = t.prototype = r, r.constructor = e;
}
function M_(e, t) {
  var r = Object.create(e.prototype);
  for (var n in t) r[n] = t[n];
  return r;
}
function ka() {
}
var Qi = 0.7, Mo = 1 / Qi, _n = "\\s*([+-]?\\d+)\\s*", ea = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Rt = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Zk = /^#([0-9a-f]{3,8})$/, Jk = new RegExp(`^rgb\\(${_n},${_n},${_n}\\)$`), Qk = new RegExp(`^rgb\\(${Rt},${Rt},${Rt}\\)$`), e$ = new RegExp(`^rgba\\(${_n},${_n},${_n},${ea}\\)$`), t$ = new RegExp(`^rgba\\(${Rt},${Rt},${Rt},${ea}\\)$`), r$ = new RegExp(`^hsl\\(${ea},${Rt},${Rt}\\)$`), n$ = new RegExp(`^hsla\\(${ea},${Rt},${Rt},${ea}\\)$`), Lb = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Rh(ka, ta, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: qb,
  // Deprecated! Use color.formatHex.
  formatHex: qb,
  formatHex8: i$,
  formatHsl: a$,
  formatRgb: Bb,
  toString: Bb
});
function qb() {
  return this.rgb().formatHex();
}
function i$() {
  return this.rgb().formatHex8();
}
function a$() {
  return j_(this).formatHsl();
}
function Bb() {
  return this.rgb().formatRgb();
}
function ta(e) {
  var t, r;
  return e = (e + "").trim().toLowerCase(), (t = Zk.exec(e)) ? (r = t[1].length, t = parseInt(t[1], 16), r === 6 ? Fb(t) : r === 3 ? new et(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : r === 8 ? Za(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : r === 4 ? Za(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = Jk.exec(e)) ? new et(t[1], t[2], t[3], 1) : (t = Qk.exec(e)) ? new et(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = e$.exec(e)) ? Za(t[1], t[2], t[3], t[4]) : (t = t$.exec(e)) ? Za(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = r$.exec(e)) ? Ub(t[1], t[2] / 100, t[3] / 100, 1) : (t = n$.exec(e)) ? Ub(t[1], t[2] / 100, t[3] / 100, t[4]) : Lb.hasOwnProperty(e) ? Fb(Lb[e]) : e === "transparent" ? new et(NaN, NaN, NaN, 0) : null;
}
function Fb(e) {
  return new et(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Za(e, t, r, n) {
  return n <= 0 && (e = t = r = NaN), new et(e, t, r, n);
}
function o$(e) {
  return e instanceof ka || (e = ta(e)), e ? (e = e.rgb(), new et(e.r, e.g, e.b, e.opacity)) : new et();
}
function Zd(e, t, r, n) {
  return arguments.length === 1 ? o$(e) : new et(e, t, r, n ?? 1);
}
function et(e, t, r, n) {
  this.r = +e, this.g = +t, this.b = +r, this.opacity = +n;
}
Rh(et, Zd, M_(ka, {
  brighter(e) {
    return e = e == null ? Mo : Math.pow(Mo, e), new et(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Qi : Math.pow(Qi, e), new et(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new et(zr(this.r), zr(this.g), zr(this.b), jo(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: zb,
  // Deprecated! Use color.formatHex.
  formatHex: zb,
  formatHex8: s$,
  formatRgb: Wb,
  toString: Wb
}));
function zb() {
  return `#${Rr(this.r)}${Rr(this.g)}${Rr(this.b)}`;
}
function s$() {
  return `#${Rr(this.r)}${Rr(this.g)}${Rr(this.b)}${Rr((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Wb() {
  const e = jo(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${zr(this.r)}, ${zr(this.g)}, ${zr(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function jo(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function zr(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Rr(e) {
  return e = zr(e), (e < 16 ? "0" : "") + e.toString(16);
}
function Ub(e, t, r, n) {
  return n <= 0 ? e = t = r = NaN : r <= 0 || r >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new At(e, t, r, n);
}
function j_(e) {
  if (e instanceof At) return new At(e.h, e.s, e.l, e.opacity);
  if (e instanceof ka || (e = ta(e)), !e) return new At();
  if (e instanceof At) return e;
  e = e.rgb();
  var t = e.r / 255, r = e.g / 255, n = e.b / 255, i = Math.min(t, r, n), a = Math.max(t, r, n), o = NaN, s = a - i, u = (a + i) / 2;
  return s ? (t === a ? o = (r - n) / s + (r < n) * 6 : r === a ? o = (n - t) / s + 2 : o = (t - r) / s + 4, s /= u < 0.5 ? a + i : 2 - a - i, o *= 60) : s = u > 0 && u < 1 ? 0 : o, new At(o, s, u, e.opacity);
}
function u$(e, t, r, n) {
  return arguments.length === 1 ? j_(e) : new At(e, t, r, n ?? 1);
}
function At(e, t, r, n) {
  this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
}
Rh(At, u$, M_(ka, {
  brighter(e) {
    return e = e == null ? Mo : Math.pow(Mo, e), new At(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Qi : Math.pow(Qi, e), new At(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < 0.5 ? r : 1 - r) * t, i = 2 * r - n;
    return new et(
      Of(e >= 240 ? e - 240 : e + 120, i, n),
      Of(e, i, n),
      Of(e < 120 ? e + 240 : e - 120, i, n),
      this.opacity
    );
  },
  clamp() {
    return new At(Gb(this.h), Ja(this.s), Ja(this.l), jo(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = jo(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${Gb(this.h)}, ${Ja(this.s) * 100}%, ${Ja(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function Gb(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function Ja(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function Of(e, t, r) {
  return (e < 60 ? t + (r - t) * e / 60 : e < 180 ? r : e < 240 ? t + (r - t) * (240 - e) / 60 : t) * 255;
}
const Dh = (e) => () => e;
function c$(e, t) {
  return function(r) {
    return e + r * t;
  };
}
function l$(e, t, r) {
  return e = Math.pow(e, r), t = Math.pow(t, r) - e, r = 1 / r, function(n) {
    return Math.pow(e + n * t, r);
  };
}
function f$(e) {
  return (e = +e) == 1 ? k_ : function(t, r) {
    return r - t ? l$(t, r, e) : Dh(isNaN(t) ? r : t);
  };
}
function k_(e, t) {
  var r = t - e;
  return r ? c$(e, r) : Dh(isNaN(e) ? t : e);
}
const Hb = function e(t) {
  var r = f$(t);
  function n(i, a) {
    var o = r((i = Zd(i)).r, (a = Zd(a)).r), s = r(i.g, a.g), u = r(i.b, a.b), c = k_(i.opacity, a.opacity);
    return function(l) {
      return i.r = o(l), i.g = s(l), i.b = u(l), i.opacity = c(l), i + "";
    };
  }
  return n.gamma = e, n;
}(1);
function d$(e, t) {
  t || (t = []);
  var r = e ? Math.min(t.length, e.length) : 0, n = t.slice(), i;
  return function(a) {
    for (i = 0; i < r; ++i) n[i] = e[i] * (1 - a) + t[i] * a;
    return n;
  };
}
function p$(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function h$(e, t) {
  var r = t ? t.length : 0, n = e ? Math.min(r, e.length) : 0, i = new Array(n), a = new Array(r), o;
  for (o = 0; o < n; ++o) i[o] = ui(e[o], t[o]);
  for (; o < r; ++o) a[o] = t[o];
  return function(s) {
    for (o = 0; o < n; ++o) a[o] = i[o](s);
    return a;
  };
}
function v$(e, t) {
  var r = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(n) {
    return r.setTime(e * (1 - n) + t * n), r;
  };
}
function ko(e, t) {
  return e = +e, t = +t, function(r) {
    return e * (1 - r) + t * r;
  };
}
function y$(e, t) {
  var r = {}, n = {}, i;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (i in t)
    i in e ? r[i] = ui(e[i], t[i]) : n[i] = t[i];
  return function(a) {
    for (i in r) n[i] = r[i](a);
    return n;
  };
}
var Jd = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, _f = new RegExp(Jd.source, "g");
function m$(e) {
  return function() {
    return e;
  };
}
function g$(e) {
  return function(t) {
    return e(t) + "";
  };
}
function b$(e, t) {
  var r = Jd.lastIndex = _f.lastIndex = 0, n, i, a, o = -1, s = [], u = [];
  for (e = e + "", t = t + ""; (n = Jd.exec(e)) && (i = _f.exec(t)); )
    (a = i.index) > r && (a = t.slice(r, a), s[o] ? s[o] += a : s[++o] = a), (n = n[0]) === (i = i[0]) ? s[o] ? s[o] += i : s[++o] = i : (s[++o] = null, u.push({ i: o, x: ko(n, i) })), r = _f.lastIndex;
  return r < t.length && (a = t.slice(r), s[o] ? s[o] += a : s[++o] = a), s.length < 2 ? u[0] ? g$(u[0].x) : m$(t) : (t = u.length, function(c) {
    for (var l = 0, f; l < t; ++l) s[(f = u[l]).i] = f.x(c);
    return s.join("");
  });
}
function ui(e, t) {
  var r = typeof t, n;
  return t == null || r === "boolean" ? Dh(t) : (r === "number" ? ko : r === "string" ? (n = ta(t)) ? (t = n, Hb) : b$ : t instanceof ta ? Hb : t instanceof Date ? v$ : p$(t) ? d$ : Array.isArray(t) ? h$ : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? y$ : ko)(e, t);
}
function Lh(e, t) {
  return e = +e, t = +t, function(r) {
    return Math.round(e * (1 - r) + t * r);
  };
}
function x$(e, t) {
  t === void 0 && (t = e, e = ui);
  for (var r = 0, n = t.length - 1, i = t[0], a = new Array(n < 0 ? 0 : n); r < n; ) a[r] = e(i, i = t[++r]);
  return function(o) {
    var s = Math.max(0, Math.min(n - 1, Math.floor(o *= n)));
    return a[s](o - s);
  };
}
function w$(e) {
  return function() {
    return e;
  };
}
function $o(e) {
  return +e;
}
var Vb = [0, 1];
function Ze(e) {
  return e;
}
function Qd(e, t) {
  return (t -= e = +e) ? function(r) {
    return (r - e) / t;
  } : w$(isNaN(t) ? NaN : 0.5);
}
function O$(e, t) {
  var r;
  return e > t && (r = e, e = t, t = r), function(n) {
    return Math.max(e, Math.min(t, n));
  };
}
function _$(e, t, r) {
  var n = e[0], i = e[1], a = t[0], o = t[1];
  return i < n ? (n = Qd(i, n), a = r(o, a)) : (n = Qd(n, i), a = r(a, o)), function(s) {
    return a(n(s));
  };
}
function S$(e, t, r) {
  var n = Math.min(e.length, t.length) - 1, i = new Array(n), a = new Array(n), o = -1;
  for (e[n] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++o < n; )
    i[o] = Qd(e[o], e[o + 1]), a[o] = r(t[o], t[o + 1]);
  return function(s) {
    var u = ja(e, s, 1, n) - 1;
    return a[u](i[u](s));
  };
}
function $a(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function qs() {
  var e = Vb, t = Vb, r = ui, n, i, a, o = Ze, s, u, c;
  function l() {
    var d = Math.min(e.length, t.length);
    return o !== Ze && (o = O$(e[0], e[d - 1])), s = d > 2 ? S$ : _$, u = c = null, f;
  }
  function f(d) {
    return d == null || isNaN(d = +d) ? a : (u || (u = s(e.map(n), t, r)))(n(o(d)));
  }
  return f.invert = function(d) {
    return o(i((c || (c = s(t, e.map(n), ko)))(d)));
  }, f.domain = function(d) {
    return arguments.length ? (e = Array.from(d, $o), l()) : e.slice();
  }, f.range = function(d) {
    return arguments.length ? (t = Array.from(d), l()) : t.slice();
  }, f.rangeRound = function(d) {
    return t = Array.from(d), r = Lh, l();
  }, f.clamp = function(d) {
    return arguments.length ? (o = d ? !0 : Ze, l()) : o !== Ze;
  }, f.interpolate = function(d) {
    return arguments.length ? (r = d, l()) : r;
  }, f.unknown = function(d) {
    return arguments.length ? (a = d, f) : a;
  }, function(d, h) {
    return n = d, i = h, l();
  };
}
function qh() {
  return qs()(Ze, Ze);
}
function A$(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function No(e, t) {
  if (!isFinite(e) || e === 0) return null;
  var r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e"), n = e.slice(0, r);
  return [
    n.length > 1 ? n[0] + n.slice(2) : n,
    +e.slice(r + 1)
  ];
}
function Nn(e) {
  return e = No(Math.abs(e)), e ? e[1] : NaN;
}
function P$(e, t) {
  return function(r, n) {
    for (var i = r.length, a = [], o = 0, s = e[0], u = 0; i > 0 && s > 0 && (u + s + 1 > n && (s = Math.max(1, n - u)), a.push(r.substring(i -= s, i + s)), !((u += s + 1) > n)); )
      s = e[o = (o + 1) % e.length];
    return a.reverse().join(t);
  };
}
function T$(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(r) {
      return e[+r];
    });
  };
}
var E$ = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function ra(e) {
  if (!(t = E$.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new Bh({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
ra.prototype = Bh.prototype;
function Bh(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
Bh.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function C$(e) {
  e: for (var t = e.length, r = 1, n = -1, i; r < t; ++r)
    switch (e[r]) {
      case ".":
        n = i = r;
        break;
      case "0":
        n === 0 && (n = r), i = r;
        break;
      default:
        if (!+e[r]) break e;
        n > 0 && (n = 0);
        break;
    }
  return n > 0 ? e.slice(0, n) + e.slice(i + 1) : e;
}
var Io;
function M$(e, t) {
  var r = No(e, t);
  if (!r) return Io = void 0, e.toPrecision(t);
  var n = r[0], i = r[1], a = i - (Io = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, o = n.length;
  return a === o ? n : a > o ? n + new Array(a - o + 1).join("0") : a > 0 ? n.slice(0, a) + "." + n.slice(a) : "0." + new Array(1 - a).join("0") + No(e, Math.max(0, t + a - 1))[0];
}
function Kb(e, t) {
  var r = No(e, t);
  if (!r) return e + "";
  var n = r[0], i = r[1];
  return i < 0 ? "0." + new Array(-i).join("0") + n : n.length > i + 1 ? n.slice(0, i + 1) + "." + n.slice(i + 1) : n + new Array(i - n.length + 2).join("0");
}
const Yb = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: A$,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => Kb(e * 100, t),
  r: Kb,
  s: M$,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function Xb(e) {
  return e;
}
var Zb = Array.prototype.map, Jb = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function j$(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? Xb : P$(Zb.call(e.grouping, Number), e.thousands + ""), r = e.currency === void 0 ? "" : e.currency[0] + "", n = e.currency === void 0 ? "" : e.currency[1] + "", i = e.decimal === void 0 ? "." : e.decimal + "", a = e.numerals === void 0 ? Xb : T$(Zb.call(e.numerals, String)), o = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", u = e.nan === void 0 ? "NaN" : e.nan + "";
  function c(f, d) {
    f = ra(f);
    var h = f.fill, m = f.align, v = f.sign, p = f.symbol, g = f.zero, b = f.width, w = f.comma, O = f.precision, y = f.trim, x = f.type;
    x === "n" ? (w = !0, x = "g") : Yb[x] || (O === void 0 && (O = 12), y = !0, x = "g"), (g || h === "0" && m === "=") && (g = !0, h = "0", m = "=");
    var _ = (d && d.prefix !== void 0 ? d.prefix : "") + (p === "$" ? r : p === "#" && /[boxX]/.test(x) ? "0" + x.toLowerCase() : ""), P = (p === "$" ? n : /[%p]/.test(x) ? o : "") + (d && d.suffix !== void 0 ? d.suffix : ""), E = Yb[x], M = /[defgprs%]/.test(x);
    O = O === void 0 ? 6 : /[gprs]/.test(x) ? Math.max(1, Math.min(21, O)) : Math.max(0, Math.min(20, O));
    function C(T) {
      var k = _, $ = P, I, R, q;
      if (x === "c")
        $ = E(T) + $, T = "";
      else {
        T = +T;
        var W = T < 0 || 1 / T < 0;
        if (T = isNaN(T) ? u : E(Math.abs(T), O), y && (T = C$(T)), W && +T == 0 && v !== "+" && (W = !1), k = (W ? v === "(" ? v : s : v === "-" || v === "(" ? "" : v) + k, $ = (x === "s" && !isNaN(T) && Io !== void 0 ? Jb[8 + Io / 3] : "") + $ + (W && v === "(" ? ")" : ""), M) {
          for (I = -1, R = T.length; ++I < R; )
            if (q = T.charCodeAt(I), 48 > q || q > 57) {
              $ = (q === 46 ? i + T.slice(I + 1) : T.slice(I)) + $, T = T.slice(0, I);
              break;
            }
        }
      }
      w && !g && (T = t(T, 1 / 0));
      var H = k.length + T.length + $.length, N = H < b ? new Array(b - H + 1).join(h) : "";
      switch (w && g && (T = t(N + T, N.length ? b - $.length : 1 / 0), N = ""), m) {
        case "<":
          T = k + T + $ + N;
          break;
        case "=":
          T = k + N + T + $;
          break;
        case "^":
          T = N.slice(0, H = N.length >> 1) + k + T + $ + N.slice(H);
          break;
        default:
          T = N + k + T + $;
          break;
      }
      return a(T);
    }
    return C.toString = function() {
      return f + "";
    }, C;
  }
  function l(f, d) {
    var h = Math.max(-8, Math.min(8, Math.floor(Nn(d) / 3))) * 3, m = Math.pow(10, -h), v = c((f = ra(f), f.type = "f", f), { suffix: Jb[8 + h / 3] });
    return function(p) {
      return v(m * p);
    };
  }
  return {
    format: c,
    formatPrefix: l
  };
}
var Qa, Fh, $_;
k$({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function k$(e) {
  return Qa = j$(e), Fh = Qa.format, $_ = Qa.formatPrefix, Qa;
}
function $$(e) {
  return Math.max(0, -Nn(Math.abs(e)));
}
function N$(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Nn(t) / 3))) * 3 - Nn(Math.abs(e)));
}
function I$(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, Nn(t) - Nn(e)) + 1;
}
function N_(e, t, r, n) {
  var i = Yd(e, t, r), a;
  switch (n = ra(n ?? ",f"), n.type) {
    case "s": {
      var o = Math.max(Math.abs(e), Math.abs(t));
      return n.precision == null && !isNaN(a = N$(i, o)) && (n.precision = a), $_(n, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(a = I$(i, Math.max(Math.abs(e), Math.abs(t)))) && (n.precision = a - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(a = $$(i)) && (n.precision = a - (n.type === "%") * 2);
      break;
    }
  }
  return Fh(n);
}
function Or(e) {
  var t = e.domain;
  return e.ticks = function(r) {
    var n = t();
    return Vd(n[0], n[n.length - 1], r ?? 10);
  }, e.tickFormat = function(r, n) {
    var i = t();
    return N_(i[0], i[i.length - 1], r ?? 10, n);
  }, e.nice = function(r) {
    r == null && (r = 10);
    var n = t(), i = 0, a = n.length - 1, o = n[i], s = n[a], u, c, l = 10;
    for (s < o && (c = o, o = s, s = c, c = i, i = a, a = c); l-- > 0; ) {
      if (c = Kd(o, s, r), c === u)
        return n[i] = o, n[a] = s, t(n);
      if (c > 0)
        o = Math.floor(o / c) * c, s = Math.ceil(s / c) * c;
      else if (c < 0)
        o = Math.ceil(o * c) / c, s = Math.floor(s * c) / c;
      else
        break;
      u = c;
    }
    return e;
  }, e;
}
function Ro() {
  var e = qh();
  return e.copy = function() {
    return $a(e, Ro());
  }, wt.apply(e, arguments), Or(e);
}
function I_(e) {
  var t;
  function r(n) {
    return n == null || isNaN(n = +n) ? t : n;
  }
  return r.invert = r, r.domain = r.range = function(n) {
    return arguments.length ? (e = Array.from(n, $o), r) : e.slice();
  }, r.unknown = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.copy = function() {
    return I_(e).unknown(t);
  }, e = arguments.length ? Array.from(e, $o) : [0, 1], Or(r);
}
function R_(e, t) {
  e = e.slice();
  var r = 0, n = e.length - 1, i = e[r], a = e[n], o;
  return a < i && (o = r, r = n, n = o, o = i, i = a, a = o), e[r] = t.floor(i), e[n] = t.ceil(a), e;
}
function Qb(e) {
  return Math.log(e);
}
function e0(e) {
  return Math.exp(e);
}
function R$(e) {
  return -Math.log(-e);
}
function D$(e) {
  return -Math.exp(-e);
}
function L$(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function q$(e) {
  return e === 10 ? L$ : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function B$(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function t0(e) {
  return (t, r) => -e(-t, r);
}
function zh(e) {
  const t = e(Qb, e0), r = t.domain;
  let n = 10, i, a;
  function o() {
    return i = B$(n), a = q$(n), r()[0] < 0 ? (i = t0(i), a = t0(a), e(R$, D$)) : e(Qb, e0), t;
  }
  return t.base = function(s) {
    return arguments.length ? (n = +s, o()) : n;
  }, t.domain = function(s) {
    return arguments.length ? (r(s), o()) : r();
  }, t.ticks = (s) => {
    const u = r();
    let c = u[0], l = u[u.length - 1];
    const f = l < c;
    f && ([c, l] = [l, c]);
    let d = i(c), h = i(l), m, v;
    const p = s == null ? 10 : +s;
    let g = [];
    if (!(n % 1) && h - d < p) {
      if (d = Math.floor(d), h = Math.ceil(h), c > 0) {
        for (; d <= h; ++d)
          for (m = 1; m < n; ++m)
            if (v = d < 0 ? m / a(-d) : m * a(d), !(v < c)) {
              if (v > l) break;
              g.push(v);
            }
      } else for (; d <= h; ++d)
        for (m = n - 1; m >= 1; --m)
          if (v = d > 0 ? m / a(-d) : m * a(d), !(v < c)) {
            if (v > l) break;
            g.push(v);
          }
      g.length * 2 < p && (g = Vd(c, l, p));
    } else
      g = Vd(d, h, Math.min(h - d, p)).map(a);
    return f ? g.reverse() : g;
  }, t.tickFormat = (s, u) => {
    if (s == null && (s = 10), u == null && (u = n === 10 ? "s" : ","), typeof u != "function" && (!(n % 1) && (u = ra(u)).precision == null && (u.trim = !0), u = Fh(u)), s === 1 / 0) return u;
    const c = Math.max(1, n * s / t.ticks().length);
    return (l) => {
      let f = l / a(Math.round(i(l)));
      return f * n < n - 0.5 && (f *= n), f <= c ? u(l) : "";
    };
  }, t.nice = () => r(R_(r(), {
    floor: (s) => a(Math.floor(i(s))),
    ceil: (s) => a(Math.ceil(i(s)))
  })), t;
}
function D_() {
  const e = zh(qs()).domain([1, 10]);
  return e.copy = () => $a(e, D_()).base(e.base()), wt.apply(e, arguments), e;
}
function r0(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function n0(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function Wh(e) {
  var t = 1, r = e(r0(t), n0(t));
  return r.constant = function(n) {
    return arguments.length ? e(r0(t = +n), n0(t)) : t;
  }, Or(r);
}
function L_() {
  var e = Wh(qs());
  return e.copy = function() {
    return $a(e, L_()).constant(e.constant());
  }, wt.apply(e, arguments);
}
function i0(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function F$(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function z$(e) {
  return e < 0 ? -e * e : e * e;
}
function Uh(e) {
  var t = e(Ze, Ze), r = 1;
  function n() {
    return r === 1 ? e(Ze, Ze) : r === 0.5 ? e(F$, z$) : e(i0(r), i0(1 / r));
  }
  return t.exponent = function(i) {
    return arguments.length ? (r = +i, n()) : r;
  }, Or(t);
}
function Gh() {
  var e = Uh(qs());
  return e.copy = function() {
    return $a(e, Gh()).exponent(e.exponent());
  }, wt.apply(e, arguments), e;
}
function W$() {
  return Gh.apply(null, arguments).exponent(0.5);
}
function a0(e) {
  return Math.sign(e) * e * e;
}
function U$(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function q_() {
  var e = qh(), t = [0, 1], r = !1, n;
  function i(a) {
    var o = U$(e(a));
    return isNaN(o) ? n : r ? Math.round(o) : o;
  }
  return i.invert = function(a) {
    return e.invert(a0(a));
  }, i.domain = function(a) {
    return arguments.length ? (e.domain(a), i) : e.domain();
  }, i.range = function(a) {
    return arguments.length ? (e.range((t = Array.from(a, $o)).map(a0)), i) : t.slice();
  }, i.rangeRound = function(a) {
    return i.range(a).round(!0);
  }, i.round = function(a) {
    return arguments.length ? (r = !!a, i) : r;
  }, i.clamp = function(a) {
    return arguments.length ? (e.clamp(a), i) : e.clamp();
  }, i.unknown = function(a) {
    return arguments.length ? (n = a, i) : n;
  }, i.copy = function() {
    return q_(e.domain(), t).round(r).clamp(e.clamp()).unknown(n);
  }, wt.apply(i, arguments), Or(i);
}
function B_() {
  var e = [], t = [], r = [], n;
  function i() {
    var o = 0, s = Math.max(1, t.length);
    for (r = new Array(s - 1); ++o < s; ) r[o - 1] = Yk(e, o / s);
    return a;
  }
  function a(o) {
    return o == null || isNaN(o = +o) ? n : t[ja(r, o)];
  }
  return a.invertExtent = function(o) {
    var s = t.indexOf(o);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? r[s - 1] : e[0],
      s < r.length ? r[s] : e[e.length - 1]
    ];
  }, a.domain = function(o) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let s of o) s != null && !isNaN(s = +s) && e.push(s);
    return e.sort(gr), i();
  }, a.range = function(o) {
    return arguments.length ? (t = Array.from(o), i()) : t.slice();
  }, a.unknown = function(o) {
    return arguments.length ? (n = o, a) : n;
  }, a.quantiles = function() {
    return r.slice();
  }, a.copy = function() {
    return B_().domain(e).range(t).unknown(n);
  }, wt.apply(a, arguments);
}
function F_() {
  var e = 0, t = 1, r = 1, n = [0.5], i = [0, 1], a;
  function o(u) {
    return u != null && u <= u ? i[ja(n, u, 0, r)] : a;
  }
  function s() {
    var u = -1;
    for (n = new Array(r); ++u < r; ) n[u] = ((u + 1) * t - (u - r) * e) / (r + 1);
    return o;
  }
  return o.domain = function(u) {
    return arguments.length ? ([e, t] = u, e = +e, t = +t, s()) : [e, t];
  }, o.range = function(u) {
    return arguments.length ? (r = (i = Array.from(u)).length - 1, s()) : i.slice();
  }, o.invertExtent = function(u) {
    var c = i.indexOf(u);
    return c < 0 ? [NaN, NaN] : c < 1 ? [e, n[0]] : c >= r ? [n[r - 1], t] : [n[c - 1], n[c]];
  }, o.unknown = function(u) {
    return arguments.length && (a = u), o;
  }, o.thresholds = function() {
    return n.slice();
  }, o.copy = function() {
    return F_().domain([e, t]).range(i).unknown(a);
  }, wt.apply(Or(o), arguments);
}
function z_() {
  var e = [0.5], t = [0, 1], r, n = 1;
  function i(a) {
    return a != null && a <= a ? t[ja(e, a, 0, n)] : r;
  }
  return i.domain = function(a) {
    return arguments.length ? (e = Array.from(a), n = Math.min(e.length, t.length - 1), i) : e.slice();
  }, i.range = function(a) {
    return arguments.length ? (t = Array.from(a), n = Math.min(e.length, t.length - 1), i) : t.slice();
  }, i.invertExtent = function(a) {
    var o = t.indexOf(a);
    return [e[o - 1], e[o]];
  }, i.unknown = function(a) {
    return arguments.length ? (r = a, i) : r;
  }, i.copy = function() {
    return z_().domain(e).range(t).unknown(r);
  }, wt.apply(i, arguments);
}
const Sf = /* @__PURE__ */ new Date(), Af = /* @__PURE__ */ new Date();
function Be(e, t, r, n) {
  function i(a) {
    return e(a = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+a)), a;
  }
  return i.floor = (a) => (e(a = /* @__PURE__ */ new Date(+a)), a), i.ceil = (a) => (e(a = new Date(a - 1)), t(a, 1), e(a), a), i.round = (a) => {
    const o = i(a), s = i.ceil(a);
    return a - o < s - a ? o : s;
  }, i.offset = (a, o) => (t(a = /* @__PURE__ */ new Date(+a), o == null ? 1 : Math.floor(o)), a), i.range = (a, o, s) => {
    const u = [];
    if (a = i.ceil(a), s = s == null ? 1 : Math.floor(s), !(a < o) || !(s > 0)) return u;
    let c;
    do
      u.push(c = /* @__PURE__ */ new Date(+a)), t(a, s), e(a);
    while (c < a && a < o);
    return u;
  }, i.filter = (a) => Be((o) => {
    if (o >= o) for (; e(o), !a(o); ) o.setTime(o - 1);
  }, (o, s) => {
    if (o >= o)
      if (s < 0) for (; ++s <= 0; )
        for (; t(o, -1), !a(o); )
          ;
      else for (; --s >= 0; )
        for (; t(o, 1), !a(o); )
          ;
  }), r && (i.count = (a, o) => (Sf.setTime(+a), Af.setTime(+o), e(Sf), e(Af), Math.floor(r(Sf, Af))), i.every = (a) => (a = Math.floor(a), !isFinite(a) || !(a > 0) ? null : a > 1 ? i.filter(n ? (o) => n(o) % a === 0 : (o) => i.count(0, o) % a === 0) : i)), i;
}
const Do = Be(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
Do.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? Be((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, r) => {
  t.setTime(+t + r * e);
}, (t, r) => (r - t) / e) : Do);
Do.range;
const Yt = 1e3, mt = Yt * 60, Xt = mt * 60, er = Xt * 24, Hh = er * 7, o0 = er * 30, Pf = er * 365, Dr = Be((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * Yt);
}, (e, t) => (t - e) / Yt, (e) => e.getUTCSeconds());
Dr.range;
const Vh = Be((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Yt);
}, (e, t) => {
  e.setTime(+e + t * mt);
}, (e, t) => (t - e) / mt, (e) => e.getMinutes());
Vh.range;
const Kh = Be((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * mt);
}, (e, t) => (t - e) / mt, (e) => e.getUTCMinutes());
Kh.range;
const Yh = Be((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Yt - e.getMinutes() * mt);
}, (e, t) => {
  e.setTime(+e + t * Xt);
}, (e, t) => (t - e) / Xt, (e) => e.getHours());
Yh.range;
const Xh = Be((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * Xt);
}, (e, t) => (t - e) / Xt, (e) => e.getUTCHours());
Xh.range;
const Na = Be(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * mt) / er,
  (e) => e.getDate() - 1
);
Na.range;
const Bs = Be((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / er, (e) => e.getUTCDate() - 1);
Bs.range;
const W_ = Be((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / er, (e) => Math.floor(e / er));
W_.range;
function nn(e) {
  return Be((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setDate(t.getDate() + r * 7);
  }, (t, r) => (r - t - (r.getTimezoneOffset() - t.getTimezoneOffset()) * mt) / Hh);
}
const Fs = nn(0), Lo = nn(1), G$ = nn(2), H$ = nn(3), In = nn(4), V$ = nn(5), K$ = nn(6);
Fs.range;
Lo.range;
G$.range;
H$.range;
In.range;
V$.range;
K$.range;
function an(e) {
  return Be((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setUTCDate(t.getUTCDate() + r * 7);
  }, (t, r) => (r - t) / Hh);
}
const zs = an(0), qo = an(1), Y$ = an(2), X$ = an(3), Rn = an(4), Z$ = an(5), J$ = an(6);
zs.range;
qo.range;
Y$.range;
X$.range;
Rn.range;
Z$.range;
J$.range;
const Zh = Be((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
Zh.range;
const Jh = Be((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
Jh.range;
const tr = Be((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
tr.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Be((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, r) => {
  t.setFullYear(t.getFullYear() + r * e);
});
tr.range;
const rr = Be((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
rr.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Be((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, r) => {
  t.setUTCFullYear(t.getUTCFullYear() + r * e);
});
rr.range;
function U_(e, t, r, n, i, a) {
  const o = [
    [Dr, 1, Yt],
    [Dr, 5, 5 * Yt],
    [Dr, 15, 15 * Yt],
    [Dr, 30, 30 * Yt],
    [a, 1, mt],
    [a, 5, 5 * mt],
    [a, 15, 15 * mt],
    [a, 30, 30 * mt],
    [i, 1, Xt],
    [i, 3, 3 * Xt],
    [i, 6, 6 * Xt],
    [i, 12, 12 * Xt],
    [n, 1, er],
    [n, 2, 2 * er],
    [r, 1, Hh],
    [t, 1, o0],
    [t, 3, 3 * o0],
    [e, 1, Pf]
  ];
  function s(c, l, f) {
    const d = l < c;
    d && ([c, l] = [l, c]);
    const h = f && typeof f.range == "function" ? f : u(c, l, f), m = h ? h.range(c, +l + 1) : [];
    return d ? m.reverse() : m;
  }
  function u(c, l, f) {
    const d = Math.abs(l - c) / f, h = Nh(([, , p]) => p).right(o, d);
    if (h === o.length) return e.every(Yd(c / Pf, l / Pf, f));
    if (h === 0) return Do.every(Math.max(Yd(c, l, f), 1));
    const [m, v] = o[d / o[h - 1][2] < o[h][2] / d ? h - 1 : h];
    return m.every(v);
  }
  return [s, u];
}
const [Q$, eN] = U_(rr, Jh, zs, W_, Xh, Kh), [tN, rN] = U_(tr, Zh, Fs, Na, Yh, Vh);
function Tf(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function Ef(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function wi(e, t, r) {
  return { y: e, m: t, d: r, H: 0, M: 0, S: 0, L: 0 };
}
function nN(e) {
  var t = e.dateTime, r = e.date, n = e.time, i = e.periods, a = e.days, o = e.shortDays, s = e.months, u = e.shortMonths, c = Oi(i), l = _i(i), f = Oi(a), d = _i(a), h = Oi(o), m = _i(o), v = Oi(s), p = _i(s), g = Oi(u), b = _i(u), w = {
    a: q,
    A: W,
    b: H,
    B: N,
    c: null,
    d: d0,
    e: d0,
    f: PN,
    g: RN,
    G: LN,
    H: _N,
    I: SN,
    j: AN,
    L: G_,
    m: TN,
    M: EN,
    p: L,
    q: B,
    Q: v0,
    s: y0,
    S: CN,
    u: MN,
    U: jN,
    V: kN,
    w: $N,
    W: NN,
    x: null,
    X: null,
    y: IN,
    Y: DN,
    Z: qN,
    "%": h0
  }, O = {
    a: K,
    A: X,
    b: te,
    B: re,
    c: null,
    d: p0,
    e: p0,
    f: WN,
    g: QN,
    G: tI,
    H: BN,
    I: FN,
    j: zN,
    L: V_,
    m: UN,
    M: GN,
    p: oe,
    q: ae,
    Q: v0,
    s: y0,
    S: HN,
    u: VN,
    U: KN,
    V: YN,
    w: XN,
    W: ZN,
    x: null,
    X: null,
    y: JN,
    Y: eI,
    Z: rI,
    "%": h0
  }, y = {
    a: M,
    A: C,
    b: T,
    B: k,
    c: $,
    d: l0,
    e: l0,
    f: bN,
    g: c0,
    G: u0,
    H: f0,
    I: f0,
    j: vN,
    L: gN,
    m: hN,
    M: yN,
    p: E,
    q: pN,
    Q: wN,
    s: ON,
    S: mN,
    u: uN,
    U: cN,
    V: lN,
    w: sN,
    W: fN,
    x: I,
    X: R,
    y: c0,
    Y: u0,
    Z: dN,
    "%": xN
  };
  w.x = x(r, w), w.X = x(n, w), w.c = x(t, w), O.x = x(r, O), O.X = x(n, O), O.c = x(t, O);
  function x(F, Y) {
    return function(ee) {
      var j = [], fe = -1, G = 0, Oe = F.length, Ee, Ue, cr;
      for (ee instanceof Date || (ee = /* @__PURE__ */ new Date(+ee)); ++fe < Oe; )
        F.charCodeAt(fe) === 37 && (j.push(F.slice(G, fe)), (Ue = s0[Ee = F.charAt(++fe)]) != null ? Ee = F.charAt(++fe) : Ue = Ee === "e" ? " " : "0", (cr = Y[Ee]) && (Ee = cr(ee, Ue)), j.push(Ee), G = fe + 1);
      return j.push(F.slice(G, fe)), j.join("");
    };
  }
  function _(F, Y) {
    return function(ee) {
      var j = wi(1900, void 0, 1), fe = P(j, F, ee += "", 0), G, Oe;
      if (fe != ee.length) return null;
      if ("Q" in j) return new Date(j.Q);
      if ("s" in j) return new Date(j.s * 1e3 + ("L" in j ? j.L : 0));
      if (Y && !("Z" in j) && (j.Z = 0), "p" in j && (j.H = j.H % 12 + j.p * 12), j.m === void 0 && (j.m = "q" in j ? j.q : 0), "V" in j) {
        if (j.V < 1 || j.V > 53) return null;
        "w" in j || (j.w = 1), "Z" in j ? (G = Ef(wi(j.y, 0, 1)), Oe = G.getUTCDay(), G = Oe > 4 || Oe === 0 ? qo.ceil(G) : qo(G), G = Bs.offset(G, (j.V - 1) * 7), j.y = G.getUTCFullYear(), j.m = G.getUTCMonth(), j.d = G.getUTCDate() + (j.w + 6) % 7) : (G = Tf(wi(j.y, 0, 1)), Oe = G.getDay(), G = Oe > 4 || Oe === 0 ? Lo.ceil(G) : Lo(G), G = Na.offset(G, (j.V - 1) * 7), j.y = G.getFullYear(), j.m = G.getMonth(), j.d = G.getDate() + (j.w + 6) % 7);
      } else ("W" in j || "U" in j) && ("w" in j || (j.w = "u" in j ? j.u % 7 : "W" in j ? 1 : 0), Oe = "Z" in j ? Ef(wi(j.y, 0, 1)).getUTCDay() : Tf(wi(j.y, 0, 1)).getDay(), j.m = 0, j.d = "W" in j ? (j.w + 6) % 7 + j.W * 7 - (Oe + 5) % 7 : j.w + j.U * 7 - (Oe + 6) % 7);
      return "Z" in j ? (j.H += j.Z / 100 | 0, j.M += j.Z % 100, Ef(j)) : Tf(j);
    };
  }
  function P(F, Y, ee, j) {
    for (var fe = 0, G = Y.length, Oe = ee.length, Ee, Ue; fe < G; ) {
      if (j >= Oe) return -1;
      if (Ee = Y.charCodeAt(fe++), Ee === 37) {
        if (Ee = Y.charAt(fe++), Ue = y[Ee in s0 ? Y.charAt(fe++) : Ee], !Ue || (j = Ue(F, ee, j)) < 0) return -1;
      } else if (Ee != ee.charCodeAt(j++))
        return -1;
    }
    return j;
  }
  function E(F, Y, ee) {
    var j = c.exec(Y.slice(ee));
    return j ? (F.p = l.get(j[0].toLowerCase()), ee + j[0].length) : -1;
  }
  function M(F, Y, ee) {
    var j = h.exec(Y.slice(ee));
    return j ? (F.w = m.get(j[0].toLowerCase()), ee + j[0].length) : -1;
  }
  function C(F, Y, ee) {
    var j = f.exec(Y.slice(ee));
    return j ? (F.w = d.get(j[0].toLowerCase()), ee + j[0].length) : -1;
  }
  function T(F, Y, ee) {
    var j = g.exec(Y.slice(ee));
    return j ? (F.m = b.get(j[0].toLowerCase()), ee + j[0].length) : -1;
  }
  function k(F, Y, ee) {
    var j = v.exec(Y.slice(ee));
    return j ? (F.m = p.get(j[0].toLowerCase()), ee + j[0].length) : -1;
  }
  function $(F, Y, ee) {
    return P(F, t, Y, ee);
  }
  function I(F, Y, ee) {
    return P(F, r, Y, ee);
  }
  function R(F, Y, ee) {
    return P(F, n, Y, ee);
  }
  function q(F) {
    return o[F.getDay()];
  }
  function W(F) {
    return a[F.getDay()];
  }
  function H(F) {
    return u[F.getMonth()];
  }
  function N(F) {
    return s[F.getMonth()];
  }
  function L(F) {
    return i[+(F.getHours() >= 12)];
  }
  function B(F) {
    return 1 + ~~(F.getMonth() / 3);
  }
  function K(F) {
    return o[F.getUTCDay()];
  }
  function X(F) {
    return a[F.getUTCDay()];
  }
  function te(F) {
    return u[F.getUTCMonth()];
  }
  function re(F) {
    return s[F.getUTCMonth()];
  }
  function oe(F) {
    return i[+(F.getUTCHours() >= 12)];
  }
  function ae(F) {
    return 1 + ~~(F.getUTCMonth() / 3);
  }
  return {
    format: function(F) {
      var Y = x(F += "", w);
      return Y.toString = function() {
        return F;
      }, Y;
    },
    parse: function(F) {
      var Y = _(F += "", !1);
      return Y.toString = function() {
        return F;
      }, Y;
    },
    utcFormat: function(F) {
      var Y = x(F += "", O);
      return Y.toString = function() {
        return F;
      }, Y;
    },
    utcParse: function(F) {
      var Y = _(F += "", !0);
      return Y.toString = function() {
        return F;
      }, Y;
    }
  };
}
var s0 = { "-": "", _: " ", 0: "0" }, We = /^\s*\d+/, iN = /^%/, aN = /[\\^$*+?|[\]().{}]/g;
function pe(e, t, r) {
  var n = e < 0 ? "-" : "", i = (n ? -e : e) + "", a = i.length;
  return n + (a < r ? new Array(r - a + 1).join(t) + i : i);
}
function oN(e) {
  return e.replace(aN, "\\$&");
}
function Oi(e) {
  return new RegExp("^(?:" + e.map(oN).join("|") + ")", "i");
}
function _i(e) {
  return new Map(e.map((t, r) => [t.toLowerCase(), r]));
}
function sN(e, t, r) {
  var n = We.exec(t.slice(r, r + 1));
  return n ? (e.w = +n[0], r + n[0].length) : -1;
}
function uN(e, t, r) {
  var n = We.exec(t.slice(r, r + 1));
  return n ? (e.u = +n[0], r + n[0].length) : -1;
}
function cN(e, t, r) {
  var n = We.exec(t.slice(r, r + 2));
  return n ? (e.U = +n[0], r + n[0].length) : -1;
}
function lN(e, t, r) {
  var n = We.exec(t.slice(r, r + 2));
  return n ? (e.V = +n[0], r + n[0].length) : -1;
}
function fN(e, t, r) {
  var n = We.exec(t.slice(r, r + 2));
  return n ? (e.W = +n[0], r + n[0].length) : -1;
}
function u0(e, t, r) {
  var n = We.exec(t.slice(r, r + 4));
  return n ? (e.y = +n[0], r + n[0].length) : -1;
}
function c0(e, t, r) {
  var n = We.exec(t.slice(r, r + 2));
  return n ? (e.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
}
function dN(e, t, r) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r, r + 6));
  return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
}
function pN(e, t, r) {
  var n = We.exec(t.slice(r, r + 1));
  return n ? (e.q = n[0] * 3 - 3, r + n[0].length) : -1;
}
function hN(e, t, r) {
  var n = We.exec(t.slice(r, r + 2));
  return n ? (e.m = n[0] - 1, r + n[0].length) : -1;
}
function l0(e, t, r) {
  var n = We.exec(t.slice(r, r + 2));
  return n ? (e.d = +n[0], r + n[0].length) : -1;
}
function vN(e, t, r) {
  var n = We.exec(t.slice(r, r + 3));
  return n ? (e.m = 0, e.d = +n[0], r + n[0].length) : -1;
}
function f0(e, t, r) {
  var n = We.exec(t.slice(r, r + 2));
  return n ? (e.H = +n[0], r + n[0].length) : -1;
}
function yN(e, t, r) {
  var n = We.exec(t.slice(r, r + 2));
  return n ? (e.M = +n[0], r + n[0].length) : -1;
}
function mN(e, t, r) {
  var n = We.exec(t.slice(r, r + 2));
  return n ? (e.S = +n[0], r + n[0].length) : -1;
}
function gN(e, t, r) {
  var n = We.exec(t.slice(r, r + 3));
  return n ? (e.L = +n[0], r + n[0].length) : -1;
}
function bN(e, t, r) {
  var n = We.exec(t.slice(r, r + 6));
  return n ? (e.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
}
function xN(e, t, r) {
  var n = iN.exec(t.slice(r, r + 1));
  return n ? r + n[0].length : -1;
}
function wN(e, t, r) {
  var n = We.exec(t.slice(r));
  return n ? (e.Q = +n[0], r + n[0].length) : -1;
}
function ON(e, t, r) {
  var n = We.exec(t.slice(r));
  return n ? (e.s = +n[0], r + n[0].length) : -1;
}
function d0(e, t) {
  return pe(e.getDate(), t, 2);
}
function _N(e, t) {
  return pe(e.getHours(), t, 2);
}
function SN(e, t) {
  return pe(e.getHours() % 12 || 12, t, 2);
}
function AN(e, t) {
  return pe(1 + Na.count(tr(e), e), t, 3);
}
function G_(e, t) {
  return pe(e.getMilliseconds(), t, 3);
}
function PN(e, t) {
  return G_(e, t) + "000";
}
function TN(e, t) {
  return pe(e.getMonth() + 1, t, 2);
}
function EN(e, t) {
  return pe(e.getMinutes(), t, 2);
}
function CN(e, t) {
  return pe(e.getSeconds(), t, 2);
}
function MN(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function jN(e, t) {
  return pe(Fs.count(tr(e) - 1, e), t, 2);
}
function H_(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? In(e) : In.ceil(e);
}
function kN(e, t) {
  return e = H_(e), pe(In.count(tr(e), e) + (tr(e).getDay() === 4), t, 2);
}
function $N(e) {
  return e.getDay();
}
function NN(e, t) {
  return pe(Lo.count(tr(e) - 1, e), t, 2);
}
function IN(e, t) {
  return pe(e.getFullYear() % 100, t, 2);
}
function RN(e, t) {
  return e = H_(e), pe(e.getFullYear() % 100, t, 2);
}
function DN(e, t) {
  return pe(e.getFullYear() % 1e4, t, 4);
}
function LN(e, t) {
  var r = e.getDay();
  return e = r >= 4 || r === 0 ? In(e) : In.ceil(e), pe(e.getFullYear() % 1e4, t, 4);
}
function qN(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + pe(t / 60 | 0, "0", 2) + pe(t % 60, "0", 2);
}
function p0(e, t) {
  return pe(e.getUTCDate(), t, 2);
}
function BN(e, t) {
  return pe(e.getUTCHours(), t, 2);
}
function FN(e, t) {
  return pe(e.getUTCHours() % 12 || 12, t, 2);
}
function zN(e, t) {
  return pe(1 + Bs.count(rr(e), e), t, 3);
}
function V_(e, t) {
  return pe(e.getUTCMilliseconds(), t, 3);
}
function WN(e, t) {
  return V_(e, t) + "000";
}
function UN(e, t) {
  return pe(e.getUTCMonth() + 1, t, 2);
}
function GN(e, t) {
  return pe(e.getUTCMinutes(), t, 2);
}
function HN(e, t) {
  return pe(e.getUTCSeconds(), t, 2);
}
function VN(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function KN(e, t) {
  return pe(zs.count(rr(e) - 1, e), t, 2);
}
function K_(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? Rn(e) : Rn.ceil(e);
}
function YN(e, t) {
  return e = K_(e), pe(Rn.count(rr(e), e) + (rr(e).getUTCDay() === 4), t, 2);
}
function XN(e) {
  return e.getUTCDay();
}
function ZN(e, t) {
  return pe(qo.count(rr(e) - 1, e), t, 2);
}
function JN(e, t) {
  return pe(e.getUTCFullYear() % 100, t, 2);
}
function QN(e, t) {
  return e = K_(e), pe(e.getUTCFullYear() % 100, t, 2);
}
function eI(e, t) {
  return pe(e.getUTCFullYear() % 1e4, t, 4);
}
function tI(e, t) {
  var r = e.getUTCDay();
  return e = r >= 4 || r === 0 ? Rn(e) : Rn.ceil(e), pe(e.getUTCFullYear() % 1e4, t, 4);
}
function rI() {
  return "+0000";
}
function h0() {
  return "%";
}
function v0(e) {
  return +e;
}
function y0(e) {
  return Math.floor(+e / 1e3);
}
var fn, Y_, X_;
nI({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function nI(e) {
  return fn = nN(e), Y_ = fn.format, fn.parse, X_ = fn.utcFormat, fn.utcParse, fn;
}
function iI(e) {
  return new Date(e);
}
function aI(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function Qh(e, t, r, n, i, a, o, s, u, c) {
  var l = qh(), f = l.invert, d = l.domain, h = c(".%L"), m = c(":%S"), v = c("%I:%M"), p = c("%I %p"), g = c("%a %d"), b = c("%b %d"), w = c("%B"), O = c("%Y");
  function y(x) {
    return (u(x) < x ? h : s(x) < x ? m : o(x) < x ? v : a(x) < x ? p : n(x) < x ? i(x) < x ? g : b : r(x) < x ? w : O)(x);
  }
  return l.invert = function(x) {
    return new Date(f(x));
  }, l.domain = function(x) {
    return arguments.length ? d(Array.from(x, aI)) : d().map(iI);
  }, l.ticks = function(x) {
    var _ = d();
    return e(_[0], _[_.length - 1], x ?? 10);
  }, l.tickFormat = function(x, _) {
    return _ == null ? y : c(_);
  }, l.nice = function(x) {
    var _ = d();
    return (!x || typeof x.range != "function") && (x = t(_[0], _[_.length - 1], x ?? 10)), x ? d(R_(_, x)) : l;
  }, l.copy = function() {
    return $a(l, Qh(e, t, r, n, i, a, o, s, u, c));
  }, l;
}
function oI() {
  return wt.apply(Qh(tN, rN, tr, Zh, Fs, Na, Yh, Vh, Dr, Y_).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function sI() {
  return wt.apply(Qh(Q$, eN, rr, Jh, zs, Bs, Xh, Kh, Dr, X_).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function Ws() {
  var e = 0, t = 1, r, n, i, a, o = Ze, s = !1, u;
  function c(f) {
    return f == null || isNaN(f = +f) ? u : o(i === 0 ? 0.5 : (f = (a(f) - r) * i, s ? Math.max(0, Math.min(1, f)) : f));
  }
  c.domain = function(f) {
    return arguments.length ? ([e, t] = f, r = a(e = +e), n = a(t = +t), i = r === n ? 0 : 1 / (n - r), c) : [e, t];
  }, c.clamp = function(f) {
    return arguments.length ? (s = !!f, c) : s;
  }, c.interpolator = function(f) {
    return arguments.length ? (o = f, c) : o;
  };
  function l(f) {
    return function(d) {
      var h, m;
      return arguments.length ? ([h, m] = d, o = f(h, m), c) : [o(0), o(1)];
    };
  }
  return c.range = l(ui), c.rangeRound = l(Lh), c.unknown = function(f) {
    return arguments.length ? (u = f, c) : u;
  }, function(f) {
    return a = f, r = f(e), n = f(t), i = r === n ? 0 : 1 / (n - r), c;
  };
}
function _r(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function Z_() {
  var e = Or(Ws()(Ze));
  return e.copy = function() {
    return _r(e, Z_());
  }, or.apply(e, arguments);
}
function J_() {
  var e = zh(Ws()).domain([1, 10]);
  return e.copy = function() {
    return _r(e, J_()).base(e.base());
  }, or.apply(e, arguments);
}
function Q_() {
  var e = Wh(Ws());
  return e.copy = function() {
    return _r(e, Q_()).constant(e.constant());
  }, or.apply(e, arguments);
}
function ev() {
  var e = Uh(Ws());
  return e.copy = function() {
    return _r(e, ev()).exponent(e.exponent());
  }, or.apply(e, arguments);
}
function uI() {
  return ev.apply(null, arguments).exponent(0.5);
}
function eS() {
  var e = [], t = Ze;
  function r(n) {
    if (n != null && !isNaN(n = +n)) return t((ja(e, n, 1) - 1) / (e.length - 1));
  }
  return r.domain = function(n) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let i of n) i != null && !isNaN(i = +i) && e.push(i);
    return e.sort(gr), r;
  }, r.interpolator = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.range = function() {
    return e.map((n, i) => t(i / (e.length - 1)));
  }, r.quantiles = function(n) {
    return Array.from({ length: n + 1 }, (i, a) => Kk(e, a / n));
  }, r.copy = function() {
    return eS(t).domain(e);
  }, or.apply(r, arguments);
}
function Us() {
  var e = 0, t = 0.5, r = 1, n = 1, i, a, o, s, u, c = Ze, l, f = !1, d;
  function h(v) {
    return isNaN(v = +v) ? d : (v = 0.5 + ((v = +l(v)) - a) * (n * v < n * a ? s : u), c(f ? Math.max(0, Math.min(1, v)) : v));
  }
  h.domain = function(v) {
    return arguments.length ? ([e, t, r] = v, i = l(e = +e), a = l(t = +t), o = l(r = +r), s = i === a ? 0 : 0.5 / (a - i), u = a === o ? 0 : 0.5 / (o - a), n = a < i ? -1 : 1, h) : [e, t, r];
  }, h.clamp = function(v) {
    return arguments.length ? (f = !!v, h) : f;
  }, h.interpolator = function(v) {
    return arguments.length ? (c = v, h) : c;
  };
  function m(v) {
    return function(p) {
      var g, b, w;
      return arguments.length ? ([g, b, w] = p, c = x$(v, [g, b, w]), h) : [c(0), c(0.5), c(1)];
    };
  }
  return h.range = m(ui), h.rangeRound = m(Lh), h.unknown = function(v) {
    return arguments.length ? (d = v, h) : d;
  }, function(v) {
    return l = v, i = v(e), a = v(t), o = v(r), s = i === a ? 0 : 0.5 / (a - i), u = a === o ? 0 : 0.5 / (o - a), n = a < i ? -1 : 1, h;
  };
}
function tS() {
  var e = Or(Us()(Ze));
  return e.copy = function() {
    return _r(e, tS());
  }, or.apply(e, arguments);
}
function rS() {
  var e = zh(Us()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return _r(e, rS()).base(e.base());
  }, or.apply(e, arguments);
}
function nS() {
  var e = Wh(Us());
  return e.copy = function() {
    return _r(e, nS()).constant(e.constant());
  }, or.apply(e, arguments);
}
function tv() {
  var e = Uh(Us());
  return e.copy = function() {
    return _r(e, tv()).exponent(e.exponent());
  }, or.apply(e, arguments);
}
function cI() {
  return tv.apply(null, arguments).exponent(0.5);
}
const m0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: Ji,
  scaleDiverging: tS,
  scaleDivergingLog: rS,
  scaleDivergingPow: tv,
  scaleDivergingSqrt: cI,
  scaleDivergingSymlog: nS,
  scaleIdentity: I_,
  scaleImplicit: Xd,
  scaleLinear: Ro,
  scaleLog: D_,
  scaleOrdinal: Ih,
  scalePoint: Ii,
  scalePow: Gh,
  scaleQuantile: B_,
  scaleQuantize: F_,
  scaleRadial: q_,
  scaleSequential: Z_,
  scaleSequentialLog: J_,
  scaleSequentialPow: ev,
  scaleSequentialQuantile: eS,
  scaleSequentialSqrt: uI,
  scaleSequentialSymlog: Q_,
  scaleSqrt: W$,
  scaleSymlog: L_,
  scaleThreshold: z_,
  scaleTime: oI,
  scaleUtc: sI,
  tickFormat: N_
}, Symbol.toStringTag, { value: "Module" }));
var Cf, g0;
function Gs() {
  if (g0) return Cf;
  g0 = 1;
  var e = ii();
  function t(r, n, i) {
    for (var a = -1, o = r.length; ++a < o; ) {
      var s = r[a], u = n(s);
      if (u != null && (c === void 0 ? u === u && !e(u) : i(u, c)))
        var c = u, l = s;
    }
    return l;
  }
  return Cf = t, Cf;
}
var Mf, b0;
function iS() {
  if (b0) return Mf;
  b0 = 1;
  function e(t, r) {
    return t > r;
  }
  return Mf = e, Mf;
}
var jf, x0;
function lI() {
  if (x0) return jf;
  x0 = 1;
  var e = Gs(), t = iS(), r = si();
  function n(i) {
    return i && i.length ? e(i, r, t) : void 0;
  }
  return jf = n, jf;
}
var fI = lI();
const yr = /* @__PURE__ */ xe(fI);
var kf, w0;
function aS() {
  if (w0) return kf;
  w0 = 1;
  function e(t, r) {
    return t < r;
  }
  return kf = e, kf;
}
var $f, O0;
function dI() {
  if (O0) return $f;
  O0 = 1;
  var e = Gs(), t = aS(), r = si();
  function n(i) {
    return i && i.length ? e(i, r, t) : void 0;
  }
  return $f = n, $f;
}
var pI = dI();
const Hs = /* @__PURE__ */ xe(pI);
var Nf, _0;
function hI() {
  if (_0) return Nf;
  _0 = 1;
  var e = mh(), t = Ft(), r = h_(), n = nt();
  function i(a, o) {
    var s = n(a) ? e : r;
    return s(a, t(o, 3));
  }
  return Nf = i, Nf;
}
var If, S0;
function vI() {
  if (S0) return If;
  S0 = 1;
  var e = d_(), t = hI();
  function r(n, i) {
    return e(t(n, i), 1);
  }
  return If = r, If;
}
var yI = vI();
const mI = /* @__PURE__ */ xe(yI);
var Rf, A0;
function gI() {
  if (A0) return Rf;
  A0 = 1;
  var e = Mh();
  function t(r, n) {
    return e(r, n);
  }
  return Rf = t, Rf;
}
var bI = gI();
const Yr = /* @__PURE__ */ xe(bI);
var ci = 1e9, xI = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, nv, Ce = !0, gt = "[DecimalError] ", Wr = gt + "Invalid argument: ", rv = gt + "Exponent out of range: ", li = Math.floor, kr = Math.pow, wI = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, st, Fe = 1e7, Te = 7, oS = 9007199254740991, Bo = li(oS / Te), J = {};
J.absoluteValue = J.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
J.comparedTo = J.cmp = function(e) {
  var t, r, n, i, a = this;
  if (e = new a.constructor(e), a.s !== e.s) return a.s || -e.s;
  if (a.e !== e.e) return a.e > e.e ^ a.s < 0 ? 1 : -1;
  for (n = a.d.length, i = e.d.length, t = 0, r = n < i ? n : i; t < r; ++t)
    if (a.d[t] !== e.d[t]) return a.d[t] > e.d[t] ^ a.s < 0 ? 1 : -1;
  return n === i ? 0 : n > i ^ a.s < 0 ? 1 : -1;
};
J.decimalPlaces = J.dp = function() {
  var e = this, t = e.d.length - 1, r = (t - e.e) * Te;
  if (t = e.d[t], t) for (; t % 10 == 0; t /= 10) r--;
  return r < 0 ? 0 : r;
};
J.dividedBy = J.div = function(e) {
  return Qt(this, new this.constructor(e));
};
J.dividedToIntegerBy = J.idiv = function(e) {
  var t = this, r = t.constructor;
  return we(Qt(t, new r(e), 0, 1), r.precision);
};
J.equals = J.eq = function(e) {
  return !this.cmp(e);
};
J.exponent = function() {
  return Ne(this);
};
J.greaterThan = J.gt = function(e) {
  return this.cmp(e) > 0;
};
J.greaterThanOrEqualTo = J.gte = function(e) {
  return this.cmp(e) >= 0;
};
J.isInteger = J.isint = function() {
  return this.e > this.d.length - 2;
};
J.isNegative = J.isneg = function() {
  return this.s < 0;
};
J.isPositive = J.ispos = function() {
  return this.s > 0;
};
J.isZero = function() {
  return this.s === 0;
};
J.lessThan = J.lt = function(e) {
  return this.cmp(e) < 0;
};
J.lessThanOrEqualTo = J.lte = function(e) {
  return this.cmp(e) < 1;
};
J.logarithm = J.log = function(e) {
  var t, r = this, n = r.constructor, i = n.precision, a = i + 5;
  if (e === void 0)
    e = new n(10);
  else if (e = new n(e), e.s < 1 || e.eq(st)) throw Error(gt + "NaN");
  if (r.s < 1) throw Error(gt + (r.s ? "NaN" : "-Infinity"));
  return r.eq(st) ? new n(0) : (Ce = !1, t = Qt(na(r, a), na(e, a), a), Ce = !0, we(t, i));
};
J.minus = J.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? cS(t, e) : sS(t, (e.s = -e.s, e));
};
J.modulo = J.mod = function(e) {
  var t, r = this, n = r.constructor, i = n.precision;
  if (e = new n(e), !e.s) throw Error(gt + "NaN");
  return r.s ? (Ce = !1, t = Qt(r, e, 0, 1).times(e), Ce = !0, r.minus(t)) : we(new n(r), i);
};
J.naturalExponential = J.exp = function() {
  return uS(this);
};
J.naturalLogarithm = J.ln = function() {
  return na(this);
};
J.negated = J.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
J.plus = J.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? sS(t, e) : cS(t, (e.s = -e.s, e));
};
J.precision = J.sd = function(e) {
  var t, r, n, i = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(Wr + e);
  if (t = Ne(i) + 1, n = i.d.length - 1, r = n * Te + 1, n = i.d[n], n) {
    for (; n % 10 == 0; n /= 10) r--;
    for (n = i.d[0]; n >= 10; n /= 10) r++;
  }
  return e && t > r ? t : r;
};
J.squareRoot = J.sqrt = function() {
  var e, t, r, n, i, a, o, s = this, u = s.constructor;
  if (s.s < 1) {
    if (!s.s) return new u(0);
    throw Error(gt + "NaN");
  }
  for (e = Ne(s), Ce = !1, i = Math.sqrt(+s), i == 0 || i == 1 / 0 ? (t = Nt(s.d), (t.length + e) % 2 == 0 && (t += "0"), i = Math.sqrt(t), e = li((e + 1) / 2) - (e < 0 || e % 2), i == 1 / 0 ? t = "5e" + e : (t = i.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), n = new u(t)) : n = new u(i.toString()), r = u.precision, i = o = r + 3; ; )
    if (a = n, n = a.plus(Qt(s, a, o + 2)).times(0.5), Nt(a.d).slice(0, o) === (t = Nt(n.d)).slice(0, o)) {
      if (t = t.slice(o - 3, o + 1), i == o && t == "4999") {
        if (we(a, r + 1, 0), a.times(a).eq(s)) {
          n = a;
          break;
        }
      } else if (t != "9999")
        break;
      o += 4;
    }
  return Ce = !0, we(n, r);
};
J.times = J.mul = function(e) {
  var t, r, n, i, a, o, s, u, c, l = this, f = l.constructor, d = l.d, h = (e = new f(e)).d;
  if (!l.s || !e.s) return new f(0);
  for (e.s *= l.s, r = l.e + e.e, u = d.length, c = h.length, u < c && (a = d, d = h, h = a, o = u, u = c, c = o), a = [], o = u + c, n = o; n--; ) a.push(0);
  for (n = c; --n >= 0; ) {
    for (t = 0, i = u + n; i > n; )
      s = a[i] + h[n] * d[i - n - 1] + t, a[i--] = s % Fe | 0, t = s / Fe | 0;
    a[i] = (a[i] + t) % Fe | 0;
  }
  for (; !a[--o]; ) a.pop();
  return t ? ++r : a.shift(), e.d = a, e.e = r, Ce ? we(e, f.precision) : e;
};
J.toDecimalPlaces = J.todp = function(e, t) {
  var r = this, n = r.constructor;
  return r = new n(r), e === void 0 ? r : (qt(e, 0, ci), t === void 0 ? t = n.rounding : qt(t, 0, 8), we(r, e + Ne(r) + 1, t));
};
J.toExponential = function(e, t) {
  var r, n = this, i = n.constructor;
  return e === void 0 ? r = Xr(n, !0) : (qt(e, 0, ci), t === void 0 ? t = i.rounding : qt(t, 0, 8), n = we(new i(n), e + 1, t), r = Xr(n, !0, e + 1)), r;
};
J.toFixed = function(e, t) {
  var r, n, i = this, a = i.constructor;
  return e === void 0 ? Xr(i) : (qt(e, 0, ci), t === void 0 ? t = a.rounding : qt(t, 0, 8), n = we(new a(i), e + Ne(i) + 1, t), r = Xr(n.abs(), !1, e + Ne(n) + 1), i.isneg() && !i.isZero() ? "-" + r : r);
};
J.toInteger = J.toint = function() {
  var e = this, t = e.constructor;
  return we(new t(e), Ne(e) + 1, t.rounding);
};
J.toNumber = function() {
  return +this;
};
J.toPower = J.pow = function(e) {
  var t, r, n, i, a, o, s = this, u = s.constructor, c = 12, l = +(e = new u(e));
  if (!e.s) return new u(st);
  if (s = new u(s), !s.s) {
    if (e.s < 1) throw Error(gt + "Infinity");
    return s;
  }
  if (s.eq(st)) return s;
  if (n = u.precision, e.eq(st)) return we(s, n);
  if (t = e.e, r = e.d.length - 1, o = t >= r, a = s.s, o) {
    if ((r = l < 0 ? -l : l) <= oS) {
      for (i = new u(st), t = Math.ceil(n / Te + 4), Ce = !1; r % 2 && (i = i.times(s), T0(i.d, t)), r = li(r / 2), r !== 0; )
        s = s.times(s), T0(s.d, t);
      return Ce = !0, e.s < 0 ? new u(st).div(i) : we(i, n);
    }
  } else if (a < 0) throw Error(gt + "NaN");
  return a = a < 0 && e.d[Math.max(t, r)] & 1 ? -1 : 1, s.s = 1, Ce = !1, i = e.times(na(s, n + c)), Ce = !0, i = uS(i), i.s = a, i;
};
J.toPrecision = function(e, t) {
  var r, n, i = this, a = i.constructor;
  return e === void 0 ? (r = Ne(i), n = Xr(i, r <= a.toExpNeg || r >= a.toExpPos)) : (qt(e, 1, ci), t === void 0 ? t = a.rounding : qt(t, 0, 8), i = we(new a(i), e, t), r = Ne(i), n = Xr(i, e <= r || r <= a.toExpNeg, e)), n;
};
J.toSignificantDigits = J.tosd = function(e, t) {
  var r = this, n = r.constructor;
  return e === void 0 ? (e = n.precision, t = n.rounding) : (qt(e, 1, ci), t === void 0 ? t = n.rounding : qt(t, 0, 8)), we(new n(r), e, t);
};
J.toString = J.valueOf = J.val = J.toJSON = J[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = Ne(e), r = e.constructor;
  return Xr(e, t <= r.toExpNeg || t >= r.toExpPos);
};
function sS(e, t) {
  var r, n, i, a, o, s, u, c, l = e.constructor, f = l.precision;
  if (!e.s || !t.s)
    return t.s || (t = new l(e)), Ce ? we(t, f) : t;
  if (u = e.d, c = t.d, o = e.e, i = t.e, u = u.slice(), a = o - i, a) {
    for (a < 0 ? (n = u, a = -a, s = c.length) : (n = c, i = o, s = u.length), o = Math.ceil(f / Te), s = o > s ? o + 1 : s + 1, a > s && (a = s, n.length = 1), n.reverse(); a--; ) n.push(0);
    n.reverse();
  }
  for (s = u.length, a = c.length, s - a < 0 && (a = s, n = c, c = u, u = n), r = 0; a; )
    r = (u[--a] = u[a] + c[a] + r) / Fe | 0, u[a] %= Fe;
  for (r && (u.unshift(r), ++i), s = u.length; u[--s] == 0; ) u.pop();
  return t.d = u, t.e = i, Ce ? we(t, f) : t;
}
function qt(e, t, r) {
  if (e !== ~~e || e < t || e > r)
    throw Error(Wr + e);
}
function Nt(e) {
  var t, r, n, i = e.length - 1, a = "", o = e[0];
  if (i > 0) {
    for (a += o, t = 1; t < i; t++)
      n = e[t] + "", r = Te - n.length, r && (a += hr(r)), a += n;
    o = e[t], n = o + "", r = Te - n.length, r && (a += hr(r));
  } else if (o === 0)
    return "0";
  for (; o % 10 === 0; ) o /= 10;
  return a + o;
}
var Qt = /* @__PURE__ */ function() {
  function e(n, i) {
    var a, o = 0, s = n.length;
    for (n = n.slice(); s--; )
      a = n[s] * i + o, n[s] = a % Fe | 0, o = a / Fe | 0;
    return o && n.unshift(o), n;
  }
  function t(n, i, a, o) {
    var s, u;
    if (a != o)
      u = a > o ? 1 : -1;
    else
      for (s = u = 0; s < a; s++)
        if (n[s] != i[s]) {
          u = n[s] > i[s] ? 1 : -1;
          break;
        }
    return u;
  }
  function r(n, i, a) {
    for (var o = 0; a--; )
      n[a] -= o, o = n[a] < i[a] ? 1 : 0, n[a] = o * Fe + n[a] - i[a];
    for (; !n[0] && n.length > 1; ) n.shift();
  }
  return function(n, i, a, o) {
    var s, u, c, l, f, d, h, m, v, p, g, b, w, O, y, x, _, P, E = n.constructor, M = n.s == i.s ? 1 : -1, C = n.d, T = i.d;
    if (!n.s) return new E(n);
    if (!i.s) throw Error(gt + "Division by zero");
    for (u = n.e - i.e, _ = T.length, y = C.length, h = new E(M), m = h.d = [], c = 0; T[c] == (C[c] || 0); ) ++c;
    if (T[c] > (C[c] || 0) && --u, a == null ? b = a = E.precision : o ? b = a + (Ne(n) - Ne(i)) + 1 : b = a, b < 0) return new E(0);
    if (b = b / Te + 2 | 0, c = 0, _ == 1)
      for (l = 0, T = T[0], b++; (c < y || l) && b--; c++)
        w = l * Fe + (C[c] || 0), m[c] = w / T | 0, l = w % T | 0;
    else {
      for (l = Fe / (T[0] + 1) | 0, l > 1 && (T = e(T, l), C = e(C, l), _ = T.length, y = C.length), O = _, v = C.slice(0, _), p = v.length; p < _; ) v[p++] = 0;
      P = T.slice(), P.unshift(0), x = T[0], T[1] >= Fe / 2 && ++x;
      do
        l = 0, s = t(T, v, _, p), s < 0 ? (g = v[0], _ != p && (g = g * Fe + (v[1] || 0)), l = g / x | 0, l > 1 ? (l >= Fe && (l = Fe - 1), f = e(T, l), d = f.length, p = v.length, s = t(f, v, d, p), s == 1 && (l--, r(f, _ < d ? P : T, d))) : (l == 0 && (s = l = 1), f = T.slice()), d = f.length, d < p && f.unshift(0), r(v, f, p), s == -1 && (p = v.length, s = t(T, v, _, p), s < 1 && (l++, r(v, _ < p ? P : T, p))), p = v.length) : s === 0 && (l++, v = [0]), m[c++] = l, s && v[0] ? v[p++] = C[O] || 0 : (v = [C[O]], p = 1);
      while ((O++ < y || v[0] !== void 0) && b--);
    }
    return m[0] || m.shift(), h.e = u, we(h, o ? a + Ne(h) + 1 : a);
  };
}();
function uS(e, t) {
  var r, n, i, a, o, s, u = 0, c = 0, l = e.constructor, f = l.precision;
  if (Ne(e) > 16) throw Error(rv + Ne(e));
  if (!e.s) return new l(st);
  for (Ce = !1, s = f, o = new l(0.03125); e.abs().gte(0.1); )
    e = e.times(o), c += 5;
  for (n = Math.log(kr(2, c)) / Math.LN10 * 2 + 5 | 0, s += n, r = i = a = new l(st), l.precision = s; ; ) {
    if (i = we(i.times(e), s), r = r.times(++u), o = a.plus(Qt(i, r, s)), Nt(o.d).slice(0, s) === Nt(a.d).slice(0, s)) {
      for (; c--; ) a = we(a.times(a), s);
      return l.precision = f, t == null ? (Ce = !0, we(a, f)) : a;
    }
    a = o;
  }
}
function Ne(e) {
  for (var t = e.e * Te, r = e.d[0]; r >= 10; r /= 10) t++;
  return t;
}
function Df(e, t, r) {
  if (t > e.LN10.sd())
    throw Ce = !0, r && (e.precision = r), Error(gt + "LN10 precision limit exceeded");
  return we(new e(e.LN10), t);
}
function hr(e) {
  for (var t = ""; e--; ) t += "0";
  return t;
}
function na(e, t) {
  var r, n, i, a, o, s, u, c, l, f = 1, d = 10, h = e, m = h.d, v = h.constructor, p = v.precision;
  if (h.s < 1) throw Error(gt + (h.s ? "NaN" : "-Infinity"));
  if (h.eq(st)) return new v(0);
  if (t == null ? (Ce = !1, c = p) : c = t, h.eq(10))
    return t == null && (Ce = !0), Df(v, c);
  if (c += d, v.precision = c, r = Nt(m), n = r.charAt(0), a = Ne(h), Math.abs(a) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
      h = h.times(e), r = Nt(h.d), n = r.charAt(0), f++;
    a = Ne(h), n > 1 ? (h = new v("0." + r), a++) : h = new v(n + "." + r.slice(1));
  } else
    return u = Df(v, c + 2, p).times(a + ""), h = na(new v(n + "." + r.slice(1)), c - d).plus(u), v.precision = p, t == null ? (Ce = !0, we(h, p)) : h;
  for (s = o = h = Qt(h.minus(st), h.plus(st), c), l = we(h.times(h), c), i = 3; ; ) {
    if (o = we(o.times(l), c), u = s.plus(Qt(o, new v(i), c)), Nt(u.d).slice(0, c) === Nt(s.d).slice(0, c))
      return s = s.times(2), a !== 0 && (s = s.plus(Df(v, c + 2, p).times(a + ""))), s = Qt(s, new v(f), c), v.precision = p, t == null ? (Ce = !0, we(s, p)) : s;
    s = u, i += 2;
  }
}
function P0(e, t) {
  var r, n, i;
  for ((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; t.charCodeAt(n) === 48; ) ++n;
  for (i = t.length; t.charCodeAt(i - 1) === 48; ) --i;
  if (t = t.slice(n, i), t) {
    if (i -= n, r = r - n - 1, e.e = li(r / Te), e.d = [], n = (r + 1) % Te, r < 0 && (n += Te), n < i) {
      for (n && e.d.push(+t.slice(0, n)), i -= Te; n < i; ) e.d.push(+t.slice(n, n += Te));
      t = t.slice(n), n = Te - t.length;
    } else
      n -= i;
    for (; n--; ) t += "0";
    if (e.d.push(+t), Ce && (e.e > Bo || e.e < -Bo)) throw Error(rv + r);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function we(e, t, r) {
  var n, i, a, o, s, u, c, l, f = e.d;
  for (o = 1, a = f[0]; a >= 10; a /= 10) o++;
  if (n = t - o, n < 0)
    n += Te, i = t, c = f[l = 0];
  else {
    if (l = Math.ceil((n + 1) / Te), a = f.length, l >= a) return e;
    for (c = a = f[l], o = 1; a >= 10; a /= 10) o++;
    n %= Te, i = n - Te + o;
  }
  if (r !== void 0 && (a = kr(10, o - i - 1), s = c / a % 10 | 0, u = t < 0 || f[l + 1] !== void 0 || c % a, u = r < 4 ? (s || u) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : s > 5 || s == 5 && (r == 4 || u || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (n > 0 ? i > 0 ? c / kr(10, o - i) : 0 : f[l - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7))), t < 1 || !f[0])
    return u ? (a = Ne(e), f.length = 1, t = t - a - 1, f[0] = kr(10, (Te - t % Te) % Te), e.e = li(-t / Te) || 0) : (f.length = 1, f[0] = e.e = e.s = 0), e;
  if (n == 0 ? (f.length = l, a = 1, l--) : (f.length = l + 1, a = kr(10, Te - n), f[l] = i > 0 ? (c / kr(10, o - i) % kr(10, i) | 0) * a : 0), u)
    for (; ; )
      if (l == 0) {
        (f[0] += a) == Fe && (f[0] = 1, ++e.e);
        break;
      } else {
        if (f[l] += a, f[l] != Fe) break;
        f[l--] = 0, a = 1;
      }
  for (n = f.length; f[--n] === 0; ) f.pop();
  if (Ce && (e.e > Bo || e.e < -Bo))
    throw Error(rv + Ne(e));
  return e;
}
function cS(e, t) {
  var r, n, i, a, o, s, u, c, l, f, d = e.constructor, h = d.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new d(e), Ce ? we(t, h) : t;
  if (u = e.d, f = t.d, n = t.e, c = e.e, u = u.slice(), o = c - n, o) {
    for (l = o < 0, l ? (r = u, o = -o, s = f.length) : (r = f, n = c, s = u.length), i = Math.max(Math.ceil(h / Te), s) + 2, o > i && (o = i, r.length = 1), r.reverse(), i = o; i--; ) r.push(0);
    r.reverse();
  } else {
    for (i = u.length, s = f.length, l = i < s, l && (s = i), i = 0; i < s; i++)
      if (u[i] != f[i]) {
        l = u[i] < f[i];
        break;
      }
    o = 0;
  }
  for (l && (r = u, u = f, f = r, t.s = -t.s), s = u.length, i = f.length - s; i > 0; --i) u[s++] = 0;
  for (i = f.length; i > o; ) {
    if (u[--i] < f[i]) {
      for (a = i; a && u[--a] === 0; ) u[a] = Fe - 1;
      --u[a], u[i] += Fe;
    }
    u[i] -= f[i];
  }
  for (; u[--s] === 0; ) u.pop();
  for (; u[0] === 0; u.shift()) --n;
  return u[0] ? (t.d = u, t.e = n, Ce ? we(t, h) : t) : new d(0);
}
function Xr(e, t, r) {
  var n, i = Ne(e), a = Nt(e.d), o = a.length;
  return t ? (r && (n = r - o) > 0 ? a = a.charAt(0) + "." + a.slice(1) + hr(n) : o > 1 && (a = a.charAt(0) + "." + a.slice(1)), a = a + (i < 0 ? "e" : "e+") + i) : i < 0 ? (a = "0." + hr(-i - 1) + a, r && (n = r - o) > 0 && (a += hr(n))) : i >= o ? (a += hr(i + 1 - o), r && (n = r - i - 1) > 0 && (a = a + "." + hr(n))) : ((n = i + 1) < o && (a = a.slice(0, n) + "." + a.slice(n)), r && (n = r - o) > 0 && (i + 1 === o && (a += "."), a += hr(n))), e.s < 0 ? "-" + a : a;
}
function T0(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function lS(e) {
  var t, r, n;
  function i(a) {
    var o = this;
    if (!(o instanceof i)) return new i(a);
    if (o.constructor = i, a instanceof i) {
      o.s = a.s, o.e = a.e, o.d = (a = a.d) ? a.slice() : a;
      return;
    }
    if (typeof a == "number") {
      if (a * 0 !== 0)
        throw Error(Wr + a);
      if (a > 0)
        o.s = 1;
      else if (a < 0)
        a = -a, o.s = -1;
      else {
        o.s = 0, o.e = 0, o.d = [0];
        return;
      }
      if (a === ~~a && a < 1e7) {
        o.e = 0, o.d = [a];
        return;
      }
      return P0(o, a.toString());
    } else if (typeof a != "string")
      throw Error(Wr + a);
    if (a.charCodeAt(0) === 45 ? (a = a.slice(1), o.s = -1) : o.s = 1, wI.test(a)) P0(o, a);
    else throw Error(Wr + a);
  }
  if (i.prototype = J, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.clone = lS, i.config = i.set = OI, e === void 0 && (e = {}), e)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < n.length; ) e.hasOwnProperty(r = n[t++]) || (e[r] = this[r]);
  return i.config(e), i;
}
function OI(e) {
  if (!e || typeof e != "object")
    throw Error(gt + "Object expected");
  var t, r, n, i = [
    "precision",
    1,
    ci,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < i.length; t += 3)
    if ((n = e[r = i[t]]) !== void 0)
      if (li(n) === n && n >= i[t + 1] && n <= i[t + 2]) this[r] = n;
      else throw Error(Wr + r + ": " + n);
  if ((n = e[r = "LN10"]) !== void 0)
    if (n == Math.LN10) this[r] = new this(n);
    else throw Error(Wr + r + ": " + n);
  return this;
}
var nv = lS(xI);
st = new nv(1);
const be = nv;
function _I(e) {
  return TI(e) || PI(e) || AI(e) || SI();
}
function SI() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function AI(e, t) {
  if (e) {
    if (typeof e == "string") return ep(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ep(e, t);
  }
}
function PI(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function TI(e) {
  if (Array.isArray(e)) return ep(e);
}
function ep(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var EI = function(t) {
  return t;
}, fS = {}, dS = function(t) {
  return t === fS;
}, E0 = function(t) {
  return function r() {
    return arguments.length === 0 || arguments.length === 1 && dS(arguments.length <= 0 ? void 0 : arguments[0]) ? r : t.apply(void 0, arguments);
  };
}, CI = function e(t, r) {
  return t === 1 ? r : E0(function() {
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    var o = i.filter(function(s) {
      return s !== fS;
    }).length;
    return o >= t ? r.apply(void 0, i) : e(t - o, E0(function() {
      for (var s = arguments.length, u = new Array(s), c = 0; c < s; c++)
        u[c] = arguments[c];
      var l = i.map(function(f) {
        return dS(f) ? u.shift() : f;
      });
      return r.apply(void 0, _I(l).concat(u));
    }));
  });
}, Vs = function(t) {
  return CI(t.length, t);
}, tp = function(t, r) {
  for (var n = [], i = t; i < r; ++i)
    n[i - t] = i;
  return n;
}, MI = Vs(function(e, t) {
  return Array.isArray(t) ? t.map(e) : Object.keys(t).map(function(r) {
    return t[r];
  }).map(e);
}), jI = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  if (!r.length)
    return EI;
  var i = r.reverse(), a = i[0], o = i.slice(1);
  return function() {
    return o.reduce(function(s, u) {
      return u(s);
    }, a.apply(void 0, arguments));
  };
}, rp = function(t) {
  return Array.isArray(t) ? t.reverse() : t.split("").reverse.join("");
}, pS = function(t) {
  var r = null, n = null;
  return function() {
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r && a.every(function(s, u) {
      return s === r[u];
    }) || (r = a, n = t.apply(void 0, a)), n;
  };
};
function kI(e) {
  var t;
  return e === 0 ? t = 1 : t = Math.floor(new be(e).abs().log(10).toNumber()) + 1, t;
}
function $I(e, t, r) {
  for (var n = new be(e), i = 0, a = []; n.lt(t) && i < 1e5; )
    a.push(n.toNumber()), n = n.add(r), i++;
  return a;
}
var NI = Vs(function(e, t, r) {
  var n = +e, i = +t;
  return n + r * (i - n);
}), II = Vs(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, (r - e) / n;
}), RI = Vs(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, Math.max(0, Math.min(1, (r - e) / n));
});
const Ks = {
  rangeStep: $I,
  getDigitCount: kI,
  interpolateNumber: NI,
  uninterpolateNumber: II,
  uninterpolateTruncation: RI
};
function np(e) {
  return qI(e) || LI(e) || hS(e) || DI();
}
function DI() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function LI(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function qI(e) {
  if (Array.isArray(e)) return ip(e);
}
function ia(e, t) {
  return zI(e) || FI(e, t) || hS(e, t) || BI();
}
function BI() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function hS(e, t) {
  if (e) {
    if (typeof e == "string") return ip(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ip(e, t);
  }
}
function ip(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function FI(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], n = !0, i = !1, a = void 0;
    try {
      for (var o = e[Symbol.iterator](), s; !(n = (s = o.next()).done) && (r.push(s.value), !(t && r.length === t)); n = !0)
        ;
    } catch (u) {
      i = !0, a = u;
    } finally {
      try {
        !n && o.return != null && o.return();
      } finally {
        if (i) throw a;
      }
    }
    return r;
  }
}
function zI(e) {
  if (Array.isArray(e)) return e;
}
function vS(e) {
  var t = ia(e, 2), r = t[0], n = t[1], i = r, a = n;
  return r > n && (i = n, a = r), [i, a];
}
function yS(e, t, r) {
  if (e.lte(0))
    return new be(0);
  var n = Ks.getDigitCount(e.toNumber()), i = new be(10).pow(n), a = e.div(i), o = n !== 1 ? 0.05 : 0.1, s = new be(Math.ceil(a.div(o).toNumber())).add(r).mul(o), u = s.mul(i);
  return t ? u : new be(Math.ceil(u));
}
function WI(e, t, r) {
  var n = 1, i = new be(e);
  if (!i.isint() && r) {
    var a = Math.abs(e);
    a < 1 ? (n = new be(10).pow(Ks.getDigitCount(e) - 1), i = new be(Math.floor(i.div(n).toNumber())).mul(n)) : a > 1 && (i = new be(Math.floor(e)));
  } else e === 0 ? i = new be(Math.floor((t - 1) / 2)) : r || (i = new be(Math.floor(e)));
  var o = Math.floor((t - 1) / 2), s = jI(MI(function(u) {
    return i.add(new be(u - o).mul(n)).toNumber();
  }), tp);
  return s(0, t);
}
function mS(e, t, r, n) {
  var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((t - e) / (r - 1)))
    return {
      step: new be(0),
      tickMin: new be(0),
      tickMax: new be(0)
    };
  var a = yS(new be(t).sub(e).div(r - 1), n, i), o;
  e <= 0 && t >= 0 ? o = new be(0) : (o = new be(e).add(t).div(2), o = o.sub(new be(o).mod(a)));
  var s = Math.ceil(o.sub(e).div(a).toNumber()), u = Math.ceil(new be(t).sub(o).div(a).toNumber()), c = s + u + 1;
  return c > r ? mS(e, t, r, n, i + 1) : (c < r && (u = t > 0 ? u + (r - c) : u, s = t > 0 ? s : s + (r - c)), {
    step: a,
    tickMin: o.sub(new be(s).mul(a)),
    tickMax: o.add(new be(u).mul(a))
  });
}
function UI(e) {
  var t = ia(e, 2), r = t[0], n = t[1], i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = Math.max(i, 2), s = vS([r, n]), u = ia(s, 2), c = u[0], l = u[1];
  if (c === -1 / 0 || l === 1 / 0) {
    var f = l === 1 / 0 ? [c].concat(np(tp(0, i - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(np(tp(0, i - 1).map(function() {
      return -1 / 0;
    })), [l]);
    return r > n ? rp(f) : f;
  }
  if (c === l)
    return WI(c, i, a);
  var d = mS(c, l, o, a), h = d.step, m = d.tickMin, v = d.tickMax, p = Ks.rangeStep(m, v.add(new be(0.1).mul(h)), h);
  return r > n ? rp(p) : p;
}
function GI(e, t) {
  var r = ia(e, 2), n = r[0], i = r[1], a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = vS([n, i]), s = ia(o, 2), u = s[0], c = s[1];
  if (u === -1 / 0 || c === 1 / 0)
    return [n, i];
  if (u === c)
    return [u];
  var l = Math.max(t, 2), f = yS(new be(c).sub(u).div(l - 1), a, 0), d = [].concat(np(Ks.rangeStep(new be(u), new be(c).sub(new be(0.99).mul(f)), f)), [c]);
  return n > i ? rp(d) : d;
}
var HI = pS(UI), VI = pS(GI), KI = process.env.NODE_ENV === "production", Lf = "Invariant failed";
function tt(e, t) {
  if (KI)
    throw new Error(Lf);
  var r = typeof t == "function" ? t() : t, n = r ? "".concat(Lf, ": ").concat(r) : Lf;
  throw new Error(n);
}
var YI = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function Dn(e) {
  "@babel/helpers - typeof";
  return Dn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Dn(e);
}
function Fo() {
  return Fo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fo.apply(this, arguments);
}
function XI(e, t) {
  return e2(e) || QI(e, t) || JI(e, t) || ZI();
}
function ZI() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function JI(e, t) {
  if (e) {
    if (typeof e == "string") return C0(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return C0(e, t);
  }
}
function C0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function QI(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function e2(e) {
  if (Array.isArray(e)) return e;
}
function t2(e, t) {
  if (e == null) return {};
  var r = r2(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function r2(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function n2(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function i2(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, xS(n.key), n);
  }
}
function a2(e, t, r) {
  return t && i2(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function o2(e, t, r) {
  return t = zo(t), s2(e, gS() ? Reflect.construct(t, r || [], zo(e).constructor) : t.apply(e, r));
}
function s2(e, t) {
  if (t && (Dn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return u2(e);
}
function u2(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function gS() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (gS = function() {
    return !!e;
  })();
}
function zo(e) {
  return zo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, zo(e);
}
function c2(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && ap(e, t);
}
function ap(e, t) {
  return ap = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, ap(e, t);
}
function bS(e, t, r) {
  return t = xS(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function xS(e) {
  var t = l2(e, "string");
  return Dn(t) == "symbol" ? t : t + "";
}
function l2(e, t) {
  if (Dn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Dn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Ia = /* @__PURE__ */ function(e) {
  function t() {
    return n2(this, t), o2(this, t, arguments);
  }
  return c2(t, e), a2(t, [{
    key: "render",
    value: function() {
      var n = this.props, i = n.offset, a = n.layout, o = n.width, s = n.dataKey, u = n.data, c = n.dataPointFormatter, l = n.xAxis, f = n.yAxis, d = t2(n, YI), h = Q(d, !1);
      this.props.direction === "x" && l.type !== "number" && (process.env.NODE_ENV !== "production" ? tt(!1, 'ErrorBar requires Axis type property to be "number".') : tt());
      var m = u.map(function(v) {
        var p = c(v, s), g = p.x, b = p.y, w = p.value, O = p.errorVal;
        if (!O)
          return null;
        var y = [], x, _;
        if (Array.isArray(O)) {
          var P = XI(O, 2);
          x = P[0], _ = P[1];
        } else
          x = _ = O;
        if (a === "vertical") {
          var E = l.scale, M = b + i, C = M + o, T = M - o, k = E(w - x), $ = E(w + _);
          y.push({
            x1: $,
            y1: C,
            x2: $,
            y2: T
          }), y.push({
            x1: k,
            y1: M,
            x2: $,
            y2: M
          }), y.push({
            x1: k,
            y1: C,
            x2: k,
            y2: T
          });
        } else if (a === "horizontal") {
          var I = f.scale, R = g + i, q = R - o, W = R + o, H = I(w - x), N = I(w + _);
          y.push({
            x1: q,
            y1: N,
            x2: W,
            y2: N
          }), y.push({
            x1: R,
            y1: H,
            x2: R,
            y2: N
          }), y.push({
            x1: q,
            y1: H,
            x2: W,
            y2: H
          });
        }
        return /* @__PURE__ */ A.createElement(le, Fo({
          className: "recharts-errorBar",
          key: "bar-".concat(y.map(function(L) {
            return "".concat(L.x1, "-").concat(L.x2, "-").concat(L.y1, "-").concat(L.y2);
          }))
        }, h), y.map(function(L) {
          return /* @__PURE__ */ A.createElement("line", Fo({}, L, {
            key: "line-".concat(L.x1, "-").concat(L.x2, "-").concat(L.y1, "-").concat(L.y2)
          }));
        }));
      });
      return /* @__PURE__ */ A.createElement(le, {
        className: "recharts-errorBars"
      }, m);
    }
  }]);
}(A.Component);
bS(Ia, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
bS(Ia, "displayName", "ErrorBar");
function aa(e) {
  "@babel/helpers - typeof";
  return aa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, aa(e);
}
function M0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Tr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? M0(Object(r), !0).forEach(function(n) {
      f2(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : M0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function f2(e, t, r) {
  return t = d2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function d2(e) {
  var t = p2(e, "string");
  return aa(t) == "symbol" ? t : t + "";
}
function p2(e, t) {
  if (aa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (aa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var wS = function(t) {
  var r = t.children, n = t.formattedGraphicalItems, i = t.legendWidth, a = t.legendContent, o = ot(r, On);
  if (!o)
    return null;
  var s = On.defaultProps, u = s !== void 0 ? Tr(Tr({}, s), o.props) : {}, c;
  return o.props && o.props.payload ? c = o.props && o.props.payload : a === "children" ? c = (n || []).reduce(function(l, f) {
    var d = f.item, h = f.props, m = h.sectors || h.data || [];
    return l.concat(m.map(function(v) {
      return {
        type: o.props.iconType || d.props.legendType,
        value: v.name,
        color: v.fill,
        payload: v
      };
    }));
  }, []) : c = (n || []).map(function(l) {
    var f = l.item, d = f.type.defaultProps, h = d !== void 0 ? Tr(Tr({}, d), f.props) : {}, m = h.dataKey, v = h.name, p = h.legendType, g = h.hide;
    return {
      inactive: g,
      dataKey: m,
      type: u.iconType || p || "square",
      color: iv(f),
      value: v || m,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: h
    };
  }), Tr(Tr(Tr({}, u), On.getWithHeight(o, i)), {}, {
    payload: c,
    item: o
  });
};
function oa(e) {
  "@babel/helpers - typeof";
  return oa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, oa(e);
}
function j0(e) {
  return m2(e) || y2(e) || v2(e) || h2();
}
function h2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function v2(e, t) {
  if (e) {
    if (typeof e == "string") return op(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return op(e, t);
  }
}
function y2(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function m2(e) {
  if (Array.isArray(e)) return op(e);
}
function op(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function k0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function je(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? k0(Object(r), !0).forEach(function(n) {
      Sn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : k0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Sn(e, t, r) {
  return t = g2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function g2(e) {
  var t = b2(e, "string");
  return oa(t) == "symbol" ? t : t + "";
}
function b2(e, t) {
  if (oa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (oa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ke(e, t, r) {
  return se(e) || se(t) ? r : qe(t) ? ut(e, t, r) : ie(t) ? t(e) : r;
}
function Ri(e, t, r, n) {
  var i = mI(e, function(s) {
    return ke(s, t);
  });
  if (r === "number") {
    var a = i.filter(function(s) {
      return U(s) || parseFloat(s);
    });
    return a.length ? [Hs(a), yr(a)] : [1 / 0, -1 / 0];
  }
  var o = n ? i.filter(function(s) {
    return !se(s);
  }) : i;
  return o.map(function(s) {
    return qe(s) || s instanceof Date ? s : "";
  });
}
var x2 = function(t) {
  var r, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = arguments.length > 2 ? arguments[2] : void 0, a = arguments.length > 3 ? arguments[3] : void 0, o = -1, s = (r = n?.length) !== null && r !== void 0 ? r : 0;
  if (s <= 1)
    return 0;
  if (a && a.axisType === "angleAxis" && Math.abs(Math.abs(a.range[1] - a.range[0]) - 360) <= 1e-6)
    for (var u = a.range, c = 0; c < s; c++) {
      var l = c > 0 ? i[c - 1].coordinate : i[s - 1].coordinate, f = i[c].coordinate, d = c >= s - 1 ? i[0].coordinate : i[c + 1].coordinate, h = void 0;
      if (Ye(f - l) !== Ye(d - f)) {
        var m = [];
        if (Ye(d - f) === Ye(u[1] - u[0])) {
          h = d;
          var v = f + u[1] - u[0];
          m[0] = Math.min(v, (v + l) / 2), m[1] = Math.max(v, (v + l) / 2);
        } else {
          h = l;
          var p = d + u[1] - u[0];
          m[0] = Math.min(f, (p + f) / 2), m[1] = Math.max(f, (p + f) / 2);
        }
        var g = [Math.min(f, (h + f) / 2), Math.max(f, (h + f) / 2)];
        if (t > g[0] && t <= g[1] || t >= m[0] && t <= m[1]) {
          o = i[c].index;
          break;
        }
      } else {
        var b = Math.min(l, d), w = Math.max(l, d);
        if (t > (b + f) / 2 && t <= (w + f) / 2) {
          o = i[c].index;
          break;
        }
      }
    }
  else
    for (var O = 0; O < s; O++)
      if (O === 0 && t <= (n[O].coordinate + n[O + 1].coordinate) / 2 || O > 0 && O < s - 1 && t > (n[O].coordinate + n[O - 1].coordinate) / 2 && t <= (n[O].coordinate + n[O + 1].coordinate) / 2 || O === s - 1 && t > (n[O].coordinate + n[O - 1].coordinate) / 2) {
        o = n[O].index;
        break;
      }
  return o;
}, iv = function(t) {
  var r, n = t, i = n.type.displayName, a = (r = t.type) !== null && r !== void 0 && r.defaultProps ? je(je({}, t.type.defaultProps), t.props) : t.props, o = a.stroke, s = a.fill, u;
  switch (i) {
    case "Line":
      u = o;
      break;
    case "Area":
    case "Radar":
      u = o && o !== "none" ? o : s;
      break;
    default:
      u = s;
      break;
  }
  return u;
}, w2 = function(t) {
  var r = t.barSize, n = t.totalSize, i = t.stackGroups, a = i === void 0 ? {} : i;
  if (!a)
    return {};
  for (var o = {}, s = Object.keys(a), u = 0, c = s.length; u < c; u++)
    for (var l = a[s[u]].stackGroups, f = Object.keys(l), d = 0, h = f.length; d < h; d++) {
      var m = l[f[d]], v = m.items, p = m.cateAxisId, g = v.filter(function(_) {
        return Jt(_.type).indexOf("Bar") >= 0;
      });
      if (g && g.length) {
        var b = g[0].type.defaultProps, w = b !== void 0 ? je(je({}, b), g[0].props) : g[0].props, O = w.barSize, y = w[p];
        o[y] || (o[y] = []);
        var x = se(O) ? r : O;
        o[y].push({
          item: g[0],
          stackList: g.slice(1),
          barSize: se(x) ? void 0 : Xe(x, n, 0)
        });
      }
    }
  return o;
}, O2 = function(t) {
  var r = t.barGap, n = t.barCategoryGap, i = t.bandSize, a = t.sizeList, o = a === void 0 ? [] : a, s = t.maxBarSize, u = o.length;
  if (u < 1) return null;
  var c = Xe(r, i, 0, !0), l, f = [];
  if (o[0].barSize === +o[0].barSize) {
    var d = !1, h = i / u, m = o.reduce(function(O, y) {
      return O + y.barSize || 0;
    }, 0);
    m += (u - 1) * c, m >= i && (m -= (u - 1) * c, c = 0), m >= i && h > 0 && (d = !0, h *= 0.9, m = u * h);
    var v = (i - m) / 2 >> 0, p = {
      offset: v - c,
      size: 0
    };
    l = o.reduce(function(O, y) {
      var x = {
        item: y.item,
        position: {
          offset: p.offset + p.size + c,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: d ? h : y.barSize
        }
      }, _ = [].concat(j0(O), [x]);
      return p = _[_.length - 1].position, y.stackList && y.stackList.length && y.stackList.forEach(function(P) {
        _.push({
          item: P,
          position: p
        });
      }), _;
    }, f);
  } else {
    var g = Xe(n, i, 0, !0);
    i - 2 * g - (u - 1) * c <= 0 && (c = 0);
    var b = (i - 2 * g - (u - 1) * c) / u;
    b > 1 && (b >>= 0);
    var w = s === +s ? Math.min(b, s) : b;
    l = o.reduce(function(O, y, x) {
      var _ = [].concat(j0(O), [{
        item: y.item,
        position: {
          offset: g + (b + c) * x + (b - w) / 2,
          size: w
        }
      }]);
      return y.stackList && y.stackList.length && y.stackList.forEach(function(P) {
        _.push({
          item: P,
          position: _[_.length - 1].position
        });
      }), _;
    }, f);
  }
  return l;
}, _2 = function(t, r, n, i) {
  var a = n.children, o = n.width, s = n.margin, u = o - (s.left || 0) - (s.right || 0), c = wS({
    children: a,
    legendWidth: u
  });
  if (c) {
    var l = i || {}, f = l.width, d = l.height, h = c.align, m = c.verticalAlign, v = c.layout;
    if ((v === "vertical" || v === "horizontal" && m === "middle") && h !== "center" && U(t[h]))
      return je(je({}, t), {}, Sn({}, h, t[h] + (f || 0)));
    if ((v === "horizontal" || v === "vertical" && h === "center") && m !== "middle" && U(t[m]))
      return je(je({}, t), {}, Sn({}, m, t[m] + (d || 0)));
  }
  return t;
}, S2 = function(t, r, n) {
  return se(r) ? !0 : t === "horizontal" ? r === "yAxis" : t === "vertical" || n === "x" ? r === "xAxis" : n === "y" ? r === "yAxis" : !0;
}, OS = function(t, r, n, i, a) {
  var o = r.props.children, s = ct(o, Ia).filter(function(c) {
    return S2(i, a, c.props.direction);
  });
  if (s && s.length) {
    var u = s.map(function(c) {
      return c.props.dataKey;
    });
    return t.reduce(function(c, l) {
      var f = ke(l, n);
      if (se(f)) return c;
      var d = Array.isArray(f) ? [Hs(f), yr(f)] : [f, f], h = u.reduce(function(m, v) {
        var p = ke(l, v, 0), g = d[0] - Math.abs(Array.isArray(p) ? p[0] : p), b = d[1] + Math.abs(Array.isArray(p) ? p[1] : p);
        return [Math.min(g, m[0]), Math.max(b, m[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(h[0], c[0]), Math.max(h[1], c[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, A2 = function(t, r, n, i, a) {
  var o = r.map(function(s) {
    return OS(t, s, n, a, i);
  }).filter(function(s) {
    return !se(s);
  });
  return o && o.length ? o.reduce(function(s, u) {
    return [Math.min(s[0], u[0]), Math.max(s[1], u[1])];
  }, [1 / 0, -1 / 0]) : null;
}, _S = function(t, r, n, i, a) {
  var o = r.map(function(u) {
    var c = u.props.dataKey;
    return n === "number" && c && OS(t, u, c, i) || Ri(t, c, n, a);
  });
  if (n === "number")
    return o.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(u, c) {
        return [Math.min(u[0], c[0]), Math.max(u[1], c[1])];
      },
      [1 / 0, -1 / 0]
    );
  var s = {};
  return o.reduce(function(u, c) {
    for (var l = 0, f = c.length; l < f; l++)
      s[c[l]] || (s[c[l]] = !0, u.push(c[l]));
    return u;
  }, []);
}, SS = function(t, r) {
  return t === "horizontal" && r === "xAxis" || t === "vertical" && r === "yAxis" || t === "centric" && r === "angleAxis" || t === "radial" && r === "radiusAxis";
}, AS = function(t, r, n, i) {
  if (i)
    return t.map(function(u) {
      return u.coordinate;
    });
  var a, o, s = t.map(function(u) {
    return u.coordinate === r && (a = !0), u.coordinate === n && (o = !0), u.coordinate;
  });
  return a || s.push(r), o || s.push(n), s;
}, Zt = function(t, r, n) {
  if (!t) return null;
  var i = t.scale, a = t.duplicateDomain, o = t.type, s = t.range, u = t.realScaleType === "scaleBand" ? i.bandwidth() / 2 : 2, c = (r || n) && o === "category" && i.bandwidth ? i.bandwidth() / u : 0;
  if (c = t.axisType === "angleAxis" && s?.length >= 2 ? Ye(s[0] - s[1]) * 2 * c : c, r && (t.ticks || t.niceTicks)) {
    var l = (t.ticks || t.niceTicks).map(function(f) {
      var d = a ? a.indexOf(f) : f;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: i(d) + c,
        value: f,
        offset: c
      };
    });
    return l.filter(function(f) {
      return !oi(f.coordinate);
    });
  }
  return t.isCategorical && t.categoricalDomain ? t.categoricalDomain.map(function(f, d) {
    return {
      coordinate: i(f) + c,
      value: f,
      index: d,
      offset: c
    };
  }) : i.ticks && !n ? i.ticks(t.tickCount).map(function(f) {
    return {
      coordinate: i(f) + c,
      value: f,
      offset: c
    };
  }) : i.domain().map(function(f, d) {
    return {
      coordinate: i(f) + c,
      value: a ? a[f] : f,
      index: d,
      offset: c
    };
  });
}, qf = /* @__PURE__ */ new WeakMap(), eo = function(t, r) {
  if (typeof r != "function")
    return t;
  qf.has(t) || qf.set(t, /* @__PURE__ */ new WeakMap());
  var n = qf.get(t);
  if (n.has(r))
    return n.get(r);
  var i = function() {
    t.apply(void 0, arguments), r.apply(void 0, arguments);
  };
  return n.set(r, i), i;
}, PS = function(t, r, n) {
  var i = t.scale, a = t.type, o = t.layout, s = t.axisType;
  if (i === "auto")
    return o === "radial" && s === "radiusAxis" ? {
      scale: Ji(),
      realScaleType: "band"
    } : o === "radial" && s === "angleAxis" ? {
      scale: Ro(),
      realScaleType: "linear"
    } : a === "category" && r && (r.indexOf("LineChart") >= 0 || r.indexOf("AreaChart") >= 0 || r.indexOf("ComposedChart") >= 0 && !n) ? {
      scale: Ii(),
      realScaleType: "point"
    } : a === "category" ? {
      scale: Ji(),
      realScaleType: "band"
    } : {
      scale: Ro(),
      realScaleType: "linear"
    };
  if (Hr(i)) {
    var u = "scale".concat(js(i));
    return {
      scale: (m0[u] || Ii)(),
      realScaleType: m0[u] ? u : "point"
    };
  }
  return ie(i) ? {
    scale: i
  } : {
    scale: Ii(),
    realScaleType: "point"
  };
}, $0 = 1e-4, TS = function(t) {
  var r = t.domain();
  if (!(!r || r.length <= 2)) {
    var n = r.length, i = t.range(), a = Math.min(i[0], i[1]) - $0, o = Math.max(i[0], i[1]) + $0, s = t(r[0]), u = t(r[n - 1]);
    (s < a || s > o || u < a || u > o) && t.domain([r[0], r[n - 1]]);
  }
}, P2 = function(t, r) {
  if (!t)
    return null;
  for (var n = 0, i = t.length; n < i; n++)
    if (t[n].item === r)
      return t[n].position;
  return null;
}, T2 = function(t, r) {
  if (!r || r.length !== 2 || !U(r[0]) || !U(r[1]))
    return t;
  var n = Math.min(r[0], r[1]), i = Math.max(r[0], r[1]), a = [t[0], t[1]];
  return (!U(t[0]) || t[0] < n) && (a[0] = n), (!U(t[1]) || t[1] > i) && (a[1] = i), a[0] > i && (a[0] = i), a[1] < n && (a[1] = n), a;
}, E2 = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, i = t[0].length; n < i; ++n)
      for (var a = 0, o = 0, s = 0; s < r; ++s) {
        var u = oi(t[s][n][1]) ? t[s][n][0] : t[s][n][1];
        u >= 0 ? (t[s][n][0] = a, t[s][n][1] = a + u, a = t[s][n][1]) : (t[s][n][0] = o, t[s][n][1] = o + u, o = t[s][n][1]);
      }
}, C2 = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, i = t[0].length; n < i; ++n)
      for (var a = 0, o = 0; o < r; ++o) {
        var s = oi(t[o][n][1]) ? t[o][n][0] : t[o][n][1];
        s >= 0 ? (t[o][n][0] = a, t[o][n][1] = a + s, a = t[o][n][1]) : (t[o][n][0] = 0, t[o][n][1] = 0);
      }
}, M2 = {
  sign: E2,
  // @ts-expect-error definitelytyped types are incorrect
  expand: m6,
  // @ts-expect-error definitelytyped types are incorrect
  none: Cn,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: g6,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: b6,
  positive: C2
}, j2 = function(t, r, n) {
  var i = r.map(function(s) {
    return s.props.dataKey;
  }), a = M2[n], o = y6().keys(i).value(function(s, u) {
    return +ke(s, u, 0);
  }).order(Rd).offset(a);
  return o(t);
}, k2 = function(t, r, n, i, a, o) {
  if (!t)
    return null;
  var s = o ? r.reverse() : r, u = {}, c = s.reduce(function(f, d) {
    var h, m = (h = d.type) !== null && h !== void 0 && h.defaultProps ? je(je({}, d.type.defaultProps), d.props) : d.props, v = m.stackId, p = m.hide;
    if (p)
      return f;
    var g = m[n], b = f[g] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (qe(v)) {
      var w = b.stackGroups[v] || {
        numericAxisId: n,
        cateAxisId: i,
        items: []
      };
      w.items.push(d), b.hasStack = !0, b.stackGroups[v] = w;
    } else
      b.stackGroups[tn("_stackId_")] = {
        numericAxisId: n,
        cateAxisId: i,
        items: [d]
      };
    return je(je({}, f), {}, Sn({}, g, b));
  }, u), l = {};
  return Object.keys(c).reduce(function(f, d) {
    var h = c[d];
    if (h.hasStack) {
      var m = {};
      h.stackGroups = Object.keys(h.stackGroups).reduce(function(v, p) {
        var g = h.stackGroups[p];
        return je(je({}, v), {}, Sn({}, p, {
          numericAxisId: n,
          cateAxisId: i,
          items: g.items,
          stackedData: j2(t, g.items, a)
        }));
      }, m);
    }
    return je(je({}, f), {}, Sn({}, d, h));
  }, l);
}, ES = function(t, r) {
  var n = r.realScaleType, i = r.type, a = r.tickCount, o = r.originalDomain, s = r.allowDecimals, u = n || r.scale;
  if (u !== "auto" && u !== "linear")
    return null;
  if (a && i === "number" && o && (o[0] === "auto" || o[1] === "auto")) {
    var c = t.domain();
    if (!c.length)
      return null;
    var l = HI(c, a, s);
    return t.domain([Hs(l), yr(l)]), {
      niceTicks: l
    };
  }
  if (a && i === "number") {
    var f = t.domain(), d = VI(f, a, s);
    return {
      niceTicks: d
    };
  }
  return null;
};
function Wo(e) {
  var t = e.axis, r = e.ticks, n = e.bandSize, i = e.entry, a = e.index, o = e.dataKey;
  if (t.type === "category") {
    if (!t.allowDuplicatedCategory && t.dataKey && !se(i[t.dataKey])) {
      var s = mo(r, "value", i[t.dataKey]);
      if (s)
        return s.coordinate + n / 2;
    }
    return r[a] ? r[a].coordinate + n / 2 : null;
  }
  var u = ke(i, se(o) ? t.dataKey : o);
  return se(u) ? null : t.scale(u);
}
var N0 = function(t) {
  var r = t.axis, n = t.ticks, i = t.offset, a = t.bandSize, o = t.entry, s = t.index;
  if (r.type === "category")
    return n[s] ? n[s].coordinate + i : null;
  var u = ke(o, r.dataKey, r.domain[s]);
  return se(u) ? null : r.scale(u) - a / 2 + i;
}, $2 = function(t) {
  var r = t.numericAxis, n = r.scale.domain();
  if (r.type === "number") {
    var i = Math.min(n[0], n[1]), a = Math.max(n[0], n[1]);
    return i <= 0 && a >= 0 ? 0 : a < 0 ? a : i;
  }
  return n[0];
}, N2 = function(t, r) {
  var n, i = (n = t.type) !== null && n !== void 0 && n.defaultProps ? je(je({}, t.type.defaultProps), t.props) : t.props, a = i.stackId;
  if (qe(a)) {
    var o = r[a];
    if (o) {
      var s = o.items.indexOf(t);
      return s >= 0 ? o.stackedData[s] : null;
    }
  }
  return null;
}, I2 = function(t) {
  return t.reduce(function(r, n) {
    return [Hs(n.concat([r[0]]).filter(U)), yr(n.concat([r[1]]).filter(U))];
  }, [1 / 0, -1 / 0]);
}, CS = function(t, r, n) {
  return Object.keys(t).reduce(function(i, a) {
    var o = t[a], s = o.stackedData, u = s.reduce(function(c, l) {
      var f = I2(l.slice(r, n + 1));
      return [Math.min(c[0], f[0]), Math.max(c[1], f[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(u[0], i[0]), Math.max(u[1], i[1])];
  }, [1 / 0, -1 / 0]).map(function(i) {
    return i === 1 / 0 || i === -1 / 0 ? 0 : i;
  });
}, I0 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, R0 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, sp = function(t, r, n) {
  if (ie(t))
    return t(r, n);
  if (!Array.isArray(t))
    return r;
  var i = [];
  if (U(t[0]))
    i[0] = n ? t[0] : Math.min(t[0], r[0]);
  else if (I0.test(t[0])) {
    var a = +I0.exec(t[0])[1];
    i[0] = r[0] - a;
  } else ie(t[0]) ? i[0] = t[0](r[0]) : i[0] = r[0];
  if (U(t[1]))
    i[1] = n ? t[1] : Math.max(t[1], r[1]);
  else if (R0.test(t[1])) {
    var o = +R0.exec(t[1])[1];
    i[1] = r[1] + o;
  } else ie(t[1]) ? i[1] = t[1](r[1]) : i[1] = r[1];
  return i;
}, Uo = function(t, r, n) {
  if (t && t.scale && t.scale.bandwidth) {
    var i = t.scale.bandwidth();
    if (!n || i > 0)
      return i;
  }
  if (t && r && r.length >= 2) {
    for (var a = kh(r, function(f) {
      return f.coordinate;
    }), o = 1 / 0, s = 1, u = a.length; s < u; s++) {
      var c = a[s], l = a[s - 1];
      o = Math.min((c.coordinate || 0) - (l.coordinate || 0), o);
    }
    return o === 1 / 0 ? 0 : o;
  }
  return n ? void 0 : 0;
}, D0 = function(t, r, n) {
  return !t || !t.length || Yr(t, ut(n, "type.defaultProps.domain")) ? r : t;
}, MS = function(t, r) {
  var n = t.type.defaultProps ? je(je({}, t.type.defaultProps), t.props) : t.props, i = n.dataKey, a = n.name, o = n.unit, s = n.formatter, u = n.tooltipType, c = n.chartType, l = n.hide;
  return je(je({}, Q(t, !1)), {}, {
    dataKey: i,
    unit: o,
    formatter: s,
    name: a || i,
    color: iv(t),
    value: ke(r, i),
    type: u,
    payload: r,
    chartType: c,
    hide: l
  });
};
function sa(e) {
  "@babel/helpers - typeof";
  return sa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, sa(e);
}
function L0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ht(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? L0(Object(r), !0).forEach(function(n) {
      jS(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : L0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function jS(e, t, r) {
  return t = R2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function R2(e) {
  var t = D2(e, "string");
  return sa(t) == "symbol" ? t : t + "";
}
function D2(e, t) {
  if (sa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (sa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function L2(e, t) {
  return z2(e) || F2(e, t) || B2(e, t) || q2();
}
function q2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function B2(e, t) {
  if (e) {
    if (typeof e == "string") return q0(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return q0(e, t);
  }
}
function q0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function F2(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function z2(e) {
  if (Array.isArray(e)) return e;
}
var Go = Math.PI / 180, W2 = function(t) {
  return t * 180 / Math.PI;
}, Ae = function(t, r, n, i) {
  return {
    x: t + Math.cos(-Go * i) * n,
    y: r + Math.sin(-Go * i) * n
  };
}, kS = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(t - (n.left || 0) - (n.right || 0)), Math.abs(r - (n.top || 0) - (n.bottom || 0))) / 2;
}, U2 = function(t, r, n, i, a) {
  var o = t.width, s = t.height, u = t.startAngle, c = t.endAngle, l = Xe(t.cx, o, o / 2), f = Xe(t.cy, s, s / 2), d = kS(o, s, n), h = Xe(t.innerRadius, d, 0), m = Xe(t.outerRadius, d, d * 0.8), v = Object.keys(r);
  return v.reduce(function(p, g) {
    var b = r[g], w = b.domain, O = b.reversed, y;
    if (se(b.range))
      i === "angleAxis" ? y = [u, c] : i === "radiusAxis" && (y = [h, m]), O && (y = [y[1], y[0]]);
    else {
      y = b.range;
      var x = y, _ = L2(x, 2);
      u = _[0], c = _[1];
    }
    var P = PS(b, a), E = P.realScaleType, M = P.scale;
    M.domain(w).range(y), TS(M);
    var C = ES(M, Ht(Ht({}, b), {}, {
      realScaleType: E
    })), T = Ht(Ht(Ht({}, b), C), {}, {
      range: y,
      radius: m,
      realScaleType: E,
      scale: M,
      cx: l,
      cy: f,
      innerRadius: h,
      outerRadius: m,
      startAngle: u,
      endAngle: c
    });
    return Ht(Ht({}, p), {}, jS({}, g, T));
  }, {});
}, G2 = function(t, r) {
  var n = t.x, i = t.y, a = r.x, o = r.y;
  return Math.sqrt(Math.pow(n - a, 2) + Math.pow(i - o, 2));
}, H2 = function(t, r) {
  var n = t.x, i = t.y, a = r.cx, o = r.cy, s = G2({
    x: n,
    y: i
  }, {
    x: a,
    y: o
  });
  if (s <= 0)
    return {
      radius: s
    };
  var u = (n - a) / s, c = Math.acos(u);
  return i > o && (c = 2 * Math.PI - c), {
    radius: s,
    angle: W2(c),
    angleInRadian: c
  };
}, V2 = function(t) {
  var r = t.startAngle, n = t.endAngle, i = Math.floor(r / 360), a = Math.floor(n / 360), o = Math.min(i, a);
  return {
    startAngle: r - o * 360,
    endAngle: n - o * 360
  };
}, K2 = function(t, r) {
  var n = r.startAngle, i = r.endAngle, a = Math.floor(n / 360), o = Math.floor(i / 360), s = Math.min(a, o);
  return t + s * 360;
}, B0 = function(t, r) {
  var n = t.x, i = t.y, a = H2({
    x: n,
    y: i
  }, r), o = a.radius, s = a.angle, u = r.innerRadius, c = r.outerRadius;
  if (o < u || o > c)
    return !1;
  if (o === 0)
    return !0;
  var l = V2(r), f = l.startAngle, d = l.endAngle, h = s, m;
  if (f <= d) {
    for (; h > d; )
      h -= 360;
    for (; h < f; )
      h += 360;
    m = h >= f && h <= d;
  } else {
    for (; h > f; )
      h -= 360;
    for (; h < d; )
      h += 360;
    m = h >= d && h <= f;
  }
  return m ? Ht(Ht({}, r), {}, {
    radius: o,
    angle: K2(h, r)
  }) : null;
}, $S = function(t) {
  return !/* @__PURE__ */ Pt(t) && !ie(t) && typeof t != "boolean" ? t.className : "";
};
function ua(e) {
  "@babel/helpers - typeof";
  return ua = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ua(e);
}
var Y2 = ["offset"];
function X2(e) {
  return eR(e) || Q2(e) || J2(e) || Z2();
}
function Z2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function J2(e, t) {
  if (e) {
    if (typeof e == "string") return up(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return up(e, t);
  }
}
function Q2(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function eR(e) {
  if (Array.isArray(e)) return up(e);
}
function up(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function tR(e, t) {
  if (e == null) return {};
  var r = rR(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function rR(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function F0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Re(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? F0(Object(r), !0).forEach(function(n) {
      nR(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : F0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function nR(e, t, r) {
  return t = iR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function iR(e) {
  var t = aR(e, "string");
  return ua(t) == "symbol" ? t : t + "";
}
function aR(e, t) {
  if (ua(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ua(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ca() {
  return ca = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ca.apply(this, arguments);
}
var oR = function(t) {
  var r = t.value, n = t.formatter, i = se(t.children) ? r : t.children;
  return ie(n) ? n(i) : i;
}, sR = function(t, r) {
  var n = Ye(r - t), i = Math.min(Math.abs(r - t), 360);
  return n * i;
}, uR = function(t, r, n) {
  var i = t.position, a = t.viewBox, o = t.offset, s = t.className, u = a, c = u.cx, l = u.cy, f = u.innerRadius, d = u.outerRadius, h = u.startAngle, m = u.endAngle, v = u.clockWise, p = (f + d) / 2, g = sR(h, m), b = g >= 0 ? 1 : -1, w, O;
  i === "insideStart" ? (w = h + b * o, O = v) : i === "insideEnd" ? (w = m - b * o, O = !v) : i === "end" && (w = m + b * o, O = v), O = g <= 0 ? O : !O;
  var y = Ae(c, l, p, w), x = Ae(c, l, p, w + (O ? 1 : -1) * 359), _ = "M".concat(y.x, ",").concat(y.y, `
    A`).concat(p, ",").concat(p, ",0,1,").concat(O ? 0 : 1, `,
    `).concat(x.x, ",").concat(x.y), P = se(t.id) ? tn("recharts-radial-line-") : t.id;
  return /* @__PURE__ */ A.createElement("text", ca({}, n, {
    dominantBaseline: "central",
    className: ue("recharts-radial-bar-label", s)
  }), /* @__PURE__ */ A.createElement("defs", null, /* @__PURE__ */ A.createElement("path", {
    id: P,
    d: _
  })), /* @__PURE__ */ A.createElement("textPath", {
    xlinkHref: "#".concat(P)
  }, r));
}, cR = function(t) {
  var r = t.viewBox, n = t.offset, i = t.position, a = r, o = a.cx, s = a.cy, u = a.innerRadius, c = a.outerRadius, l = a.startAngle, f = a.endAngle, d = (l + f) / 2;
  if (i === "outside") {
    var h = Ae(o, s, c + n, d), m = h.x, v = h.y;
    return {
      x: m,
      y: v,
      textAnchor: m >= o ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (i === "center")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (i === "centerTop")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (i === "centerBottom")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var p = (u + c) / 2, g = Ae(o, s, p, d), b = g.x, w = g.y;
  return {
    x: b,
    y: w,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, lR = function(t) {
  var r = t.viewBox, n = t.parentViewBox, i = t.offset, a = t.position, o = r, s = o.x, u = o.y, c = o.width, l = o.height, f = l >= 0 ? 1 : -1, d = f * i, h = f > 0 ? "end" : "start", m = f > 0 ? "start" : "end", v = c >= 0 ? 1 : -1, p = v * i, g = v > 0 ? "end" : "start", b = v > 0 ? "start" : "end";
  if (a === "top") {
    var w = {
      x: s + c / 2,
      y: u - f * i,
      textAnchor: "middle",
      verticalAnchor: h
    };
    return Re(Re({}, w), n ? {
      height: Math.max(u - n.y, 0),
      width: c
    } : {});
  }
  if (a === "bottom") {
    var O = {
      x: s + c / 2,
      y: u + l + d,
      textAnchor: "middle",
      verticalAnchor: m
    };
    return Re(Re({}, O), n ? {
      height: Math.max(n.y + n.height - (u + l), 0),
      width: c
    } : {});
  }
  if (a === "left") {
    var y = {
      x: s - p,
      y: u + l / 2,
      textAnchor: g,
      verticalAnchor: "middle"
    };
    return Re(Re({}, y), n ? {
      width: Math.max(y.x - n.x, 0),
      height: l
    } : {});
  }
  if (a === "right") {
    var x = {
      x: s + c + p,
      y: u + l / 2,
      textAnchor: b,
      verticalAnchor: "middle"
    };
    return Re(Re({}, x), n ? {
      width: Math.max(n.x + n.width - x.x, 0),
      height: l
    } : {});
  }
  var _ = n ? {
    width: c,
    height: l
  } : {};
  return a === "insideLeft" ? Re({
    x: s + p,
    y: u + l / 2,
    textAnchor: b,
    verticalAnchor: "middle"
  }, _) : a === "insideRight" ? Re({
    x: s + c - p,
    y: u + l / 2,
    textAnchor: g,
    verticalAnchor: "middle"
  }, _) : a === "insideTop" ? Re({
    x: s + c / 2,
    y: u + d,
    textAnchor: "middle",
    verticalAnchor: m
  }, _) : a === "insideBottom" ? Re({
    x: s + c / 2,
    y: u + l - d,
    textAnchor: "middle",
    verticalAnchor: h
  }, _) : a === "insideTopLeft" ? Re({
    x: s + p,
    y: u + d,
    textAnchor: b,
    verticalAnchor: m
  }, _) : a === "insideTopRight" ? Re({
    x: s + c - p,
    y: u + d,
    textAnchor: g,
    verticalAnchor: m
  }, _) : a === "insideBottomLeft" ? Re({
    x: s + p,
    y: u + l - d,
    textAnchor: b,
    verticalAnchor: h
  }, _) : a === "insideBottomRight" ? Re({
    x: s + c - p,
    y: u + l - d,
    textAnchor: g,
    verticalAnchor: h
  }, _) : ai(a) && (U(a.x) || Ir(a.x)) && (U(a.y) || Ir(a.y)) ? Re({
    x: s + Xe(a.x, c),
    y: u + Xe(a.y, l),
    textAnchor: "end",
    verticalAnchor: "end"
  }, _) : Re({
    x: s + c / 2,
    y: u + l / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, _);
}, fR = function(t) {
  return "cx" in t && U(t.cx);
};
function ze(e) {
  var t = e.offset, r = t === void 0 ? 5 : t, n = tR(e, Y2), i = Re({
    offset: r
  }, n), a = i.viewBox, o = i.position, s = i.value, u = i.children, c = i.content, l = i.className, f = l === void 0 ? "" : l, d = i.textBreakAll;
  if (!a || se(s) && se(u) && !/* @__PURE__ */ Pt(c) && !ie(c))
    return null;
  if (/* @__PURE__ */ Pt(c))
    return /* @__PURE__ */ De(c, i);
  var h;
  if (ie(c)) {
    if (h = /* @__PURE__ */ Fi(c, i), /* @__PURE__ */ Pt(h))
      return h;
  } else
    h = oR(i);
  var m = fR(a), v = Q(i, !0);
  if (m && (o === "insideStart" || o === "insideEnd" || o === "end"))
    return uR(i, h, v);
  var p = m ? cR(i) : lR(i);
  return /* @__PURE__ */ A.createElement(Kr, ca({
    className: ue("recharts-label", f)
  }, v, p, {
    breakAll: d
  }), h);
}
ze.displayName = "Label";
var NS = function(t) {
  var r = t.cx, n = t.cy, i = t.angle, a = t.startAngle, o = t.endAngle, s = t.r, u = t.radius, c = t.innerRadius, l = t.outerRadius, f = t.x, d = t.y, h = t.top, m = t.left, v = t.width, p = t.height, g = t.clockWise, b = t.labelViewBox;
  if (b)
    return b;
  if (U(v) && U(p)) {
    if (U(f) && U(d))
      return {
        x: f,
        y: d,
        width: v,
        height: p
      };
    if (U(h) && U(m))
      return {
        x: h,
        y: m,
        width: v,
        height: p
      };
  }
  return U(f) && U(d) ? {
    x: f,
    y: d,
    width: 0,
    height: 0
  } : U(r) && U(n) ? {
    cx: r,
    cy: n,
    startAngle: a || i || 0,
    endAngle: o || i || 0,
    innerRadius: c || 0,
    outerRadius: l || u || s || 0,
    clockWise: g
  } : t.viewBox ? t.viewBox : {};
}, dR = function(t, r) {
  return t ? t === !0 ? /* @__PURE__ */ A.createElement(ze, {
    key: "label-implicit",
    viewBox: r
  }) : qe(t) ? /* @__PURE__ */ A.createElement(ze, {
    key: "label-implicit",
    viewBox: r,
    value: t
  }) : /* @__PURE__ */ Pt(t) ? t.type === ze ? /* @__PURE__ */ De(t, {
    key: "label-implicit",
    viewBox: r
  }) : /* @__PURE__ */ A.createElement(ze, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : ie(t) ? /* @__PURE__ */ A.createElement(ze, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : ai(t) ? /* @__PURE__ */ A.createElement(ze, ca({
    viewBox: r
  }, t, {
    key: "label-implicit"
  })) : null : null;
}, pR = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && n && !t.label)
    return null;
  var i = t.children, a = NS(t), o = ct(i, ze).map(function(u, c) {
    return /* @__PURE__ */ De(u, {
      viewBox: r || a,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(c)
    });
  });
  if (!n)
    return o;
  var s = dR(t.label, r || a);
  return [s].concat(X2(o));
};
ze.parseViewBox = NS;
ze.renderCallByParent = pR;
var Bf, z0;
function hR() {
  if (z0) return Bf;
  z0 = 1;
  function e(t) {
    var r = t == null ? 0 : t.length;
    return r ? t[r - 1] : void 0;
  }
  return Bf = e, Bf;
}
var vR = hR();
const yR = /* @__PURE__ */ xe(vR);
function la(e) {
  "@babel/helpers - typeof";
  return la = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, la(e);
}
var mR = ["valueAccessor"], gR = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function bR(e) {
  return _R(e) || OR(e) || wR(e) || xR();
}
function xR() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wR(e, t) {
  if (e) {
    if (typeof e == "string") return cp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return cp(e, t);
  }
}
function OR(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function _R(e) {
  if (Array.isArray(e)) return cp(e);
}
function cp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Ho() {
  return Ho = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ho.apply(this, arguments);
}
function W0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function U0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? W0(Object(r), !0).forEach(function(n) {
      SR(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : W0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function SR(e, t, r) {
  return t = AR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function AR(e) {
  var t = PR(e, "string");
  return la(t) == "symbol" ? t : t + "";
}
function PR(e, t) {
  if (la(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (la(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function G0(e, t) {
  if (e == null) return {};
  var r = TR(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function TR(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var ER = function(t) {
  return Array.isArray(t.value) ? yR(t.value) : t.value;
};
function Dt(e) {
  var t = e.valueAccessor, r = t === void 0 ? ER : t, n = G0(e, mR), i = n.data, a = n.dataKey, o = n.clockWise, s = n.id, u = n.textBreakAll, c = G0(n, gR);
  return !i || !i.length ? null : /* @__PURE__ */ A.createElement(le, {
    className: "recharts-label-list"
  }, i.map(function(l, f) {
    var d = se(a) ? r(l, f) : ke(l && l.payload, a), h = se(s) ? {} : {
      id: "".concat(s, "-").concat(f)
    };
    return /* @__PURE__ */ A.createElement(ze, Ho({}, Q(l, !0), c, h, {
      parentViewBox: l.parentViewBox,
      value: d,
      textBreakAll: u,
      viewBox: ze.parseViewBox(se(o) ? l : U0(U0({}, l), {}, {
        clockWise: o
      })),
      key: "label-".concat(f),
      index: f
    }));
  }));
}
Dt.displayName = "LabelList";
function CR(e, t) {
  return e ? e === !0 ? /* @__PURE__ */ A.createElement(Dt, {
    key: "labelList-implicit",
    data: t
  }) : /* @__PURE__ */ A.isValidElement(e) || ie(e) ? /* @__PURE__ */ A.createElement(Dt, {
    key: "labelList-implicit",
    data: t,
    content: e
  }) : ai(e) ? /* @__PURE__ */ A.createElement(Dt, Ho({
    data: t
  }, e, {
    key: "labelList-implicit"
  })) : null : null;
}
function MR(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && r && !e.label)
    return null;
  var n = e.children, i = ct(n, Dt).map(function(o, s) {
    return /* @__PURE__ */ De(o, {
      data: t,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(s)
    });
  });
  if (!r)
    return i;
  var a = CR(e.label, t);
  return [a].concat(bR(i));
}
Dt.renderCallByParent = MR;
function fa(e) {
  "@babel/helpers - typeof";
  return fa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fa(e);
}
function lp() {
  return lp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lp.apply(this, arguments);
}
function H0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function V0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? H0(Object(r), !0).forEach(function(n) {
      jR(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : H0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function jR(e, t, r) {
  return t = kR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function kR(e) {
  var t = $R(e, "string");
  return fa(t) == "symbol" ? t : t + "";
}
function $R(e, t) {
  if (fa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (fa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var NR = function(t, r) {
  var n = Ye(r - t), i = Math.min(Math.abs(r - t), 359.999);
  return n * i;
}, to = function(t) {
  var r = t.cx, n = t.cy, i = t.radius, a = t.angle, o = t.sign, s = t.isExternal, u = t.cornerRadius, c = t.cornerIsExternal, l = u * (s ? 1 : -1) + i, f = Math.asin(u / l) / Go, d = c ? a : a + o * f, h = Ae(r, n, l, d), m = Ae(r, n, i, d), v = c ? a - o * f : a, p = Ae(r, n, l * Math.cos(f * Go), v);
  return {
    center: h,
    circleTangency: m,
    lineTangency: p,
    theta: f
  };
}, IS = function(t) {
  var r = t.cx, n = t.cy, i = t.innerRadius, a = t.outerRadius, o = t.startAngle, s = t.endAngle, u = NR(o, s), c = o + u, l = Ae(r, n, a, o), f = Ae(r, n, a, c), d = "M ".concat(l.x, ",").concat(l.y, `
    A `).concat(a, ",").concat(a, `,0,
    `).concat(+(Math.abs(u) > 180), ",").concat(+(o > c), `,
    `).concat(f.x, ",").concat(f.y, `
  `);
  if (i > 0) {
    var h = Ae(r, n, i, o), m = Ae(r, n, i, c);
    d += "L ".concat(m.x, ",").concat(m.y, `
            A `).concat(i, ",").concat(i, `,0,
            `).concat(+(Math.abs(u) > 180), ",").concat(+(o <= c), `,
            `).concat(h.x, ",").concat(h.y, " Z");
  } else
    d += "L ".concat(r, ",").concat(n, " Z");
  return d;
}, IR = function(t) {
  var r = t.cx, n = t.cy, i = t.innerRadius, a = t.outerRadius, o = t.cornerRadius, s = t.forceCornerRadius, u = t.cornerIsExternal, c = t.startAngle, l = t.endAngle, f = Ye(l - c), d = to({
    cx: r,
    cy: n,
    radius: a,
    angle: c,
    sign: f,
    cornerRadius: o,
    cornerIsExternal: u
  }), h = d.circleTangency, m = d.lineTangency, v = d.theta, p = to({
    cx: r,
    cy: n,
    radius: a,
    angle: l,
    sign: -f,
    cornerRadius: o,
    cornerIsExternal: u
  }), g = p.circleTangency, b = p.lineTangency, w = p.theta, O = u ? Math.abs(c - l) : Math.abs(c - l) - v - w;
  if (O < 0)
    return s ? "M ".concat(m.x, ",").concat(m.y, `
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(o * 2, `,0
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(-o * 2, `,0
      `) : IS({
      cx: r,
      cy: n,
      innerRadius: i,
      outerRadius: a,
      startAngle: c,
      endAngle: l
    });
  var y = "M ".concat(m.x, ",").concat(m.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(h.x, ",").concat(h.y, `
    A`).concat(a, ",").concat(a, ",0,").concat(+(O > 180), ",").concat(+(f < 0), ",").concat(g.x, ",").concat(g.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(b.x, ",").concat(b.y, `
  `);
  if (i > 0) {
    var x = to({
      cx: r,
      cy: n,
      radius: i,
      angle: c,
      sign: f,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: u
    }), _ = x.circleTangency, P = x.lineTangency, E = x.theta, M = to({
      cx: r,
      cy: n,
      radius: i,
      angle: l,
      sign: -f,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: u
    }), C = M.circleTangency, T = M.lineTangency, k = M.theta, $ = u ? Math.abs(c - l) : Math.abs(c - l) - E - k;
    if ($ < 0 && o === 0)
      return "".concat(y, "L").concat(r, ",").concat(n, "Z");
    y += "L".concat(T.x, ",").concat(T.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(C.x, ",").concat(C.y, `
      A`).concat(i, ",").concat(i, ",0,").concat(+($ > 180), ",").concat(+(f > 0), ",").concat(_.x, ",").concat(_.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(P.x, ",").concat(P.y, "Z");
  } else
    y += "L".concat(r, ",").concat(n, "Z");
  return y;
}, RR = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, RS = function(t) {
  var r = V0(V0({}, RR), t), n = r.cx, i = r.cy, a = r.innerRadius, o = r.outerRadius, s = r.cornerRadius, u = r.forceCornerRadius, c = r.cornerIsExternal, l = r.startAngle, f = r.endAngle, d = r.className;
  if (o < a || l === f)
    return null;
  var h = ue("recharts-sector", d), m = o - a, v = Xe(s, m, 0, !0), p;
  return v > 0 && Math.abs(l - f) < 360 ? p = IR({
    cx: n,
    cy: i,
    innerRadius: a,
    outerRadius: o,
    cornerRadius: Math.min(v, m / 2),
    forceCornerRadius: u,
    cornerIsExternal: c,
    startAngle: l,
    endAngle: f
  }) : p = IS({
    cx: n,
    cy: i,
    innerRadius: a,
    outerRadius: o,
    startAngle: l,
    endAngle: f
  }), /* @__PURE__ */ A.createElement("path", lp({}, Q(r, !0), {
    className: h,
    d: p,
    role: "img"
  }));
};
function da(e) {
  "@babel/helpers - typeof";
  return da = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, da(e);
}
function fp() {
  return fp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fp.apply(this, arguments);
}
function K0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Y0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? K0(Object(r), !0).forEach(function(n) {
      DR(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : K0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function DR(e, t, r) {
  return t = LR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function LR(e) {
  var t = qR(e, "string");
  return da(t) == "symbol" ? t : t + "";
}
function qR(e, t) {
  if (da(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (da(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var X0 = {
  curveBasisClosed: a6,
  curveBasisOpen: o6,
  curveBasis: i6,
  curveBumpX: U3,
  curveBumpY: G3,
  curveLinearClosed: s6,
  curveLinear: $s,
  curveMonotoneX: u6,
  curveMonotoneY: c6,
  curveNatural: l6,
  curveStep: f6,
  curveStepAfter: p6,
  curveStepBefore: d6
}, ro = function(t) {
  return t.x === +t.x && t.y === +t.y;
}, Si = function(t) {
  return t.x;
}, Ai = function(t) {
  return t.y;
}, BR = function(t, r) {
  if (ie(t))
    return t;
  var n = "curve".concat(js(t));
  return (n === "curveMonotone" || n === "curveBump") && r ? X0["".concat(n).concat(r === "vertical" ? "Y" : "X")] : X0[n] || $s;
}, FR = function(t) {
  var r = t.type, n = r === void 0 ? "linear" : r, i = t.points, a = i === void 0 ? [] : i, o = t.baseLine, s = t.layout, u = t.connectNulls, c = u === void 0 ? !1 : u, l = BR(n, s), f = c ? a.filter(function(v) {
    return ro(v);
  }) : a, d;
  if (Array.isArray(o)) {
    var h = c ? o.filter(function(v) {
      return ro(v);
    }) : o, m = f.map(function(v, p) {
      return Y0(Y0({}, v), {}, {
        base: h[p]
      });
    });
    return s === "vertical" ? d = Va().y(Ai).x1(Si).x0(function(v) {
      return v.base.x;
    }) : d = Va().x(Si).y1(Ai).y0(function(v) {
      return v.base.y;
    }), d.defined(ro).curve(l), d(m);
  }
  return s === "vertical" && U(o) ? d = Va().y(Ai).x1(Si).x0(o) : U(o) ? d = Va().x(Si).y1(Ai).y0(o) : d = IO().x(Si).y(Ai), d.defined(ro).curve(l), d(f);
}, Ur = function(t) {
  var r = t.className, n = t.points, i = t.path, a = t.pathRef;
  if ((!n || !n.length) && !i)
    return null;
  var o = n && n.length ? FR(t) : i;
  return /* @__PURE__ */ V.createElement("path", fp({}, Q(t, !1), go(t), {
    className: ue("recharts-curve", r),
    d: o,
    ref: a
  }));
}, no = { exports: {} }, io = { exports: {} }, ye = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Z0;
function zR() {
  if (Z0) return ye;
  Z0 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, p = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
  function w(y) {
    if (typeof y == "object" && y !== null) {
      var x = y.$$typeof;
      switch (x) {
        case t:
          switch (y = y.type, y) {
            case u:
            case c:
            case n:
            case a:
            case i:
            case f:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case l:
                case m:
                case h:
                case o:
                  return y;
                default:
                  return x;
              }
          }
        case r:
          return x;
      }
    }
  }
  function O(y) {
    return w(y) === c;
  }
  return ye.AsyncMode = u, ye.ConcurrentMode = c, ye.ContextConsumer = s, ye.ContextProvider = o, ye.Element = t, ye.ForwardRef = l, ye.Fragment = n, ye.Lazy = m, ye.Memo = h, ye.Portal = r, ye.Profiler = a, ye.StrictMode = i, ye.Suspense = f, ye.isAsyncMode = function(y) {
    return O(y) || w(y) === u;
  }, ye.isConcurrentMode = O, ye.isContextConsumer = function(y) {
    return w(y) === s;
  }, ye.isContextProvider = function(y) {
    return w(y) === o;
  }, ye.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === t;
  }, ye.isForwardRef = function(y) {
    return w(y) === l;
  }, ye.isFragment = function(y) {
    return w(y) === n;
  }, ye.isLazy = function(y) {
    return w(y) === m;
  }, ye.isMemo = function(y) {
    return w(y) === h;
  }, ye.isPortal = function(y) {
    return w(y) === r;
  }, ye.isProfiler = function(y) {
    return w(y) === a;
  }, ye.isStrictMode = function(y) {
    return w(y) === i;
  }, ye.isSuspense = function(y) {
    return w(y) === f;
  }, ye.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === c || y === a || y === i || y === f || y === d || typeof y == "object" && y !== null && (y.$$typeof === m || y.$$typeof === h || y.$$typeof === o || y.$$typeof === s || y.$$typeof === l || y.$$typeof === p || y.$$typeof === g || y.$$typeof === b || y.$$typeof === v);
  }, ye.typeOf = w, ye;
}
var me = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var J0;
function WR() {
  return J0 || (J0 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, p = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
    function w(j) {
      return typeof j == "string" || typeof j == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      j === n || j === c || j === a || j === i || j === f || j === d || typeof j == "object" && j !== null && (j.$$typeof === m || j.$$typeof === h || j.$$typeof === o || j.$$typeof === s || j.$$typeof === l || j.$$typeof === p || j.$$typeof === g || j.$$typeof === b || j.$$typeof === v);
    }
    function O(j) {
      if (typeof j == "object" && j !== null) {
        var fe = j.$$typeof;
        switch (fe) {
          case t:
            var G = j.type;
            switch (G) {
              case u:
              case c:
              case n:
              case a:
              case i:
              case f:
                return G;
              default:
                var Oe = G && G.$$typeof;
                switch (Oe) {
                  case s:
                  case l:
                  case m:
                  case h:
                  case o:
                    return Oe;
                  default:
                    return fe;
                }
            }
          case r:
            return fe;
        }
      }
    }
    var y = u, x = c, _ = s, P = o, E = t, M = l, C = n, T = m, k = h, $ = r, I = a, R = i, q = f, W = !1;
    function H(j) {
      return W || (W = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), N(j) || O(j) === u;
    }
    function N(j) {
      return O(j) === c;
    }
    function L(j) {
      return O(j) === s;
    }
    function B(j) {
      return O(j) === o;
    }
    function K(j) {
      return typeof j == "object" && j !== null && j.$$typeof === t;
    }
    function X(j) {
      return O(j) === l;
    }
    function te(j) {
      return O(j) === n;
    }
    function re(j) {
      return O(j) === m;
    }
    function oe(j) {
      return O(j) === h;
    }
    function ae(j) {
      return O(j) === r;
    }
    function F(j) {
      return O(j) === a;
    }
    function Y(j) {
      return O(j) === i;
    }
    function ee(j) {
      return O(j) === f;
    }
    me.AsyncMode = y, me.ConcurrentMode = x, me.ContextConsumer = _, me.ContextProvider = P, me.Element = E, me.ForwardRef = M, me.Fragment = C, me.Lazy = T, me.Memo = k, me.Portal = $, me.Profiler = I, me.StrictMode = R, me.Suspense = q, me.isAsyncMode = H, me.isConcurrentMode = N, me.isContextConsumer = L, me.isContextProvider = B, me.isElement = K, me.isForwardRef = X, me.isFragment = te, me.isLazy = re, me.isMemo = oe, me.isPortal = ae, me.isProfiler = F, me.isStrictMode = Y, me.isSuspense = ee, me.isValidElementType = w, me.typeOf = O;
  }()), me;
}
var Q0;
function DS() {
  return Q0 || (Q0 = 1, process.env.NODE_ENV === "production" ? io.exports = zR() : io.exports = WR()), io.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ff, ex;
function UR() {
  if (ex) return Ff;
  ex = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var u = Object.getOwnPropertyNames(o).map(function(l) {
        return o[l];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        c[l] = l;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Ff = i() ? Object.assign : function(a, o) {
    for (var s, u = n(a), c, l = 1; l < arguments.length; l++) {
      s = Object(arguments[l]);
      for (var f in s)
        t.call(s, f) && (u[f] = s[f]);
      if (e) {
        c = e(s);
        for (var d = 0; d < c.length; d++)
          r.call(s, c[d]) && (u[c[d]] = s[c[d]]);
      }
    }
    return u;
  }, Ff;
}
var zf, tx;
function av() {
  if (tx) return zf;
  tx = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return zf = e, zf;
}
var Wf, rx;
function LS() {
  return rx || (rx = 1, Wf = Function.call.bind(Object.prototype.hasOwnProperty)), Wf;
}
var Uf, nx;
function GR() {
  if (nx) return Uf;
  nx = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ av(), r = {}, n = /* @__PURE__ */ LS();
    e = function(a) {
      var o = "Warning: " + a;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function i(a, o, s, u, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in a)
        if (n(a, l)) {
          var f;
          try {
            if (typeof a[l] != "function") {
              var d = Error(
                (u || "React class") + ": " + s + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            f = a[l](o, l, u, s, null, t);
          } catch (m) {
            f = m;
          }
          if (f && !(f instanceof Error) && e(
            (u || "React class") + ": type specification of " + s + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in r)) {
            r[f.message] = !0;
            var h = c ? c() : "";
            e(
              "Failed " + s + " type: " + f.message + (h ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Uf = i, Uf;
}
var Gf, ix;
function HR() {
  if (ix) return Gf;
  ix = 1;
  var e = DS(), t = UR(), r = /* @__PURE__ */ av(), n = /* @__PURE__ */ LS(), i = /* @__PURE__ */ GR(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var u = "Warning: " + s;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Gf = function(s, u) {
    var c = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
    function f(N) {
      var L = N && (c && N[c] || N[l]);
      if (typeof L == "function")
        return L;
    }
    var d = "<<anonymous>>", h = {
      array: g("array"),
      bigint: g("bigint"),
      bool: g("boolean"),
      func: g("function"),
      number: g("number"),
      object: g("object"),
      string: g("string"),
      symbol: g("symbol"),
      any: b(),
      arrayOf: w,
      element: O(),
      elementType: y(),
      instanceOf: x,
      node: M(),
      objectOf: P,
      oneOf: _,
      oneOfType: E,
      shape: T,
      exact: k
    };
    function m(N, L) {
      return N === L ? N !== 0 || 1 / N === 1 / L : N !== N && L !== L;
    }
    function v(N, L) {
      this.message = N, this.data = L && typeof L == "object" ? L : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function p(N) {
      if (process.env.NODE_ENV !== "production")
        var L = {}, B = 0;
      function K(te, re, oe, ae, F, Y, ee) {
        if (ae = ae || d, Y = Y || oe, ee !== r) {
          if (u) {
            var j = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw j.name = "Invariant Violation", j;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var fe = ae + ":" + oe;
            !L[fe] && // Avoid spamming the console because they are often not actionable except for lib authors
            B < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + Y + "` prop on `" + ae + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), L[fe] = !0, B++);
          }
        }
        return re[oe] == null ? te ? re[oe] === null ? new v("The " + F + " `" + Y + "` is marked as required " + ("in `" + ae + "`, but its value is `null`.")) : new v("The " + F + " `" + Y + "` is marked as required in " + ("`" + ae + "`, but its value is `undefined`.")) : null : N(re, oe, ae, F, Y);
      }
      var X = K.bind(null, !1);
      return X.isRequired = K.bind(null, !0), X;
    }
    function g(N) {
      function L(B, K, X, te, re, oe) {
        var ae = B[K], F = R(ae);
        if (F !== N) {
          var Y = q(ae);
          return new v(
            "Invalid " + te + " `" + re + "` of type " + ("`" + Y + "` supplied to `" + X + "`, expected ") + ("`" + N + "`."),
            { expectedType: N }
          );
        }
        return null;
      }
      return p(L);
    }
    function b() {
      return p(o);
    }
    function w(N) {
      function L(B, K, X, te, re) {
        if (typeof N != "function")
          return new v("Property `" + re + "` of component `" + X + "` has invalid PropType notation inside arrayOf.");
        var oe = B[K];
        if (!Array.isArray(oe)) {
          var ae = R(oe);
          return new v("Invalid " + te + " `" + re + "` of type " + ("`" + ae + "` supplied to `" + X + "`, expected an array."));
        }
        for (var F = 0; F < oe.length; F++) {
          var Y = N(oe, F, X, te, re + "[" + F + "]", r);
          if (Y instanceof Error)
            return Y;
        }
        return null;
      }
      return p(L);
    }
    function O() {
      function N(L, B, K, X, te) {
        var re = L[B];
        if (!s(re)) {
          var oe = R(re);
          return new v("Invalid " + X + " `" + te + "` of type " + ("`" + oe + "` supplied to `" + K + "`, expected a single ReactElement."));
        }
        return null;
      }
      return p(N);
    }
    function y() {
      function N(L, B, K, X, te) {
        var re = L[B];
        if (!e.isValidElementType(re)) {
          var oe = R(re);
          return new v("Invalid " + X + " `" + te + "` of type " + ("`" + oe + "` supplied to `" + K + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return p(N);
    }
    function x(N) {
      function L(B, K, X, te, re) {
        if (!(B[K] instanceof N)) {
          var oe = N.name || d, ae = H(B[K]);
          return new v("Invalid " + te + " `" + re + "` of type " + ("`" + ae + "` supplied to `" + X + "`, expected ") + ("instance of `" + oe + "`."));
        }
        return null;
      }
      return p(L);
    }
    function _(N) {
      if (!Array.isArray(N))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), o;
      function L(B, K, X, te, re) {
        for (var oe = B[K], ae = 0; ae < N.length; ae++)
          if (m(oe, N[ae]))
            return null;
        var F = JSON.stringify(N, function(ee, j) {
          var fe = q(j);
          return fe === "symbol" ? String(j) : j;
        });
        return new v("Invalid " + te + " `" + re + "` of value `" + String(oe) + "` " + ("supplied to `" + X + "`, expected one of " + F + "."));
      }
      return p(L);
    }
    function P(N) {
      function L(B, K, X, te, re) {
        if (typeof N != "function")
          return new v("Property `" + re + "` of component `" + X + "` has invalid PropType notation inside objectOf.");
        var oe = B[K], ae = R(oe);
        if (ae !== "object")
          return new v("Invalid " + te + " `" + re + "` of type " + ("`" + ae + "` supplied to `" + X + "`, expected an object."));
        for (var F in oe)
          if (n(oe, F)) {
            var Y = N(oe, F, X, te, re + "." + F, r);
            if (Y instanceof Error)
              return Y;
          }
        return null;
      }
      return p(L);
    }
    function E(N) {
      if (!Array.isArray(N))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var L = 0; L < N.length; L++) {
        var B = N[L];
        if (typeof B != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + W(B) + " at index " + L + "."
          ), o;
      }
      function K(X, te, re, oe, ae) {
        for (var F = [], Y = 0; Y < N.length; Y++) {
          var ee = N[Y], j = ee(X, te, re, oe, ae, r);
          if (j == null)
            return null;
          j.data && n(j.data, "expectedType") && F.push(j.data.expectedType);
        }
        var fe = F.length > 0 ? ", expected one of type [" + F.join(", ") + "]" : "";
        return new v("Invalid " + oe + " `" + ae + "` supplied to " + ("`" + re + "`" + fe + "."));
      }
      return p(K);
    }
    function M() {
      function N(L, B, K, X, te) {
        return $(L[B]) ? null : new v("Invalid " + X + " `" + te + "` supplied to " + ("`" + K + "`, expected a ReactNode."));
      }
      return p(N);
    }
    function C(N, L, B, K, X) {
      return new v(
        (N || "React class") + ": " + L + " type `" + B + "." + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + X + "`."
      );
    }
    function T(N) {
      function L(B, K, X, te, re) {
        var oe = B[K], ae = R(oe);
        if (ae !== "object")
          return new v("Invalid " + te + " `" + re + "` of type `" + ae + "` " + ("supplied to `" + X + "`, expected `object`."));
        for (var F in N) {
          var Y = N[F];
          if (typeof Y != "function")
            return C(X, te, re, F, q(Y));
          var ee = Y(oe, F, X, te, re + "." + F, r);
          if (ee)
            return ee;
        }
        return null;
      }
      return p(L);
    }
    function k(N) {
      function L(B, K, X, te, re) {
        var oe = B[K], ae = R(oe);
        if (ae !== "object")
          return new v("Invalid " + te + " `" + re + "` of type `" + ae + "` " + ("supplied to `" + X + "`, expected `object`."));
        var F = t({}, B[K], N);
        for (var Y in F) {
          var ee = N[Y];
          if (n(N, Y) && typeof ee != "function")
            return C(X, te, re, Y, q(ee));
          if (!ee)
            return new v(
              "Invalid " + te + " `" + re + "` key `" + Y + "` supplied to `" + X + "`.\nBad object: " + JSON.stringify(B[K], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(N), null, "  ")
            );
          var j = ee(oe, Y, X, te, re + "." + Y, r);
          if (j)
            return j;
        }
        return null;
      }
      return p(L);
    }
    function $(N) {
      switch (typeof N) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !N;
        case "object":
          if (Array.isArray(N))
            return N.every($);
          if (N === null || s(N))
            return !0;
          var L = f(N);
          if (L) {
            var B = L.call(N), K;
            if (L !== N.entries) {
              for (; !(K = B.next()).done; )
                if (!$(K.value))
                  return !1;
            } else
              for (; !(K = B.next()).done; ) {
                var X = K.value;
                if (X && !$(X[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function I(N, L) {
      return N === "symbol" ? !0 : L ? L["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && L instanceof Symbol : !1;
    }
    function R(N) {
      var L = typeof N;
      return Array.isArray(N) ? "array" : N instanceof RegExp ? "object" : I(L, N) ? "symbol" : L;
    }
    function q(N) {
      if (typeof N > "u" || N === null)
        return "" + N;
      var L = R(N);
      if (L === "object") {
        if (N instanceof Date)
          return "date";
        if (N instanceof RegExp)
          return "regexp";
      }
      return L;
    }
    function W(N) {
      var L = q(N);
      switch (L) {
        case "array":
        case "object":
          return "an " + L;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + L;
        default:
          return L;
      }
    }
    function H(N) {
      return !N.constructor || !N.constructor.name ? d : N.constructor.name;
    }
    return h.checkPropTypes = i, h.resetWarningCache = i.resetWarningCache, h.PropTypes = h, h;
  }, Gf;
}
var Hf, ax;
function VR() {
  if (ax) return Hf;
  ax = 1;
  var e = /* @__PURE__ */ av();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, Hf = function() {
    function n(o, s, u, c, l, f) {
      if (f !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var a = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, Hf;
}
var ox;
function KR() {
  if (ox) return no.exports;
  if (ox = 1, process.env.NODE_ENV !== "production") {
    var e = DS(), t = !0;
    no.exports = /* @__PURE__ */ HR()(e.isElement, t);
  } else
    no.exports = /* @__PURE__ */ VR()();
  return no.exports;
}
var YR = /* @__PURE__ */ KR();
const ge = /* @__PURE__ */ xe(YR), { getOwnPropertyNames: XR, getOwnPropertySymbols: ZR } = Object, { hasOwnProperty: JR } = Object.prototype;
function Vf(e, t) {
  return function(n, i, a) {
    return e(n, i, a) && t(n, i, a);
  };
}
function ao(e) {
  return function(r, n, i) {
    if (!r || !n || typeof r != "object" || typeof n != "object")
      return e(r, n, i);
    const { cache: a } = i, o = a.get(r), s = a.get(n);
    if (o && s)
      return o === n && s === r;
    a.set(r, n), a.set(n, r);
    const u = e(r, n, i);
    return a.delete(r), a.delete(n), u;
  };
}
function QR(e) {
  return e?.[Symbol.toStringTag];
}
function sx(e) {
  return XR(e).concat(ZR(e));
}
const eD = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  Object.hasOwn || ((e, t) => JR.call(e, t))
);
function on(e, t) {
  return e === t || !e && !t && e !== e && t !== t;
}
const tD = "__v", rD = "__o", nD = "_owner", { getOwnPropertyDescriptor: ux, keys: cx } = Object;
function iD(e, t) {
  return e.byteLength === t.byteLength && Vo(new Uint8Array(e), new Uint8Array(t));
}
function aD(e, t, r) {
  let n = e.length;
  if (t.length !== n)
    return !1;
  for (; n-- > 0; )
    if (!r.equals(e[n], t[n], n, n, e, t, r))
      return !1;
  return !0;
}
function oD(e, t) {
  return e.byteLength === t.byteLength && Vo(new Uint8Array(e.buffer, e.byteOffset, e.byteLength), new Uint8Array(t.buffer, t.byteOffset, t.byteLength));
}
function sD(e, t) {
  return on(e.getTime(), t.getTime());
}
function uD(e, t) {
  return e.name === t.name && e.message === t.message && e.cause === t.cause && e.stack === t.stack;
}
function cD(e, t) {
  return e === t;
}
function lx(e, t, r) {
  const n = e.size;
  if (n !== t.size)
    return !1;
  if (!n)
    return !0;
  const i = new Array(n), a = e.entries();
  let o, s, u = 0;
  for (; (o = a.next()) && !o.done; ) {
    const c = t.entries();
    let l = !1, f = 0;
    for (; (s = c.next()) && !s.done; ) {
      if (i[f]) {
        f++;
        continue;
      }
      const d = o.value, h = s.value;
      if (r.equals(d[0], h[0], u, f, e, t, r) && r.equals(d[1], h[1], d[0], h[0], e, t, r)) {
        l = i[f] = !0;
        break;
      }
      f++;
    }
    if (!l)
      return !1;
    u++;
  }
  return !0;
}
const lD = on;
function fD(e, t, r) {
  const n = cx(e);
  let i = n.length;
  if (cx(t).length !== i)
    return !1;
  for (; i-- > 0; )
    if (!qS(e, t, r, n[i]))
      return !1;
  return !0;
}
function Pi(e, t, r) {
  const n = sx(e);
  let i = n.length;
  if (sx(t).length !== i)
    return !1;
  let a, o, s;
  for (; i-- > 0; )
    if (a = n[i], !qS(e, t, r, a) || (o = ux(e, a), s = ux(t, a), (o || s) && (!o || !s || o.configurable !== s.configurable || o.enumerable !== s.enumerable || o.writable !== s.writable)))
      return !1;
  return !0;
}
function dD(e, t) {
  return on(e.valueOf(), t.valueOf());
}
function pD(e, t) {
  return e.source === t.source && e.flags === t.flags;
}
function fx(e, t, r) {
  const n = e.size;
  if (n !== t.size)
    return !1;
  if (!n)
    return !0;
  const i = new Array(n), a = e.values();
  let o, s;
  for (; (o = a.next()) && !o.done; ) {
    const u = t.values();
    let c = !1, l = 0;
    for (; (s = u.next()) && !s.done; ) {
      if (!i[l] && r.equals(o.value, s.value, o.value, s.value, e, t, r)) {
        c = i[l] = !0;
        break;
      }
      l++;
    }
    if (!c)
      return !1;
  }
  return !0;
}
function Vo(e, t) {
  let r = e.byteLength;
  if (t.byteLength !== r || e.byteOffset !== t.byteOffset)
    return !1;
  for (; r-- > 0; )
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function hD(e, t) {
  return e.hostname === t.hostname && e.pathname === t.pathname && e.protocol === t.protocol && e.port === t.port && e.hash === t.hash && e.username === t.username && e.password === t.password;
}
function qS(e, t, r, n) {
  return (n === nD || n === rD || n === tD) && (e.$$typeof || t.$$typeof) ? !0 : eD(t, n) && r.equals(e[n], t[n], n, n, e, t, r);
}
const vD = "[object ArrayBuffer]", yD = "[object Arguments]", mD = "[object Boolean]", gD = "[object DataView]", bD = "[object Date]", xD = "[object Error]", wD = "[object Map]", OD = "[object Number]", _D = "[object Object]", SD = "[object RegExp]", AD = "[object Set]", PD = "[object String]", TD = {
  "[object Int8Array]": !0,
  "[object Uint8Array]": !0,
  "[object Uint8ClampedArray]": !0,
  "[object Int16Array]": !0,
  "[object Uint16Array]": !0,
  "[object Int32Array]": !0,
  "[object Uint32Array]": !0,
  "[object Float16Array]": !0,
  "[object Float32Array]": !0,
  "[object Float64Array]": !0,
  "[object BigInt64Array]": !0,
  "[object BigUint64Array]": !0
}, ED = "[object URL]", CD = Object.prototype.toString;
function MD({ areArrayBuffersEqual: e, areArraysEqual: t, areDataViewsEqual: r, areDatesEqual: n, areErrorsEqual: i, areFunctionsEqual: a, areMapsEqual: o, areNumbersEqual: s, areObjectsEqual: u, arePrimitiveWrappersEqual: c, areRegExpsEqual: l, areSetsEqual: f, areTypedArraysEqual: d, areUrlsEqual: h, unknownTagComparators: m }) {
  return function(p, g, b) {
    if (p === g)
      return !0;
    if (p == null || g == null)
      return !1;
    const w = typeof p;
    if (w !== typeof g)
      return !1;
    if (w !== "object")
      return w === "number" ? s(p, g, b) : w === "function" ? a(p, g, b) : !1;
    const O = p.constructor;
    if (O !== g.constructor)
      return !1;
    if (O === Object)
      return u(p, g, b);
    if (Array.isArray(p))
      return t(p, g, b);
    if (O === Date)
      return n(p, g, b);
    if (O === RegExp)
      return l(p, g, b);
    if (O === Map)
      return o(p, g, b);
    if (O === Set)
      return f(p, g, b);
    const y = CD.call(p);
    if (y === bD)
      return n(p, g, b);
    if (y === SD)
      return l(p, g, b);
    if (y === wD)
      return o(p, g, b);
    if (y === AD)
      return f(p, g, b);
    if (y === _D)
      return typeof p.then != "function" && typeof g.then != "function" && u(p, g, b);
    if (y === ED)
      return h(p, g, b);
    if (y === xD)
      return i(p, g, b);
    if (y === yD)
      return u(p, g, b);
    if (TD[y])
      return d(p, g, b);
    if (y === vD)
      return e(p, g, b);
    if (y === gD)
      return r(p, g, b);
    if (y === mD || y === OD || y === PD)
      return c(p, g, b);
    if (m) {
      let x = m[y];
      if (!x) {
        const _ = QR(p);
        _ && (x = m[_]);
      }
      if (x)
        return x(p, g, b);
    }
    return !1;
  };
}
function jD({ circular: e, createCustomConfig: t, strict: r }) {
  let n = {
    areArrayBuffersEqual: iD,
    areArraysEqual: r ? Pi : aD,
    areDataViewsEqual: oD,
    areDatesEqual: sD,
    areErrorsEqual: uD,
    areFunctionsEqual: cD,
    areMapsEqual: r ? Vf(lx, Pi) : lx,
    areNumbersEqual: lD,
    areObjectsEqual: r ? Pi : fD,
    arePrimitiveWrappersEqual: dD,
    areRegExpsEqual: pD,
    areSetsEqual: r ? Vf(fx, Pi) : fx,
    areTypedArraysEqual: r ? Vf(Vo, Pi) : Vo,
    areUrlsEqual: hD,
    unknownTagComparators: void 0
  };
  if (t && (n = Object.assign({}, n, t(n))), e) {
    const i = ao(n.areArraysEqual), a = ao(n.areMapsEqual), o = ao(n.areObjectsEqual), s = ao(n.areSetsEqual);
    n = Object.assign({}, n, {
      areArraysEqual: i,
      areMapsEqual: a,
      areObjectsEqual: o,
      areSetsEqual: s
    });
  }
  return n;
}
function kD(e) {
  return function(t, r, n, i, a, o, s) {
    return e(t, r, s);
  };
}
function $D({ circular: e, comparator: t, createState: r, equals: n, strict: i }) {
  if (r)
    return function(s, u) {
      const { cache: c = e ? /* @__PURE__ */ new WeakMap() : void 0, meta: l } = r();
      return t(s, u, {
        cache: c,
        equals: n,
        meta: l,
        strict: i
      });
    };
  if (e)
    return function(s, u) {
      return t(s, u, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: n,
        meta: void 0,
        strict: i
      });
    };
  const a = {
    cache: void 0,
    equals: n,
    meta: void 0,
    strict: i
  };
  return function(s, u) {
    return t(s, u, a);
  };
}
const ND = Sr();
Sr({ strict: !0 });
Sr({ circular: !0 });
Sr({
  circular: !0,
  strict: !0
});
Sr({
  createInternalComparator: () => on
});
Sr({
  strict: !0,
  createInternalComparator: () => on
});
Sr({
  circular: !0,
  createInternalComparator: () => on
});
Sr({
  circular: !0,
  createInternalComparator: () => on,
  strict: !0
});
function Sr(e = {}) {
  const { circular: t = !1, createInternalComparator: r, createState: n, strict: i = !1 } = e, a = jD(e), o = MD(a), s = r ? r(o) : kD(o);
  return $D({ circular: t, comparator: o, createState: n, equals: s, strict: i });
}
function ID(e) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
}
function dx(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = -1, n = function i(a) {
    r < 0 && (r = a), a - r > t ? (e(a), r = -1) : ID(i);
  };
  requestAnimationFrame(n);
}
function dp(e) {
  "@babel/helpers - typeof";
  return dp = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, dp(e);
}
function RD(e) {
  return BD(e) || qD(e) || LD(e) || DD();
}
function DD() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function LD(e, t) {
  if (e) {
    if (typeof e == "string") return px(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return px(e, t);
  }
}
function px(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function qD(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function BD(e) {
  if (Array.isArray(e)) return e;
}
function FD() {
  var e = {}, t = function() {
    return null;
  }, r = !1, n = function i(a) {
    if (!r) {
      if (Array.isArray(a)) {
        if (!a.length)
          return;
        var o = a, s = RD(o), u = s[0], c = s.slice(1);
        if (typeof u == "number") {
          dx(i.bind(null, c), u);
          return;
        }
        i(u), dx(i.bind(null, c));
        return;
      }
      dp(a) === "object" && (e = a, t(e)), typeof a == "function" && a();
    }
  };
  return {
    stop: function() {
      r = !0;
    },
    start: function(a) {
      r = !1, n(a);
    },
    subscribe: function(a) {
      return t = a, function() {
        t = function() {
          return null;
        };
      };
    }
  };
}
function pa(e) {
  "@babel/helpers - typeof";
  return pa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, pa(e);
}
function hx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? hx(Object(r), !0).forEach(function(n) {
      BS(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : hx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function BS(e, t, r) {
  return t = zD(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function zD(e) {
  var t = WD(e, "string");
  return pa(t) === "symbol" ? t : String(t);
}
function WD(e, t) {
  if (pa(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (pa(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var UD = function(t, r) {
  return [Object.keys(t), Object.keys(r)].reduce(function(n, i) {
    return n.filter(function(a) {
      return i.includes(a);
    });
  });
}, GD = function(t) {
  return t;
}, HD = function(t) {
  return t.replace(/([A-Z])/g, function(r) {
    return "-".concat(r.toLowerCase());
  });
}, Di = function(t, r) {
  return Object.keys(r).reduce(function(n, i) {
    return vx(vx({}, n), {}, BS({}, i, t(i, r[i])));
  }, {});
}, yx = function(t, r, n) {
  return t.map(function(i) {
    return "".concat(HD(i), " ").concat(r, "ms ").concat(n);
  }).join(",");
}, VD = process.env.NODE_ENV !== "production", Ko = function(t, r, n, i, a, o, s, u) {
  if (VD && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var c = [n, i, a, o, s, u], l = 0;
      console.warn(r.replace(/%s/g, function() {
        return c[l++];
      }));
    }
};
function KD(e, t) {
  return ZD(e) || XD(e, t) || FS(e, t) || YD();
}
function YD() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function XD(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function ZD(e) {
  if (Array.isArray(e)) return e;
}
function JD(e) {
  return t9(e) || e9(e) || FS(e) || QD();
}
function QD() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function FS(e, t) {
  if (e) {
    if (typeof e == "string") return pp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return pp(e, t);
  }
}
function e9(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function t9(e) {
  if (Array.isArray(e)) return pp(e);
}
function pp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var Yo = 1e-4, zS = function(t, r) {
  return [0, 3 * t, 3 * r - 6 * t, 3 * t - 3 * r + 1];
}, WS = function(t, r) {
  return t.map(function(n, i) {
    return n * Math.pow(r, i);
  }).reduce(function(n, i) {
    return n + i;
  });
}, mx = function(t, r) {
  return function(n) {
    var i = zS(t, r);
    return WS(i, n);
  };
}, r9 = function(t, r) {
  return function(n) {
    var i = zS(t, r), a = [].concat(JD(i.map(function(o, s) {
      return o * s;
    }).slice(1)), [0]);
    return WS(a, n);
  };
}, gx = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var i = r[0], a = r[1], o = r[2], s = r[3];
  if (r.length === 1)
    switch (r[0]) {
      case "linear":
        i = 0, a = 0, o = 1, s = 1;
        break;
      case "ease":
        i = 0.25, a = 0.1, o = 0.25, s = 1;
        break;
      case "ease-in":
        i = 0.42, a = 0, o = 1, s = 1;
        break;
      case "ease-out":
        i = 0.42, a = 0, o = 0.58, s = 1;
        break;
      case "ease-in-out":
        i = 0, a = 0, o = 0.58, s = 1;
        break;
      default: {
        var u = r[0].split("(");
        if (u[0] === "cubic-bezier" && u[1].split(")")[0].split(",").length === 4) {
          var c = u[1].split(")")[0].split(",").map(function(p) {
            return parseFloat(p);
          }), l = KD(c, 4);
          i = l[0], a = l[1], o = l[2], s = l[3];
        } else
          Ko(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", r);
      }
    }
  Ko([i, o, a, s].every(function(p) {
    return typeof p == "number" && p >= 0 && p <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", r);
  var f = mx(i, o), d = mx(a, s), h = r9(i, o), m = function(g) {
    return g > 1 ? 1 : g < 0 ? 0 : g;
  }, v = function(g) {
    for (var b = g > 1 ? 1 : g, w = b, O = 0; O < 8; ++O) {
      var y = f(w) - b, x = h(w);
      if (Math.abs(y - b) < Yo || x < Yo)
        return d(w);
      w = m(w - y / x);
    }
    return d(w);
  };
  return v.isStepper = !1, v;
}, n9 = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.stiff, n = r === void 0 ? 100 : r, i = t.damping, a = i === void 0 ? 8 : i, o = t.dt, s = o === void 0 ? 17 : o, u = function(l, f, d) {
    var h = -(l - f) * n, m = d * a, v = d + (h - m) * s / 1e3, p = d * s / 1e3 + l;
    return Math.abs(p - f) < Yo && Math.abs(v) < Yo ? [f, 0] : [p, v];
  };
  return u.isStepper = !0, u.dt = s, u;
}, i9 = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var i = r[0];
  if (typeof i == "string")
    switch (i) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return gx(i);
      case "spring":
        return n9();
      default:
        if (i.split("(")[0] === "cubic-bezier")
          return gx(i);
        Ko(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", r);
    }
  return typeof i == "function" ? i : (Ko(!1, "[configEasing]: first argument type should be function or string, instead received %s", r), null);
};
function ha(e) {
  "@babel/helpers - typeof";
  return ha = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ha(e);
}
function bx(e) {
  return s9(e) || o9(e) || US(e) || a9();
}
function a9() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function o9(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function s9(e) {
  if (Array.isArray(e)) return vp(e);
}
function xx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ge(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xx(Object(r), !0).forEach(function(n) {
      hp(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : xx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function hp(e, t, r) {
  return t = u9(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function u9(e) {
  var t = c9(e, "string");
  return ha(t) === "symbol" ? t : String(t);
}
function c9(e, t) {
  if (ha(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ha(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function l9(e, t) {
  return p9(e) || d9(e, t) || US(e, t) || f9();
}
function f9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function US(e, t) {
  if (e) {
    if (typeof e == "string") return vp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return vp(e, t);
  }
}
function vp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function d9(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function p9(e) {
  if (Array.isArray(e)) return e;
}
var Xo = function(t, r, n) {
  return t + (r - t) * n;
}, yp = function(t) {
  var r = t.from, n = t.to;
  return r !== n;
}, h9 = function e(t, r, n) {
  var i = Di(function(a, o) {
    if (yp(o)) {
      var s = t(o.from, o.to, o.velocity), u = l9(s, 2), c = u[0], l = u[1];
      return Ge(Ge({}, o), {}, {
        from: c,
        velocity: l
      });
    }
    return o;
  }, r);
  return n < 1 ? Di(function(a, o) {
    return yp(o) ? Ge(Ge({}, o), {}, {
      velocity: Xo(o.velocity, i[a].velocity, n),
      from: Xo(o.from, i[a].from, n)
    }) : o;
  }, r) : e(t, i, n - 1);
};
const v9 = function(e, t, r, n, i) {
  var a = UD(e, t), o = a.reduce(function(p, g) {
    return Ge(Ge({}, p), {}, hp({}, g, [e[g], t[g]]));
  }, {}), s = a.reduce(function(p, g) {
    return Ge(Ge({}, p), {}, hp({}, g, {
      from: e[g],
      velocity: 0,
      to: t[g]
    }));
  }, {}), u = -1, c, l, f = function() {
    return null;
  }, d = function() {
    return Di(function(g, b) {
      return b.from;
    }, s);
  }, h = function() {
    return !Object.values(s).filter(yp).length;
  }, m = function(g) {
    c || (c = g);
    var b = g - c, w = b / r.dt;
    s = h9(r, s, w), i(Ge(Ge(Ge({}, e), t), d())), c = g, h() || (u = requestAnimationFrame(f));
  }, v = function(g) {
    l || (l = g);
    var b = (g - l) / n, w = Di(function(y, x) {
      return Xo.apply(void 0, bx(x).concat([r(b)]));
    }, o);
    if (i(Ge(Ge(Ge({}, e), t), w)), b < 1)
      u = requestAnimationFrame(f);
    else {
      var O = Di(function(y, x) {
        return Xo.apply(void 0, bx(x).concat([r(1)]));
      }, o);
      i(Ge(Ge(Ge({}, e), t), O));
    }
  };
  return f = r.isStepper ? m : v, function() {
    return requestAnimationFrame(f), function() {
      cancelAnimationFrame(u);
    };
  };
};
function Ln(e) {
  "@babel/helpers - typeof";
  return Ln = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ln(e);
}
var y9 = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function m9(e, t) {
  if (e == null) return {};
  var r = g9(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function g9(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
function Kf(e) {
  return O9(e) || w9(e) || x9(e) || b9();
}
function b9() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function x9(e, t) {
  if (e) {
    if (typeof e == "string") return mp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return mp(e, t);
  }
}
function w9(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function O9(e) {
  if (Array.isArray(e)) return mp(e);
}
function mp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function wx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ot(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wx(Object(r), !0).forEach(function(n) {
      $i(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : wx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function $i(e, t, r) {
  return t = GS(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function _9(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function S9(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, GS(n.key), n);
  }
}
function A9(e, t, r) {
  return t && S9(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function GS(e) {
  var t = P9(e, "string");
  return Ln(t) === "symbol" ? t : String(t);
}
function P9(e, t) {
  if (Ln(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ln(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function T9(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && gp(e, t);
}
function gp(e, t) {
  return gp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, gp(e, t);
}
function E9(e) {
  var t = C9();
  return function() {
    var n = Zo(e), i;
    if (t) {
      var a = Zo(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return bp(this, i);
  };
}
function bp(e, t) {
  if (t && (Ln(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return xp(e);
}
function xp(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function C9() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Zo(e) {
  return Zo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Zo(e);
}
var Mt = /* @__PURE__ */ function(e) {
  T9(r, e);
  var t = E9(r);
  function r(n, i) {
    var a;
    _9(this, r), a = t.call(this, n, i);
    var o = a.props, s = o.isActive, u = o.attributeName, c = o.from, l = o.to, f = o.steps, d = o.children, h = o.duration;
    if (a.handleStyleChange = a.handleStyleChange.bind(xp(a)), a.changeStyle = a.changeStyle.bind(xp(a)), !s || h <= 0)
      return a.state = {
        style: {}
      }, typeof d == "function" && (a.state = {
        style: l
      }), bp(a);
    if (f && f.length)
      a.state = {
        style: f[0].style
      };
    else if (c) {
      if (typeof d == "function")
        return a.state = {
          style: c
        }, bp(a);
      a.state = {
        style: u ? $i({}, u, c) : c
      };
    } else
      a.state = {
        style: {}
      };
    return a;
  }
  return A9(r, [{
    key: "componentDidMount",
    value: function() {
      var i = this.props, a = i.isActive, o = i.canBegin;
      this.mounted = !0, !(!a || !o) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      var a = this.props, o = a.isActive, s = a.canBegin, u = a.attributeName, c = a.shouldReAnimate, l = a.to, f = a.from, d = this.state.style;
      if (s) {
        if (!o) {
          var h = {
            style: u ? $i({}, u, l) : l
          };
          this.state && d && (u && d[u] !== l || !u && d !== l) && this.setState(h);
          return;
        }
        if (!(ND(i.to, l) && i.canBegin && i.isActive)) {
          var m = !i.canBegin || !i.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var v = m || c ? f : i.to;
          if (this.state && d) {
            var p = {
              style: u ? $i({}, u, v) : v
            };
            (u && d[u] !== v || !u && d !== v) && this.setState(p);
          }
          this.runAnimation(Ot(Ot({}, this.props), {}, {
            from: v,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var i = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), i && i();
    }
  }, {
    key: "handleStyleChange",
    value: function(i) {
      this.changeStyle(i);
    }
  }, {
    key: "changeStyle",
    value: function(i) {
      this.mounted && this.setState({
        style: i
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(i) {
      var a = this, o = i.from, s = i.to, u = i.duration, c = i.easing, l = i.begin, f = i.onAnimationEnd, d = i.onAnimationStart, h = v9(o, s, i9(c), u, this.changeStyle), m = function() {
        a.stopJSAnimation = h();
      };
      this.manager.start([d, l, m, u, f]);
    }
  }, {
    key: "runStepAnimation",
    value: function(i) {
      var a = this, o = i.steps, s = i.begin, u = i.onAnimationStart, c = o[0], l = c.style, f = c.duration, d = f === void 0 ? 0 : f, h = function(v, p, g) {
        if (g === 0)
          return v;
        var b = p.duration, w = p.easing, O = w === void 0 ? "ease" : w, y = p.style, x = p.properties, _ = p.onAnimationEnd, P = g > 0 ? o[g - 1] : p, E = x || Object.keys(y);
        if (typeof O == "function" || O === "spring")
          return [].concat(Kf(v), [a.runJSAnimation.bind(a, {
            from: P.style,
            to: y,
            duration: b,
            easing: O
          }), b]);
        var M = yx(E, b, O), C = Ot(Ot(Ot({}, P.style), y), {}, {
          transition: M
        });
        return [].concat(Kf(v), [C, b, _]).filter(GD);
      };
      return this.manager.start([u].concat(Kf(o.reduce(h, [l, Math.max(d, s)])), [i.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(i) {
      this.manager || (this.manager = FD());
      var a = i.begin, o = i.duration, s = i.attributeName, u = i.to, c = i.easing, l = i.onAnimationStart, f = i.onAnimationEnd, d = i.steps, h = i.children, m = this.manager;
      if (this.unSubscribe = m.subscribe(this.handleStyleChange), typeof c == "function" || typeof h == "function" || c === "spring") {
        this.runJSAnimation(i);
        return;
      }
      if (d.length > 1) {
        this.runStepAnimation(i);
        return;
      }
      var v = s ? $i({}, s, u) : u, p = yx(Object.keys(v), o, c);
      m.start([l, a, Ot(Ot({}, v), {}, {
        transition: p
      }), o, f]);
    }
  }, {
    key: "render",
    value: function() {
      var i = this.props, a = i.children;
      i.begin;
      var o = i.duration;
      i.attributeName, i.easing;
      var s = i.isActive;
      i.steps, i.from, i.to, i.canBegin, i.onAnimationEnd, i.shouldReAnimate, i.onAnimationReStart;
      var u = m9(i, y9), c = Br.count(a), l = this.state.style;
      if (typeof a == "function")
        return a(l);
      if (!s || c === 0 || o <= 0)
        return a;
      var f = function(h) {
        var m = h.props, v = m.style, p = v === void 0 ? {} : v, g = m.className, b = /* @__PURE__ */ De(h, Ot(Ot({}, u), {}, {
          style: Ot(Ot({}, p), l),
          className: g
        }));
        return b;
      };
      return c === 1 ? f(Br.only(a)) : /* @__PURE__ */ A.createElement("div", null, Br.map(a, function(d) {
        return f(d);
      }));
    }
  }]), r;
}(bt);
Mt.displayName = "Animate";
Mt.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
Mt.propTypes = {
  from: ge.oneOfType([ge.object, ge.string]),
  to: ge.oneOfType([ge.object, ge.string]),
  attributeName: ge.string,
  // animation duration
  duration: ge.number,
  begin: ge.number,
  easing: ge.oneOfType([ge.string, ge.func]),
  steps: ge.arrayOf(ge.shape({
    duration: ge.number.isRequired,
    style: ge.object.isRequired,
    easing: ge.oneOfType([ge.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), ge.func]),
    // transition css properties(dash case), optional
    properties: ge.arrayOf("string"),
    onAnimationEnd: ge.func
  })),
  children: ge.oneOfType([ge.node, ge.func]),
  isActive: ge.bool,
  canBegin: ge.bool,
  onAnimationEnd: ge.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: ge.bool,
  onAnimationStart: ge.func,
  onAnimationReStart: ge.func
};
function va(e) {
  "@babel/helpers - typeof";
  return va = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, va(e);
}
function Jo() {
  return Jo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Jo.apply(this, arguments);
}
function M9(e, t) {
  return N9(e) || $9(e, t) || k9(e, t) || j9();
}
function j9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function k9(e, t) {
  if (e) {
    if (typeof e == "string") return Ox(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Ox(e, t);
  }
}
function Ox(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function $9(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function N9(e) {
  if (Array.isArray(e)) return e;
}
function _x(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Sx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _x(Object(r), !0).forEach(function(n) {
      I9(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : _x(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function I9(e, t, r) {
  return t = R9(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function R9(e) {
  var t = D9(e, "string");
  return va(t) == "symbol" ? t : t + "";
}
function D9(e, t) {
  if (va(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (va(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ax = function(t, r, n, i, a) {
  var o = Math.min(Math.abs(n) / 2, Math.abs(i) / 2), s = i >= 0 ? 1 : -1, u = n >= 0 ? 1 : -1, c = i >= 0 && n >= 0 || i < 0 && n < 0 ? 1 : 0, l;
  if (o > 0 && a instanceof Array) {
    for (var f = [0, 0, 0, 0], d = 0, h = 4; d < h; d++)
      f[d] = a[d] > o ? o : a[d];
    l = "M".concat(t, ",").concat(r + s * f[0]), f[0] > 0 && (l += "A ".concat(f[0], ",").concat(f[0], ",0,0,").concat(c, ",").concat(t + u * f[0], ",").concat(r)), l += "L ".concat(t + n - u * f[1], ",").concat(r), f[1] > 0 && (l += "A ".concat(f[1], ",").concat(f[1], ",0,0,").concat(c, `,
        `).concat(t + n, ",").concat(r + s * f[1])), l += "L ".concat(t + n, ",").concat(r + i - s * f[2]), f[2] > 0 && (l += "A ".concat(f[2], ",").concat(f[2], ",0,0,").concat(c, `,
        `).concat(t + n - u * f[2], ",").concat(r + i)), l += "L ".concat(t + u * f[3], ",").concat(r + i), f[3] > 0 && (l += "A ".concat(f[3], ",").concat(f[3], ",0,0,").concat(c, `,
        `).concat(t, ",").concat(r + i - s * f[3])), l += "Z";
  } else if (o > 0 && a === +a && a > 0) {
    var m = Math.min(o, a);
    l = "M ".concat(t, ",").concat(r + s * m, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(t + u * m, ",").concat(r, `
            L `).concat(t + n - u * m, ",").concat(r, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(t + n, ",").concat(r + s * m, `
            L `).concat(t + n, ",").concat(r + i - s * m, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(t + n - u * m, ",").concat(r + i, `
            L `).concat(t + u * m, ",").concat(r + i, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(t, ",").concat(r + i - s * m, " Z");
  } else
    l = "M ".concat(t, ",").concat(r, " h ").concat(n, " v ").concat(i, " h ").concat(-n, " Z");
  return l;
}, L9 = function(t, r) {
  if (!t || !r)
    return !1;
  var n = t.x, i = t.y, a = r.x, o = r.y, s = r.width, u = r.height;
  if (Math.abs(s) > 0 && Math.abs(u) > 0) {
    var c = Math.min(a, a + s), l = Math.max(a, a + s), f = Math.min(o, o + u), d = Math.max(o, o + u);
    return n >= c && n <= l && i >= f && i <= d;
  }
  return !1;
}, q9 = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, ov = function(t) {
  var r = Sx(Sx({}, q9), t), n = An(), i = Vt(-1), a = M9(i, 2), o = a[0], s = a[1];
  Aa(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var O = n.current.getTotalLength();
        O && s(O);
      } catch {
      }
  }, []);
  var u = r.x, c = r.y, l = r.width, f = r.height, d = r.radius, h = r.className, m = r.animationEasing, v = r.animationDuration, p = r.animationBegin, g = r.isAnimationActive, b = r.isUpdateAnimationActive;
  if (u !== +u || c !== +c || l !== +l || f !== +f || l === 0 || f === 0)
    return null;
  var w = ue("recharts-rectangle", h);
  return b ? /* @__PURE__ */ A.createElement(Mt, {
    canBegin: o > 0,
    from: {
      width: l,
      height: f,
      x: u,
      y: c
    },
    to: {
      width: l,
      height: f,
      x: u,
      y: c
    },
    duration: v,
    animationEasing: m,
    isActive: b
  }, function(O) {
    var y = O.width, x = O.height, _ = O.x, P = O.y;
    return /* @__PURE__ */ A.createElement(Mt, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: p,
      duration: v,
      isActive: g,
      easing: m
    }, /* @__PURE__ */ A.createElement("path", Jo({}, Q(r, !0), {
      className: w,
      d: Ax(_, P, y, x, d),
      ref: n
    })));
  }) : /* @__PURE__ */ A.createElement("path", Jo({}, Q(r, !0), {
    className: w,
    d: Ax(u, c, l, f, d)
  }));
}, B9 = ["points", "className", "baseLinePoints", "connectNulls"];
function vn() {
  return vn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vn.apply(this, arguments);
}
function F9(e, t) {
  if (e == null) return {};
  var r = z9(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function z9(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Px(e) {
  return H9(e) || G9(e) || U9(e) || W9();
}
function W9() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function U9(e, t) {
  if (e) {
    if (typeof e == "string") return wp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return wp(e, t);
  }
}
function G9(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function H9(e) {
  if (Array.isArray(e)) return wp(e);
}
function wp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var Tx = function(t) {
  return t && t.x === +t.x && t.y === +t.y;
}, V9 = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = [[]];
  return t.forEach(function(n) {
    Tx(n) ? r[r.length - 1].push(n) : r[r.length - 1].length > 0 && r.push([]);
  }), Tx(t[0]) && r[r.length - 1].push(t[0]), r[r.length - 1].length <= 0 && (r = r.slice(0, -1)), r;
}, Li = function(t, r) {
  var n = V9(t);
  r && (n = [n.reduce(function(a, o) {
    return [].concat(Px(a), Px(o));
  }, [])]);
  var i = n.map(function(a) {
    return a.reduce(function(o, s, u) {
      return "".concat(o).concat(u === 0 ? "M" : "L").concat(s.x, ",").concat(s.y);
    }, "");
  }).join("");
  return n.length === 1 ? "".concat(i, "Z") : i;
}, K9 = function(t, r, n) {
  var i = Li(t, n);
  return "".concat(i.slice(-1) === "Z" ? i.slice(0, -1) : i, "L").concat(Li(r.reverse(), n).slice(1));
}, Y9 = function(t) {
  var r = t.points, n = t.className, i = t.baseLinePoints, a = t.connectNulls, o = F9(t, B9);
  if (!r || !r.length)
    return null;
  var s = ue("recharts-polygon", n);
  if (i && i.length) {
    var u = o.stroke && o.stroke !== "none", c = K9(r, i, a);
    return /* @__PURE__ */ A.createElement("g", {
      className: s
    }, /* @__PURE__ */ A.createElement("path", vn({}, Q(o, !0), {
      fill: c.slice(-1) === "Z" ? o.fill : "none",
      stroke: "none",
      d: c
    })), u ? /* @__PURE__ */ A.createElement("path", vn({}, Q(o, !0), {
      fill: "none",
      d: Li(r, a)
    })) : null, u ? /* @__PURE__ */ A.createElement("path", vn({}, Q(o, !0), {
      fill: "none",
      d: Li(i, a)
    })) : null);
  }
  var l = Li(r, a);
  return /* @__PURE__ */ A.createElement("path", vn({}, Q(o, !0), {
    fill: l.slice(-1) === "Z" ? o.fill : "none",
    className: s,
    d: l
  }));
};
function Op() {
  return Op = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Op.apply(this, arguments);
}
var Ra = function(t) {
  var r = t.cx, n = t.cy, i = t.r, a = t.className, o = ue("recharts-dot", a);
  return r === +r && n === +n && i === +i ? /* @__PURE__ */ V.createElement("circle", Op({}, Q(t, !1), go(t), {
    className: o,
    cx: r,
    cy: n,
    r: i
  })) : null;
};
function ya(e) {
  "@babel/helpers - typeof";
  return ya = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ya(e);
}
var X9 = ["x", "y", "top", "left", "width", "height", "className"];
function _p() {
  return _p = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _p.apply(this, arguments);
}
function Ex(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Z9(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ex(Object(r), !0).forEach(function(n) {
      J9(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ex(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function J9(e, t, r) {
  return t = Q9(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Q9(e) {
  var t = eL(e, "string");
  return ya(t) == "symbol" ? t : t + "";
}
function eL(e, t) {
  if (ya(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ya(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function tL(e, t) {
  if (e == null) return {};
  var r = rL(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function rL(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var nL = function(t, r, n, i, a, o) {
  return "M".concat(t, ",").concat(a, "v").concat(i, "M").concat(o, ",").concat(r, "h").concat(n);
}, iL = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, i = t.y, a = i === void 0 ? 0 : i, o = t.top, s = o === void 0 ? 0 : o, u = t.left, c = u === void 0 ? 0 : u, l = t.width, f = l === void 0 ? 0 : l, d = t.height, h = d === void 0 ? 0 : d, m = t.className, v = tL(t, X9), p = Z9({
    x: n,
    y: a,
    top: s,
    left: c,
    width: f,
    height: h
  }, v);
  return !U(n) || !U(a) || !U(f) || !U(h) || !U(s) || !U(c) ? null : /* @__PURE__ */ A.createElement("path", _p({}, Q(p, !0), {
    className: ue("recharts-cross", m),
    d: nL(n, a, f, h, s, c)
  }));
}, Yf, Cx;
function aL() {
  if (Cx) return Yf;
  Cx = 1;
  var e = Gs(), t = iS(), r = Ft();
  function n(i, a) {
    return i && i.length ? e(i, r(a, 2), t) : void 0;
  }
  return Yf = n, Yf;
}
var oL = aL();
const sL = /* @__PURE__ */ xe(oL);
var Xf, Mx;
function uL() {
  if (Mx) return Xf;
  Mx = 1;
  var e = Gs(), t = Ft(), r = aS();
  function n(i, a) {
    return i && i.length ? e(i, t(a, 2), r) : void 0;
  }
  return Xf = n, Xf;
}
var cL = uL();
const lL = /* @__PURE__ */ xe(cL);
var fL = ["cx", "cy", "angle", "ticks", "axisLine"], dL = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function qn(e) {
  "@babel/helpers - typeof";
  return qn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qn(e);
}
function qi() {
  return qi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qi.apply(this, arguments);
}
function jx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Er(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jx(Object(r), !0).forEach(function(n) {
      Ys(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : jx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function kx(e, t) {
  if (e == null) return {};
  var r = pL(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function pL(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function hL(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function $x(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, VS(n.key), n);
  }
}
function vL(e, t, r) {
  return t && $x(e.prototype, t), r && $x(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function yL(e, t, r) {
  return t = Qo(t), mL(e, HS() ? Reflect.construct(t, r || [], Qo(e).constructor) : t.apply(e, r));
}
function mL(e, t) {
  if (t && (qn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return gL(e);
}
function gL(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function HS() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (HS = function() {
    return !!e;
  })();
}
function Qo(e) {
  return Qo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Qo(e);
}
function bL(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Sp(e, t);
}
function Sp(e, t) {
  return Sp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Sp(e, t);
}
function Ys(e, t, r) {
  return t = VS(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function VS(e) {
  var t = xL(e, "string");
  return qn(t) == "symbol" ? t : t + "";
}
function xL(e, t) {
  if (qn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (qn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Xs = /* @__PURE__ */ function(e) {
  function t() {
    return hL(this, t), yL(this, t, arguments);
  }
  return bL(t, e), vL(t, [{
    key: "getTickValueCoord",
    value: (
      /**
       * Calculate the coordinate of tick
       * @param  {Number} coordinate The radius of tick
       * @return {Object} (x, y)
       */
      function(n) {
        var i = n.coordinate, a = this.props, o = a.angle, s = a.cx, u = a.cy;
        return Ae(s, u, i, o);
      }
    )
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props.orientation, i;
      switch (n) {
        case "left":
          i = "end";
          break;
        case "right":
          i = "start";
          break;
        default:
          i = "middle";
          break;
      }
      return i;
    }
  }, {
    key: "getViewBox",
    value: function() {
      var n = this.props, i = n.cx, a = n.cy, o = n.angle, s = n.ticks, u = sL(s, function(l) {
        return l.coordinate || 0;
      }), c = lL(s, function(l) {
        return l.coordinate || 0;
      });
      return {
        cx: i,
        cy: a,
        startAngle: o,
        endAngle: o,
        innerRadius: c.coordinate || 0,
        outerRadius: u.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, i = n.cx, a = n.cy, o = n.angle, s = n.ticks, u = n.axisLine, c = kx(n, fL), l = s.reduce(function(m, v) {
        return [Math.min(m[0], v.coordinate), Math.max(m[1], v.coordinate)];
      }, [1 / 0, -1 / 0]), f = Ae(i, a, l[0], o), d = Ae(i, a, l[1], o), h = Er(Er(Er({}, Q(c, !1)), {}, {
        fill: "none"
      }, Q(u, !1)), {}, {
        x1: f.x,
        y1: f.y,
        x2: d.x,
        y2: d.y
      });
      return /* @__PURE__ */ A.createElement("line", qi({
        className: "recharts-polar-radius-axis-line"
      }, h));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, i = this.props, a = i.ticks, o = i.tick, s = i.angle, u = i.tickFormatter, c = i.stroke, l = kx(i, dL), f = this.getTickTextAnchor(), d = Q(l, !1), h = Q(o, !1), m = a.map(function(v, p) {
        var g = n.getTickValueCoord(v), b = Er(Er(Er(Er({
          textAnchor: f,
          transform: "rotate(".concat(90 - s, ", ").concat(g.x, ", ").concat(g.y, ")")
        }, d), {}, {
          stroke: "none",
          fill: c
        }, h), {}, {
          index: p
        }, g), {}, {
          payload: v
        });
        return /* @__PURE__ */ A.createElement(le, qi({
          className: ue("recharts-polar-radius-axis-tick", $S(o)),
          key: "tick-".concat(v.coordinate)
        }, Vr(n.props, v, p)), t.renderTickItem(o, b, u ? u(v.value, p) : v.value));
      });
      return /* @__PURE__ */ A.createElement(le, {
        className: "recharts-polar-radius-axis-ticks"
      }, m);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, i = n.ticks, a = n.axisLine, o = n.tick;
      return !i || !i.length ? null : /* @__PURE__ */ A.createElement(le, {
        className: ue("recharts-polar-radius-axis", this.props.className)
      }, a && this.renderAxisLine(), o && this.renderTicks(), ze.renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, i, a) {
      var o;
      return /* @__PURE__ */ A.isValidElement(n) ? o = /* @__PURE__ */ A.cloneElement(n, i) : ie(n) ? o = n(i) : o = /* @__PURE__ */ A.createElement(Kr, qi({}, i, {
        className: "recharts-polar-radius-axis-tick-value"
      }), a), o;
    }
  }]);
}(bt);
Ys(Xs, "displayName", "PolarRadiusAxis");
Ys(Xs, "axisType", "radiusAxis");
Ys(Xs, "defaultProps", {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: !0,
  tick: !0,
  tickCount: 5,
  allowDataOverflow: !1,
  scale: "auto",
  allowDuplicatedCategory: !0
});
function Bn(e) {
  "@babel/helpers - typeof";
  return Bn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Bn(e);
}
function $r() {
  return $r = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $r.apply(this, arguments);
}
function Nx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Cr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Nx(Object(r), !0).forEach(function(n) {
      Zs(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Nx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function wL(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ix(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, YS(n.key), n);
  }
}
function OL(e, t, r) {
  return t && Ix(e.prototype, t), r && Ix(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function _L(e, t, r) {
  return t = es(t), SL(e, KS() ? Reflect.construct(t, r || [], es(e).constructor) : t.apply(e, r));
}
function SL(e, t) {
  if (t && (Bn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return AL(e);
}
function AL(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function KS() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (KS = function() {
    return !!e;
  })();
}
function es(e) {
  return es = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, es(e);
}
function PL(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ap(e, t);
}
function Ap(e, t) {
  return Ap = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Ap(e, t);
}
function Zs(e, t, r) {
  return t = YS(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function YS(e) {
  var t = TL(e, "string");
  return Bn(t) == "symbol" ? t : t + "";
}
function TL(e, t) {
  if (Bn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Bn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var EL = Math.PI / 180, Rx = 1e-5, Js = /* @__PURE__ */ function(e) {
  function t() {
    return wL(this, t), _L(this, t, arguments);
  }
  return PL(t, e), OL(t, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      function(n) {
        var i = this.props, a = i.cx, o = i.cy, s = i.radius, u = i.orientation, c = i.tickSize, l = c || 8, f = Ae(a, o, s, n.coordinate), d = Ae(a, o, s + (u === "inner" ? -1 : 1) * l, n.coordinate);
        return {
          x1: f.x,
          y1: f.y,
          x2: d.x,
          y2: d.y
        };
      }
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function(n) {
      var i = this.props.orientation, a = Math.cos(-n.coordinate * EL), o;
      return a > Rx ? o = i === "outer" ? "start" : "end" : a < -Rx ? o = i === "outer" ? "end" : "start" : o = "middle", o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, i = n.cx, a = n.cy, o = n.radius, s = n.axisLine, u = n.axisLineType, c = Cr(Cr({}, Q(this.props, !1)), {}, {
        fill: "none"
      }, Q(s, !1));
      if (u === "circle")
        return /* @__PURE__ */ A.createElement(Ra, $r({
          className: "recharts-polar-angle-axis-line"
        }, c, {
          cx: i,
          cy: a,
          r: o
        }));
      var l = this.props.ticks, f = l.map(function(d) {
        return Ae(i, a, o, d.coordinate);
      });
      return /* @__PURE__ */ A.createElement(Y9, $r({
        className: "recharts-polar-angle-axis-line"
      }, c, {
        points: f
      }));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, i = this.props, a = i.ticks, o = i.tick, s = i.tickLine, u = i.tickFormatter, c = i.stroke, l = Q(this.props, !1), f = Q(o, !1), d = Cr(Cr({}, l), {}, {
        fill: "none"
      }, Q(s, !1)), h = a.map(function(m, v) {
        var p = n.getTickLineCoord(m), g = n.getTickTextAnchor(m), b = Cr(Cr(Cr({
          textAnchor: g
        }, l), {}, {
          stroke: "none",
          fill: c
        }, f), {}, {
          index: v,
          payload: m,
          x: p.x2,
          y: p.y2
        });
        return /* @__PURE__ */ A.createElement(le, $r({
          className: ue("recharts-polar-angle-axis-tick", $S(o)),
          key: "tick-".concat(m.coordinate)
        }, Vr(n.props, m, v)), s && /* @__PURE__ */ A.createElement("line", $r({
          className: "recharts-polar-angle-axis-tick-line"
        }, d, p)), o && t.renderTickItem(o, b, u ? u(m.value, v) : m.value));
      });
      return /* @__PURE__ */ A.createElement(le, {
        className: "recharts-polar-angle-axis-ticks"
      }, h);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, i = n.ticks, a = n.radius, o = n.axisLine;
      return a <= 0 || !i || !i.length ? null : /* @__PURE__ */ A.createElement(le, {
        className: ue("recharts-polar-angle-axis", this.props.className)
      }, o && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function(n, i, a) {
      var o;
      return /* @__PURE__ */ A.isValidElement(n) ? o = /* @__PURE__ */ A.cloneElement(n, i) : ie(n) ? o = n(i) : o = /* @__PURE__ */ A.createElement(Kr, $r({}, i, {
        className: "recharts-polar-angle-axis-tick-value"
      }), a), o;
    }
  }]);
}(bt);
Zs(Js, "displayName", "PolarAngleAxis");
Zs(Js, "axisType", "angleAxis");
Zs(Js, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: !0,
  tickLine: !0,
  tickSize: 8,
  tick: !0,
  hide: !1,
  allowDuplicatedCategory: !0
});
var Zf, Dx;
function CL() {
  if (Dx) return Zf;
  Dx = 1;
  var e = i_(), t = e(Object.getPrototypeOf, Object);
  return Zf = t, Zf;
}
var Jf, Lx;
function ML() {
  if (Lx) return Jf;
  Lx = 1;
  var e = ir(), t = CL(), r = ar(), n = "[object Object]", i = Function.prototype, a = Object.prototype, o = i.toString, s = a.hasOwnProperty, u = o.call(Object);
  function c(l) {
    if (!r(l) || e(l) != n)
      return !1;
    var f = t(l);
    if (f === null)
      return !0;
    var d = s.call(f, "constructor") && f.constructor;
    return typeof d == "function" && d instanceof d && o.call(d) == u;
  }
  return Jf = c, Jf;
}
var jL = ML();
const kL = /* @__PURE__ */ xe(jL);
var Qf, qx;
function $L() {
  if (qx) return Qf;
  qx = 1;
  var e = ir(), t = ar(), r = "[object Boolean]";
  function n(i) {
    return i === !0 || i === !1 || t(i) && e(i) == r;
  }
  return Qf = n, Qf;
}
var NL = $L();
const IL = /* @__PURE__ */ xe(NL);
function ma(e) {
  "@babel/helpers - typeof";
  return ma = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ma(e);
}
function ts() {
  return ts = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ts.apply(this, arguments);
}
function RL(e, t) {
  return BL(e) || qL(e, t) || LL(e, t) || DL();
}
function DL() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function LL(e, t) {
  if (e) {
    if (typeof e == "string") return Bx(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Bx(e, t);
  }
}
function Bx(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function qL(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function BL(e) {
  if (Array.isArray(e)) return e;
}
function Fx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function zx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Fx(Object(r), !0).forEach(function(n) {
      FL(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Fx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function FL(e, t, r) {
  return t = zL(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function zL(e) {
  var t = WL(e, "string");
  return ma(t) == "symbol" ? t : t + "";
}
function WL(e, t) {
  if (ma(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ma(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Wx = function(t, r, n, i, a) {
  var o = n - i, s;
  return s = "M ".concat(t, ",").concat(r), s += "L ".concat(t + n, ",").concat(r), s += "L ".concat(t + n - o / 2, ",").concat(r + a), s += "L ".concat(t + n - o / 2 - i, ",").concat(r + a), s += "L ".concat(t, ",").concat(r, " Z"), s;
}, UL = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, GL = function(t) {
  var r = zx(zx({}, UL), t), n = An(), i = Vt(-1), a = RL(i, 2), o = a[0], s = a[1];
  Aa(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var w = n.current.getTotalLength();
        w && s(w);
      } catch {
      }
  }, []);
  var u = r.x, c = r.y, l = r.upperWidth, f = r.lowerWidth, d = r.height, h = r.className, m = r.animationEasing, v = r.animationDuration, p = r.animationBegin, g = r.isUpdateAnimationActive;
  if (u !== +u || c !== +c || l !== +l || f !== +f || d !== +d || l === 0 && f === 0 || d === 0)
    return null;
  var b = ue("recharts-trapezoid", h);
  return g ? /* @__PURE__ */ A.createElement(Mt, {
    canBegin: o > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: d,
      x: u,
      y: c
    },
    to: {
      upperWidth: l,
      lowerWidth: f,
      height: d,
      x: u,
      y: c
    },
    duration: v,
    animationEasing: m,
    isActive: g
  }, function(w) {
    var O = w.upperWidth, y = w.lowerWidth, x = w.height, _ = w.x, P = w.y;
    return /* @__PURE__ */ A.createElement(Mt, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: p,
      duration: v,
      easing: m
    }, /* @__PURE__ */ A.createElement("path", ts({}, Q(r, !0), {
      className: b,
      d: Wx(_, P, O, y, x),
      ref: n
    })));
  }) : /* @__PURE__ */ A.createElement("g", null, /* @__PURE__ */ A.createElement("path", ts({}, Q(r, !0), {
    className: b,
    d: Wx(u, c, l, f, d)
  })));
}, HL = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function ga(e) {
  "@babel/helpers - typeof";
  return ga = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ga(e);
}
function VL(e, t) {
  if (e == null) return {};
  var r = KL(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function KL(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Ux(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function rs(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ux(Object(r), !0).forEach(function(n) {
      YL(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ux(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function YL(e, t, r) {
  return t = XL(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function XL(e) {
  var t = ZL(e, "string");
  return ga(t) == "symbol" ? t : t + "";
}
function ZL(e, t) {
  if (ga(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ga(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function JL(e, t) {
  return rs(rs({}, t), e);
}
function QL(e, t) {
  return e === "symbols";
}
function Gx(e) {
  var t = e.shapeType, r = e.elementProps;
  switch (t) {
    case "rectangle":
      return /* @__PURE__ */ A.createElement(ov, r);
    case "trapezoid":
      return /* @__PURE__ */ A.createElement(GL, r);
    case "sector":
      return /* @__PURE__ */ A.createElement(RS, r);
    case "symbols":
      if (QL(t))
        return /* @__PURE__ */ A.createElement(Sh, r);
      break;
    default:
      return null;
  }
}
function eq(e) {
  return /* @__PURE__ */ Pt(e) ? e.props : e;
}
function XS(e) {
  var t = e.option, r = e.shapeType, n = e.propTransformer, i = n === void 0 ? JL : n, a = e.activeClassName, o = a === void 0 ? "recharts-active-shape" : a, s = e.isActive, u = VL(e, HL), c;
  if (/* @__PURE__ */ Pt(t))
    c = /* @__PURE__ */ De(t, rs(rs({}, u), eq(t)));
  else if (ie(t))
    c = t(u);
  else if (kL(t) && !IL(t)) {
    var l = i(t, u);
    c = /* @__PURE__ */ A.createElement(Gx, {
      shapeType: r,
      elementProps: l
    });
  } else {
    var f = u;
    c = /* @__PURE__ */ A.createElement(Gx, {
      shapeType: r,
      elementProps: f
    });
  }
  return s ? /* @__PURE__ */ A.createElement(le, {
    className: o
  }, c) : c;
}
function Qs(e, t) {
  return t != null && "trapezoids" in e.props;
}
function eu(e, t) {
  return t != null && "sectors" in e.props;
}
function ba(e, t) {
  return t != null && "points" in e.props;
}
function tq(e, t) {
  var r, n, i = e.x === (t == null || (r = t.labelViewBox) === null || r === void 0 ? void 0 : r.x) || e.x === t.x, a = e.y === (t == null || (n = t.labelViewBox) === null || n === void 0 ? void 0 : n.y) || e.y === t.y;
  return i && a;
}
function rq(e, t) {
  var r = e.endAngle === t.endAngle, n = e.startAngle === t.startAngle;
  return r && n;
}
function nq(e, t) {
  var r = e.x === t.x, n = e.y === t.y, i = e.z === t.z;
  return r && n && i;
}
function iq(e, t) {
  var r;
  return Qs(e, t) ? r = tq : eu(e, t) ? r = rq : ba(e, t) && (r = nq), r;
}
function aq(e, t) {
  var r;
  return Qs(e, t) ? r = "trapezoids" : eu(e, t) ? r = "sectors" : ba(e, t) && (r = "points"), r;
}
function oq(e, t) {
  if (Qs(e, t)) {
    var r;
    return (r = t.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  if (eu(e, t)) {
    var n;
    return (n = t.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  return ba(e, t) ? t.payload : {};
}
function sq(e) {
  var t = e.activeTooltipItem, r = e.graphicalItem, n = e.itemData, i = aq(r, t), a = oq(r, t), o = n.filter(function(u, c) {
    var l = Yr(a, u), f = r.props[i].filter(function(m) {
      var v = iq(r, t);
      return v(m, t);
    }), d = r.props[i].indexOf(f[f.length - 1]), h = c === d;
    return l && h;
  }), s = n.indexOf(o[o.length - 1]);
  return s;
}
var lo;
function Fn(e) {
  "@babel/helpers - typeof";
  return Fn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fn(e);
}
function yn() {
  return yn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yn.apply(this, arguments);
}
function Hx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Hx(Object(r), !0).forEach(function(n) {
      yt(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Hx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function uq(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Vx(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, JS(n.key), n);
  }
}
function cq(e, t, r) {
  return t && Vx(e.prototype, t), r && Vx(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function lq(e, t, r) {
  return t = ns(t), fq(e, ZS() ? Reflect.construct(t, r || [], ns(e).constructor) : t.apply(e, r));
}
function fq(e, t) {
  if (t && (Fn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return dq(e);
}
function dq(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ZS() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ZS = function() {
    return !!e;
  })();
}
function ns(e) {
  return ns = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ns(e);
}
function pq(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Pp(e, t);
}
function Pp(e, t) {
  return Pp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Pp(e, t);
}
function yt(e, t, r) {
  return t = JS(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function JS(e) {
  var t = hq(e, "string");
  return Fn(t) == "symbol" ? t : t + "";
}
function hq(e, t) {
  if (Fn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Fn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var sr = /* @__PURE__ */ function(e) {
  function t(r) {
    var n;
    return uq(this, t), n = lq(this, t, [r]), yt(n, "pieRef", null), yt(n, "sectorRefs", []), yt(n, "id", tn("recharts-pie-")), yt(n, "handleAnimationEnd", function() {
      var i = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), ie(i) && i();
    }), yt(n, "handleAnimationStart", function() {
      var i = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), ie(i) && i();
    }), n.state = {
      isAnimationFinished: !r.isAnimationActive,
      prevIsAnimationActive: r.isAnimationActive,
      prevAnimationId: r.animationId,
      sectorToFocus: 0
    }, n;
  }
  return pq(t, e), cq(t, [{
    key: "isActiveIndex",
    value: function(n) {
      var i = this.props.activeIndex;
      return Array.isArray(i) ? i.indexOf(n) !== -1 : n === i;
    }
  }, {
    key: "hasActiveIndex",
    value: function() {
      var n = this.props.activeIndex;
      return Array.isArray(n) ? n.length !== 0 : n || n === 0;
    }
  }, {
    key: "renderLabels",
    value: function(n) {
      var i = this.props.isAnimationActive;
      if (i && !this.state.isAnimationFinished)
        return null;
      var a = this.props, o = a.label, s = a.labelLine, u = a.dataKey, c = a.valueKey, l = Q(this.props, !1), f = Q(o, !1), d = Q(s, !1), h = o && o.offsetRadius || 20, m = n.map(function(v, p) {
        var g = (v.startAngle + v.endAngle) / 2, b = Ae(v.cx, v.cy, v.outerRadius + h, g), w = _e(_e(_e(_e({}, l), v), {}, {
          stroke: "none"
        }, f), {}, {
          index: p,
          textAnchor: t.getTextAnchor(b.x, v.cx)
        }, b), O = _e(_e(_e(_e({}, l), v), {}, {
          fill: "none",
          stroke: v.fill
        }, d), {}, {
          index: p,
          points: [Ae(v.cx, v.cy, v.outerRadius, g), b]
        }), y = u;
        return se(u) && se(c) ? y = "value" : se(u) && (y = c), // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ A.createElement(le, {
          key: "label-".concat(v.startAngle, "-").concat(v.endAngle, "-").concat(v.midAngle, "-").concat(p)
        }, s && t.renderLabelLineItem(s, O, "line"), t.renderLabelItem(o, w, ke(v, y)));
      });
      return /* @__PURE__ */ A.createElement(le, {
        className: "recharts-pie-labels"
      }, m);
    }
  }, {
    key: "renderSectorsStatically",
    value: function(n) {
      var i = this, a = this.props, o = a.activeShape, s = a.blendStroke, u = a.inactiveShape;
      return n.map(function(c, l) {
        if (c?.startAngle === 0 && c?.endAngle === 0 && n.length !== 1) return null;
        var f = i.isActiveIndex(l), d = u && i.hasActiveIndex() ? u : null, h = f ? o : d, m = _e(_e({}, c), {}, {
          stroke: s ? c.fill : c.stroke,
          tabIndex: -1
        });
        return /* @__PURE__ */ A.createElement(le, yn({
          ref: function(p) {
            p && !i.sectorRefs.includes(p) && i.sectorRefs.push(p);
          },
          tabIndex: -1,
          className: "recharts-pie-sector"
        }, Vr(i.props, c, l), {
          // eslint-disable-next-line react/no-array-index-key
          key: "sector-".concat(c?.startAngle, "-").concat(c?.endAngle, "-").concat(c.midAngle, "-").concat(l)
        }), /* @__PURE__ */ A.createElement(XS, yn({
          option: h,
          isActive: f,
          shapeType: "sector"
        }, m)));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function() {
      var n = this, i = this.props, a = i.sectors, o = i.isAnimationActive, s = i.animationBegin, u = i.animationDuration, c = i.animationEasing, l = i.animationId, f = this.state, d = f.prevSectors, h = f.prevIsAnimationActive;
      return /* @__PURE__ */ A.createElement(Mt, {
        begin: s,
        duration: u,
        isActive: o,
        easing: c,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(l, "-").concat(h),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function(m) {
        var v = m.t, p = [], g = a && a[0], b = g.startAngle;
        return a.forEach(function(w, O) {
          var y = d && d[O], x = O > 0 ? ut(w, "paddingAngle", 0) : 0;
          if (y) {
            var _ = Le(y.endAngle - y.startAngle, w.endAngle - w.startAngle), P = _e(_e({}, w), {}, {
              startAngle: b + x,
              endAngle: b + _(v) + x
            });
            p.push(P), b = P.endAngle;
          } else {
            var E = w.endAngle, M = w.startAngle, C = Le(0, E - M), T = C(v), k = _e(_e({}, w), {}, {
              startAngle: b + x,
              endAngle: b + T + x
            });
            p.push(k), b = k.endAngle;
          }
        }), /* @__PURE__ */ A.createElement(le, null, n.renderSectorsStatically(p));
      });
    }
  }, {
    key: "attachKeyboardHandlers",
    value: function(n) {
      var i = this;
      n.onkeydown = function(a) {
        if (!a.altKey)
          switch (a.key) {
            case "ArrowLeft": {
              var o = ++i.state.sectorToFocus % i.sectorRefs.length;
              i.sectorRefs[o].focus(), i.setState({
                sectorToFocus: o
              });
              break;
            }
            case "ArrowRight": {
              var s = --i.state.sectorToFocus < 0 ? i.sectorRefs.length - 1 : i.state.sectorToFocus % i.sectorRefs.length;
              i.sectorRefs[s].focus(), i.setState({
                sectorToFocus: s
              });
              break;
            }
            case "Escape": {
              i.sectorRefs[i.state.sectorToFocus].blur(), i.setState({
                sectorToFocus: 0
              });
              break;
            }
          }
      };
    }
  }, {
    key: "renderSectors",
    value: function() {
      var n = this.props, i = n.sectors, a = n.isAnimationActive, o = this.state.prevSectors;
      return a && i && i.length && (!o || !Yr(o, i)) ? this.renderSectorsWithAnimation() : this.renderSectorsStatically(i);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.pieRef && this.attachKeyboardHandlers(this.pieRef);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, i = this.props, a = i.hide, o = i.sectors, s = i.className, u = i.label, c = i.cx, l = i.cy, f = i.innerRadius, d = i.outerRadius, h = i.isAnimationActive, m = this.state.isAnimationFinished;
      if (a || !o || !o.length || !U(c) || !U(l) || !U(f) || !U(d))
        return null;
      var v = ue("recharts-pie", s);
      return /* @__PURE__ */ A.createElement(le, {
        tabIndex: this.props.rootTabIndex,
        className: v,
        ref: function(g) {
          n.pieRef = g;
        }
      }, this.renderSectors(), u && this.renderLabels(o), ze.renderCallByParent(this.props, null, !1), (!h || m) && Dt.renderCallByParent(this.props, o, !1));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, i) {
      return i.prevIsAnimationActive !== n.isAnimationActive ? {
        prevIsAnimationActive: n.isAnimationActive,
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: [],
        isAnimationFinished: !0
      } : n.isAnimationActive && n.animationId !== i.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: i.curSectors,
        isAnimationFinished: !0
      } : n.sectors !== i.curSectors ? {
        curSectors: n.sectors,
        isAnimationFinished: !0
      } : null;
    }
  }, {
    key: "getTextAnchor",
    value: function(n, i) {
      return n > i ? "start" : n < i ? "end" : "middle";
    }
  }, {
    key: "renderLabelLineItem",
    value: function(n, i, a) {
      if (/* @__PURE__ */ A.isValidElement(n))
        return /* @__PURE__ */ A.cloneElement(n, i);
      if (ie(n))
        return n(i);
      var o = ue("recharts-pie-label-line", typeof n != "boolean" ? n.className : "");
      return /* @__PURE__ */ A.createElement(Ur, yn({}, i, {
        key: a,
        type: "linear",
        className: o
      }));
    }
  }, {
    key: "renderLabelItem",
    value: function(n, i, a) {
      if (/* @__PURE__ */ A.isValidElement(n))
        return /* @__PURE__ */ A.cloneElement(n, i);
      var o = a;
      if (ie(n) && (o = n(i), /* @__PURE__ */ A.isValidElement(o)))
        return o;
      var s = ue("recharts-pie-label-text", typeof n != "boolean" && !ie(n) ? n.className : "");
      return /* @__PURE__ */ A.createElement(Kr, yn({}, i, {
        alignmentBaseline: "middle",
        className: s
      }), o);
    }
  }]);
}(bt);
lo = sr;
yt(sr, "displayName", "Pie");
yt(sr, "defaultProps", {
  stroke: "#fff",
  fill: "#808080",
  legendType: "rect",
  cx: "50%",
  cy: "50%",
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: "80%",
  paddingAngle: 0,
  labelLine: !0,
  hide: !1,
  minAngle: 0,
  isAnimationActive: !wr.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: "ease",
  nameKey: "name",
  blendStroke: !1,
  rootTabIndex: 0
});
yt(sr, "parseDeltaAngle", function(e, t) {
  var r = Ye(t - e), n = Math.min(Math.abs(t - e), 360);
  return r * n;
});
yt(sr, "getRealPieData", function(e) {
  var t = e.data, r = e.children, n = Q(e, !1), i = ct(r, Ls);
  return t && t.length ? t.map(function(a, o) {
    return _e(_e(_e({
      payload: a
    }, n), a), i && i[o] && i[o].props);
  }) : i && i.length ? i.map(function(a) {
    return _e(_e({}, n), a.props);
  }) : [];
});
yt(sr, "parseCoordinateOfPie", function(e, t) {
  var r = t.top, n = t.left, i = t.width, a = t.height, o = kS(i, a), s = n + Xe(e.cx, i, i / 2), u = r + Xe(e.cy, a, a / 2), c = Xe(e.innerRadius, o, 0), l = Xe(e.outerRadius, o, o * 0.8), f = e.maxRadius || Math.sqrt(i * i + a * a) / 2;
  return {
    cx: s,
    cy: u,
    innerRadius: c,
    outerRadius: l,
    maxRadius: f
  };
});
yt(sr, "getComposedData", function(e) {
  var t = e.item, r = e.offset, n = t.type.defaultProps !== void 0 ? _e(_e({}, t.type.defaultProps), t.props) : t.props, i = lo.getRealPieData(n);
  if (!i || !i.length)
    return null;
  var a = n.cornerRadius, o = n.startAngle, s = n.endAngle, u = n.paddingAngle, c = n.dataKey, l = n.nameKey, f = n.valueKey, d = n.tooltipType, h = Math.abs(n.minAngle), m = lo.parseCoordinateOfPie(n, r), v = lo.parseDeltaAngle(o, s), p = Math.abs(v), g = c;
  se(c) && se(f) ? (Et(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), g = "value") : se(c) && (Et(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), g = f);
  var b = i.filter(function(P) {
    return ke(P, g, 0) !== 0;
  }).length, w = (p >= 360 ? b : b - 1) * u, O = p - b * h - w, y = i.reduce(function(P, E) {
    var M = ke(E, g, 0);
    return P + (U(M) ? M : 0);
  }, 0), x;
  if (y > 0) {
    var _;
    x = i.map(function(P, E) {
      var M = ke(P, g, 0), C = ke(P, l, E), T = (U(M) ? M : 0) / y, k;
      E ? k = _.endAngle + Ye(v) * u * (M !== 0 ? 1 : 0) : k = o;
      var $ = k + Ye(v) * ((M !== 0 ? h : 0) + T * O), I = (k + $) / 2, R = (m.innerRadius + m.outerRadius) / 2, q = [{
        name: C,
        value: M,
        payload: P,
        dataKey: g,
        type: d
      }], W = Ae(m.cx, m.cy, R, I);
      return _ = _e(_e(_e({
        percent: T,
        cornerRadius: a,
        name: C,
        tooltipPayload: q,
        midAngle: I,
        middleRadius: R,
        tooltipPosition: W
      }, P), m), {}, {
        value: ke(P, g),
        startAngle: k,
        endAngle: $,
        payload: P,
        paddingAngle: Ye(v) * u
      }), _;
    });
  }
  return _e(_e({}, m), {}, {
    sectors: x,
    data: i
  });
});
var ed, Kx;
function vq() {
  if (Kx) return ed;
  Kx = 1;
  var e = Math.ceil, t = Math.max;
  function r(n, i, a, o) {
    for (var s = -1, u = t(e((i - n) / (a || 1)), 0), c = Array(u); u--; )
      c[o ? u : ++s] = n, n += a;
    return c;
  }
  return ed = r, ed;
}
var td, Yx;
function QS() {
  if (Yx) return td;
  Yx = 1;
  var e = x_(), t = 1 / 0, r = 17976931348623157e292;
  function n(i) {
    if (!i)
      return i === 0 ? i : 0;
    if (i = e(i), i === t || i === -t) {
      var a = i < 0 ? -1 : 1;
      return a * r;
    }
    return i === i ? i : 0;
  }
  return td = n, td;
}
var rd, Xx;
function yq() {
  if (Xx) return rd;
  Xx = 1;
  var e = vq(), t = Ds(), r = QS();
  function n(i) {
    return function(a, o, s) {
      return s && typeof s != "number" && t(a, o, s) && (o = s = void 0), a = r(a), o === void 0 ? (o = a, a = 0) : o = r(o), s = s === void 0 ? a < o ? 1 : -1 : r(s), e(a, o, s, i);
    };
  }
  return rd = n, rd;
}
var nd, Zx;
function mq() {
  if (Zx) return nd;
  Zx = 1;
  var e = yq(), t = e();
  return nd = t, nd;
}
var gq = mq();
const is = /* @__PURE__ */ xe(gq);
function xa(e) {
  "@babel/helpers - typeof";
  return xa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xa(e);
}
function Jx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Qx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Jx(Object(r), !0).forEach(function(n) {
      eA(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Jx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function eA(e, t, r) {
  return t = bq(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function bq(e) {
  var t = xq(e, "string");
  return xa(t) == "symbol" ? t : t + "";
}
function xq(e, t) {
  if (xa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (xa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var wq = ["Webkit", "Moz", "O", "ms"], Oq = function(t, r) {
  var n = t.replace(/(\w)/, function(a) {
    return a.toUpperCase();
  }), i = wq.reduce(function(a, o) {
    return Qx(Qx({}, a), {}, eA({}, o + n, r));
  }, {});
  return i[t] = r, i;
};
function zn(e) {
  "@babel/helpers - typeof";
  return zn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, zn(e);
}
function as() {
  return as = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, as.apply(this, arguments);
}
function ew(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function id(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ew(Object(r), !0).forEach(function(n) {
      at(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ew(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function _q(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function tw(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, rA(n.key), n);
  }
}
function Sq(e, t, r) {
  return t && tw(e.prototype, t), r && tw(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Aq(e, t, r) {
  return t = os(t), Pq(e, tA() ? Reflect.construct(t, r || [], os(e).constructor) : t.apply(e, r));
}
function Pq(e, t) {
  if (t && (zn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Tq(e);
}
function Tq(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function tA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (tA = function() {
    return !!e;
  })();
}
function os(e) {
  return os = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, os(e);
}
function Eq(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Tp(e, t);
}
function Tp(e, t) {
  return Tp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Tp(e, t);
}
function at(e, t, r) {
  return t = rA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function rA(e) {
  var t = Cq(e, "string");
  return zn(t) == "symbol" ? t : t + "";
}
function Cq(e, t) {
  if (zn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (zn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Mq = function(t) {
  var r = t.data, n = t.startIndex, i = t.endIndex, a = t.x, o = t.width, s = t.travellerWidth;
  if (!r || !r.length)
    return {};
  var u = r.length, c = Ii().domain(is(0, u)).range([a, a + o - s]), l = c.domain().map(function(f) {
    return c(f);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: c(n),
    endX: c(i),
    scale: c,
    scaleValues: l
  };
}, rw = function(t) {
  return t.changedTouches && !!t.changedTouches.length;
}, Wn = /* @__PURE__ */ function(e) {
  function t(r) {
    var n;
    return _q(this, t), n = Aq(this, t, [r]), at(n, "handleDrag", function(i) {
      n.leaveTimer && (clearTimeout(n.leaveTimer), n.leaveTimer = null), n.state.isTravellerMoving ? n.handleTravellerMove(i) : n.state.isSlideMoving && n.handleSlideDrag(i);
    }), at(n, "handleTouchMove", function(i) {
      i.changedTouches != null && i.changedTouches.length > 0 && n.handleDrag(i.changedTouches[0]);
    }), at(n, "handleDragEnd", function() {
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var i = n.props, a = i.endIndex, o = i.onDragEnd, s = i.startIndex;
        o?.({
          endIndex: a,
          startIndex: s
        });
      }), n.detachDragEndListener();
    }), at(n, "handleLeaveWrapper", function() {
      (n.state.isTravellerMoving || n.state.isSlideMoving) && (n.leaveTimer = window.setTimeout(n.handleDragEnd, n.props.leaveTimeOut));
    }), at(n, "handleEnterSlideOrTraveller", function() {
      n.setState({
        isTextActive: !0
      });
    }), at(n, "handleLeaveSlideOrTraveller", function() {
      n.setState({
        isTextActive: !1
      });
    }), at(n, "handleSlideDragStart", function(i) {
      var a = rw(i) ? i.changedTouches[0] : i;
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: a.pageX
      }), n.attachDragEndListener();
    }), n.travellerDragStartHandlers = {
      startX: n.handleTravellerDragStart.bind(n, "startX"),
      endX: n.handleTravellerDragStart.bind(n, "endX")
    }, n.state = {}, n;
  }
  return Eq(t, e), Sq(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(n) {
      var i = n.startX, a = n.endX, o = this.state.scaleValues, s = this.props, u = s.gap, c = s.data, l = c.length - 1, f = Math.min(i, a), d = Math.max(i, a), h = t.getIndexInRange(o, f), m = t.getIndexInRange(o, d);
      return {
        startIndex: h - h % u,
        endIndex: m === l ? l : m - m % u
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(n) {
      var i = this.props, a = i.data, o = i.tickFormatter, s = i.dataKey, u = ke(a[n], s, n);
      return ie(o) ? o(u, n) : u;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(n) {
      var i = this.state, a = i.slideMoveStartX, o = i.startX, s = i.endX, u = this.props, c = u.x, l = u.width, f = u.travellerWidth, d = u.startIndex, h = u.endIndex, m = u.onChange, v = n.pageX - a;
      v > 0 ? v = Math.min(v, c + l - f - s, c + l - f - o) : v < 0 && (v = Math.max(v, c - o, c - s));
      var p = this.getIndex({
        startX: o + v,
        endX: s + v
      });
      (p.startIndex !== d || p.endIndex !== h) && m && m(p), this.setState({
        startX: o + v,
        endX: s + v,
        slideMoveStartX: n.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(n, i) {
      var a = rw(i) ? i.changedTouches[0] : i;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: n,
        brushMoveStartX: a.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(n) {
      var i = this.state, a = i.brushMoveStartX, o = i.movingTravellerId, s = i.endX, u = i.startX, c = this.state[o], l = this.props, f = l.x, d = l.width, h = l.travellerWidth, m = l.onChange, v = l.gap, p = l.data, g = {
        startX: this.state.startX,
        endX: this.state.endX
      }, b = n.pageX - a;
      b > 0 ? b = Math.min(b, f + d - h - c) : b < 0 && (b = Math.max(b, f - c)), g[o] = c + b;
      var w = this.getIndex(g), O = w.startIndex, y = w.endIndex, x = function() {
        var P = p.length - 1;
        return o === "startX" && (s > u ? O % v === 0 : y % v === 0) || s < u && y === P || o === "endX" && (s > u ? y % v === 0 : O % v === 0) || s > u && y === P;
      };
      this.setState(at(at({}, o, c + b), "brushMoveStartX", n.pageX), function() {
        m && x() && m(w);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(n, i) {
      var a = this, o = this.state, s = o.scaleValues, u = o.startX, c = o.endX, l = this.state[i], f = s.indexOf(l);
      if (f !== -1) {
        var d = f + n;
        if (!(d === -1 || d >= s.length)) {
          var h = s[d];
          i === "startX" && h >= c || i === "endX" && h <= u || this.setState(at({}, i, h), function() {
            a.props.onChange(a.getIndex({
              startX: a.state.startX,
              endX: a.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this.props, i = n.x, a = n.y, o = n.width, s = n.height, u = n.fill, c = n.stroke;
      return /* @__PURE__ */ A.createElement("rect", {
        stroke: c,
        fill: u,
        x: i,
        y: a,
        width: o,
        height: s
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var n = this.props, i = n.x, a = n.y, o = n.width, s = n.height, u = n.data, c = n.children, l = n.padding, f = Br.only(c);
      return f ? /* @__PURE__ */ A.cloneElement(f, {
        x: i,
        y: a,
        width: o,
        height: s,
        margin: l,
        compact: !0,
        data: u
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(n, i) {
      var a, o, s = this, u = this.props, c = u.y, l = u.travellerWidth, f = u.height, d = u.traveller, h = u.ariaLabel, m = u.data, v = u.startIndex, p = u.endIndex, g = Math.max(n, this.props.x), b = id(id({}, Q(this.props, !1)), {}, {
        x: g,
        y: c,
        width: l,
        height: f
      }), w = h || "Min value: ".concat((a = m[v]) === null || a === void 0 ? void 0 : a.name, ", Max value: ").concat((o = m[p]) === null || o === void 0 ? void 0 : o.name);
      return /* @__PURE__ */ A.createElement(le, {
        tabIndex: 0,
        role: "slider",
        "aria-label": w,
        "aria-valuenow": n,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[i],
        onTouchStart: this.travellerDragStartHandlers[i],
        onKeyDown: function(y) {
          ["ArrowLeft", "ArrowRight"].includes(y.key) && (y.preventDefault(), y.stopPropagation(), s.handleTravellerMoveKeyboard(y.key === "ArrowRight" ? 1 : -1, i));
        },
        onFocus: function() {
          s.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          s.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, t.renderTraveller(d, b));
    }
  }, {
    key: "renderSlide",
    value: function(n, i) {
      var a = this.props, o = a.y, s = a.height, u = a.stroke, c = a.travellerWidth, l = Math.min(n, i) + c, f = Math.max(Math.abs(i - n) - c, 0);
      return /* @__PURE__ */ A.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: u,
        fillOpacity: 0.2,
        x: l,
        y: o,
        width: f,
        height: s
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var n = this.props, i = n.startIndex, a = n.endIndex, o = n.y, s = n.height, u = n.travellerWidth, c = n.stroke, l = this.state, f = l.startX, d = l.endX, h = 5, m = {
        pointerEvents: "none",
        fill: c
      };
      return /* @__PURE__ */ A.createElement(le, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ A.createElement(Kr, as({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(f, d) - h,
        y: o + s / 2
      }, m), this.getTextOfTick(i)), /* @__PURE__ */ A.createElement(Kr, as({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(f, d) + u + h,
        y: o + s / 2
      }, m), this.getTextOfTick(a)));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, i = n.data, a = n.className, o = n.children, s = n.x, u = n.y, c = n.width, l = n.height, f = n.alwaysShowText, d = this.state, h = d.startX, m = d.endX, v = d.isTextActive, p = d.isSlideMoving, g = d.isTravellerMoving, b = d.isTravellerFocused;
      if (!i || !i.length || !U(s) || !U(u) || !U(c) || !U(l) || c <= 0 || l <= 0)
        return null;
      var w = ue("recharts-brush", a), O = A.Children.count(o) === 1, y = Oq("userSelect", "none");
      return /* @__PURE__ */ A.createElement(le, {
        className: w,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: y
      }, this.renderBackground(), O && this.renderPanorama(), this.renderSlide(h, m), this.renderTravellerLayer(h, "startX"), this.renderTravellerLayer(m, "endX"), (v || p || g || b || f) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(n) {
      var i = n.x, a = n.y, o = n.width, s = n.height, u = n.stroke, c = Math.floor(a + s / 2) - 1;
      return /* @__PURE__ */ A.createElement(A.Fragment, null, /* @__PURE__ */ A.createElement("rect", {
        x: i,
        y: a,
        width: o,
        height: s,
        fill: u,
        stroke: "none"
      }), /* @__PURE__ */ A.createElement("line", {
        x1: i + 1,
        y1: c,
        x2: i + o - 1,
        y2: c,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ A.createElement("line", {
        x1: i + 1,
        y1: c + 2,
        x2: i + o - 1,
        y2: c + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(n, i) {
      var a;
      return /* @__PURE__ */ A.isValidElement(n) ? a = /* @__PURE__ */ A.cloneElement(n, i) : ie(n) ? a = n(i) : a = t.renderDefaultTraveller(i), a;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(n, i) {
      var a = n.data, o = n.width, s = n.x, u = n.travellerWidth, c = n.updateId, l = n.startIndex, f = n.endIndex;
      if (a !== i.prevData || c !== i.prevUpdateId)
        return id({
          prevData: a,
          prevTravellerWidth: u,
          prevUpdateId: c,
          prevX: s,
          prevWidth: o
        }, a && a.length ? Mq({
          data: a,
          width: o,
          x: s,
          travellerWidth: u,
          startIndex: l,
          endIndex: f
        }) : {
          scale: null,
          scaleValues: null
        });
      if (i.scale && (o !== i.prevWidth || s !== i.prevX || u !== i.prevTravellerWidth)) {
        i.scale.range([s, s + o - u]);
        var d = i.scale.domain().map(function(h) {
          return i.scale(h);
        });
        return {
          prevData: a,
          prevTravellerWidth: u,
          prevUpdateId: c,
          prevX: s,
          prevWidth: o,
          startX: i.scale(n.startIndex),
          endX: i.scale(n.endIndex),
          scaleValues: d
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(n, i) {
      for (var a = n.length, o = 0, s = a - 1; s - o > 1; ) {
        var u = Math.floor((o + s) / 2);
        n[u] > i ? s = u : o = u;
      }
      return i >= n[s] ? s : o;
    }
  }]);
}(bt);
at(Wn, "displayName", "Brush");
at(Wn, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var ad, nw;
function jq() {
  if (nw) return ad;
  nw = 1;
  var e = jh();
  function t(r, n) {
    var i;
    return e(r, function(a, o, s) {
      return i = n(a, o, s), !i;
    }), !!i;
  }
  return ad = t, ad;
}
var od, iw;
function kq() {
  if (iw) return od;
  iw = 1;
  var e = ZO(), t = Ft(), r = jq(), n = nt(), i = Ds();
  function a(o, s, u) {
    var c = n(o) ? e : r;
    return u && i(o, s, u) && (s = void 0), c(o, t(s, 3));
  }
  return od = a, od;
}
var $q = kq();
const Nq = /* @__PURE__ */ xe($q);
var Lt = function(t, r) {
  var n = t.alwaysShow, i = t.ifOverflow;
  return n && (i = "extendDomain"), i === r;
}, sd, aw;
function Iq() {
  if (aw) return sd;
  aw = 1;
  var e = v_();
  function t(r, n, i) {
    n == "__proto__" && e ? e(r, n, {
      configurable: !0,
      enumerable: !0,
      value: i,
      writable: !0
    }) : r[n] = i;
  }
  return sd = t, sd;
}
var ud, ow;
function Rq() {
  if (ow) return ud;
  ow = 1;
  var e = Iq(), t = p_(), r = Ft();
  function n(i, a) {
    var o = {};
    return a = r(a, 3), t(i, function(s, u, c) {
      e(o, u, a(s, u, c));
    }), o;
  }
  return ud = n, ud;
}
var Dq = Rq();
const Lq = /* @__PURE__ */ xe(Dq);
var cd, sw;
function qq() {
  if (sw) return cd;
  sw = 1;
  function e(t, r) {
    for (var n = -1, i = t == null ? 0 : t.length; ++n < i; )
      if (!r(t[n], n, t))
        return !1;
    return !0;
  }
  return cd = e, cd;
}
var ld, uw;
function Bq() {
  if (uw) return ld;
  uw = 1;
  var e = jh();
  function t(r, n) {
    var i = !0;
    return e(r, function(a, o, s) {
      return i = !!n(a, o, s), i;
    }), i;
  }
  return ld = t, ld;
}
var fd, cw;
function Fq() {
  if (cw) return fd;
  cw = 1;
  var e = qq(), t = Bq(), r = Ft(), n = nt(), i = Ds();
  function a(o, s, u) {
    var c = n(o) ? e : t;
    return u && i(o, s, u) && (s = void 0), c(o, r(s, 3));
  }
  return fd = a, fd;
}
var zq = Fq();
const nA = /* @__PURE__ */ xe(zq);
var Wq = ["x", "y"];
function Un(e) {
  "@babel/helpers - typeof";
  return Un = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Un(e);
}
function Ep() {
  return Ep = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ep.apply(this, arguments);
}
function lw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ti(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? lw(Object(r), !0).forEach(function(n) {
      Uq(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : lw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Uq(e, t, r) {
  return t = Gq(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Gq(e) {
  var t = Hq(e, "string");
  return Un(t) == "symbol" ? t : t + "";
}
function Hq(e, t) {
  if (Un(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Un(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Vq(e, t) {
  if (e == null) return {};
  var r = Kq(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Kq(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Yq(e, t) {
  var r = e.x, n = e.y, i = Vq(e, Wq), a = "".concat(r), o = parseInt(a, 10), s = "".concat(n), u = parseInt(s, 10), c = "".concat(t.height || i.height), l = parseInt(c, 10), f = "".concat(t.width || i.width), d = parseInt(f, 10);
  return Ti(Ti(Ti(Ti(Ti({}, t), i), o ? {
    x: o
  } : {}), u ? {
    y: u
  } : {}), {}, {
    height: l,
    width: d,
    name: t.name,
    radius: t.radius
  });
}
function fw(e) {
  return /* @__PURE__ */ A.createElement(XS, Ep({
    shapeType: "rectangle",
    propTransformer: Yq,
    activeClassName: "recharts-active-bar"
  }, e));
}
var Xq = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(n, i) {
    if (typeof t == "number") return t;
    var a = U(n) || f3(n);
    return a ? t(n, i) : (a || (process.env.NODE_ENV !== "production" ? tt(!1, "minPointSize callback function received a value with type of ".concat(Un(n), ". Currently only numbers or null/undefined are supported.")) : tt()), r);
  };
}, Zq = ["value", "background"], iA;
function Gn(e) {
  "@babel/helpers - typeof";
  return Gn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gn(e);
}
function Jq(e, t) {
  if (e == null) return {};
  var r = Qq(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Qq(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function ss() {
  return ss = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ss.apply(this, arguments);
}
function dw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dw(Object(r), !0).forEach(function(n) {
      mr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : dw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function eB(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function pw(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, oA(n.key), n);
  }
}
function tB(e, t, r) {
  return t && pw(e.prototype, t), r && pw(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function rB(e, t, r) {
  return t = us(t), nB(e, aA() ? Reflect.construct(t, r || [], us(e).constructor) : t.apply(e, r));
}
function nB(e, t) {
  if (t && (Gn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return iB(e);
}
function iB(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function aA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (aA = function() {
    return !!e;
  })();
}
function us(e) {
  return us = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, us(e);
}
function aB(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Cp(e, t);
}
function Cp(e, t) {
  return Cp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Cp(e, t);
}
function mr(e, t, r) {
  return t = oA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function oA(e) {
  var t = oB(e, "string");
  return Gn(t) == "symbol" ? t : t + "";
}
function oB(e, t) {
  if (Gn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Gn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Ar = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    eB(this, t);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = rB(this, t, [].concat(i)), mr(r, "state", {
      isAnimationFinished: !1
    }), mr(r, "id", tn("recharts-bar-")), mr(r, "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), o && o();
    }), mr(r, "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), o && o();
    }), r;
  }
  return aB(t, e), tB(t, [{
    key: "renderRectanglesStatically",
    value: function(n) {
      var i = this, a = this.props, o = a.shape, s = a.dataKey, u = a.activeIndex, c = a.activeBar, l = Q(this.props, !1);
      return n && n.map(function(f, d) {
        var h = d === u, m = h ? c : o, v = $e($e($e({}, l), f), {}, {
          isActive: h,
          option: m,
          index: d,
          dataKey: s,
          onAnimationStart: i.handleAnimationStart,
          onAnimationEnd: i.handleAnimationEnd
        });
        return /* @__PURE__ */ A.createElement(le, ss({
          className: "recharts-bar-rectangle"
        }, Vr(i.props, f, d), {
          // https://github.com/recharts/recharts/issues/5415
          // eslint-disable-next-line react/no-array-index-key
          key: "rectangle-".concat(f?.x, "-").concat(f?.y, "-").concat(f?.value, "-").concat(d)
        }), /* @__PURE__ */ A.createElement(fw, v));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var n = this, i = this.props, a = i.data, o = i.layout, s = i.isAnimationActive, u = i.animationBegin, c = i.animationDuration, l = i.animationEasing, f = i.animationId, d = this.state.prevData;
      return /* @__PURE__ */ A.createElement(Mt, {
        begin: u,
        duration: c,
        isActive: s,
        easing: l,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(f),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(h) {
        var m = h.t, v = a.map(function(p, g) {
          var b = d && d[g];
          if (b) {
            var w = Le(b.x, p.x), O = Le(b.y, p.y), y = Le(b.width, p.width), x = Le(b.height, p.height);
            return $e($e({}, p), {}, {
              x: w(m),
              y: O(m),
              width: y(m),
              height: x(m)
            });
          }
          if (o === "horizontal") {
            var _ = Le(0, p.height), P = _(m);
            return $e($e({}, p), {}, {
              y: p.y + p.height - P,
              height: P
            });
          }
          var E = Le(0, p.width), M = E(m);
          return $e($e({}, p), {}, {
            width: M
          });
        });
        return /* @__PURE__ */ A.createElement(le, null, n.renderRectanglesStatically(v));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var n = this.props, i = n.data, a = n.isAnimationActive, o = this.state.prevData;
      return a && i && i.length && (!o || !Yr(o, i)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(i);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this, i = this.props, a = i.data, o = i.dataKey, s = i.activeIndex, u = Q(this.props.background, !1);
      return a.map(function(c, l) {
        c.value;
        var f = c.background, d = Jq(c, Zq);
        if (!f)
          return null;
        var h = $e($e($e($e($e({}, d), {}, {
          fill: "#eee"
        }, f), u), Vr(n.props, c, l)), {}, {
          onAnimationStart: n.handleAnimationStart,
          onAnimationEnd: n.handleAnimationEnd,
          dataKey: o,
          index: l,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ A.createElement(fw, ss({
          key: "background-bar-".concat(l),
          option: n.props.background,
          isActive: l === s
        }, h));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(n, i) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var a = this.props, o = a.data, s = a.xAxis, u = a.yAxis, c = a.layout, l = a.children, f = ct(l, Ia);
      if (!f)
        return null;
      var d = c === "vertical" ? o[0].height / 2 : o[0].width / 2, h = function(p, g) {
        var b = Array.isArray(p.value) ? p.value[1] : p.value;
        return {
          x: p.x,
          y: p.y,
          value: b,
          errorVal: ke(p, g)
        };
      }, m = {
        clipPath: n ? "url(#clipPath-".concat(i, ")") : null
      };
      return /* @__PURE__ */ A.createElement(le, m, f.map(function(v) {
        return /* @__PURE__ */ A.cloneElement(v, {
          key: "error-bar-".concat(i, "-").concat(v.props.dataKey),
          data: o,
          xAxis: s,
          yAxis: u,
          layout: c,
          offset: d,
          dataPointFormatter: h
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, i = n.hide, a = n.data, o = n.className, s = n.xAxis, u = n.yAxis, c = n.left, l = n.top, f = n.width, d = n.height, h = n.isAnimationActive, m = n.background, v = n.id;
      if (i || !a || !a.length)
        return null;
      var p = this.state.isAnimationFinished, g = ue("recharts-bar", o), b = s && s.allowDataOverflow, w = u && u.allowDataOverflow, O = b || w, y = se(v) ? this.id : v;
      return /* @__PURE__ */ A.createElement(le, {
        className: g
      }, b || w ? /* @__PURE__ */ A.createElement("defs", null, /* @__PURE__ */ A.createElement("clipPath", {
        id: "clipPath-".concat(y)
      }, /* @__PURE__ */ A.createElement("rect", {
        x: b ? c : c - f / 2,
        y: w ? l : l - d / 2,
        width: b ? f : f * 2,
        height: w ? d : d * 2
      }))) : null, /* @__PURE__ */ A.createElement(le, {
        className: "recharts-bar-rectangles",
        clipPath: O ? "url(#clipPath-".concat(y, ")") : null
      }, m ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(O, y), (!h || p) && Dt.renderCallByParent(this.props, a));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, i) {
      return n.animationId !== i.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curData: n.data,
        prevData: i.curData
      } : n.data !== i.curData ? {
        curData: n.data
      } : null;
    }
  }]);
}(bt);
iA = Ar;
mr(Ar, "displayName", "Bar");
mr(Ar, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !wr.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
mr(Ar, "getComposedData", function(e) {
  var t = e.props, r = e.item, n = e.barPosition, i = e.bandSize, a = e.xAxis, o = e.yAxis, s = e.xAxisTicks, u = e.yAxisTicks, c = e.stackedData, l = e.dataStartIndex, f = e.displayedData, d = e.offset, h = P2(n, r);
  if (!h)
    return null;
  var m = t.layout, v = r.type.defaultProps, p = v !== void 0 ? $e($e({}, v), r.props) : r.props, g = p.dataKey, b = p.children, w = p.minPointSize, O = m === "horizontal" ? o : a, y = c ? O.scale.domain() : null, x = $2({
    numericAxis: O
  }), _ = ct(b, Ls), P = f.map(function(E, M) {
    var C, T, k, $, I, R;
    c ? C = T2(c[l + M], y) : (C = ke(E, g), Array.isArray(C) || (C = [x, C]));
    var q = Xq(w, iA.defaultProps.minPointSize)(C[1], M);
    if (m === "horizontal") {
      var W, H = [o.scale(C[0]), o.scale(C[1])], N = H[0], L = H[1];
      T = N0({
        axis: a,
        ticks: s,
        bandSize: i,
        offset: h.offset,
        entry: E,
        index: M
      }), k = (W = L ?? N) !== null && W !== void 0 ? W : void 0, $ = h.size;
      var B = N - L;
      if (I = Number.isNaN(B) ? 0 : B, R = {
        x: T,
        y: o.y,
        width: $,
        height: o.height
      }, Math.abs(q) > 0 && Math.abs(I) < Math.abs(q)) {
        var K = Ye(I || q) * (Math.abs(q) - Math.abs(I));
        k -= K, I += K;
      }
    } else {
      var X = [a.scale(C[0]), a.scale(C[1])], te = X[0], re = X[1];
      if (T = te, k = N0({
        axis: o,
        ticks: u,
        bandSize: i,
        offset: h.offset,
        entry: E,
        index: M
      }), $ = re - te, I = h.size, R = {
        x: a.x,
        y: k,
        width: a.width,
        height: I
      }, Math.abs(q) > 0 && Math.abs($) < Math.abs(q)) {
        var oe = Ye($ || q) * (Math.abs(q) - Math.abs($));
        $ += oe;
      }
    }
    return $e($e($e({}, E), {}, {
      x: T,
      y: k,
      width: $,
      height: I,
      value: c ? C : C[1],
      payload: E,
      background: R
    }, _ && _[M] && _[M].props), {}, {
      tooltipPayload: [MS(r, E)],
      tooltipPosition: {
        x: T + $ / 2,
        y: k + I / 2
      }
    });
  });
  return $e({
    data: P,
    layout: m
  }, d);
});
function wa(e) {
  "@babel/helpers - typeof";
  return wa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wa(e);
}
function sB(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function hw(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, sA(n.key), n);
  }
}
function uB(e, t, r) {
  return t && hw(e.prototype, t), r && hw(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function vw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _t(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vw(Object(r), !0).forEach(function(n) {
      tu(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function tu(e, t, r) {
  return t = sA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function sA(e) {
  var t = cB(e, "string");
  return wa(t) == "symbol" ? t : t + "";
}
function cB(e, t) {
  if (wa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (wa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var sv = function(t, r, n, i, a) {
  var o = t.width, s = t.height, u = t.layout, c = t.children, l = Object.keys(r), f = {
    left: n.left,
    leftMirror: n.left,
    right: o - n.right,
    rightMirror: o - n.right,
    top: n.top,
    topMirror: n.top,
    bottom: s - n.bottom,
    bottomMirror: s - n.bottom
  }, d = !!ot(c, Ar);
  return l.reduce(function(h, m) {
    var v = r[m], p = v.orientation, g = v.domain, b = v.padding, w = b === void 0 ? {} : b, O = v.mirror, y = v.reversed, x = "".concat(p).concat(O ? "Mirror" : ""), _, P, E, M, C;
    if (v.type === "number" && (v.padding === "gap" || v.padding === "no-gap")) {
      var T = g[1] - g[0], k = 1 / 0, $ = v.categoricalDomain.sort(h3);
      if ($.forEach(function(X, te) {
        te > 0 && (k = Math.min((X || 0) - ($[te - 1] || 0), k));
      }), Number.isFinite(k)) {
        var I = k / T, R = v.layout === "vertical" ? n.height : n.width;
        if (v.padding === "gap" && (_ = I * R / 2), v.padding === "no-gap") {
          var q = Xe(t.barCategoryGap, I * R), W = I * R / 2;
          _ = W - q - (W - q) / R * q;
        }
      }
    }
    i === "xAxis" ? P = [n.left + (w.left || 0) + (_ || 0), n.left + n.width - (w.right || 0) - (_ || 0)] : i === "yAxis" ? P = u === "horizontal" ? [n.top + n.height - (w.bottom || 0), n.top + (w.top || 0)] : [n.top + (w.top || 0) + (_ || 0), n.top + n.height - (w.bottom || 0) - (_ || 0)] : P = v.range, y && (P = [P[1], P[0]]);
    var H = PS(v, a, d), N = H.scale, L = H.realScaleType;
    N.domain(g).range(P), TS(N);
    var B = ES(N, _t(_t({}, v), {}, {
      realScaleType: L
    }));
    i === "xAxis" ? (C = p === "top" && !O || p === "bottom" && O, E = n.left, M = f[x] - C * v.height) : i === "yAxis" && (C = p === "left" && !O || p === "right" && O, E = f[x] - C * v.width, M = n.top);
    var K = _t(_t(_t({}, v), B), {}, {
      realScaleType: L,
      x: E,
      y: M,
      scale: N,
      width: i === "xAxis" ? n.width : v.width,
      height: i === "yAxis" ? n.height : v.height
    });
    return K.bandSize = Uo(K, B), !v.hide && i === "xAxis" ? f[x] += (C ? -1 : 1) * K.height : v.hide || (f[x] += (C ? -1 : 1) * K.width), _t(_t({}, h), {}, tu({}, m, K));
  }, {});
}, uA = function(t, r) {
  var n = t.x, i = t.y, a = r.x, o = r.y;
  return {
    x: Math.min(n, a),
    y: Math.min(i, o),
    width: Math.abs(a - n),
    height: Math.abs(o - i)
  };
}, lB = function(t) {
  var r = t.x1, n = t.y1, i = t.x2, a = t.y2;
  return uA({
    x: r,
    y: n
  }, {
    x: i,
    y: a
  });
}, cA = /* @__PURE__ */ function() {
  function e(t) {
    sB(this, e), this.scale = t;
  }
  return uB(e, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = n.bandAware, a = n.position;
      if (r !== void 0) {
        if (a)
          switch (a) {
            case "start":
              return this.scale(r);
            case "middle": {
              var o = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(r) + o;
            }
            case "end": {
              var s = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(r) + s;
            }
            default:
              return this.scale(r);
          }
        if (i) {
          var u = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(r) + u;
        }
        return this.scale(r);
      }
    }
  }, {
    key: "isInRange",
    value: function(r) {
      var n = this.range(), i = n[0], a = n[n.length - 1];
      return i <= a ? r >= i && r <= a : r >= a && r <= i;
    }
  }], [{
    key: "create",
    value: function(r) {
      return new e(r);
    }
  }]);
}();
tu(cA, "EPS", 1e-4);
var uv = function(t) {
  var r = Object.keys(t).reduce(function(n, i) {
    return _t(_t({}, n), {}, tu({}, i, cA.create(t[i])));
  }, {});
  return _t(_t({}, r), {}, {
    apply: function(i) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = a.bandAware, s = a.position;
      return Lq(i, function(u, c) {
        return r[c].apply(u, {
          bandAware: o,
          position: s
        });
      });
    },
    isInRange: function(i) {
      return nA(i, function(a, o) {
        return r[o].isInRange(a);
      });
    }
  });
};
function fB(e) {
  return (e % 180 + 180) % 180;
}
var dB = function(t) {
  var r = t.width, n = t.height, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, a = fB(i), o = a * Math.PI / 180, s = Math.atan(n / r), u = o > s && o < Math.PI - s ? n / Math.sin(o) : r / Math.cos(o);
  return Math.abs(u);
}, dd, yw;
function pB() {
  if (yw) return dd;
  yw = 1;
  var e = Ft(), t = Ma(), r = Is();
  function n(i) {
    return function(a, o, s) {
      var u = Object(a);
      if (!t(a)) {
        var c = e(o, 3);
        a = r(a), o = function(f) {
          return c(u[f], f, u);
        };
      }
      var l = i(a, o, s);
      return l > -1 ? u[c ? a[l] : l] : void 0;
    };
  }
  return dd = n, dd;
}
var pd, mw;
function hB() {
  if (mw) return pd;
  mw = 1;
  var e = QS();
  function t(r) {
    var n = e(r), i = n % 1;
    return n === n ? i ? n - i : n : 0;
  }
  return pd = t, pd;
}
var hd, gw;
function vB() {
  if (gw) return hd;
  gw = 1;
  var e = u_(), t = Ft(), r = hB(), n = Math.max;
  function i(a, o, s) {
    var u = a == null ? 0 : a.length;
    if (!u)
      return -1;
    var c = s == null ? 0 : r(s);
    return c < 0 && (c = n(u + c, 0)), e(a, t(o, 3), c);
  }
  return hd = i, hd;
}
var vd, bw;
function yB() {
  if (bw) return vd;
  bw = 1;
  var e = pB(), t = vB(), r = e(t);
  return vd = r, vd;
}
var mB = yB();
const gB = /* @__PURE__ */ xe(mB);
var bB = _O();
const xB = /* @__PURE__ */ xe(bB);
var wB = xB(function(e) {
  return {
    x: e.left,
    y: e.top,
    width: e.width,
    height: e.height
  };
}, function(e) {
  return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
});
function cs(e) {
  "@babel/helpers - typeof";
  return cs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, cs(e);
}
var cv = /* @__PURE__ */ Jr(void 0), lv = /* @__PURE__ */ Jr(void 0), lA = /* @__PURE__ */ Jr(void 0), fA = /* @__PURE__ */ Jr({}), dA = /* @__PURE__ */ Jr(void 0), pA = /* @__PURE__ */ Jr(0), hA = /* @__PURE__ */ Jr(0), xw = function(t) {
  var r = t.state, n = r.xAxisMap, i = r.yAxisMap, a = r.offset, o = t.clipPathId, s = t.children, u = t.width, c = t.height, l = wB(a);
  return /* @__PURE__ */ A.createElement(cv.Provider, {
    value: n
  }, /* @__PURE__ */ A.createElement(lv.Provider, {
    value: i
  }, /* @__PURE__ */ A.createElement(fA.Provider, {
    value: a
  }, /* @__PURE__ */ A.createElement(lA.Provider, {
    value: l
  }, /* @__PURE__ */ A.createElement(dA.Provider, {
    value: o
  }, /* @__PURE__ */ A.createElement(pA.Provider, {
    value: c
  }, /* @__PURE__ */ A.createElement(hA.Provider, {
    value: u
  }, s)))))));
}, OB = function() {
  return nr(dA);
};
function vA(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "There are no available ids." : "Available ids are: ".concat(t, ".");
}
var yA = function(t) {
  var r = nr(cv);
  r == null && (process.env.NODE_ENV !== "production" ? tt(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : tt());
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? tt(!1, 'Could not find xAxis by id "'.concat(t, '" [').concat(cs(t), "]. ").concat(vA(r))) : tt()), n;
}, _B = function() {
  var t = nr(cv);
  return vr(t);
}, SB = function() {
  var t = nr(lv), r = gB(t, function(n) {
    return nA(n.domain, Number.isFinite);
  });
  return r || vr(t);
}, mA = function(t) {
  var r = nr(lv);
  r == null && (process.env.NODE_ENV !== "production" ? tt(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : tt());
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? tt(!1, 'Could not find yAxis by id "'.concat(t, '" [').concat(cs(t), "]. ").concat(vA(r))) : tt()), n;
}, AB = function() {
  var t = nr(lA);
  return t;
}, PB = function() {
  return nr(fA);
}, fv = function() {
  return nr(hA);
}, dv = function() {
  return nr(pA);
};
function Hn(e) {
  "@babel/helpers - typeof";
  return Hn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Hn(e);
}
function TB(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function EB(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bA(n.key), n);
  }
}
function CB(e, t, r) {
  return t && EB(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function MB(e, t, r) {
  return t = ls(t), jB(e, gA() ? Reflect.construct(t, r || [], ls(e).constructor) : t.apply(e, r));
}
function jB(e, t) {
  if (t && (Hn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return kB(e);
}
function kB(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function gA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (gA = function() {
    return !!e;
  })();
}
function ls(e) {
  return ls = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ls(e);
}
function $B(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Mp(e, t);
}
function Mp(e, t) {
  return Mp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Mp(e, t);
}
function ww(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ow(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ww(Object(r), !0).forEach(function(n) {
      pv(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ww(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function pv(e, t, r) {
  return t = bA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function bA(e) {
  var t = NB(e, "string");
  return Hn(t) == "symbol" ? t : t + "";
}
function NB(e, t) {
  if (Hn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Hn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function IB(e, t) {
  return qB(e) || LB(e, t) || DB(e, t) || RB();
}
function RB() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function DB(e, t) {
  if (e) {
    if (typeof e == "string") return _w(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return _w(e, t);
  }
}
function _w(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function LB(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function qB(e) {
  if (Array.isArray(e)) return e;
}
function jp() {
  return jp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jp.apply(this, arguments);
}
var BB = function(t, r) {
  var n;
  return /* @__PURE__ */ A.isValidElement(t) ? n = /* @__PURE__ */ A.cloneElement(t, r) : ie(t) ? n = t(r) : n = /* @__PURE__ */ A.createElement("line", jp({}, r, {
    className: "recharts-reference-line-line"
  })), n;
}, FB = function(t, r, n, i, a, o, s, u, c) {
  var l = a.x, f = a.y, d = a.width, h = a.height;
  if (n) {
    var m = c.y, v = t.y.apply(m, {
      position: o
    });
    if (Lt(c, "discard") && !t.y.isInRange(v))
      return null;
    var p = [{
      x: l + d,
      y: v
    }, {
      x: l,
      y: v
    }];
    return u === "left" ? p.reverse() : p;
  }
  if (r) {
    var g = c.x, b = t.x.apply(g, {
      position: o
    });
    if (Lt(c, "discard") && !t.x.isInRange(b))
      return null;
    var w = [{
      x: b,
      y: f + h
    }, {
      x: b,
      y: f
    }];
    return s === "top" ? w.reverse() : w;
  }
  if (i) {
    var O = c.segment, y = O.map(function(x) {
      return t.apply(x, {
        position: o
      });
    });
    return Lt(c, "discard") && Nq(y, function(x) {
      return !t.isInRange(x);
    }) ? null : y;
  }
  return null;
};
function zB(e) {
  var t = e.x, r = e.y, n = e.segment, i = e.xAxisId, a = e.yAxisId, o = e.shape, s = e.className, u = e.alwaysShow, c = OB(), l = yA(i), f = mA(a), d = AB();
  if (!c || !d)
    return null;
  Et(u === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var h = uv({
    x: l.scale,
    y: f.scale
  }), m = qe(t), v = qe(r), p = n && n.length === 2, g = FB(h, m, v, p, d, e.position, l.orientation, f.orientation, e);
  if (!g)
    return null;
  var b = IB(g, 2), w = b[0], O = w.x, y = w.y, x = b[1], _ = x.x, P = x.y, E = Lt(e, "hidden") ? "url(#".concat(c, ")") : void 0, M = Ow(Ow({
    clipPath: E
  }, Q(e, !0)), {}, {
    x1: O,
    y1: y,
    x2: _,
    y2: P
  });
  return /* @__PURE__ */ A.createElement(le, {
    className: ue("recharts-reference-line", s)
  }, BB(o, M), ze.renderCallByParent(e, lB({
    x1: O,
    y1: y,
    x2: _,
    y2: P
  })));
}
var hv = /* @__PURE__ */ function(e) {
  function t() {
    return TB(this, t), MB(this, t, arguments);
  }
  return $B(t, e), CB(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ A.createElement(zB, this.props);
    }
  }]);
}(A.Component);
pv(hv, "displayName", "ReferenceLine");
pv(hv, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function kp() {
  return kp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kp.apply(this, arguments);
}
function Vn(e) {
  "@babel/helpers - typeof";
  return Vn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Vn(e);
}
function Sw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Aw(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Sw(Object(r), !0).forEach(function(n) {
      ru(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Sw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function WB(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function UB(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, wA(n.key), n);
  }
}
function GB(e, t, r) {
  return t && UB(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function HB(e, t, r) {
  return t = fs(t), VB(e, xA() ? Reflect.construct(t, r || [], fs(e).constructor) : t.apply(e, r));
}
function VB(e, t) {
  if (t && (Vn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return KB(e);
}
function KB(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function xA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (xA = function() {
    return !!e;
  })();
}
function fs(e) {
  return fs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, fs(e);
}
function YB(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && $p(e, t);
}
function $p(e, t) {
  return $p = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, $p(e, t);
}
function ru(e, t, r) {
  return t = wA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function wA(e) {
  var t = XB(e, "string");
  return Vn(t) == "symbol" ? t : t + "";
}
function XB(e, t) {
  if (Vn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Vn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var ZB = function(t) {
  var r = t.x, n = t.y, i = t.xAxis, a = t.yAxis, o = uv({
    x: i.scale,
    y: a.scale
  }), s = o.apply({
    x: r,
    y: n
  }, {
    bandAware: !0
  });
  return Lt(t, "discard") && !o.isInRange(s) ? null : s;
}, nu = /* @__PURE__ */ function(e) {
  function t() {
    return WB(this, t), HB(this, t, arguments);
  }
  return YB(t, e), GB(t, [{
    key: "render",
    value: function() {
      var n = this.props, i = n.x, a = n.y, o = n.r, s = n.alwaysShow, u = n.clipPathId, c = qe(i), l = qe(a);
      if (Et(s === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !c || !l)
        return null;
      var f = ZB(this.props);
      if (!f)
        return null;
      var d = f.x, h = f.y, m = this.props, v = m.shape, p = m.className, g = Lt(this.props, "hidden") ? "url(#".concat(u, ")") : void 0, b = Aw(Aw({
        clipPath: g
      }, Q(this.props, !0)), {}, {
        cx: d,
        cy: h
      });
      return /* @__PURE__ */ A.createElement(le, {
        className: ue("recharts-reference-dot", p)
      }, t.renderDot(v, b), ze.renderCallByParent(this.props, {
        x: d - o,
        y: h - o,
        width: 2 * o,
        height: 2 * o
      }));
    }
  }]);
}(A.Component);
ru(nu, "displayName", "ReferenceDot");
ru(nu, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
ru(nu, "renderDot", function(e, t) {
  var r;
  return /* @__PURE__ */ A.isValidElement(e) ? r = /* @__PURE__ */ A.cloneElement(e, t) : ie(e) ? r = e(t) : r = /* @__PURE__ */ A.createElement(Ra, kp({}, t, {
    cx: t.cx,
    cy: t.cy,
    className: "recharts-reference-dot-dot"
  })), r;
});
function Np() {
  return Np = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Np.apply(this, arguments);
}
function Kn(e) {
  "@babel/helpers - typeof";
  return Kn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Kn(e);
}
function Pw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Tw(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Pw(Object(r), !0).forEach(function(n) {
      iu(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Pw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function JB(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function QB(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, _A(n.key), n);
  }
}
function eF(e, t, r) {
  return t && QB(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function tF(e, t, r) {
  return t = ds(t), rF(e, OA() ? Reflect.construct(t, r || [], ds(e).constructor) : t.apply(e, r));
}
function rF(e, t) {
  if (t && (Kn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return nF(e);
}
function nF(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function OA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (OA = function() {
    return !!e;
  })();
}
function ds(e) {
  return ds = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ds(e);
}
function iF(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ip(e, t);
}
function Ip(e, t) {
  return Ip = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Ip(e, t);
}
function iu(e, t, r) {
  return t = _A(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function _A(e) {
  var t = aF(e, "string");
  return Kn(t) == "symbol" ? t : t + "";
}
function aF(e, t) {
  if (Kn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Kn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var oF = function(t, r, n, i, a) {
  var o = a.x1, s = a.x2, u = a.y1, c = a.y2, l = a.xAxis, f = a.yAxis;
  if (!l || !f) return null;
  var d = uv({
    x: l.scale,
    y: f.scale
  }), h = {
    x: t ? d.x.apply(o, {
      position: "start"
    }) : d.x.rangeMin,
    y: n ? d.y.apply(u, {
      position: "start"
    }) : d.y.rangeMin
  }, m = {
    x: r ? d.x.apply(s, {
      position: "end"
    }) : d.x.rangeMax,
    y: i ? d.y.apply(c, {
      position: "end"
    }) : d.y.rangeMax
  };
  return Lt(a, "discard") && (!d.isInRange(h) || !d.isInRange(m)) ? null : uA(h, m);
}, au = /* @__PURE__ */ function(e) {
  function t() {
    return JB(this, t), tF(this, t, arguments);
  }
  return iF(t, e), eF(t, [{
    key: "render",
    value: function() {
      var n = this.props, i = n.x1, a = n.x2, o = n.y1, s = n.y2, u = n.className, c = n.alwaysShow, l = n.clipPathId;
      Et(c === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var f = qe(i), d = qe(a), h = qe(o), m = qe(s), v = this.props.shape;
      if (!f && !d && !h && !m && !v)
        return null;
      var p = oF(f, d, h, m, this.props);
      if (!p && !v)
        return null;
      var g = Lt(this.props, "hidden") ? "url(#".concat(l, ")") : void 0;
      return /* @__PURE__ */ A.createElement(le, {
        className: ue("recharts-reference-area", u)
      }, t.renderRect(v, Tw(Tw({
        clipPath: g
      }, Q(this.props, !0)), p)), ze.renderCallByParent(this.props, p));
    }
  }]);
}(A.Component);
iu(au, "displayName", "ReferenceArea");
iu(au, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
iu(au, "renderRect", function(e, t) {
  var r;
  return /* @__PURE__ */ A.isValidElement(e) ? r = /* @__PURE__ */ A.cloneElement(e, t) : ie(e) ? r = e(t) : r = /* @__PURE__ */ A.createElement(ov, Np({}, t, {
    className: "recharts-reference-area-rect"
  })), r;
});
function SA(e, t, r) {
  if (t < 1)
    return [];
  if (t === 1 && r === void 0)
    return e;
  for (var n = [], i = 0; i < e.length; i += t)
    n.push(e[i]);
  return n;
}
function sF(e, t, r) {
  var n = {
    width: e.width + t.width,
    height: e.height + t.height
  };
  return dB(n, r);
}
function uF(e, t, r) {
  var n = r === "width", i = e.x, a = e.y, o = e.width, s = e.height;
  return t === 1 ? {
    start: n ? i : a,
    end: n ? i + o : a + s
  } : {
    start: n ? i + o : a + s,
    end: n ? i : a
  };
}
function ps(e, t, r, n, i) {
  if (e * t < e * n || e * t > e * i)
    return !1;
  var a = r();
  return e * (t - e * a / 2 - n) >= 0 && e * (t + e * a / 2 - i) <= 0;
}
function cF(e, t) {
  return SA(e, t + 1);
}
function lF(e, t, r, n, i) {
  for (var a = (n || []).slice(), o = t.start, s = t.end, u = 0, c = 1, l = o, f = function() {
    var m = n?.[u];
    if (m === void 0)
      return {
        v: SA(n, c)
      };
    var v = u, p, g = function() {
      return p === void 0 && (p = r(m, v)), p;
    }, b = m.coordinate, w = u === 0 || ps(e, b, g, l, s);
    w || (u = 0, l = o, c += 1), w && (l = b + e * (g() / 2 + i), u += c);
  }, d; c <= a.length; )
    if (d = f(), d) return d.v;
  return [];
}
function Oa(e) {
  "@babel/helpers - typeof";
  return Oa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Oa(e);
}
function Ew(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function He(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ew(Object(r), !0).forEach(function(n) {
      fF(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ew(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function fF(e, t, r) {
  return t = dF(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function dF(e) {
  var t = pF(e, "string");
  return Oa(t) == "symbol" ? t : t + "";
}
function pF(e, t) {
  if (Oa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Oa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function hF(e, t, r, n, i) {
  for (var a = (n || []).slice(), o = a.length, s = t.start, u = t.end, c = function(d) {
    var h = a[d], m, v = function() {
      return m === void 0 && (m = r(h, d)), m;
    };
    if (d === o - 1) {
      var p = e * (h.coordinate + e * v() / 2 - u);
      a[d] = h = He(He({}, h), {}, {
        tickCoord: p > 0 ? h.coordinate - p * e : h.coordinate
      });
    } else
      a[d] = h = He(He({}, h), {}, {
        tickCoord: h.coordinate
      });
    var g = ps(e, h.tickCoord, v, s, u);
    g && (u = h.tickCoord - e * (v() / 2 + i), a[d] = He(He({}, h), {}, {
      isShow: !0
    }));
  }, l = o - 1; l >= 0; l--)
    c(l);
  return a;
}
function vF(e, t, r, n, i, a) {
  var o = (n || []).slice(), s = o.length, u = t.start, c = t.end;
  if (a) {
    var l = n[s - 1], f = r(l, s - 1), d = e * (l.coordinate + e * f / 2 - c);
    o[s - 1] = l = He(He({}, l), {}, {
      tickCoord: d > 0 ? l.coordinate - d * e : l.coordinate
    });
    var h = ps(e, l.tickCoord, function() {
      return f;
    }, u, c);
    h && (c = l.tickCoord - e * (f / 2 + i), o[s - 1] = He(He({}, l), {}, {
      isShow: !0
    }));
  }
  for (var m = a ? s - 1 : s, v = function(b) {
    var w = o[b], O, y = function() {
      return O === void 0 && (O = r(w, b)), O;
    };
    if (b === 0) {
      var x = e * (w.coordinate - e * y() / 2 - u);
      o[b] = w = He(He({}, w), {}, {
        tickCoord: x < 0 ? w.coordinate - x * e : w.coordinate
      });
    } else
      o[b] = w = He(He({}, w), {}, {
        tickCoord: w.coordinate
      });
    var _ = ps(e, w.tickCoord, y, u, c);
    _ && (u = w.tickCoord + e * (y() / 2 + i), o[b] = He(He({}, w), {}, {
      isShow: !0
    }));
  }, p = 0; p < m; p++)
    v(p);
  return o;
}
function vv(e, t, r) {
  var n = e.tick, i = e.ticks, a = e.viewBox, o = e.minTickGap, s = e.orientation, u = e.interval, c = e.tickFormatter, l = e.unit, f = e.angle;
  if (!i || !i.length || !n)
    return [];
  if (U(u) || wr.isSsr)
    return cF(i, typeof u == "number" && U(u) ? u : 0);
  var d = [], h = s === "top" || s === "bottom" ? "width" : "height", m = l && h === "width" ? Ni(l, {
    fontSize: t,
    letterSpacing: r
  }) : {
    width: 0,
    height: 0
  }, v = function(w, O) {
    var y = ie(c) ? c(w.value, O) : w.value;
    return h === "width" ? sF(Ni(y, {
      fontSize: t,
      letterSpacing: r
    }), m, f) : Ni(y, {
      fontSize: t,
      letterSpacing: r
    })[h];
  }, p = i.length >= 2 ? Ye(i[1].coordinate - i[0].coordinate) : 1, g = uF(a, p, h);
  return u === "equidistantPreserveStart" ? lF(p, g, v, i, o) : (u === "preserveStart" || u === "preserveStartEnd" ? d = vF(p, g, v, i, o, u === "preserveStartEnd") : d = hF(p, g, v, i, o), d.filter(function(b) {
    return b.isShow;
  }));
}
var yF = ["viewBox"], mF = ["viewBox"], gF = ["ticks"];
function Yn(e) {
  "@babel/helpers - typeof";
  return Yn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Yn(e);
}
function mn() {
  return mn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mn.apply(this, arguments);
}
function Cw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ie(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Cw(Object(r), !0).forEach(function(n) {
      yv(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Cw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function yd(e, t) {
  if (e == null) return {};
  var r = bF(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function bF(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function xF(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Mw(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, PA(n.key), n);
  }
}
function wF(e, t, r) {
  return t && Mw(e.prototype, t), r && Mw(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function OF(e, t, r) {
  return t = hs(t), _F(e, AA() ? Reflect.construct(t, r || [], hs(e).constructor) : t.apply(e, r));
}
function _F(e, t) {
  if (t && (Yn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return SF(e);
}
function SF(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function AA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (AA = function() {
    return !!e;
  })();
}
function hs(e) {
  return hs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, hs(e);
}
function AF(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Rp(e, t);
}
function Rp(e, t) {
  return Rp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Rp(e, t);
}
function yv(e, t, r) {
  return t = PA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function PA(e) {
  var t = PF(e, "string");
  return Yn(t) == "symbol" ? t : t + "";
}
function PF(e, t) {
  if (Yn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Yn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var fi = /* @__PURE__ */ function(e) {
  function t(r) {
    var n;
    return xF(this, t), n = OF(this, t, [r]), n.state = {
      fontSize: "",
      letterSpacing: ""
    }, n;
  }
  return AF(t, e), wF(t, [{
    key: "shouldComponentUpdate",
    value: function(n, i) {
      var a = n.viewBox, o = yd(n, yF), s = this.props, u = s.viewBox, c = yd(s, mF);
      return !wn(a, u) || !wn(o, c) || !wn(i, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var n = this.layerReference;
      if (n) {
        var i = n.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        i && this.setState({
          fontSize: window.getComputedStyle(i).fontSize,
          letterSpacing: window.getComputedStyle(i).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(n) {
      var i = this.props, a = i.x, o = i.y, s = i.width, u = i.height, c = i.orientation, l = i.tickSize, f = i.mirror, d = i.tickMargin, h, m, v, p, g, b, w = f ? -1 : 1, O = n.tickSize || l, y = U(n.tickCoord) ? n.tickCoord : n.coordinate;
      switch (c) {
        case "top":
          h = m = n.coordinate, p = o + +!f * u, v = p - w * O, b = v - w * d, g = y;
          break;
        case "left":
          v = p = n.coordinate, m = a + +!f * s, h = m - w * O, g = h - w * d, b = y;
          break;
        case "right":
          v = p = n.coordinate, m = a + +f * s, h = m + w * O, g = h + w * d, b = y;
          break;
        default:
          h = m = n.coordinate, p = o + +f * u, v = p + w * O, b = v + w * d, g = y;
          break;
      }
      return {
        line: {
          x1: h,
          y1: v,
          x2: m,
          y2: p
        },
        tick: {
          x: g,
          y: b
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props, i = n.orientation, a = n.mirror, o;
      switch (i) {
        case "left":
          o = a ? "start" : "end";
          break;
        case "right":
          o = a ? "end" : "start";
          break;
        default:
          o = "middle";
          break;
      }
      return o;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var n = this.props, i = n.orientation, a = n.mirror, o = "end";
      switch (i) {
        case "left":
        case "right":
          o = "middle";
          break;
        case "top":
          o = a ? "start" : "end";
          break;
        default:
          o = a ? "end" : "start";
          break;
      }
      return o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, i = n.x, a = n.y, o = n.width, s = n.height, u = n.orientation, c = n.mirror, l = n.axisLine, f = Ie(Ie(Ie({}, Q(this.props, !1)), Q(l, !1)), {}, {
        fill: "none"
      });
      if (u === "top" || u === "bottom") {
        var d = +(u === "top" && !c || u === "bottom" && c);
        f = Ie(Ie({}, f), {}, {
          x1: i,
          y1: a + d * s,
          x2: i + o,
          y2: a + d * s
        });
      } else {
        var h = +(u === "left" && !c || u === "right" && c);
        f = Ie(Ie({}, f), {}, {
          x1: i + h * o,
          y1: a,
          x2: i + h * o,
          y2: a + s
        });
      }
      return /* @__PURE__ */ A.createElement("line", mn({}, f, {
        className: ue("recharts-cartesian-axis-line", ut(l, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(n, i, a) {
        var o = this, s = this.props, u = s.tickLine, c = s.stroke, l = s.tick, f = s.tickFormatter, d = s.unit, h = vv(Ie(Ie({}, this.props), {}, {
          ticks: n
        }), i, a), m = this.getTickTextAnchor(), v = this.getTickVerticalAnchor(), p = Q(this.props, !1), g = Q(l, !1), b = Ie(Ie({}, p), {}, {
          fill: "none"
        }, Q(u, !1)), w = h.map(function(O, y) {
          var x = o.getTickLineCoord(O), _ = x.line, P = x.tick, E = Ie(Ie(Ie(Ie({
            textAnchor: m,
            verticalAnchor: v
          }, p), {}, {
            stroke: "none",
            fill: c
          }, g), P), {}, {
            index: y,
            payload: O,
            visibleTicksCount: h.length,
            tickFormatter: f
          });
          return /* @__PURE__ */ A.createElement(le, mn({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(O.value, "-").concat(O.coordinate, "-").concat(O.tickCoord)
          }, Vr(o.props, O, y)), u && /* @__PURE__ */ A.createElement("line", mn({}, b, _, {
            className: ue("recharts-cartesian-axis-tick-line", ut(u, "className"))
          })), l && t.renderTickItem(l, E, "".concat(ie(f) ? f(O.value, y) : O.value).concat(d || "")));
        });
        return /* @__PURE__ */ A.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, w);
      }
    )
  }, {
    key: "render",
    value: function() {
      var n = this, i = this.props, a = i.axisLine, o = i.width, s = i.height, u = i.ticksGenerator, c = i.className, l = i.hide;
      if (l)
        return null;
      var f = this.props, d = f.ticks, h = yd(f, gF), m = d;
      return ie(u) && (m = d && d.length > 0 ? u(this.props) : u(h)), o <= 0 || s <= 0 || !m || !m.length ? null : /* @__PURE__ */ A.createElement(le, {
        className: ue("recharts-cartesian-axis", c),
        ref: function(p) {
          n.layerReference = p;
        }
      }, a && this.renderAxisLine(), this.renderTicks(m, this.state.fontSize, this.state.letterSpacing), ze.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, i, a) {
      var o, s = ue(i.className, "recharts-cartesian-axis-tick-value");
      return /* @__PURE__ */ A.isValidElement(n) ? o = /* @__PURE__ */ A.cloneElement(n, Ie(Ie({}, i), {}, {
        className: s
      })) : ie(n) ? o = n(Ie(Ie({}, i), {}, {
        className: s
      })) : o = /* @__PURE__ */ A.createElement(Kr, mn({}, i, {
        className: "recharts-cartesian-axis-tick-value"
      }), a), o;
    }
  }]);
}(Zw);
yv(fi, "displayName", "CartesianAxis");
yv(fi, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var TF = ["x1", "y1", "x2", "y2", "key"], EF = ["offset"];
function Zr(e) {
  "@babel/helpers - typeof";
  return Zr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zr(e);
}
function jw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ke(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jw(Object(r), !0).forEach(function(n) {
      CF(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : jw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function CF(e, t, r) {
  return t = MF(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function MF(e) {
  var t = jF(e, "string");
  return Zr(t) == "symbol" ? t : t + "";
}
function jF(e, t) {
  if (Zr(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Zr(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Lr() {
  return Lr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Lr.apply(this, arguments);
}
function kw(e, t) {
  if (e == null) return {};
  var r = kF(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function kF(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var $F = function(t) {
  var r = t.fill;
  if (!r || r === "none")
    return null;
  var n = t.fillOpacity, i = t.x, a = t.y, o = t.width, s = t.height, u = t.ry;
  return /* @__PURE__ */ A.createElement("rect", {
    x: i,
    y: a,
    ry: u,
    width: o,
    height: s,
    stroke: "none",
    fill: r,
    fillOpacity: n,
    className: "recharts-cartesian-grid-bg"
  });
};
function TA(e, t) {
  var r;
  if (/* @__PURE__ */ A.isValidElement(e))
    r = /* @__PURE__ */ A.cloneElement(e, t);
  else if (ie(e))
    r = e(t);
  else {
    var n = t.x1, i = t.y1, a = t.x2, o = t.y2, s = t.key, u = kw(t, TF), c = Q(u, !1);
    c.offset;
    var l = kw(c, EF);
    r = /* @__PURE__ */ A.createElement("line", Lr({}, l, {
      x1: n,
      y1: i,
      x2: a,
      y2: o,
      fill: "none",
      key: s
    }));
  }
  return r;
}
function NF(e) {
  var t = e.x, r = e.width, n = e.horizontal, i = n === void 0 ? !0 : n, a = e.horizontalPoints;
  if (!i || !a || !a.length)
    return null;
  var o = a.map(function(s, u) {
    var c = Ke(Ke({}, e), {}, {
      x1: t,
      y1: s,
      x2: t + r,
      y2: s,
      key: "line-".concat(u),
      index: u
    });
    return TA(i, c);
  });
  return /* @__PURE__ */ A.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, o);
}
function IF(e) {
  var t = e.y, r = e.height, n = e.vertical, i = n === void 0 ? !0 : n, a = e.verticalPoints;
  if (!i || !a || !a.length)
    return null;
  var o = a.map(function(s, u) {
    var c = Ke(Ke({}, e), {}, {
      x1: s,
      y1: t,
      x2: s,
      y2: t + r,
      key: "line-".concat(u),
      index: u
    });
    return TA(i, c);
  });
  return /* @__PURE__ */ A.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, o);
}
function RF(e) {
  var t = e.horizontalFill, r = e.fillOpacity, n = e.x, i = e.y, a = e.width, o = e.height, s = e.horizontalPoints, u = e.horizontal, c = u === void 0 ? !0 : u;
  if (!c || !t || !t.length)
    return null;
  var l = s.map(function(d) {
    return Math.round(d + i - i);
  }).sort(function(d, h) {
    return d - h;
  });
  i !== l[0] && l.unshift(0);
  var f = l.map(function(d, h) {
    var m = !l[h + 1], v = m ? i + o - d : l[h + 1] - d;
    if (v <= 0)
      return null;
    var p = h % t.length;
    return /* @__PURE__ */ A.createElement("rect", {
      key: "react-".concat(h),
      y: d,
      x: n,
      height: v,
      width: a,
      stroke: "none",
      fill: t[p],
      fillOpacity: r,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ A.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, f);
}
function DF(e) {
  var t = e.vertical, r = t === void 0 ? !0 : t, n = e.verticalFill, i = e.fillOpacity, a = e.x, o = e.y, s = e.width, u = e.height, c = e.verticalPoints;
  if (!r || !n || !n.length)
    return null;
  var l = c.map(function(d) {
    return Math.round(d + a - a);
  }).sort(function(d, h) {
    return d - h;
  });
  a !== l[0] && l.unshift(0);
  var f = l.map(function(d, h) {
    var m = !l[h + 1], v = m ? a + s - d : l[h + 1] - d;
    if (v <= 0)
      return null;
    var p = h % n.length;
    return /* @__PURE__ */ A.createElement("rect", {
      key: "react-".concat(h),
      x: d,
      y: o,
      width: v,
      height: u,
      stroke: "none",
      fill: n[p],
      fillOpacity: i,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ A.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, f);
}
var LF = function(t, r) {
  var n = t.xAxis, i = t.width, a = t.height, o = t.offset;
  return AS(vv(Ke(Ke(Ke({}, fi.defaultProps), n), {}, {
    ticks: Zt(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: i,
      height: a
    }
  })), o.left, o.left + o.width, r);
}, qF = function(t, r) {
  var n = t.yAxis, i = t.width, a = t.height, o = t.offset;
  return AS(vv(Ke(Ke(Ke({}, fi.defaultProps), n), {}, {
    ticks: Zt(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: i,
      height: a
    }
  })), o.top, o.top + o.height, r);
}, dn = {
  horizontal: !0,
  vertical: !0,
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function sn(e) {
  var t, r, n, i, a, o, s = fv(), u = dv(), c = PB(), l = Ke(Ke({}, e), {}, {
    stroke: (t = e.stroke) !== null && t !== void 0 ? t : dn.stroke,
    fill: (r = e.fill) !== null && r !== void 0 ? r : dn.fill,
    horizontal: (n = e.horizontal) !== null && n !== void 0 ? n : dn.horizontal,
    horizontalFill: (i = e.horizontalFill) !== null && i !== void 0 ? i : dn.horizontalFill,
    vertical: (a = e.vertical) !== null && a !== void 0 ? a : dn.vertical,
    verticalFill: (o = e.verticalFill) !== null && o !== void 0 ? o : dn.verticalFill,
    x: U(e.x) ? e.x : c.left,
    y: U(e.y) ? e.y : c.top,
    width: U(e.width) ? e.width : c.width,
    height: U(e.height) ? e.height : c.height
  }), f = l.x, d = l.y, h = l.width, m = l.height, v = l.syncWithTicks, p = l.horizontalValues, g = l.verticalValues, b = _B(), w = SB();
  if (!U(h) || h <= 0 || !U(m) || m <= 0 || !U(f) || f !== +f || !U(d) || d !== +d)
    return null;
  var O = l.verticalCoordinatesGenerator || LF, y = l.horizontalCoordinatesGenerator || qF, x = l.horizontalPoints, _ = l.verticalPoints;
  if ((!x || !x.length) && ie(y)) {
    var P = p && p.length, E = y({
      yAxis: w ? Ke(Ke({}, w), {}, {
        ticks: P ? p : w.ticks
      }) : void 0,
      width: s,
      height: u,
      offset: c
    }, P ? !0 : v);
    Et(Array.isArray(E), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(Zr(E), "]")), Array.isArray(E) && (x = E);
  }
  if ((!_ || !_.length) && ie(O)) {
    var M = g && g.length, C = O({
      xAxis: b ? Ke(Ke({}, b), {}, {
        ticks: M ? g : b.ticks
      }) : void 0,
      width: s,
      height: u,
      offset: c
    }, M ? !0 : v);
    Et(Array.isArray(C), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(Zr(C), "]")), Array.isArray(C) && (_ = C);
  }
  return /* @__PURE__ */ A.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ A.createElement($F, {
    fill: l.fill,
    fillOpacity: l.fillOpacity,
    x: l.x,
    y: l.y,
    width: l.width,
    height: l.height,
    ry: l.ry
  }), /* @__PURE__ */ A.createElement(NF, Lr({}, l, {
    offset: c,
    horizontalPoints: x,
    xAxis: b,
    yAxis: w
  })), /* @__PURE__ */ A.createElement(IF, Lr({}, l, {
    offset: c,
    verticalPoints: _,
    xAxis: b,
    yAxis: w
  })), /* @__PURE__ */ A.createElement(RF, Lr({}, l, {
    horizontalPoints: x
  })), /* @__PURE__ */ A.createElement(DF, Lr({}, l, {
    verticalPoints: _
  })));
}
sn.displayName = "CartesianGrid";
var BF = ["type", "layout", "connectNulls", "ref"], FF = ["key"];
function Xn(e) {
  "@babel/helpers - typeof";
  return Xn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xn(e);
}
function $w(e, t) {
  if (e == null) return {};
  var r = zF(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function zF(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Bi() {
  return Bi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bi.apply(this, arguments);
}
function Nw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function it(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Nw(Object(r), !0).forEach(function(n) {
      St(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Nw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function pn(e) {
  return HF(e) || GF(e) || UF(e) || WF();
}
function WF() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function UF(e, t) {
  if (e) {
    if (typeof e == "string") return Dp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Dp(e, t);
  }
}
function GF(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function HF(e) {
  if (Array.isArray(e)) return Dp(e);
}
function Dp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function VF(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Iw(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, CA(n.key), n);
  }
}
function KF(e, t, r) {
  return t && Iw(e.prototype, t), r && Iw(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function YF(e, t, r) {
  return t = vs(t), XF(e, EA() ? Reflect.construct(t, r || [], vs(e).constructor) : t.apply(e, r));
}
function XF(e, t) {
  if (t && (Xn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ZF(e);
}
function ZF(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function EA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (EA = function() {
    return !!e;
  })();
}
function vs(e) {
  return vs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, vs(e);
}
function JF(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Lp(e, t);
}
function Lp(e, t) {
  return Lp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Lp(e, t);
}
function St(e, t, r) {
  return t = CA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function CA(e) {
  var t = QF(e, "string");
  return Xn(t) == "symbol" ? t : t + "";
}
function QF(e, t) {
  if (Xn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Xn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var di = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    VF(this, t);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = YF(this, t, [].concat(i)), St(r, "state", {
      isAnimationFinished: !0,
      totalLength: 0
    }), St(r, "generateSimpleStrokeDasharray", function(o, s) {
      return "".concat(s, "px ").concat(o - s, "px");
    }), St(r, "getStrokeDasharray", function(o, s, u) {
      var c = u.reduce(function(g, b) {
        return g + b;
      });
      if (!c)
        return r.generateSimpleStrokeDasharray(s, o);
      for (var l = Math.floor(o / c), f = o % c, d = s - o, h = [], m = 0, v = 0; m < u.length; v += u[m], ++m)
        if (v + u[m] > f) {
          h = [].concat(pn(u.slice(0, m)), [f - v]);
          break;
        }
      var p = h.length % 2 === 0 ? [0, d] : [d];
      return [].concat(pn(t.repeat(u, l)), pn(h), p).map(function(g) {
        return "".concat(g, "px");
      }).join(", ");
    }), St(r, "id", tn("recharts-line-")), St(r, "pathRef", function(o) {
      r.mainCurve = o;
    }), St(r, "handleAnimationEnd", function() {
      r.setState({
        isAnimationFinished: !0
      }), r.props.onAnimationEnd && r.props.onAnimationEnd();
    }), St(r, "handleAnimationStart", function() {
      r.setState({
        isAnimationFinished: !1
      }), r.props.onAnimationStart && r.props.onAnimationStart();
    }), r;
  }
  return JF(t, e), KF(t, [{
    key: "componentDidMount",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        n !== this.state.totalLength && this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "getTotalLength",
    value: function() {
      var n = this.mainCurve;
      try {
        return n && n.getTotalLength && n.getTotalLength() || 0;
      } catch {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function(n, i) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var a = this.props, o = a.points, s = a.xAxis, u = a.yAxis, c = a.layout, l = a.children, f = ct(l, Ia);
      if (!f)
        return null;
      var d = function(v, p) {
        return {
          x: v.x,
          y: v.y,
          value: v.value,
          errorVal: ke(v.payload, p)
        };
      }, h = {
        clipPath: n ? "url(#clipPath-".concat(i, ")") : null
      };
      return /* @__PURE__ */ A.createElement(le, h, f.map(function(m) {
        return /* @__PURE__ */ A.cloneElement(m, {
          key: "bar-".concat(m.props.dataKey),
          data: o,
          xAxis: s,
          yAxis: u,
          layout: c,
          dataPointFormatter: d
        });
      }));
    }
  }, {
    key: "renderDots",
    value: function(n, i, a) {
      var o = this.props.isAnimationActive;
      if (o && !this.state.isAnimationFinished)
        return null;
      var s = this.props, u = s.dot, c = s.points, l = s.dataKey, f = Q(this.props, !1), d = Q(u, !0), h = c.map(function(v, p) {
        var g = it(it(it({
          key: "dot-".concat(p),
          r: 3
        }, f), d), {}, {
          index: p,
          cx: v.x,
          cy: v.y,
          value: v.value,
          dataKey: l,
          payload: v.payload,
          points: c
        });
        return t.renderDotItem(u, g);
      }), m = {
        clipPath: n ? "url(#clipPath-".concat(i ? "" : "dots-").concat(a, ")") : null
      };
      return /* @__PURE__ */ A.createElement(le, Bi({
        className: "recharts-line-dots",
        key: "dots"
      }, m), h);
    }
  }, {
    key: "renderCurveStatically",
    value: function(n, i, a, o) {
      var s = this.props, u = s.type, c = s.layout, l = s.connectNulls;
      s.ref;
      var f = $w(s, BF), d = it(it(it({}, Q(f, !0)), {}, {
        fill: "none",
        className: "recharts-line-curve",
        clipPath: i ? "url(#clipPath-".concat(a, ")") : null,
        points: n
      }, o), {}, {
        type: u,
        layout: c,
        connectNulls: l
      });
      return /* @__PURE__ */ A.createElement(Ur, Bi({}, d, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function(n, i) {
      var a = this, o = this.props, s = o.points, u = o.strokeDasharray, c = o.isAnimationActive, l = o.animationBegin, f = o.animationDuration, d = o.animationEasing, h = o.animationId, m = o.animateNewValues, v = o.width, p = o.height, g = this.state, b = g.prevPoints, w = g.totalLength;
      return /* @__PURE__ */ A.createElement(Mt, {
        begin: l,
        duration: f,
        isActive: c,
        easing: d,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(h),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(O) {
        var y = O.t;
        if (b) {
          var x = b.length / s.length, _ = s.map(function(T, k) {
            var $ = Math.floor(k * x);
            if (b[$]) {
              var I = b[$], R = Le(I.x, T.x), q = Le(I.y, T.y);
              return it(it({}, T), {}, {
                x: R(y),
                y: q(y)
              });
            }
            if (m) {
              var W = Le(v * 2, T.x), H = Le(p / 2, T.y);
              return it(it({}, T), {}, {
                x: W(y),
                y: H(y)
              });
            }
            return it(it({}, T), {}, {
              x: T.x,
              y: T.y
            });
          });
          return a.renderCurveStatically(_, n, i);
        }
        var P = Le(0, w), E = P(y), M;
        if (u) {
          var C = "".concat(u).split(/[,\s]+/gim).map(function(T) {
            return parseFloat(T);
          });
          M = a.getStrokeDasharray(E, w, C);
        } else
          M = a.generateSimpleStrokeDasharray(w, E);
        return a.renderCurveStatically(s, n, i, {
          strokeDasharray: M
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function(n, i) {
      var a = this.props, o = a.points, s = a.isAnimationActive, u = this.state, c = u.prevPoints, l = u.totalLength;
      return s && o && o.length && (!c && l > 0 || !Yr(c, o)) ? this.renderCurveWithAnimation(n, i) : this.renderCurveStatically(o, n, i);
    }
  }, {
    key: "render",
    value: function() {
      var n, i = this.props, a = i.hide, o = i.dot, s = i.points, u = i.className, c = i.xAxis, l = i.yAxis, f = i.top, d = i.left, h = i.width, m = i.height, v = i.isAnimationActive, p = i.id;
      if (a || !s || !s.length)
        return null;
      var g = this.state.isAnimationFinished, b = s.length === 1, w = ue("recharts-line", u), O = c && c.allowDataOverflow, y = l && l.allowDataOverflow, x = O || y, _ = se(p) ? this.id : p, P = (n = Q(o, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, E = P.r, M = E === void 0 ? 3 : E, C = P.strokeWidth, T = C === void 0 ? 2 : C, k = EO(o) ? o : {}, $ = k.clipDot, I = $ === void 0 ? !0 : $, R = M * 2 + T;
      return /* @__PURE__ */ A.createElement(le, {
        className: w
      }, O || y ? /* @__PURE__ */ A.createElement("defs", null, /* @__PURE__ */ A.createElement("clipPath", {
        id: "clipPath-".concat(_)
      }, /* @__PURE__ */ A.createElement("rect", {
        x: O ? d : d - h / 2,
        y: y ? f : f - m / 2,
        width: O ? h : h * 2,
        height: y ? m : m * 2
      })), !I && /* @__PURE__ */ A.createElement("clipPath", {
        id: "clipPath-dots-".concat(_)
      }, /* @__PURE__ */ A.createElement("rect", {
        x: d - R / 2,
        y: f - R / 2,
        width: h + R,
        height: m + R
      }))) : null, !b && this.renderCurve(x, _), this.renderErrorBar(x, _), (b || o) && this.renderDots(x, I, _), (!v || g) && Dt.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, i) {
      return n.animationId !== i.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        prevPoints: i.curPoints
      } : n.points !== i.curPoints ? {
        curPoints: n.points
      } : null;
    }
  }, {
    key: "repeat",
    value: function(n, i) {
      for (var a = n.length % 2 !== 0 ? [].concat(pn(n), [0]) : n, o = [], s = 0; s < i; ++s)
        o = [].concat(pn(o), pn(a));
      return o;
    }
  }, {
    key: "renderDotItem",
    value: function(n, i) {
      var a;
      if (/* @__PURE__ */ A.isValidElement(n))
        a = /* @__PURE__ */ A.cloneElement(n, i);
      else if (ie(n))
        a = n(i);
      else {
        var o = i.key, s = $w(i, FF), u = ue("recharts-line-dot", typeof n != "boolean" ? n.className : "");
        a = /* @__PURE__ */ A.createElement(Ra, Bi({
          key: o
        }, s, {
          className: u
        }));
      }
      return a;
    }
  }]);
}(bt);
St(di, "displayName", "Line");
St(di, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: !1,
  activeDot: !0,
  dot: !0,
  legendType: "line",
  stroke: "#3182bd",
  strokeWidth: 1,
  fill: "#fff",
  points: [],
  isAnimationActive: !wr.isSsr,
  animateNewValues: !0,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease",
  hide: !1,
  label: !1
});
St(di, "getComposedData", function(e) {
  var t = e.props, r = e.xAxis, n = e.yAxis, i = e.xAxisTicks, a = e.yAxisTicks, o = e.dataKey, s = e.bandSize, u = e.displayedData, c = e.offset, l = t.layout, f = u.map(function(d, h) {
    var m = ke(d, o);
    return l === "horizontal" ? {
      x: Wo({
        axis: r,
        ticks: i,
        bandSize: s,
        entry: d,
        index: h
      }),
      y: se(m) ? null : n.scale(m),
      value: m,
      payload: d
    } : {
      x: se(m) ? null : r.scale(m),
      y: Wo({
        axis: n,
        ticks: a,
        bandSize: s,
        entry: d,
        index: h
      }),
      value: m,
      payload: d
    };
  });
  return it({
    points: f,
    layout: l
  }, c);
});
var e8 = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"], t8 = ["key"], MA;
function Zn(e) {
  "@babel/helpers - typeof";
  return Zn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zn(e);
}
function jA(e, t) {
  if (e == null) return {};
  var r = r8(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function r8(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function qr() {
  return qr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qr.apply(this, arguments);
}
function Rw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function pr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Rw(Object(r), !0).forEach(function(n) {
      It(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Rw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function n8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Dw(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $A(n.key), n);
  }
}
function i8(e, t, r) {
  return t && Dw(e.prototype, t), r && Dw(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function a8(e, t, r) {
  return t = ys(t), o8(e, kA() ? Reflect.construct(t, r || [], ys(e).constructor) : t.apply(e, r));
}
function o8(e, t) {
  if (t && (Zn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return s8(e);
}
function s8(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function kA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (kA = function() {
    return !!e;
  })();
}
function ys(e) {
  return ys = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ys(e);
}
function u8(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && qp(e, t);
}
function qp(e, t) {
  return qp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, qp(e, t);
}
function It(e, t, r) {
  return t = $A(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function $A(e) {
  var t = c8(e, "string");
  return Zn(t) == "symbol" ? t : t + "";
}
function c8(e, t) {
  if (Zn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Zn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var ur = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    n8(this, t);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = a8(this, t, [].concat(i)), It(r, "state", {
      isAnimationFinished: !0
    }), It(r, "id", tn("recharts-area-")), It(r, "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), ie(o) && o();
    }), It(r, "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), ie(o) && o();
    }), r;
  }
  return u8(t, e), i8(t, [{
    key: "renderDots",
    value: function(n, i, a) {
      var o = this.props.isAnimationActive, s = this.state.isAnimationFinished;
      if (o && !s)
        return null;
      var u = this.props, c = u.dot, l = u.points, f = u.dataKey, d = Q(this.props, !1), h = Q(c, !0), m = l.map(function(p, g) {
        var b = pr(pr(pr({
          key: "dot-".concat(g),
          r: 3
        }, d), h), {}, {
          index: g,
          cx: p.x,
          cy: p.y,
          dataKey: f,
          value: p.value,
          payload: p.payload,
          points: l
        });
        return t.renderDotItem(c, b);
      }), v = {
        clipPath: n ? "url(#clipPath-".concat(i ? "" : "dots-").concat(a, ")") : null
      };
      return /* @__PURE__ */ A.createElement(le, qr({
        className: "recharts-area-dots"
      }, v), m);
    }
  }, {
    key: "renderHorizontalRect",
    value: function(n) {
      var i = this.props, a = i.baseLine, o = i.points, s = i.strokeWidth, u = o[0].x, c = o[o.length - 1].x, l = n * Math.abs(u - c), f = yr(o.map(function(d) {
        return d.y || 0;
      }));
      return U(a) && typeof a == "number" ? f = Math.max(a, f) : a && Array.isArray(a) && a.length && (f = Math.max(yr(a.map(function(d) {
        return d.y || 0;
      })), f)), U(f) ? /* @__PURE__ */ A.createElement("rect", {
        x: u < c ? u : u - l,
        y: 0,
        width: l,
        height: Math.floor(f + (s ? parseInt("".concat(s), 10) : 1))
      }) : null;
    }
  }, {
    key: "renderVerticalRect",
    value: function(n) {
      var i = this.props, a = i.baseLine, o = i.points, s = i.strokeWidth, u = o[0].y, c = o[o.length - 1].y, l = n * Math.abs(u - c), f = yr(o.map(function(d) {
        return d.x || 0;
      }));
      return U(a) && typeof a == "number" ? f = Math.max(a, f) : a && Array.isArray(a) && a.length && (f = Math.max(yr(a.map(function(d) {
        return d.x || 0;
      })), f)), U(f) ? /* @__PURE__ */ A.createElement("rect", {
        x: 0,
        y: u < c ? u : u - l,
        width: f + (s ? parseInt("".concat(s), 10) : 1),
        height: Math.floor(l)
      }) : null;
    }
  }, {
    key: "renderClipRect",
    value: function(n) {
      var i = this.props.layout;
      return i === "vertical" ? this.renderVerticalRect(n) : this.renderHorizontalRect(n);
    }
  }, {
    key: "renderAreaStatically",
    value: function(n, i, a, o) {
      var s = this.props, u = s.layout, c = s.type, l = s.stroke, f = s.connectNulls, d = s.isRange;
      s.ref;
      var h = jA(s, e8);
      return /* @__PURE__ */ A.createElement(le, {
        clipPath: a ? "url(#clipPath-".concat(o, ")") : null
      }, /* @__PURE__ */ A.createElement(Ur, qr({}, Q(h, !0), {
        points: n,
        connectNulls: f,
        type: c,
        baseLine: i,
        layout: u,
        stroke: "none",
        className: "recharts-area-area"
      })), l !== "none" && /* @__PURE__ */ A.createElement(Ur, qr({}, Q(this.props, !1), {
        className: "recharts-area-curve",
        layout: u,
        type: c,
        connectNulls: f,
        fill: "none",
        points: n
      })), l !== "none" && d && /* @__PURE__ */ A.createElement(Ur, qr({}, Q(this.props, !1), {
        className: "recharts-area-curve",
        layout: u,
        type: c,
        connectNulls: f,
        fill: "none",
        points: i
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function(n, i) {
      var a = this, o = this.props, s = o.points, u = o.baseLine, c = o.isAnimationActive, l = o.animationBegin, f = o.animationDuration, d = o.animationEasing, h = o.animationId, m = this.state, v = m.prevPoints, p = m.prevBaseLine;
      return /* @__PURE__ */ A.createElement(Mt, {
        begin: l,
        duration: f,
        isActive: c,
        easing: d,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(h),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(g) {
        var b = g.t;
        if (v) {
          var w = v.length / s.length, O = s.map(function(P, E) {
            var M = Math.floor(E * w);
            if (v[M]) {
              var C = v[M], T = Le(C.x, P.x), k = Le(C.y, P.y);
              return pr(pr({}, P), {}, {
                x: T(b),
                y: k(b)
              });
            }
            return P;
          }), y;
          if (U(u) && typeof u == "number") {
            var x = Le(p, u);
            y = x(b);
          } else if (se(u) || oi(u)) {
            var _ = Le(p, 0);
            y = _(b);
          } else
            y = u.map(function(P, E) {
              var M = Math.floor(E * w);
              if (p[M]) {
                var C = p[M], T = Le(C.x, P.x), k = Le(C.y, P.y);
                return pr(pr({}, P), {}, {
                  x: T(b),
                  y: k(b)
                });
              }
              return P;
            });
          return a.renderAreaStatically(O, y, n, i);
        }
        return /* @__PURE__ */ A.createElement(le, null, /* @__PURE__ */ A.createElement("defs", null, /* @__PURE__ */ A.createElement("clipPath", {
          id: "animationClipPath-".concat(i)
        }, a.renderClipRect(b))), /* @__PURE__ */ A.createElement(le, {
          clipPath: "url(#animationClipPath-".concat(i, ")")
        }, a.renderAreaStatically(s, u, n, i)));
      });
    }
  }, {
    key: "renderArea",
    value: function(n, i) {
      var a = this.props, o = a.points, s = a.baseLine, u = a.isAnimationActive, c = this.state, l = c.prevPoints, f = c.prevBaseLine, d = c.totalLength;
      return u && o && o.length && (!l && d > 0 || !Yr(l, o) || !Yr(f, s)) ? this.renderAreaWithAnimation(n, i) : this.renderAreaStatically(o, s, n, i);
    }
  }, {
    key: "render",
    value: function() {
      var n, i = this.props, a = i.hide, o = i.dot, s = i.points, u = i.className, c = i.top, l = i.left, f = i.xAxis, d = i.yAxis, h = i.width, m = i.height, v = i.isAnimationActive, p = i.id;
      if (a || !s || !s.length)
        return null;
      var g = this.state.isAnimationFinished, b = s.length === 1, w = ue("recharts-area", u), O = f && f.allowDataOverflow, y = d && d.allowDataOverflow, x = O || y, _ = se(p) ? this.id : p, P = (n = Q(o, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, E = P.r, M = E === void 0 ? 3 : E, C = P.strokeWidth, T = C === void 0 ? 2 : C, k = EO(o) ? o : {}, $ = k.clipDot, I = $ === void 0 ? !0 : $, R = M * 2 + T;
      return /* @__PURE__ */ A.createElement(le, {
        className: w
      }, O || y ? /* @__PURE__ */ A.createElement("defs", null, /* @__PURE__ */ A.createElement("clipPath", {
        id: "clipPath-".concat(_)
      }, /* @__PURE__ */ A.createElement("rect", {
        x: O ? l : l - h / 2,
        y: y ? c : c - m / 2,
        width: O ? h : h * 2,
        height: y ? m : m * 2
      })), !I && /* @__PURE__ */ A.createElement("clipPath", {
        id: "clipPath-dots-".concat(_)
      }, /* @__PURE__ */ A.createElement("rect", {
        x: l - R / 2,
        y: c - R / 2,
        width: h + R,
        height: m + R
      }))) : null, b ? null : this.renderArea(x, _), (o || b) && this.renderDots(x, I, _), (!v || g) && Dt.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, i) {
      return n.animationId !== i.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        curBaseLine: n.baseLine,
        prevPoints: i.curPoints,
        prevBaseLine: i.curBaseLine
      } : n.points !== i.curPoints || n.baseLine !== i.curBaseLine ? {
        curPoints: n.points,
        curBaseLine: n.baseLine
      } : null;
    }
  }]);
}(bt);
MA = ur;
It(ur, "displayName", "Area");
It(ur, "defaultProps", {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: !1,
  // points of area
  points: [],
  dot: !1,
  activeDot: !0,
  hide: !1,
  isAnimationActive: !wr.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
It(ur, "getBaseValue", function(e, t, r, n) {
  var i = e.layout, a = e.baseValue, o = t.props.baseValue, s = o ?? a;
  if (U(s) && typeof s == "number")
    return s;
  var u = i === "horizontal" ? n : r, c = u.scale.domain();
  if (u.type === "number") {
    var l = Math.max(c[0], c[1]), f = Math.min(c[0], c[1]);
    return s === "dataMin" ? f : s === "dataMax" || l < 0 ? l : Math.max(Math.min(c[0], c[1]), 0);
  }
  return s === "dataMin" ? c[0] : s === "dataMax" ? c[1] : c[0];
});
It(ur, "getComposedData", function(e) {
  var t = e.props, r = e.item, n = e.xAxis, i = e.yAxis, a = e.xAxisTicks, o = e.yAxisTicks, s = e.bandSize, u = e.dataKey, c = e.stackedData, l = e.dataStartIndex, f = e.displayedData, d = e.offset, h = t.layout, m = c && c.length, v = MA.getBaseValue(t, r, n, i), p = h === "horizontal", g = !1, b = f.map(function(O, y) {
    var x;
    m ? x = c[l + y] : (x = ke(O, u), Array.isArray(x) ? g = !0 : x = [v, x]);
    var _ = x[1] == null || m && ke(O, u) == null;
    return p ? {
      x: Wo({
        axis: n,
        ticks: a,
        bandSize: s,
        entry: O,
        index: y
      }),
      y: _ ? null : i.scale(x[1]),
      value: x,
      payload: O
    } : {
      x: _ ? null : n.scale(x[1]),
      y: Wo({
        axis: i,
        ticks: o,
        bandSize: s,
        entry: O,
        index: y
      }),
      value: x,
      payload: O
    };
  }), w;
  return m || g ? w = b.map(function(O) {
    var y = Array.isArray(O.value) ? O.value[0] : null;
    return p ? {
      x: O.x,
      y: y != null && O.y != null ? i.scale(y) : null
    } : {
      x: y != null ? n.scale(y) : null,
      y: O.y
    };
  }) : w = p ? i.scale(v) : n.scale(v), pr({
    points: b,
    baseLine: w,
    layout: h,
    isRange: g
  }, d);
});
It(ur, "renderDotItem", function(e, t) {
  var r;
  if (/* @__PURE__ */ A.isValidElement(e))
    r = /* @__PURE__ */ A.cloneElement(e, t);
  else if (ie(e))
    r = e(t);
  else {
    var n = ue("recharts-area-dot", typeof e != "boolean" ? e.className : ""), i = t.key, a = jA(t, t8);
    r = /* @__PURE__ */ A.createElement(Ra, qr({}, a, {
      key: i,
      className: n
    }));
  }
  return r;
});
function Jn(e) {
  "@babel/helpers - typeof";
  return Jn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Jn(e);
}
function l8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function f8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, RA(n.key), n);
  }
}
function d8(e, t, r) {
  return t && f8(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function p8(e, t, r) {
  return t = ms(t), h8(e, NA() ? Reflect.construct(t, r || [], ms(e).constructor) : t.apply(e, r));
}
function h8(e, t) {
  if (t && (Jn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return v8(e);
}
function v8(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function NA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (NA = function() {
    return !!e;
  })();
}
function ms(e) {
  return ms = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ms(e);
}
function y8(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Bp(e, t);
}
function Bp(e, t) {
  return Bp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Bp(e, t);
}
function IA(e, t, r) {
  return t = RA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function RA(e) {
  var t = m8(e, "string");
  return Jn(t) == "symbol" ? t : t + "";
}
function m8(e, t) {
  if (Jn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Jn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Fp() {
  return Fp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fp.apply(this, arguments);
}
function g8(e) {
  var t = e.xAxisId, r = fv(), n = dv(), i = yA(t);
  return i == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ V.createElement(fi, Fp({}, i, {
      className: ue("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
      viewBox: {
        x: 0,
        y: 0,
        width: r,
        height: n
      },
      ticksGenerator: function(o) {
        return Zt(o, !0);
      }
    }))
  );
}
var kt = /* @__PURE__ */ function(e) {
  function t() {
    return l8(this, t), p8(this, t, arguments);
  }
  return y8(t, e), d8(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ V.createElement(g8, this.props);
    }
  }]);
}(V.Component);
IA(kt, "displayName", "XAxis");
IA(kt, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
function Qn(e) {
  "@babel/helpers - typeof";
  return Qn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Qn(e);
}
function b8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function x8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, qA(n.key), n);
  }
}
function w8(e, t, r) {
  return t && x8(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function O8(e, t, r) {
  return t = gs(t), _8(e, DA() ? Reflect.construct(t, r || [], gs(e).constructor) : t.apply(e, r));
}
function _8(e, t) {
  if (t && (Qn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return S8(e);
}
function S8(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function DA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (DA = function() {
    return !!e;
  })();
}
function gs(e) {
  return gs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, gs(e);
}
function A8(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && zp(e, t);
}
function zp(e, t) {
  return zp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, zp(e, t);
}
function LA(e, t, r) {
  return t = qA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function qA(e) {
  var t = P8(e, "string");
  return Qn(t) == "symbol" ? t : t + "";
}
function P8(e, t) {
  if (Qn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Qn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Wp() {
  return Wp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wp.apply(this, arguments);
}
var T8 = function(t) {
  var r = t.yAxisId, n = fv(), i = dv(), a = mA(r);
  return a == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ V.createElement(fi, Wp({}, a, {
      className: ue("recharts-".concat(a.axisType, " ").concat(a.axisType), a.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: i
      },
      ticksGenerator: function(s) {
        return Zt(s, !0);
      }
    }))
  );
}, $t = /* @__PURE__ */ function(e) {
  function t() {
    return b8(this, t), O8(this, t, arguments);
  }
  return A8(t, e), w8(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ V.createElement(T8, this.props);
    }
  }]);
}(V.Component);
LA($t, "displayName", "YAxis");
LA($t, "defaultProps", {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
});
function Lw(e) {
  return j8(e) || M8(e) || C8(e) || E8();
}
function E8() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function C8(e, t) {
  if (e) {
    if (typeof e == "string") return Up(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Up(e, t);
  }
}
function M8(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function j8(e) {
  if (Array.isArray(e)) return Up(e);
}
function Up(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var Gp = function(t, r, n, i, a) {
  var o = ct(t, hv), s = ct(t, nu), u = [].concat(Lw(o), Lw(s)), c = ct(t, au), l = "".concat(i, "Id"), f = i[0], d = r;
  if (u.length && (d = u.reduce(function(v, p) {
    if (p.props[l] === n && Lt(p.props, "extendDomain") && U(p.props[f])) {
      var g = p.props[f];
      return [Math.min(v[0], g), Math.max(v[1], g)];
    }
    return v;
  }, d)), c.length) {
    var h = "".concat(f, "1"), m = "".concat(f, "2");
    d = c.reduce(function(v, p) {
      if (p.props[l] === n && Lt(p.props, "extendDomain") && U(p.props[h]) && U(p.props[m])) {
        var g = p.props[h], b = p.props[m];
        return [Math.min(v[0], g, b), Math.max(v[1], g, b)];
      }
      return v;
    }, d);
  }
  return a && a.length && (d = a.reduce(function(v, p) {
    return U(p) ? [Math.min(v[0], p), Math.max(v[1], p)] : v;
  }, d)), d;
}, md = { exports: {} }, qw;
function k8() {
  return qw || (qw = 1, function(e) {
    var t = Object.prototype.hasOwnProperty, r = "~";
    function n() {
    }
    Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
    function i(u, c, l) {
      this.fn = u, this.context = c, this.once = l || !1;
    }
    function a(u, c, l, f, d) {
      if (typeof l != "function")
        throw new TypeError("The listener must be a function");
      var h = new i(l, f || u, d), m = r ? r + c : c;
      return u._events[m] ? u._events[m].fn ? u._events[m] = [u._events[m], h] : u._events[m].push(h) : (u._events[m] = h, u._eventsCount++), u;
    }
    function o(u, c) {
      --u._eventsCount === 0 ? u._events = new n() : delete u._events[c];
    }
    function s() {
      this._events = new n(), this._eventsCount = 0;
    }
    s.prototype.eventNames = function() {
      var c = [], l, f;
      if (this._eventsCount === 0) return c;
      for (f in l = this._events)
        t.call(l, f) && c.push(r ? f.slice(1) : f);
      return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(l)) : c;
    }, s.prototype.listeners = function(c) {
      var l = r ? r + c : c, f = this._events[l];
      if (!f) return [];
      if (f.fn) return [f.fn];
      for (var d = 0, h = f.length, m = new Array(h); d < h; d++)
        m[d] = f[d].fn;
      return m;
    }, s.prototype.listenerCount = function(c) {
      var l = r ? r + c : c, f = this._events[l];
      return f ? f.fn ? 1 : f.length : 0;
    }, s.prototype.emit = function(c, l, f, d, h, m) {
      var v = r ? r + c : c;
      if (!this._events[v]) return !1;
      var p = this._events[v], g = arguments.length, b, w;
      if (p.fn) {
        switch (p.once && this.removeListener(c, p.fn, void 0, !0), g) {
          case 1:
            return p.fn.call(p.context), !0;
          case 2:
            return p.fn.call(p.context, l), !0;
          case 3:
            return p.fn.call(p.context, l, f), !0;
          case 4:
            return p.fn.call(p.context, l, f, d), !0;
          case 5:
            return p.fn.call(p.context, l, f, d, h), !0;
          case 6:
            return p.fn.call(p.context, l, f, d, h, m), !0;
        }
        for (w = 1, b = new Array(g - 1); w < g; w++)
          b[w - 1] = arguments[w];
        p.fn.apply(p.context, b);
      } else {
        var O = p.length, y;
        for (w = 0; w < O; w++)
          switch (p[w].once && this.removeListener(c, p[w].fn, void 0, !0), g) {
            case 1:
              p[w].fn.call(p[w].context);
              break;
            case 2:
              p[w].fn.call(p[w].context, l);
              break;
            case 3:
              p[w].fn.call(p[w].context, l, f);
              break;
            case 4:
              p[w].fn.call(p[w].context, l, f, d);
              break;
            default:
              if (!b) for (y = 1, b = new Array(g - 1); y < g; y++)
                b[y - 1] = arguments[y];
              p[w].fn.apply(p[w].context, b);
          }
      }
      return !0;
    }, s.prototype.on = function(c, l, f) {
      return a(this, c, l, f, !1);
    }, s.prototype.once = function(c, l, f) {
      return a(this, c, l, f, !0);
    }, s.prototype.removeListener = function(c, l, f, d) {
      var h = r ? r + c : c;
      if (!this._events[h]) return this;
      if (!l)
        return o(this, h), this;
      var m = this._events[h];
      if (m.fn)
        m.fn === l && (!d || m.once) && (!f || m.context === f) && o(this, h);
      else {
        for (var v = 0, p = [], g = m.length; v < g; v++)
          (m[v].fn !== l || d && !m[v].once || f && m[v].context !== f) && p.push(m[v]);
        p.length ? this._events[h] = p.length === 1 ? p[0] : p : o(this, h);
      }
      return this;
    }, s.prototype.removeAllListeners = function(c) {
      var l;
      return c ? (l = r ? r + c : c, this._events[l] && o(this, l)) : (this._events = new n(), this._eventsCount = 0), this;
    }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = r, s.EventEmitter = s, e.exports = s;
  }(md)), md.exports;
}
var $8 = k8();
const N8 = /* @__PURE__ */ xe($8);
var gd = new N8(), bd = "recharts.syncMouseEvents";
function _a(e) {
  "@babel/helpers - typeof";
  return _a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _a(e);
}
function I8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function R8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, BA(n.key), n);
  }
}
function D8(e, t, r) {
  return t && R8(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function xd(e, t, r) {
  return t = BA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function BA(e) {
  var t = L8(e, "string");
  return _a(t) == "symbol" ? t : t + "";
}
function L8(e, t) {
  if (_a(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (_a(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var q8 = /* @__PURE__ */ function() {
  function e() {
    I8(this, e), xd(this, "activeIndex", 0), xd(this, "coordinateList", []), xd(this, "layout", "horizontal");
  }
  return D8(e, [{
    key: "setDetails",
    value: function(r) {
      var n, i = r.coordinateList, a = i === void 0 ? null : i, o = r.container, s = o === void 0 ? null : o, u = r.layout, c = u === void 0 ? null : u, l = r.offset, f = l === void 0 ? null : l, d = r.mouseHandlerCallback, h = d === void 0 ? null : d;
      this.coordinateList = (n = a ?? this.coordinateList) !== null && n !== void 0 ? n : [], this.container = s ?? this.container, this.layout = c ?? this.layout, this.offset = f ?? this.offset, this.mouseHandlerCallback = h ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(r) {
      if (this.coordinateList.length !== 0)
        switch (r.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(r) {
      this.activeIndex = r;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var r, n;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var i = this.container.getBoundingClientRect(), a = i.x, o = i.y, s = i.height, u = this.coordinateList[this.activeIndex].coordinate, c = ((r = window) === null || r === void 0 ? void 0 : r.scrollX) || 0, l = ((n = window) === null || n === void 0 ? void 0 : n.scrollY) || 0, f = a + u + c, d = o + this.offset.top + s / 2 + l;
        this.mouseHandlerCallback({
          pageX: f,
          pageY: d
        });
      }
    }
  }]);
}();
function B8(e, t, r) {
  if (r === "number" && t === !0 && Array.isArray(e)) {
    var n = e?.[0], i = e?.[1];
    if (n && i && U(n) && U(i))
      return !0;
  }
  return !1;
}
function F8(e, t, r, n) {
  var i = n / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? t.x - i : r.left + 0.5,
    y: e === "horizontal" ? r.top + 0.5 : t.y - i,
    width: e === "horizontal" ? n : r.width - 1,
    height: e === "horizontal" ? r.height - 1 : n
  };
}
function FA(e) {
  var t = e.cx, r = e.cy, n = e.radius, i = e.startAngle, a = e.endAngle, o = Ae(t, r, n, i), s = Ae(t, r, n, a);
  return {
    points: [o, s],
    cx: t,
    cy: r,
    radius: n,
    startAngle: i,
    endAngle: a
  };
}
function z8(e, t, r) {
  var n, i, a, o;
  if (e === "horizontal")
    n = t.x, a = n, i = r.top, o = r.top + r.height;
  else if (e === "vertical")
    i = t.y, o = i, n = r.left, a = r.left + r.width;
  else if (t.cx != null && t.cy != null)
    if (e === "centric") {
      var s = t.cx, u = t.cy, c = t.innerRadius, l = t.outerRadius, f = t.angle, d = Ae(s, u, c, f), h = Ae(s, u, l, f);
      n = d.x, i = d.y, a = h.x, o = h.y;
    } else
      return FA(t);
  return [{
    x: n,
    y: i
  }, {
    x: a,
    y: o
  }];
}
function Sa(e) {
  "@babel/helpers - typeof";
  return Sa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Sa(e);
}
function Bw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function oo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Bw(Object(r), !0).forEach(function(n) {
      W8(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Bw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function W8(e, t, r) {
  return t = U8(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function U8(e) {
  var t = G8(e, "string");
  return Sa(t) == "symbol" ? t : t + "";
}
function G8(e, t) {
  if (Sa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Sa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function H8(e) {
  var t, r, n = e.element, i = e.tooltipEventType, a = e.isActive, o = e.activeCoordinate, s = e.activePayload, u = e.offset, c = e.activeTooltipIndex, l = e.tooltipAxisBandSize, f = e.layout, d = e.chartName, h = (t = n.props.cursor) !== null && t !== void 0 ? t : (r = n.type.defaultProps) === null || r === void 0 ? void 0 : r.cursor;
  if (!n || !h || !a || !o || d !== "ScatterChart" && i !== "axis")
    return null;
  var m, v = Ur;
  if (d === "ScatterChart")
    m = o, v = iL;
  else if (d === "BarChart")
    m = F8(f, o, u, l), v = ov;
  else if (f === "radial") {
    var p = FA(o), g = p.cx, b = p.cy, w = p.radius, O = p.startAngle, y = p.endAngle;
    m = {
      cx: g,
      cy: b,
      startAngle: O,
      endAngle: y,
      innerRadius: w,
      outerRadius: w
    }, v = RS;
  } else
    m = {
      points: z8(f, o, u)
    }, v = Ur;
  var x = oo(oo(oo(oo({
    stroke: "#ccc",
    pointerEvents: "none"
  }, u), m), Q(h, !1)), {}, {
    payload: s,
    payloadIndex: c,
    className: ue("recharts-tooltip-cursor", h.className)
  });
  return /* @__PURE__ */ Pt(h) ? /* @__PURE__ */ De(h, x) : /* @__PURE__ */ Fi(v, x);
}
var V8 = ["item"], K8 = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function ei(e) {
  "@babel/helpers - typeof";
  return ei = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ei(e);
}
function gn() {
  return gn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gn.apply(this, arguments);
}
function Fw(e, t) {
  return Z8(e) || X8(e, t) || WA(e, t) || Y8();
}
function Y8() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function X8(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function Z8(e) {
  if (Array.isArray(e)) return e;
}
function zw(e, t) {
  if (e == null) return {};
  var r = J8(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function J8(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Q8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ez(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, UA(n.key), n);
  }
}
function tz(e, t, r) {
  return t && ez(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function rz(e, t, r) {
  return t = bs(t), nz(e, zA() ? Reflect.construct(t, r || [], bs(e).constructor) : t.apply(e, r));
}
function nz(e, t) {
  if (t && (ei(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return iz(e);
}
function iz(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function zA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (zA = function() {
    return !!e;
  })();
}
function bs(e) {
  return bs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, bs(e);
}
function az(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Hp(e, t);
}
function Hp(e, t) {
  return Hp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Hp(e, t);
}
function ti(e) {
  return uz(e) || sz(e) || WA(e) || oz();
}
function oz() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function WA(e, t) {
  if (e) {
    if (typeof e == "string") return Vp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Vp(e, t);
  }
}
function sz(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function uz(e) {
  if (Array.isArray(e)) return Vp(e);
}
function Vp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Ww(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function D(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ww(Object(r), !0).forEach(function(n) {
      ne(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ww(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ne(e, t, r) {
  return t = UA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function UA(e) {
  var t = cz(e, "string");
  return ei(t) == "symbol" ? t : t + "";
}
function cz(e, t) {
  if (ei(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ei(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var lz = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, fz = {
  width: "100%",
  height: "100%"
}, GA = {
  x: 0,
  y: 0
};
function so(e) {
  return e;
}
var dz = function(t, r) {
  return r === "horizontal" ? t.x : r === "vertical" ? t.y : r === "centric" ? t.angle : t.radius;
}, pz = function(t, r, n, i) {
  var a = r.find(function(l) {
    return l && l.index === n;
  });
  if (a) {
    if (t === "horizontal")
      return {
        x: a.coordinate,
        y: i.y
      };
    if (t === "vertical")
      return {
        x: i.x,
        y: a.coordinate
      };
    if (t === "centric") {
      var o = a.coordinate, s = i.radius;
      return D(D(D({}, i), Ae(i.cx, i.cy, s, o)), {}, {
        angle: o,
        radius: s
      });
    }
    var u = a.coordinate, c = i.angle;
    return D(D(D({}, i), Ae(i.cx, i.cy, u, c)), {}, {
      angle: c,
      radius: u
    });
  }
  return GA;
}, ou = function(t, r) {
  var n = r.graphicalItems, i = r.dataStartIndex, a = r.dataEndIndex, o = (n ?? []).reduce(function(s, u) {
    var c = u.props.data;
    return c && c.length ? [].concat(ti(s), ti(c)) : s;
  }, []);
  return o.length > 0 ? o : t && t.length && U(i) && U(a) ? t.slice(i, a + 1) : [];
};
function HA(e) {
  return e === "number" ? [0, "auto"] : void 0;
}
var Kp = function(t, r, n, i) {
  var a = t.graphicalItems, o = t.tooltipAxis, s = ou(r, t);
  return n < 0 || !a || !a.length || n >= s.length ? null : a.reduce(function(u, c) {
    var l, f = (l = c.props.data) !== null && l !== void 0 ? l : r;
    f && t.dataStartIndex + t.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    t.dataEndIndex - t.dataStartIndex >= n && (f = f.slice(t.dataStartIndex, t.dataEndIndex + 1));
    var d;
    if (o.dataKey && !o.allowDuplicatedCategory) {
      var h = f === void 0 ? s : f;
      d = mo(h, o.dataKey, i);
    } else
      d = f && f[n] || s[n];
    return d ? [].concat(ti(u), [MS(c, d)]) : u;
  }, []);
}, Uw = function(t, r, n, i) {
  var a = i || {
    x: t.chartX,
    y: t.chartY
  }, o = dz(a, n), s = t.orderedTooltipTicks, u = t.tooltipAxis, c = t.tooltipTicks, l = x2(o, s, c, u);
  if (l >= 0 && c) {
    var f = c[l] && c[l].value, d = Kp(t, r, l, f), h = pz(n, s, l, a);
    return {
      activeTooltipIndex: l,
      activeLabel: f,
      activePayload: d,
      activeCoordinate: h
    };
  }
  return null;
}, hz = function(t, r) {
  var n = r.axes, i = r.graphicalItems, a = r.axisType, o = r.axisIdKey, s = r.stackGroups, u = r.dataStartIndex, c = r.dataEndIndex, l = t.layout, f = t.children, d = t.stackOffset, h = SS(l, a);
  return n.reduce(function(m, v) {
    var p, g = v.type.defaultProps !== void 0 ? D(D({}, v.type.defaultProps), v.props) : v.props, b = g.type, w = g.dataKey, O = g.allowDataOverflow, y = g.allowDuplicatedCategory, x = g.scale, _ = g.ticks, P = g.includeHidden, E = g[o];
    if (m[E])
      return m;
    var M = ou(t.data, {
      graphicalItems: i.filter(function(B) {
        var K, X = o in B.props ? B.props[o] : (K = B.type.defaultProps) === null || K === void 0 ? void 0 : K[o];
        return X === E;
      }),
      dataStartIndex: u,
      dataEndIndex: c
    }), C = M.length, T, k, $;
    B8(g.domain, O, b) && (T = sp(g.domain, null, O), h && (b === "number" || x !== "auto") && ($ = Ri(M, w, "category")));
    var I = HA(b);
    if (!T || T.length === 0) {
      var R, q = (R = g.domain) !== null && R !== void 0 ? R : I;
      if (w) {
        if (T = Ri(M, w, b), b === "category" && h) {
          var W = p3(T);
          y && W ? (k = T, T = is(0, C)) : y || (T = D0(q, T, v).reduce(function(B, K) {
            return B.indexOf(K) >= 0 ? B : [].concat(ti(B), [K]);
          }, []));
        } else if (b === "category")
          y ? T = T.filter(function(B) {
            return B !== "" && !se(B);
          }) : T = D0(q, T, v).reduce(function(B, K) {
            return B.indexOf(K) >= 0 || K === "" || se(K) ? B : [].concat(ti(B), [K]);
          }, []);
        else if (b === "number") {
          var H = A2(M, i.filter(function(B) {
            var K, X, te = o in B.props ? B.props[o] : (K = B.type.defaultProps) === null || K === void 0 ? void 0 : K[o], re = "hide" in B.props ? B.props.hide : (X = B.type.defaultProps) === null || X === void 0 ? void 0 : X.hide;
            return te === E && (P || !re);
          }), w, a, l);
          H && (T = H);
        }
        h && (b === "number" || x !== "auto") && ($ = Ri(M, w, "category"));
      } else h ? T = is(0, C) : s && s[E] && s[E].hasStack && b === "number" ? T = d === "expand" ? [0, 1] : CS(s[E].stackGroups, u, c) : T = _S(M, i.filter(function(B) {
        var K = o in B.props ? B.props[o] : B.type.defaultProps[o], X = "hide" in B.props ? B.props.hide : B.type.defaultProps.hide;
        return K === E && (P || !X);
      }), b, l, !0);
      if (b === "number")
        T = Gp(f, T, E, a, _), q && (T = sp(q, T, O));
      else if (b === "category" && q) {
        var N = q, L = T.every(function(B) {
          return N.indexOf(B) >= 0;
        });
        L && (T = N);
      }
    }
    return D(D({}, m), {}, ne({}, E, D(D({}, g), {}, {
      axisType: a,
      domain: T,
      categoricalDomain: $,
      duplicateDomain: k,
      originalDomain: (p = g.domain) !== null && p !== void 0 ? p : I,
      isCategorical: h,
      layout: l
    })));
  }, {});
}, vz = function(t, r) {
  var n = r.graphicalItems, i = r.Axis, a = r.axisType, o = r.axisIdKey, s = r.stackGroups, u = r.dataStartIndex, c = r.dataEndIndex, l = t.layout, f = t.children, d = ou(t.data, {
    graphicalItems: n,
    dataStartIndex: u,
    dataEndIndex: c
  }), h = d.length, m = SS(l, a), v = -1;
  return n.reduce(function(p, g) {
    var b = g.type.defaultProps !== void 0 ? D(D({}, g.type.defaultProps), g.props) : g.props, w = b[o], O = HA("number");
    if (!p[w]) {
      v++;
      var y;
      return m ? y = is(0, h) : s && s[w] && s[w].hasStack ? (y = CS(s[w].stackGroups, u, c), y = Gp(f, y, w, a)) : (y = sp(O, _S(d, n.filter(function(x) {
        var _, P, E = o in x.props ? x.props[o] : (_ = x.type.defaultProps) === null || _ === void 0 ? void 0 : _[o], M = "hide" in x.props ? x.props.hide : (P = x.type.defaultProps) === null || P === void 0 ? void 0 : P.hide;
        return E === w && !M;
      }), "number", l), i.defaultProps.allowDataOverflow), y = Gp(f, y, w, a)), D(D({}, p), {}, ne({}, w, D(D({
        axisType: a
      }, i.defaultProps), {}, {
        hide: !0,
        orientation: ut(lz, "".concat(a, ".").concat(v % 2), null),
        domain: y,
        originalDomain: O,
        isCategorical: m,
        layout: l
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return p;
  }, {});
}, yz = function(t, r) {
  var n = r.axisType, i = n === void 0 ? "xAxis" : n, a = r.AxisComp, o = r.graphicalItems, s = r.stackGroups, u = r.dataStartIndex, c = r.dataEndIndex, l = t.children, f = "".concat(i, "Id"), d = ct(l, a), h = {};
  return d && d.length ? h = hz(t, {
    axes: d,
    graphicalItems: o,
    axisType: i,
    axisIdKey: f,
    stackGroups: s,
    dataStartIndex: u,
    dataEndIndex: c
  }) : o && o.length && (h = vz(t, {
    Axis: a,
    graphicalItems: o,
    axisType: i,
    axisIdKey: f,
    stackGroups: s,
    dataStartIndex: u,
    dataEndIndex: c
  })), h;
}, mz = function(t) {
  var r = vr(t), n = Zt(r, !1, !0);
  return {
    tooltipTicks: n,
    orderedTooltipTicks: kh(n, function(i) {
      return i.coordinate;
    }),
    tooltipAxis: r,
    tooltipAxisBandSize: Uo(r, n)
  };
}, Gw = function(t) {
  var r = t.children, n = t.defaultShowTooltip, i = ot(r, Wn), a = 0, o = 0;
  return t.data && t.data.length !== 0 && (o = t.data.length - 1), i && i.props && (i.props.startIndex >= 0 && (a = i.props.startIndex), i.props.endIndex >= 0 && (o = i.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: a,
    dataEndIndex: o,
    activeTooltipIndex: -1,
    isTooltipActive: !!n
  };
}, gz = function(t) {
  return !t || !t.length ? !1 : t.some(function(r) {
    var n = Jt(r && r.type);
    return n && n.indexOf("Bar") >= 0;
  });
}, Hw = function(t) {
  return t === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : t === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : t === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, bz = function(t, r) {
  var n = t.props, i = t.graphicalItems, a = t.xAxisMap, o = a === void 0 ? {} : a, s = t.yAxisMap, u = s === void 0 ? {} : s, c = n.width, l = n.height, f = n.children, d = n.margin || {}, h = ot(f, Wn), m = ot(f, On), v = Object.keys(u).reduce(function(y, x) {
    var _ = u[x], P = _.orientation;
    return !_.mirror && !_.hide ? D(D({}, y), {}, ne({}, P, y[P] + _.width)) : y;
  }, {
    left: d.left || 0,
    right: d.right || 0
  }), p = Object.keys(o).reduce(function(y, x) {
    var _ = o[x], P = _.orientation;
    return !_.mirror && !_.hide ? D(D({}, y), {}, ne({}, P, ut(y, "".concat(P)) + _.height)) : y;
  }, {
    top: d.top || 0,
    bottom: d.bottom || 0
  }), g = D(D({}, p), v), b = g.bottom;
  h && (g.bottom += h.props.height || Wn.defaultProps.height), m && r && (g = _2(g, i, n, r));
  var w = c - g.left - g.right, O = l - g.top - g.bottom;
  return D(D({
    brushBottom: b
  }, g), {}, {
    // never return negative values for height and width
    width: Math.max(w, 0),
    height: Math.max(O, 0)
  });
}, xz = function(t, r) {
  if (r === "xAxis")
    return t[r].width;
  if (r === "yAxis")
    return t[r].height;
}, su = function(t) {
  var r = t.chartName, n = t.GraphicalChild, i = t.defaultTooltipEventType, a = i === void 0 ? "axis" : i, o = t.validateTooltipEventTypes, s = o === void 0 ? ["axis"] : o, u = t.axisComponents, c = t.legendContent, l = t.formatAxisMap, f = t.defaultProps, d = function(g, b) {
    var w = b.graphicalItems, O = b.stackGroups, y = b.offset, x = b.updateId, _ = b.dataStartIndex, P = b.dataEndIndex, E = g.barSize, M = g.layout, C = g.barGap, T = g.barCategoryGap, k = g.maxBarSize, $ = Hw(M), I = $.numericAxisName, R = $.cateAxisName, q = gz(w), W = [];
    return w.forEach(function(H, N) {
      var L = ou(g.data, {
        graphicalItems: [H],
        dataStartIndex: _,
        dataEndIndex: P
      }), B = H.type.defaultProps !== void 0 ? D(D({}, H.type.defaultProps), H.props) : H.props, K = B.dataKey, X = B.maxBarSize, te = B["".concat(I, "Id")], re = B["".concat(R, "Id")], oe = {}, ae = u.reduce(function(Pr, zt) {
        var uu, cu, lu = b["".concat(zt.axisType, "Map")], gv = B["".concat(zt.axisType, "Id")];
        lu && lu[gv] || zt.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? tt(!1, "Specifying a(n) ".concat(zt.axisType, "Id requires a corresponding ").concat(
          zt.axisType,
          "Id on the targeted graphical component "
        ).concat((uu = H == null || (cu = H.type) === null || cu === void 0 ? void 0 : cu.displayName) !== null && uu !== void 0 ? uu : "")) : tt());
        var bv = lu[gv];
        return D(D({}, Pr), {}, ne(ne({}, zt.axisType, bv), "".concat(zt.axisType, "Ticks"), Zt(bv)));
      }, oe), F = ae[R], Y = ae["".concat(R, "Ticks")], ee = O && O[te] && O[te].hasStack && N2(H, O[te].stackGroups), j = Jt(H.type).indexOf("Bar") >= 0, fe = Uo(F, Y), G = [], Oe = q && w2({
        barSize: E,
        stackGroups: O,
        totalSize: xz(ae, R)
      });
      if (j) {
        var Ee, Ue, cr = se(X) ? k : X, un = (Ee = (Ue = Uo(F, Y, !0)) !== null && Ue !== void 0 ? Ue : cr) !== null && Ee !== void 0 ? Ee : 0;
        G = O2({
          barGap: C,
          barCategoryGap: T,
          bandSize: un !== fe ? un : fe,
          sizeList: Oe[re],
          maxBarSize: cr
        }), un !== fe && (G = G.map(function(Pr) {
          return D(D({}, Pr), {}, {
            position: D(D({}, Pr.position), {}, {
              offset: Pr.position.offset - un / 2
            })
          });
        }));
      }
      var La = H && H.type && H.type.getComposedData;
      La && W.push({
        props: D(D({}, La(D(D({}, ae), {}, {
          displayedData: L,
          props: g,
          dataKey: K,
          item: H,
          bandSize: fe,
          barPosition: G,
          offset: y,
          stackedData: ee,
          layout: M,
          dataStartIndex: _,
          dataEndIndex: P
        }))), {}, ne(ne(ne({
          key: H.key || "item-".concat(N)
        }, I, ae[I]), R, ae[R]), "animationId", x)),
        childIndex: A3(H, g.children),
        item: H
      });
    }), W;
  }, h = function(g, b) {
    var w = g.props, O = g.dataStartIndex, y = g.dataEndIndex, x = g.updateId;
    if (!Jy({
      props: w
    }))
      return null;
    var _ = w.children, P = w.layout, E = w.stackOffset, M = w.data, C = w.reverseStackOrder, T = Hw(P), k = T.numericAxisName, $ = T.cateAxisName, I = ct(_, n), R = k2(M, I, "".concat(k, "Id"), "".concat($, "Id"), E, C), q = u.reduce(function(B, K) {
      var X = "".concat(K.axisType, "Map");
      return D(D({}, B), {}, ne({}, X, yz(w, D(D({}, K), {}, {
        graphicalItems: I,
        stackGroups: K.axisType === k && R,
        dataStartIndex: O,
        dataEndIndex: y
      }))));
    }, {}), W = bz(D(D({}, q), {}, {
      props: w,
      graphicalItems: I
    }), b?.legendBBox);
    Object.keys(q).forEach(function(B) {
      q[B] = l(w, q[B], W, B.replace("Map", ""), r);
    });
    var H = q["".concat($, "Map")], N = mz(H), L = d(w, D(D({}, q), {}, {
      dataStartIndex: O,
      dataEndIndex: y,
      updateId: x,
      graphicalItems: I,
      stackGroups: R,
      offset: W
    }));
    return D(D({
      formattedGraphicalItems: L,
      graphicalItems: I,
      offset: W,
      stackGroups: R
    }, N), q);
  }, m = /* @__PURE__ */ function(p) {
    function g(b) {
      var w, O, y;
      return Q8(this, g), y = rz(this, g, [b]), ne(y, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), ne(y, "accessibilityManager", new q8()), ne(y, "handleLegendBBoxUpdate", function(x) {
        if (x) {
          var _ = y.state, P = _.dataStartIndex, E = _.dataEndIndex, M = _.updateId;
          y.setState(D({
            legendBBox: x
          }, h({
            props: y.props,
            dataStartIndex: P,
            dataEndIndex: E,
            updateId: M
          }, D(D({}, y.state), {}, {
            legendBBox: x
          }))));
        }
      }), ne(y, "handleReceiveSyncEvent", function(x, _, P) {
        if (y.props.syncId === x) {
          if (P === y.eventEmitterSymbol && typeof y.props.syncMethod != "function")
            return;
          y.applySyncEvent(_);
        }
      }), ne(y, "handleBrushChange", function(x) {
        var _ = x.startIndex, P = x.endIndex;
        if (_ !== y.state.dataStartIndex || P !== y.state.dataEndIndex) {
          var E = y.state.updateId;
          y.setState(function() {
            return D({
              dataStartIndex: _,
              dataEndIndex: P
            }, h({
              props: y.props,
              dataStartIndex: _,
              dataEndIndex: P,
              updateId: E
            }, y.state));
          }), y.triggerSyncEvent({
            dataStartIndex: _,
            dataEndIndex: P
          });
        }
      }), ne(y, "handleMouseEnter", function(x) {
        var _ = y.getMouseInfo(x);
        if (_) {
          var P = D(D({}, _), {}, {
            isTooltipActive: !0
          });
          y.setState(P), y.triggerSyncEvent(P);
          var E = y.props.onMouseEnter;
          ie(E) && E(P, x);
        }
      }), ne(y, "triggeredAfterMouseMove", function(x) {
        var _ = y.getMouseInfo(x), P = _ ? D(D({}, _), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        y.setState(P), y.triggerSyncEvent(P);
        var E = y.props.onMouseMove;
        ie(E) && E(P, x);
      }), ne(y, "handleItemMouseEnter", function(x) {
        y.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: x,
            activePayload: x.tooltipPayload,
            activeCoordinate: x.tooltipPosition || {
              x: x.cx,
              y: x.cy
            }
          };
        });
      }), ne(y, "handleItemMouseLeave", function() {
        y.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), ne(y, "handleMouseMove", function(x) {
        x.persist(), y.throttleTriggeredAfterMouseMove(x);
      }), ne(y, "handleMouseLeave", function(x) {
        y.throttleTriggeredAfterMouseMove.cancel();
        var _ = {
          isTooltipActive: !1
        };
        y.setState(_), y.triggerSyncEvent(_);
        var P = y.props.onMouseLeave;
        ie(P) && P(_, x);
      }), ne(y, "handleOuterEvent", function(x) {
        var _ = S3(x), P = ut(y.props, "".concat(_));
        if (_ && ie(P)) {
          var E, M;
          /.*touch.*/i.test(_) ? M = y.getMouseInfo(x.changedTouches[0]) : M = y.getMouseInfo(x), P((E = M) !== null && E !== void 0 ? E : {}, x);
        }
      }), ne(y, "handleClick", function(x) {
        var _ = y.getMouseInfo(x);
        if (_) {
          var P = D(D({}, _), {}, {
            isTooltipActive: !0
          });
          y.setState(P), y.triggerSyncEvent(P);
          var E = y.props.onClick;
          ie(E) && E(P, x);
        }
      }), ne(y, "handleMouseDown", function(x) {
        var _ = y.props.onMouseDown;
        if (ie(_)) {
          var P = y.getMouseInfo(x);
          _(P, x);
        }
      }), ne(y, "handleMouseUp", function(x) {
        var _ = y.props.onMouseUp;
        if (ie(_)) {
          var P = y.getMouseInfo(x);
          _(P, x);
        }
      }), ne(y, "handleTouchMove", function(x) {
        x.changedTouches != null && x.changedTouches.length > 0 && y.throttleTriggeredAfterMouseMove(x.changedTouches[0]);
      }), ne(y, "handleTouchStart", function(x) {
        x.changedTouches != null && x.changedTouches.length > 0 && y.handleMouseDown(x.changedTouches[0]);
      }), ne(y, "handleTouchEnd", function(x) {
        x.changedTouches != null && x.changedTouches.length > 0 && y.handleMouseUp(x.changedTouches[0]);
      }), ne(y, "handleDoubleClick", function(x) {
        var _ = y.props.onDoubleClick;
        if (ie(_)) {
          var P = y.getMouseInfo(x);
          _(P, x);
        }
      }), ne(y, "handleContextMenu", function(x) {
        var _ = y.props.onContextMenu;
        if (ie(_)) {
          var P = y.getMouseInfo(x);
          _(P, x);
        }
      }), ne(y, "triggerSyncEvent", function(x) {
        y.props.syncId !== void 0 && gd.emit(bd, y.props.syncId, x, y.eventEmitterSymbol);
      }), ne(y, "applySyncEvent", function(x) {
        var _ = y.props, P = _.layout, E = _.syncMethod, M = y.state.updateId, C = x.dataStartIndex, T = x.dataEndIndex;
        if (x.dataStartIndex !== void 0 || x.dataEndIndex !== void 0)
          y.setState(D({
            dataStartIndex: C,
            dataEndIndex: T
          }, h({
            props: y.props,
            dataStartIndex: C,
            dataEndIndex: T,
            updateId: M
          }, y.state)));
        else if (x.activeTooltipIndex !== void 0) {
          var k = x.chartX, $ = x.chartY, I = x.activeTooltipIndex, R = y.state, q = R.offset, W = R.tooltipTicks;
          if (!q)
            return;
          if (typeof E == "function")
            I = E(W, x);
          else if (E === "value") {
            I = -1;
            for (var H = 0; H < W.length; H++)
              if (W[H].value === x.activeLabel) {
                I = H;
                break;
              }
          }
          var N = D(D({}, q), {}, {
            x: q.left,
            y: q.top
          }), L = Math.min(k, N.x + N.width), B = Math.min($, N.y + N.height), K = W[I] && W[I].value, X = Kp(y.state, y.props.data, I), te = W[I] ? {
            x: P === "horizontal" ? W[I].coordinate : L,
            y: P === "horizontal" ? B : W[I].coordinate
          } : GA;
          y.setState(D(D({}, x), {}, {
            activeLabel: K,
            activeCoordinate: te,
            activePayload: X,
            activeTooltipIndex: I
          }));
        } else
          y.setState(x);
      }), ne(y, "renderCursor", function(x) {
        var _, P = y.state, E = P.isTooltipActive, M = P.activeCoordinate, C = P.activePayload, T = P.offset, k = P.activeTooltipIndex, $ = P.tooltipAxisBandSize, I = y.getTooltipEventType(), R = (_ = x.props.active) !== null && _ !== void 0 ? _ : E, q = y.props.layout, W = x.key || "_recharts-cursor";
        return /* @__PURE__ */ A.createElement(H8, {
          key: W,
          activeCoordinate: M,
          activePayload: C,
          activeTooltipIndex: k,
          chartName: r,
          element: x,
          isActive: R,
          layout: q,
          offset: T,
          tooltipAxisBandSize: $,
          tooltipEventType: I
        });
      }), ne(y, "renderPolarAxis", function(x, _, P) {
        var E = ut(x, "type.axisType"), M = ut(y.state, "".concat(E, "Map")), C = x.type.defaultProps, T = C !== void 0 ? D(D({}, C), x.props) : x.props, k = M && M[T["".concat(E, "Id")]];
        return /* @__PURE__ */ De(x, D(D({}, k), {}, {
          className: ue(E, k.className),
          key: x.key || "".concat(_, "-").concat(P),
          ticks: Zt(k, !0)
        }));
      }), ne(y, "renderPolarGrid", function(x) {
        var _ = x.props, P = _.radialLines, E = _.polarAngles, M = _.polarRadius, C = y.state, T = C.radiusAxisMap, k = C.angleAxisMap, $ = vr(T), I = vr(k), R = I.cx, q = I.cy, W = I.innerRadius, H = I.outerRadius;
        return /* @__PURE__ */ De(x, {
          polarAngles: Array.isArray(E) ? E : Zt(I, !0).map(function(N) {
            return N.coordinate;
          }),
          polarRadius: Array.isArray(M) ? M : Zt($, !0).map(function(N) {
            return N.coordinate;
          }),
          cx: R,
          cy: q,
          innerRadius: W,
          outerRadius: H,
          key: x.key || "polar-grid",
          radialLines: P
        });
      }), ne(y, "renderLegend", function() {
        var x = y.state.formattedGraphicalItems, _ = y.props, P = _.children, E = _.width, M = _.height, C = y.props.margin || {}, T = E - (C.left || 0) - (C.right || 0), k = wS({
          children: P,
          formattedGraphicalItems: x,
          legendWidth: T,
          legendContent: c
        });
        if (!k)
          return null;
        var $ = k.item, I = zw(k, V8);
        return /* @__PURE__ */ De($, D(D({}, I), {}, {
          chartWidth: E,
          chartHeight: M,
          margin: C,
          onBBoxUpdate: y.handleLegendBBoxUpdate
        }));
      }), ne(y, "renderTooltip", function() {
        var x, _ = y.props, P = _.children, E = _.accessibilityLayer, M = ot(P, Ve);
        if (!M)
          return null;
        var C = y.state, T = C.isTooltipActive, k = C.activeCoordinate, $ = C.activePayload, I = C.activeLabel, R = C.offset, q = (x = M.props.active) !== null && x !== void 0 ? x : T;
        return /* @__PURE__ */ De(M, {
          viewBox: D(D({}, R), {}, {
            x: R.left,
            y: R.top
          }),
          active: q,
          label: I,
          payload: q ? $ : [],
          coordinate: k,
          accessibilityLayer: E
        });
      }), ne(y, "renderBrush", function(x) {
        var _ = y.props, P = _.margin, E = _.data, M = y.state, C = M.offset, T = M.dataStartIndex, k = M.dataEndIndex, $ = M.updateId;
        return /* @__PURE__ */ De(x, {
          key: x.key || "_recharts-brush",
          onChange: eo(y.handleBrushChange, x.props.onChange),
          data: E,
          x: U(x.props.x) ? x.props.x : C.left,
          y: U(x.props.y) ? x.props.y : C.top + C.height + C.brushBottom - (P.bottom || 0),
          width: U(x.props.width) ? x.props.width : C.width,
          startIndex: T,
          endIndex: k,
          updateId: "brush-".concat($)
        });
      }), ne(y, "renderReferenceElement", function(x, _, P) {
        if (!x)
          return null;
        var E = y, M = E.clipPathId, C = y.state, T = C.xAxisMap, k = C.yAxisMap, $ = C.offset, I = x.type.defaultProps || {}, R = x.props, q = R.xAxisId, W = q === void 0 ? I.xAxisId : q, H = R.yAxisId, N = H === void 0 ? I.yAxisId : H;
        return /* @__PURE__ */ De(x, {
          key: x.key || "".concat(_, "-").concat(P),
          xAxis: T[W],
          yAxis: k[N],
          viewBox: {
            x: $.left,
            y: $.top,
            width: $.width,
            height: $.height
          },
          clipPathId: M
        });
      }), ne(y, "renderActivePoints", function(x) {
        var _ = x.item, P = x.activePoint, E = x.basePoint, M = x.childIndex, C = x.isRange, T = [], k = _.props.key, $ = _.item.type.defaultProps !== void 0 ? D(D({}, _.item.type.defaultProps), _.item.props) : _.item.props, I = $.activeDot, R = $.dataKey, q = D(D({
          index: M,
          dataKey: R,
          cx: P.x,
          cy: P.y,
          r: 4,
          fill: iv(_.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: P.payload,
          value: P.value
        }, Q(I, !1)), go(I));
        return T.push(g.renderActiveDot(I, q, "".concat(k, "-activePoint-").concat(M))), E ? T.push(g.renderActiveDot(I, D(D({}, q), {}, {
          cx: E.x,
          cy: E.y
        }), "".concat(k, "-basePoint-").concat(M))) : C && T.push(null), T;
      }), ne(y, "renderGraphicChild", function(x, _, P) {
        var E = y.filterFormatItem(x, _, P);
        if (!E)
          return null;
        var M = y.getTooltipEventType(), C = y.state, T = C.isTooltipActive, k = C.tooltipAxis, $ = C.activeTooltipIndex, I = C.activeLabel, R = y.props.children, q = ot(R, Ve), W = E.props, H = W.points, N = W.isRange, L = W.baseLine, B = E.item.type.defaultProps !== void 0 ? D(D({}, E.item.type.defaultProps), E.item.props) : E.item.props, K = B.activeDot, X = B.hide, te = B.activeBar, re = B.activeShape, oe = !!(!X && T && q && (K || te || re)), ae = {};
        M !== "axis" && q && q.props.trigger === "click" ? ae = {
          onClick: eo(y.handleItemMouseEnter, x.props.onClick)
        } : M !== "axis" && (ae = {
          onMouseLeave: eo(y.handleItemMouseLeave, x.props.onMouseLeave),
          onMouseEnter: eo(y.handleItemMouseEnter, x.props.onMouseEnter)
        });
        var F = /* @__PURE__ */ De(x, D(D({}, E.props), ae));
        function Y(zt) {
          return typeof k.dataKey == "function" ? k.dataKey(zt.payload) : null;
        }
        if (oe)
          if ($ >= 0) {
            var ee, j;
            if (k.dataKey && !k.allowDuplicatedCategory) {
              var fe = typeof k.dataKey == "function" ? Y : "payload.".concat(k.dataKey.toString());
              ee = mo(H, fe, I), j = N && L && mo(L, fe, I);
            } else
              ee = H?.[$], j = N && L && L[$];
            if (re || te) {
              var G = x.props.activeIndex !== void 0 ? x.props.activeIndex : $;
              return [/* @__PURE__ */ De(x, D(D(D({}, E.props), ae), {}, {
                activeIndex: G
              })), null, null];
            }
            if (!se(ee))
              return [F].concat(ti(y.renderActivePoints({
                item: E,
                activePoint: ee,
                basePoint: j,
                childIndex: $,
                isRange: N
              })));
          } else {
            var Oe, Ee = (Oe = y.getItemByXY(y.state.activeCoordinate)) !== null && Oe !== void 0 ? Oe : {
              graphicalItem: F
            }, Ue = Ee.graphicalItem, cr = Ue.item, un = cr === void 0 ? x : cr, La = Ue.childIndex, Pr = D(D(D({}, E.props), ae), {}, {
              activeIndex: La
            });
            return [/* @__PURE__ */ De(un, Pr), null, null];
          }
        return N ? [F, null, null] : [F, null];
      }), ne(y, "renderCustomized", function(x, _, P) {
        return /* @__PURE__ */ De(x, D(D({
          key: "recharts-customized-".concat(P)
        }, y.props), y.state));
      }), ne(y, "renderMap", {
        CartesianGrid: {
          handler: so,
          once: !0
        },
        ReferenceArea: {
          handler: y.renderReferenceElement
        },
        ReferenceLine: {
          handler: so
        },
        ReferenceDot: {
          handler: y.renderReferenceElement
        },
        XAxis: {
          handler: so
        },
        YAxis: {
          handler: so
        },
        Brush: {
          handler: y.renderBrush,
          once: !0
        },
        Bar: {
          handler: y.renderGraphicChild
        },
        Line: {
          handler: y.renderGraphicChild
        },
        Area: {
          handler: y.renderGraphicChild
        },
        Radar: {
          handler: y.renderGraphicChild
        },
        RadialBar: {
          handler: y.renderGraphicChild
        },
        Scatter: {
          handler: y.renderGraphicChild
        },
        Pie: {
          handler: y.renderGraphicChild
        },
        Funnel: {
          handler: y.renderGraphicChild
        },
        Tooltip: {
          handler: y.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: y.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: y.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: y.renderPolarAxis
        },
        Customized: {
          handler: y.renderCustomized
        }
      }), y.clipPathId = "".concat((w = b.id) !== null && w !== void 0 ? w : tn("recharts"), "-clip"), y.throttleTriggeredAfterMouseMove = w_(y.triggeredAfterMouseMove, (O = b.throttleDelay) !== null && O !== void 0 ? O : 1e3 / 60), y.state = {}, y;
    }
    return az(g, p), tz(g, [{
      key: "componentDidMount",
      value: function() {
        var w, O;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (w = this.props.margin.left) !== null && w !== void 0 ? w : 0,
            top: (O = this.props.margin.top) !== null && O !== void 0 ? O : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var w = this.props, O = w.children, y = w.data, x = w.height, _ = w.layout, P = ot(O, Ve);
        if (P) {
          var E = P.props.defaultIndex;
          if (!(typeof E != "number" || E < 0 || E > this.state.tooltipTicks.length - 1)) {
            var M = this.state.tooltipTicks[E] && this.state.tooltipTicks[E].value, C = Kp(this.state, y, E, M), T = this.state.tooltipTicks[E].coordinate, k = (this.state.offset.top + x) / 2, $ = _ === "horizontal", I = $ ? {
              x: T,
              y: k
            } : {
              y: T,
              x: k
            }, R = this.state.formattedGraphicalItems.find(function(W) {
              var H = W.item;
              return H.type.name === "Scatter";
            });
            R && (I = D(D({}, I), R.props.points[E].tooltipPosition), C = R.props.points[E].tooltipPayload);
            var q = {
              activeTooltipIndex: E,
              isTooltipActive: !0,
              activeLabel: M,
              activePayload: C,
              activeCoordinate: I
            };
            this.setState(q), this.renderCursor(P), this.accessibilityManager.setIndex(E);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(w, O) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== O.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== w.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== w.margin) {
          var y, x;
          this.accessibilityManager.setDetails({
            offset: {
              left: (y = this.props.margin.left) !== null && y !== void 0 ? y : 0,
              top: (x = this.props.margin.top) !== null && x !== void 0 ? x : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(w) {
        Cd([ot(w.children, Ve)], [ot(this.props.children, Ve)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var w = ot(this.props.children, Ve);
        if (w && typeof w.props.shared == "boolean") {
          var O = w.props.shared ? "axis" : "item";
          return s.indexOf(O) >= 0 ? O : a;
        }
        return a;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(w) {
        if (!this.container)
          return null;
        var O = this.container, y = O.getBoundingClientRect(), x = dk(y), _ = {
          chartX: Math.round(w.pageX - x.left),
          chartY: Math.round(w.pageY - x.top)
        }, P = y.width / O.offsetWidth || 1, E = this.inRange(_.chartX, _.chartY, P);
        if (!E)
          return null;
        var M = this.state, C = M.xAxisMap, T = M.yAxisMap, k = this.getTooltipEventType(), $ = Uw(this.state, this.props.data, this.props.layout, E);
        if (k !== "axis" && C && T) {
          var I = vr(C).scale, R = vr(T).scale, q = I && I.invert ? I.invert(_.chartX) : null, W = R && R.invert ? R.invert(_.chartY) : null;
          return D(D({}, _), {}, {
            xValue: q,
            yValue: W
          }, $);
        }
        return $ ? D(D({}, _), $) : null;
      }
    }, {
      key: "inRange",
      value: function(w, O) {
        var y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, x = this.props.layout, _ = w / y, P = O / y;
        if (x === "horizontal" || x === "vertical") {
          var E = this.state.offset, M = _ >= E.left && _ <= E.left + E.width && P >= E.top && P <= E.top + E.height;
          return M ? {
            x: _,
            y: P
          } : null;
        }
        var C = this.state, T = C.angleAxisMap, k = C.radiusAxisMap;
        if (T && k) {
          var $ = vr(T);
          return B0({
            x: _,
            y: P
          }, $);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var w = this.props.children, O = this.getTooltipEventType(), y = ot(w, Ve), x = {};
        y && O === "axis" && (y.props.trigger === "click" ? x = {
          onClick: this.handleClick
        } : x = {
          onMouseEnter: this.handleMouseEnter,
          onDoubleClick: this.handleDoubleClick,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd,
          onContextMenu: this.handleContextMenu
        });
        var _ = go(this.props, this.handleOuterEvent);
        return D(D({}, _), x);
      }
    }, {
      key: "addListener",
      value: function() {
        gd.on(bd, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        gd.removeListener(bd, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(w, O, y) {
        for (var x = this.state.formattedGraphicalItems, _ = 0, P = x.length; _ < P; _++) {
          var E = x[_];
          if (E.item === w || E.props.key === w.key || O === Jt(E.item.type) && y === E.childIndex)
            return E;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var w = this.clipPathId, O = this.state.offset, y = O.left, x = O.top, _ = O.height, P = O.width;
        return /* @__PURE__ */ A.createElement("defs", null, /* @__PURE__ */ A.createElement("clipPath", {
          id: w
        }, /* @__PURE__ */ A.createElement("rect", {
          x: y,
          y: x,
          height: _,
          width: P
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var w = this.state.xAxisMap;
        return w ? Object.entries(w).reduce(function(O, y) {
          var x = Fw(y, 2), _ = x[0], P = x[1];
          return D(D({}, O), {}, ne({}, _, P.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var w = this.state.yAxisMap;
        return w ? Object.entries(w).reduce(function(O, y) {
          var x = Fw(y, 2), _ = x[0], P = x[1];
          return D(D({}, O), {}, ne({}, _, P.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(w) {
        var O;
        return (O = this.state.xAxisMap) === null || O === void 0 || (O = O[w]) === null || O === void 0 ? void 0 : O.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(w) {
        var O;
        return (O = this.state.yAxisMap) === null || O === void 0 || (O = O[w]) === null || O === void 0 ? void 0 : O.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(w) {
        var O = this.state, y = O.formattedGraphicalItems, x = O.activeItem;
        if (y && y.length)
          for (var _ = 0, P = y.length; _ < P; _++) {
            var E = y[_], M = E.props, C = E.item, T = C.type.defaultProps !== void 0 ? D(D({}, C.type.defaultProps), C.props) : C.props, k = Jt(C.type);
            if (k === "Bar") {
              var $ = (M.data || []).find(function(W) {
                return L9(w, W);
              });
              if ($)
                return {
                  graphicalItem: E,
                  payload: $
                };
            } else if (k === "RadialBar") {
              var I = (M.data || []).find(function(W) {
                return B0(w, W);
              });
              if (I)
                return {
                  graphicalItem: E,
                  payload: I
                };
            } else if (Qs(E, x) || eu(E, x) || ba(E, x)) {
              var R = sq({
                graphicalItem: E,
                activeTooltipItem: x,
                itemData: T.data
              }), q = T.activeIndex === void 0 ? R : T.activeIndex;
              return {
                graphicalItem: D(D({}, E), {}, {
                  childIndex: q
                }),
                payload: ba(E, x) ? T.data[R] : E.props.data[R]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var w = this;
        if (!Jy(this))
          return null;
        var O = this.props, y = O.children, x = O.className, _ = O.width, P = O.height, E = O.style, M = O.compact, C = O.title, T = O.desc, k = zw(O, K8), $ = Q(k, !1);
        if (M)
          return /* @__PURE__ */ A.createElement(xw, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ A.createElement(jd, gn({}, $, {
            width: _,
            height: P,
            title: C,
            desc: T
          }), this.renderClipPath(), em(y, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var I, R;
          $.tabIndex = (I = this.props.tabIndex) !== null && I !== void 0 ? I : 0, $.role = (R = this.props.role) !== null && R !== void 0 ? R : "application", $.onKeyDown = function(W) {
            w.accessibilityManager.keyboardEvent(W);
          }, $.onFocus = function() {
            w.accessibilityManager.focus();
          };
        }
        var q = this.parseEventsOfWrapper();
        return /* @__PURE__ */ A.createElement(xw, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ A.createElement("div", gn({
          className: ue("recharts-wrapper", x),
          style: D({
            position: "relative",
            cursor: "default",
            width: _,
            height: P
          }, E)
        }, q, {
          ref: function(H) {
            w.container = H;
          }
        }), /* @__PURE__ */ A.createElement(jd, gn({}, $, {
          width: _,
          height: P,
          title: C,
          desc: T,
          style: fz
        }), this.renderClipPath(), em(y, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  }(Zw);
  ne(m, "displayName", r), ne(m, "defaultProps", D({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, f)), ne(m, "getDerivedStateFromProps", function(p, g) {
    var b = p.dataKey, w = p.data, O = p.children, y = p.width, x = p.height, _ = p.layout, P = p.stackOffset, E = p.margin, M = g.dataStartIndex, C = g.dataEndIndex;
    if (g.updateId === void 0) {
      var T = Gw(p);
      return D(D(D({}, T), {}, {
        updateId: 0
      }, h(D(D({
        props: p
      }, T), {}, {
        updateId: 0
      }), g)), {}, {
        prevDataKey: b,
        prevData: w,
        prevWidth: y,
        prevHeight: x,
        prevLayout: _,
        prevStackOffset: P,
        prevMargin: E,
        prevChildren: O
      });
    }
    if (b !== g.prevDataKey || w !== g.prevData || y !== g.prevWidth || x !== g.prevHeight || _ !== g.prevLayout || P !== g.prevStackOffset || !wn(E, g.prevMargin)) {
      var k = Gw(p), $ = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: g.chartX,
        chartY: g.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: g.isTooltipActive
      }, I = D(D({}, Uw(g, w, _)), {}, {
        updateId: g.updateId + 1
      }), R = D(D(D({}, k), $), I);
      return D(D(D({}, R), h(D({
        props: p
      }, R), g)), {}, {
        prevDataKey: b,
        prevData: w,
        prevWidth: y,
        prevHeight: x,
        prevLayout: _,
        prevStackOffset: P,
        prevMargin: E,
        prevChildren: O
      });
    }
    if (!Cd(O, g.prevChildren)) {
      var q, W, H, N, L = ot(O, Wn), B = L && (q = (W = L.props) === null || W === void 0 ? void 0 : W.startIndex) !== null && q !== void 0 ? q : M, K = L && (H = (N = L.props) === null || N === void 0 ? void 0 : N.endIndex) !== null && H !== void 0 ? H : C, X = B !== M || K !== C, te = !se(w), re = te && !X ? g.updateId : g.updateId + 1;
      return D(D({
        updateId: re
      }, h(D(D({
        props: p
      }, g), {}, {
        updateId: re,
        dataStartIndex: B,
        dataEndIndex: K
      }), g)), {}, {
        prevChildren: O,
        dataStartIndex: B,
        dataEndIndex: K
      });
    }
    return null;
  }), ne(m, "renderActiveDot", function(p, g, b) {
    var w;
    return /* @__PURE__ */ Pt(p) ? w = /* @__PURE__ */ De(p, g) : ie(p) ? w = p(g) : w = /* @__PURE__ */ A.createElement(Ra, g), /* @__PURE__ */ A.createElement(le, {
      className: "recharts-active-dot",
      key: b
    }, w);
  });
  var v = /* @__PURE__ */ xs(function(g, b) {
    return /* @__PURE__ */ A.createElement(m, gn({}, g, {
      ref: b
    }));
  });
  return v.displayName = m.displayName, v;
}, VA = su({
  chartName: "LineChart",
  GraphicalChild: di,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: kt
  }, {
    axisType: "yAxis",
    AxisComp: $t
  }],
  formatAxisMap: sv
}), KA = su({
  chartName: "BarChart",
  GraphicalChild: Ar,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: kt
  }, {
    axisType: "yAxis",
    AxisComp: $t
  }],
  formatAxisMap: sv
}), wz = su({
  chartName: "PieChart",
  GraphicalChild: sr,
  validateTooltipEventTypes: ["item"],
  defaultTooltipEventType: "item",
  legendContent: "children",
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: Js
  }, {
    axisType: "radiusAxis",
    AxisComp: Xs
  }],
  formatAxisMap: U2,
  defaultProps: {
    layout: "centric",
    startAngle: 0,
    endAngle: 360,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
}), YA = su({
  chartName: "AreaChart",
  GraphicalChild: ur,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: kt
  }, {
    axisType: "yAxis",
    AxisComp: $t
  }],
  formatAxisMap: sv
});
const Oz = (e) => Number.isFinite(e) ? String(Math.round(e)) : "", pi = (e) => e ? {
  allowDecimals: !1,
  tickFormatter: Oz
} : {}, _z = "rgb(var(--color-muted) / 1)", mv = (e) => `rgb(var(--color-chart-${e % 5 + 1}) / 1)`, fW = [0, 1, 2, 3, 4].map(mv), Da = mv(0), dW = ({
  data: e,
  className: t,
  height: r = 240,
  color: n = Da,
  integerTicks: i = !0,
  compact: a = !1
}) => /* @__PURE__ */ S("div", { className: z("w-full min-w-0", t), style: { height: r }, children: /* @__PURE__ */ S(rn, { width: "100%", height: "100%", children: /* @__PURE__ */ Z(
  KA,
  {
    data: e,
    margin: a ? { top: 0, right: 0, left: 0, bottom: 0 } : void 0,
    children: [
      a ? null : /* @__PURE__ */ S(sn, { strokeDasharray: "3 3", vertical: !1 }),
      a ? null : /* @__PURE__ */ S(kt, { dataKey: "label", tick: { fontSize: 11 } }),
      a ? null : /* @__PURE__ */ S(
        $t,
        {
          tick: { fontSize: 11 },
          width: 40,
          ...pi(i)
        }
      ),
      a ? null : /* @__PURE__ */ S(Ve, {}),
      /* @__PURE__ */ S(Ar, { dataKey: "value", fill: n, radius: [4, 4, 0, 0] })
    ]
  }
) }) }), pW = ({
  data: e,
  className: t,
  height: r = 240,
  color: n = Da,
  integerTicks: i = !0,
  compact: a = !1
}) => /* @__PURE__ */ S("div", { className: z("w-full min-w-0", t), style: { height: r }, children: /* @__PURE__ */ S(rn, { width: "100%", height: "100%", children: /* @__PURE__ */ Z(
  VA,
  {
    data: e,
    margin: a ? { top: 0, right: 0, left: 0, bottom: 0 } : void 0,
    children: [
      a ? null : /* @__PURE__ */ S(sn, { strokeDasharray: "3 3", vertical: !1 }),
      a ? null : /* @__PURE__ */ S(kt, { dataKey: "label", tick: { fontSize: 11 } }),
      a ? null : /* @__PURE__ */ S(
        $t,
        {
          tick: { fontSize: 11 },
          width: 40,
          ...pi(i)
        }
      ),
      a ? null : /* @__PURE__ */ S(Ve, {}),
      /* @__PURE__ */ S(
        di,
        {
          type: "monotone",
          dataKey: "value",
          stroke: n,
          strokeWidth: 2,
          dot: !1
        }
      )
    ]
  }
) }) }), hW = ({
  data: e,
  className: t,
  height: r = 240,
  color: n = Da,
  integerTicks: i = !0,
  compact: a = !1
}) => /* @__PURE__ */ S("div", { className: z("w-full min-w-0", t), style: { height: r }, children: /* @__PURE__ */ S(rn, { width: "100%", height: "100%", children: /* @__PURE__ */ Z(
  YA,
  {
    data: e,
    margin: a ? { top: 0, right: 0, left: 0, bottom: 0 } : void 0,
    children: [
      a ? null : /* @__PURE__ */ S(sn, { strokeDasharray: "3 3", vertical: !1 }),
      a ? null : /* @__PURE__ */ S(kt, { dataKey: "label", tick: { fontSize: 11 } }),
      a ? null : /* @__PURE__ */ S(
        $t,
        {
          tick: { fontSize: 11 },
          width: 40,
          ...pi(i)
        }
      ),
      a ? null : /* @__PURE__ */ S(Ve, {}),
      /* @__PURE__ */ S(
        ur,
        {
          type: "monotone",
          dataKey: "value",
          stroke: n,
          fill: n,
          fillOpacity: 0.2
        }
      )
    ]
  }
) }) }), vW = ({
  data: e,
  series: t,
  className: r,
  height: n = 260,
  integerTicks: i = !0
}) => /* @__PURE__ */ S("div", { className: z("w-full min-w-0", r), style: { height: n }, children: /* @__PURE__ */ S(rn, { width: "100%", height: "100%", children: /* @__PURE__ */ Z(KA, { data: e, margin: { top: 8, right: 8, left: 0, bottom: 0 }, children: [
  /* @__PURE__ */ S(sn, { strokeDasharray: "3 3", vertical: !1 }),
  /* @__PURE__ */ S(kt, { dataKey: "label", tick: { fontSize: 11 } }),
  /* @__PURE__ */ S(
    $t,
    {
      tick: { fontSize: 11 },
      width: 40,
      ...pi(i)
    }
  ),
  /* @__PURE__ */ S(Ve, {}),
  t.map((a, o) => /* @__PURE__ */ S(
    Ar,
    {
      dataKey: a.key,
      name: a.label,
      stackId: "stack",
      fill: a.color,
      radius: o === t.length - 1 ? [4, 4, 0, 0] : [0, 0, 0, 0]
    },
    a.key
  ))
] }) }) }), yW = ({
  data: e,
  series: t,
  className: r,
  height: n = 280,
  integerTicks: i = !0
}) => /* @__PURE__ */ S("div", { className: z("w-full min-w-0", r), style: { height: n }, children: /* @__PURE__ */ S(rn, { width: "100%", height: "100%", children: /* @__PURE__ */ Z(VA, { data: e, margin: { top: 8, right: 8, left: 0, bottom: 0 }, children: [
  /* @__PURE__ */ S(sn, { strokeDasharray: "3 3", vertical: !1 }),
  /* @__PURE__ */ S(kt, { dataKey: "label", tick: { fontSize: 11 } }),
  /* @__PURE__ */ S(
    $t,
    {
      tick: { fontSize: 11 },
      width: 40,
      ...pi(i)
    }
  ),
  /* @__PURE__ */ S(Ve, {}),
  t.map((a) => /* @__PURE__ */ S(
    di,
    {
      type: "monotone",
      dataKey: a.key,
      name: a.label,
      stroke: a.color,
      strokeWidth: 2,
      dot: !1
    },
    a.key
  ))
] }) }) }), mW = ({
  data: e,
  series: t,
  className: r,
  height: n = 280,
  integerTicks: i = !0
}) => /* @__PURE__ */ S("div", { className: z("w-full min-w-0", r), style: { height: n }, children: /* @__PURE__ */ S(rn, { width: "100%", height: "100%", children: /* @__PURE__ */ Z(YA, { data: e, margin: { top: 8, right: 8, left: 0, bottom: 0 }, children: [
  /* @__PURE__ */ S(sn, { strokeDasharray: "3 3", vertical: !1 }),
  /* @__PURE__ */ S(kt, { dataKey: "label", tick: { fontSize: 11 } }),
  /* @__PURE__ */ S(
    $t,
    {
      tick: { fontSize: 11 },
      width: 40,
      ...pi(i)
    }
  ),
  /* @__PURE__ */ S(Ve, {}),
  t.map((a) => /* @__PURE__ */ S(
    ur,
    {
      type: "monotone",
      dataKey: a.key,
      name: a.label,
      stackId: "stack",
      stroke: a.color,
      fill: a.color,
      fillOpacity: 0.55,
      strokeWidth: 1.5
    },
    a.key
  ))
] }) }) }), gW = ({
  data: e,
  className: t,
  height: r = 240
}) => /* @__PURE__ */ S("div", { className: z("w-full min-w-0", t), style: { height: r }, children: /* @__PURE__ */ S(rn, { width: "100%", height: "100%", children: /* @__PURE__ */ Z(wz, { children: [
  /* @__PURE__ */ S(
    sr,
    {
      data: e,
      dataKey: "value",
      nameKey: "label",
      innerRadius: "55%",
      outerRadius: "80%",
      children: e.map((n, i) => /* @__PURE__ */ S(
        Ls,
        {
          fill: n.color ?? mv(i)
        },
        n.label
      ))
    }
  ),
  /* @__PURE__ */ S(Ve, {})
] }) }) }), bW = ({
  data: e,
  className: t
}) => {
  const r = Math.max(1, ...e.map((a) => a.value)), n = Array.from(
    { length: 7 },
    (a, o) => Array.from({ length: 24 }, (s, u) => e.find((l) => l.dow === o && l.hour === u)?.value ?? 0)
  ), i = ["S", "M", "T", "W", "T", "F", "S"];
  return /* @__PURE__ */ S("div", { className: z("overflow-x-auto", t), children: /* @__PURE__ */ Z("div", { className: "inline-grid grid-cols-[auto_repeat(24,minmax(0,1fr))] gap-0.5", children: [
    /* @__PURE__ */ S("div", {}),
    Array.from({ length: 24 }, (a, o) => /* @__PURE__ */ S(
      "div",
      {
        className: "text-muted-foreground text-center text-[10px]",
        children: o % 3 === 0 ? o : ""
      },
      o
    )),
    n.map((a, o) => /* @__PURE__ */ Z(eP, { children: [
      /* @__PURE__ */ S("div", { className: "text-muted-foreground pr-1 text-right text-[10px] leading-4", children: i[o] }),
      a.map((s, u) => /* @__PURE__ */ S(
        "div",
        {
          title: `${i[o]} ${u}:00 — ${s}`,
          className: "h-4 w-4 rounded-sm",
          style: {
            backgroundColor: `color-mix(in srgb, ${Da} ${Math.round(s / r * 100)}%, transparent)`
          }
        },
        `${o}-${u}`
      ))
    ] }, `row-${o}`))
  ] }) });
}, Sz = (e, t) => {
  if (e <= 0) return _z;
  const r = Math.max(18, Math.round(e / t * 100));
  return `color-mix(in srgb, ${Da} ${r}%, transparent)`;
}, xW = ({
  data: e,
  className: t
}) => {
  if (e.length === 0)
    return /* @__PURE__ */ S("p", { className: z("text-muted-foreground text-sm", t), children: "No data yet" });
  const r = Math.max(1, ...e.map((h) => h.value)), n = e[0].day, i = e[e.length - 1].day, a = new Map(e.map((h) => [h.day, h.value])), o = /* @__PURE__ */ new Date(`${n}T00:00:00.000Z`), s = /* @__PURE__ */ new Date(`${i}T00:00:00.000Z`), u = (o.getUTCDay() + 6) % 7;
  o.setUTCDate(o.getUTCDate() - u);
  const c = (s.getUTCDay() + 6) % 7;
  s.setUTCDate(s.getUTCDate() + (6 - c));
  const l = [];
  for (let h = new Date(o.getTime()); h.getTime() <= s.getTime(); h = new Date(h.getTime() + 864e5)) {
    const m = h.toISOString().slice(0, 10), v = m >= n && m <= i;
    l.push({
      day: v ? m : null,
      value: v ? a.get(m) ?? 0 : 0,
      inRange: v
    });
  }
  const f = [];
  for (let h = 0; h < l.length; h += 7)
    f.push(l.slice(h, h + 7));
  const d = ["M", "T", "W", "T", "F", "S", "S"];
  return /* @__PURE__ */ Z("div", { className: z("w-full min-w-0", t), children: [
    /* @__PURE__ */ Z("div", { className: "flex h-28 gap-1 sm:h-32", children: [
      /* @__PURE__ */ S("div", { className: "text-muted-foreground flex w-3 shrink-0 flex-col justify-between py-0.5 text-[9px] leading-none", children: d.map((h, m) => /* @__PURE__ */ S("span", { className: "flex flex-1 items-center", children: m % 2 === 0 ? h : "" }, `${h}-${m}`)) }),
      /* @__PURE__ */ S("div", { className: "flex min-w-0 flex-1 gap-[3px]", children: f.map((h, m) => /* @__PURE__ */ S("div", { className: "flex min-w-0 flex-1 flex-col gap-[3px]", children: h.map((v, p) => /* @__PURE__ */ S(
        "div",
        {
          title: v.day ? `${v.day} — ${v.value}` : void 0,
          className: z(
            "min-h-0 flex-1 rounded-[2px]",
            !v.inRange && "opacity-0"
          ),
          style: v.inRange ? { backgroundColor: Sz(v.value, r) } : void 0
        },
        v.day ?? `pad-${m}-${p}`
      )) }, m)) })
    ] }),
    /* @__PURE__ */ Z("div", { className: "text-muted-foreground mt-2 flex justify-between text-[10px]", children: [
      /* @__PURE__ */ S("span", { children: n }),
      /* @__PURE__ */ S("span", { children: i })
    ] })
  ] });
}, Vw = (e) => {
  const t = e.replaceAll("##", "#"), r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
  if (!r) return null;
  const [, n, i, a] = r;
  return { r: parseInt(n, 16), g: parseInt(i, 16), b: parseInt(a, 16) };
}, Az = (e) => {
  const t = e.replaceAll("##", "#"), r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
  if (!r) return "(invalid)";
  const [, n, i, a] = r;
  return `${parseInt(n, 16)} ${parseInt(i, 16)} ${parseInt(a, 16)}`;
}, Kw = (e) => {
  const t = [e.r, e.g, e.b].map((r) => {
    const n = r / 255;
    return n <= 0.03928 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
  });
  return t[0] * 0.2126 + t[1] * 0.7152 + t[2] * 0.0722;
}, Yw = (e, t) => {
  const r = Kw(Vw(e)), n = Kw(Vw(t));
  return r > n ? (n + 0.05) / (r + 0.05) : (r + 0.05) / (n + 0.05);
}, Pz = (e) => {
  const t = Yw(e, "#000000"), r = Yw(e, "#FFFFFF");
  return t < r ? "0 0 0" : "255 255 255";
}, XA = {
  id: "Inter",
  family: "Inter",
  cssFamily: "'Inter', system-ui, sans-serif"
}, Yp = [
  XA,
  {
    id: "Space Grotesk",
    family: "Space Grotesk",
    cssFamily: "'Space Grotesk', system-ui, sans-serif"
  },
  {
    id: "JetBrains Mono",
    family: "JetBrains Mono",
    cssFamily: "'JetBrains Mono', ui-monospace, monospace"
  },
  {
    id: "Playfair Display",
    family: "Playfair Display",
    cssFamily: "'Playfair Display', Georgia, serif"
  },
  {
    id: "Fraunces",
    family: "Fraunces",
    cssFamily: "'Fraunces', Georgia, serif"
  },
  {
    id: "Syne",
    family: "Syne",
    cssFamily: "'Syne', system-ui, sans-serif"
  },
  {
    id: "Fredoka",
    family: "Fredoka",
    cssFamily: "'Fredoka', system-ui, sans-serif"
  },
  {
    id: "Patrick Hand",
    family: "Patrick Hand",
    cssFamily: "'Patrick Hand', 'Comic Sans MS', cursive"
  },
  {
    id: "Baloo 2",
    family: "Baloo 2",
    cssFamily: "'Baloo 2', system-ui, sans-serif"
  },
  {
    id: "Amatic SC",
    family: "Amatic SC",
    cssFamily: "'Amatic SC', 'Comic Sans MS', cursive"
  }
], Tz = XA, uo = (e) => e.trim().toLowerCase(), ZA = (e) => {
  const t = e?.trim();
  if (!t) return;
  const r = uo(t);
  return Yp.find(
    (n) => uo(n.id) === r || uo(n.family) === r
  ) ?? Yp.find((n) => r.includes(uo(n.family)));
}, Ez = (e) => ZA(e) ?? Tz, Cz = (e) => {
  if (e?.trim())
    return ZA(e)?.cssFamily ?? e.trim();
}, wW = ({
  value: e,
  onChange: t,
  className: r,
  id: n,
  "aria-label": i
}) => {
  const a = Ez(e);
  return /* @__PURE__ */ S(
    "select",
    {
      id: n,
      "aria-label": i,
      className: r,
      value: a.id,
      style: { fontFamily: a.cssFamily },
      onChange: (o) => t(o.target.value),
      children: Yp.map((o) => /* @__PURE__ */ S(
        "option",
        {
          value: o.id,
          style: { fontFamily: o.cssFamily },
          children: o.family
        },
        o.id
      ))
    }
  );
}, Xw = (e, t) => {
  const r = Az(t);
  if (r === "(invalid)") return "";
  const n = Pz(t.startsWith("#") ? t : `#${t}`);
  return `--color-${e}: ${r};
	--color-${e}-foreground: ${n};
	`;
}, Mz = (e, t) => {
  const {
    primaryHex: r,
    secondaryHex: n,
    fontFamily: i,
    buttonRadius: a,
    radius: o,
    background: s = ""
  } = t, u = Cz(i), c = [
    Xw("primary", r),
    n ? Xw("secondary", n) : "",
    u ? `--theme-font-family-base: ${u};
	--theme-font-family-heading: ${u};
	` : "",
    a ? `--theme-rounded-base: ${a};
	` : "",
    o ? `--theme-rounded-container: ${o};
	` : ""
  ].join(""), l = s ? `background-image: url(${s});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;` : "";
  return `<style>
:root, [data-theme='${e}'] {
${c}
}
body {
  scrollbar-color: rgb(var(--color-primary) / 0.5) transparent;
  ${l}
}
</style>`;
}, OW = (e, t, r) => Mz(e, { primaryHex: t, background: r }), _W = (e) => {
  typeof document > "u" || document.body?.setAttribute("data-theme", e);
}, SW = (e) => {
  if (typeof document > "u" || typeof getComputedStyle != "function")
    return;
  const t = getComputedStyle(document.body || document.documentElement).getPropertyValue(e).trim();
  return t ? `rgb(${t})` : void 0;
};
export {
  fW as ANALYTICS_CHART_COLORS,
  Tn as AccessibleButtonLabel,
  VP as AlertDialog,
  v1 as AlertDialogAction,
  y1 as AlertDialogCancel,
  d1 as AlertDialogContent,
  h1 as AlertDialogDescription,
  xn as AlertDialogFooter,
  YP as AlertDialogHeader,
  Qp as AlertDialogOverlay,
  f1 as AlertDialogPortal,
  p1 as AlertDialogTitle,
  KP as AlertDialogTrigger,
  hW as AnalyticsAreaChart,
  dW as AnalyticsBarChart,
  xW as AnalyticsDayHeatmap,
  gW as AnalyticsDonutChart,
  bW as AnalyticsHeatmap,
  GT as AnalyticsInfoBadge,
  pW as AnalyticsLineChart,
  yW as AnalyticsMultiLineChart,
  mW as AnalyticsStackedAreaChart,
  vW as AnalyticsStackedBarChart,
  m1 as Avatar,
  b1 as AvatarFallback,
  g1 as AvatarImage,
  AT as Badge,
  Bz as Badges,
  Hz as Blur,
  Tt as Button,
  x1 as Card,
  S1 as CardContent,
  _1 as CardDescription,
  A1 as CardFooter,
  w1 as CardHeader,
  O1 as CardTitle,
  P1 as Checkbox,
  Tz as DEFAULT_THEME_FONT,
  lW as DateRangeFilter,
  fo as Dialog,
  QP as DialogActions,
  Av as DialogClose,
  Ui as DialogContent,
  Sd as DialogDescription,
  xn as DialogFooter,
  ho as DialogHeader,
  Wi as DialogOverlay,
  po as DialogPortal,
  vo as DialogTitle,
  Sv as DialogTrigger,
  th as DropdownMenu,
  Os as DropdownMenuContent,
  T1 as DropdownMenuItem,
  E1 as DropdownMenuLabel,
  C1 as DropdownMenuSeparator,
  rh as DropdownMenuTrigger,
  Uz as ExpandableBox,
  mT as Form,
  q1 as FormControl,
  B1 as FormDescription,
  gT as FormField,
  D1 as FormItem,
  L1 as FormLabel,
  F1 as FormMessage,
  Dz as IconButton,
  Kz as InfiniteScrollContainer,
  uh as Input,
  CT as Label,
  Yz as Link,
  DT as Loader,
  Xz as LoadingIcon,
  _s as LoadingSpinner,
  cW as MetricCard,
  Zz as Modal,
  xn as ModalFooter,
  Qz as ModalHeader,
  Jz as ModalWrapper,
  z1 as Popover,
  bT as PopoverAnchor,
  ch as PopoverContent,
  W1 as PopoverTrigger,
  eW as PopupMenu,
  rW as PopupMenuButton,
  nW as PopupSection,
  iW as PopupSeparator,
  U1 as RadioGroup,
  G1 as RadioGroupItem,
  Gz as RadioSelect,
  H1 as ScrollArea,
  lh as ScrollBar,
  kv as ScrollObserver,
  aW as SearchAndFilterBar,
  xT as Select,
  K1 as SelectContent,
  OT as SelectGroup,
  Y1 as SelectItem,
  V1 as SelectTrigger,
  wT as SelectValue,
  X1 as Separator,
  XP as ShadcnBadge,
  sh as ShadcnLabel,
  fo as Sheet,
  Av as SheetClose,
  Ui as SheetContent,
  Sd as SheetDescription,
  xn as SheetFooter,
  ho as SheetHeader,
  Wi as SheetOverlay,
  po as SheetPortal,
  vo as SheetTitle,
  Sv as SheetTrigger,
  _T as Skeleton,
  tW as SplitButtonMenu,
  Vz as SquareStop,
  zz as StopWatch,
  Z1 as Switch,
  Yp as THEME_FONTS,
  oW as Table,
  eO as TableBody,
  nO as TableCell,
  rO as TableHead,
  Q1 as TableHeader,
  J1 as TableRoot,
  tO as TableRow,
  ST as Tabs,
  oO as TabsContent,
  iO as TabsList,
  aO as TabsTrigger,
  Lz as TextButton,
  sO as Textarea,
  wW as ThemeFontSelect,
  Wz as Timespan,
  sW as Toast,
  uW as Tooltip,
  fh as TooltipContent,
  uO as TooltipProvider,
  cO as TooltipRoot,
  lO as TooltipTrigger,
  Fz as UpdatingDate,
  RT as WaitForQueries,
  mv as analyticsChartColor,
  Mz as applyThemeOverrides,
  eh as badgeVariants,
  Ta as buttonVariants,
  z as cn,
  PT as dateFormatter,
  NP as deepGet,
  Nz as deepSet,
  ZA as findThemeFont,
  Pz as generateA11yOnColor,
  Kw as getLuminance,
  BT as getModalManager,
  IP as getUniqueBy,
  Vw as hexToRgb,
  Az as hexToTailwindRgbString,
  Ez as matchThemeFont,
  Kt as modalStore,
  Iz as preventDefault,
  qz as primitives,
  SW as readCssColorVar,
  Cz as resolveThemeFontCss,
  _W as setTheme,
  Rz as stopPropagation,
  TT as stopWatchFormatter,
  OW as themeStyleString,
  Ea as useFormField,
  RP as useInfiniteScroll,
  FT as useModalManager
};
//# sourceMappingURL=index.js.map
